
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire735e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire735e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iw2gE", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d7acf975af164d67$export$ffb0004e005737fa, (v) => $d7acf975af164d67$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d7acf975af164d67$export$34b9dba7ce09269b, (v) => $d7acf975af164d67$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d7acf975af164d67$export$25062201e9e25d76, (v) => $d7acf975af164d67$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7acf975af164d67$export$ffb0004e005737fa;
var $d7acf975af164d67$export$34b9dba7ce09269b;
var $d7acf975af164d67$export$25062201e9e25d76;
"use strict";
var $d7acf975af164d67$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d7acf975af164d67$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $d7acf975af164d67$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $d7acf975af164d67$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$d7acf975af164d67$export$ffb0004e005737fa = $d7acf975af164d67$var$REACT_FRAGMENT_TYPE;
$d7acf975af164d67$export$34b9dba7ce09269b = $d7acf975af164d67$var$jsxProd;
$d7acf975af164d67$export$25062201e9e25d76 = $d7acf975af164d67$var$jsxProd;

});

parcelRegister("9Q9Iw", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72a081fca2fa8551$export$9c16c1426311996d, (v) => $72a081fca2fa8551$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72a081fca2fa8551$export$dca3b0875bd9a954, (v) => $72a081fca2fa8551$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72a081fca2fa8551$export$16fa2f45be04daa8, (v) => $72a081fca2fa8551$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72a081fca2fa8551$export$ffb0004e005737fa, (v) => $72a081fca2fa8551$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72a081fca2fa8551$export$e2c29f18771995cb, (v) => $72a081fca2fa8551$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72a081fca2fa8551$export$221d75b3f55bb0bd, (v) => $72a081fca2fa8551$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72a081fca2fa8551$export$5f8d39834fd61797, (v) => $72a081fca2fa8551$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72a081fca2fa8551$export$74bf444e3cd11ea5, (v) => $72a081fca2fa8551$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72a081fca2fa8551$export$1ced07cd6b1985ce, (v) => $72a081fca2fa8551$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72a081fca2fa8551$export$abd8e32b826d7ea7, (v) => $72a081fca2fa8551$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72a081fca2fa8551$export$69a3209f1a06c04d, (v) => $72a081fca2fa8551$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72a081fca2fa8551$export$8c538325882c7eec, (v) => $72a081fca2fa8551$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72a081fca2fa8551$export$e530037191fcd5d7, (v) => $72a081fca2fa8551$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72a081fca2fa8551$export$fd42f52fd3ae1109, (v) => $72a081fca2fa8551$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72a081fca2fa8551$export$c8a8987d4410bf2d, (v) => $72a081fca2fa8551$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72a081fca2fa8551$export$7d1e3a5e95ceca43, (v) => $72a081fca2fa8551$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72a081fca2fa8551$export$257a8862b851cb5b, (v) => $72a081fca2fa8551$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72a081fca2fa8551$export$a8257692ac88316c, (v) => $72a081fca2fa8551$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72a081fca2fa8551$export$488013bae63b21da, (v) => $72a081fca2fa8551$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72a081fca2fa8551$export$7c73462e0d25e514, (v) => $72a081fca2fa8551$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72a081fca2fa8551$export$7568632d0d33d16d, (v) => $72a081fca2fa8551$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72a081fca2fa8551$export$f93f40ac0ca7e3a8, (v) => $72a081fca2fa8551$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72a081fca2fa8551$export$1f96ae73734a86cc, (v) => $72a081fca2fa8551$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72a081fca2fa8551$export$9a47ced3238df325, (v) => $72a081fca2fa8551$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72a081fca2fa8551$export$35808ee640e87ca7, (v) => $72a081fca2fa8551$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72a081fca2fa8551$export$fae74005e78b1a27, (v) => $72a081fca2fa8551$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72a081fca2fa8551$export$dc8fbce3eb94dc1e, (v) => $72a081fca2fa8551$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72a081fca2fa8551$export$6a7bc4e911dc01cf, (v) => $72a081fca2fa8551$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72a081fca2fa8551$export$6d9c69b0de29b591, (v) => $72a081fca2fa8551$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72a081fca2fa8551$export$7f54fc3180508a52, (v) => $72a081fca2fa8551$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72a081fca2fa8551$export$f680877a34711e37, (v) => $72a081fca2fa8551$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72a081fca2fa8551$export$d5a552a76deda3c2, (v) => $72a081fca2fa8551$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72a081fca2fa8551$export$aaabe4eda9ed9969, (v) => $72a081fca2fa8551$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72a081fca2fa8551$export$e5c5a5f917a5871c, (v) => $72a081fca2fa8551$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72a081fca2fa8551$export$1538c33de8887b59, (v) => $72a081fca2fa8551$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72a081fca2fa8551$export$fca7f784ae7a249a, (v) => $72a081fca2fa8551$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72a081fca2fa8551$export$13e3392192263954, (v) => $72a081fca2fa8551$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72a081fca2fa8551$export$b8f5890fc79d6aca, (v) => $72a081fca2fa8551$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72a081fca2fa8551$export$60241385465d0a34, (v) => $72a081fca2fa8551$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72a081fca2fa8551$export$306c0aa65ff9ec16, (v) => $72a081fca2fa8551$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72a081fca2fa8551$export$7b286972b8d8ccbf, (v) => $72a081fca2fa8551$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72a081fca2fa8551$export$83d89fbfd8236492, (v) => $72a081fca2fa8551$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72a081fca2fa8551$export$9c16c1426311996d;
var $72a081fca2fa8551$export$dca3b0875bd9a954;
var $72a081fca2fa8551$export$16fa2f45be04daa8;
var $72a081fca2fa8551$export$ffb0004e005737fa;
var $72a081fca2fa8551$export$e2c29f18771995cb;
var $72a081fca2fa8551$export$221d75b3f55bb0bd;
var $72a081fca2fa8551$export$5f8d39834fd61797;
var $72a081fca2fa8551$export$74bf444e3cd11ea5;
var $72a081fca2fa8551$export$1ced07cd6b1985ce;
var $72a081fca2fa8551$export$abd8e32b826d7ea7;
var $72a081fca2fa8551$export$69a3209f1a06c04d;
var $72a081fca2fa8551$export$8c538325882c7eec;
var $72a081fca2fa8551$export$e530037191fcd5d7;
var $72a081fca2fa8551$export$fd42f52fd3ae1109;
var $72a081fca2fa8551$export$c8a8987d4410bf2d;
var $72a081fca2fa8551$export$7d1e3a5e95ceca43;
var $72a081fca2fa8551$export$257a8862b851cb5b;
var $72a081fca2fa8551$export$a8257692ac88316c;
var $72a081fca2fa8551$export$488013bae63b21da;
var $72a081fca2fa8551$export$7c73462e0d25e514;
var $72a081fca2fa8551$export$7568632d0d33d16d;
var $72a081fca2fa8551$export$f93f40ac0ca7e3a8;
var $72a081fca2fa8551$export$1f96ae73734a86cc;
var $72a081fca2fa8551$export$9a47ced3238df325;
var $72a081fca2fa8551$export$35808ee640e87ca7;
var $72a081fca2fa8551$export$fae74005e78b1a27;
var $72a081fca2fa8551$export$dc8fbce3eb94dc1e;
var $72a081fca2fa8551$export$6a7bc4e911dc01cf;
var $72a081fca2fa8551$export$6d9c69b0de29b591;
var $72a081fca2fa8551$export$7f54fc3180508a52;
var $72a081fca2fa8551$export$f680877a34711e37;
var $72a081fca2fa8551$export$d5a552a76deda3c2;
var $72a081fca2fa8551$export$aaabe4eda9ed9969;
var $72a081fca2fa8551$export$e5c5a5f917a5871c;
var $72a081fca2fa8551$export$1538c33de8887b59;
var $72a081fca2fa8551$export$fca7f784ae7a249a;
var $72a081fca2fa8551$export$13e3392192263954;
var $72a081fca2fa8551$export$b8f5890fc79d6aca;
var $72a081fca2fa8551$export$60241385465d0a34;
var $72a081fca2fa8551$export$306c0aa65ff9ec16;
var $72a081fca2fa8551$export$7b286972b8d8ccbf;
var $72a081fca2fa8551$export$83d89fbfd8236492;
"use strict";
var $72a081fca2fa8551$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72a081fca2fa8551$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72a081fca2fa8551$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72a081fca2fa8551$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72a081fca2fa8551$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72a081fca2fa8551$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72a081fca2fa8551$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72a081fca2fa8551$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72a081fca2fa8551$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72a081fca2fa8551$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72a081fca2fa8551$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72a081fca2fa8551$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72a081fca2fa8551$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72a081fca2fa8551$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72a081fca2fa8551$var$assign = Object.assign, $72a081fca2fa8551$var$emptyObject = {};
function $72a081fca2fa8551$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72a081fca2fa8551$var$emptyObject;
    this.updater = updater || $72a081fca2fa8551$var$ReactNoopUpdateQueue;
}
$72a081fca2fa8551$var$Component.prototype.isReactComponent = {};
$72a081fca2fa8551$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72a081fca2fa8551$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72a081fca2fa8551$var$ComponentDummy() {}
$72a081fca2fa8551$var$ComponentDummy.prototype = $72a081fca2fa8551$var$Component.prototype;
function $72a081fca2fa8551$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72a081fca2fa8551$var$emptyObject;
    this.updater = updater || $72a081fca2fa8551$var$ReactNoopUpdateQueue;
}
var $72a081fca2fa8551$var$pureComponentPrototype = $72a081fca2fa8551$var$PureComponent.prototype = new $72a081fca2fa8551$var$ComponentDummy();
$72a081fca2fa8551$var$pureComponentPrototype.constructor = $72a081fca2fa8551$var$PureComponent;
$72a081fca2fa8551$var$assign($72a081fca2fa8551$var$pureComponentPrototype, $72a081fca2fa8551$var$Component.prototype);
$72a081fca2fa8551$var$pureComponentPrototype.isPureReactComponent = !0;
var $72a081fca2fa8551$var$isArrayImpl = Array.isArray;
function $72a081fca2fa8551$var$noop() {}
var $72a081fca2fa8551$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72a081fca2fa8551$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72a081fca2fa8551$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72a081fca2fa8551$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72a081fca2fa8551$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72a081fca2fa8551$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72a081fca2fa8551$var$REACT_ELEMENT_TYPE;
}
function $72a081fca2fa8551$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72a081fca2fa8551$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72a081fca2fa8551$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72a081fca2fa8551$var$escape("" + element.key) : index.toString(36);
}
function $72a081fca2fa8551$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72a081fca2fa8551$var$noop, $72a081fca2fa8551$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72a081fca2fa8551$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72a081fca2fa8551$var$REACT_ELEMENT_TYPE:
                case $72a081fca2fa8551$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72a081fca2fa8551$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72a081fca2fa8551$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72a081fca2fa8551$var$getElementKey(children, 0) : nameSoFar, $72a081fca2fa8551$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72a081fca2fa8551$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72a081fca2fa8551$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72a081fca2fa8551$var$isValidElement(callback) && (callback = $72a081fca2fa8551$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72a081fca2fa8551$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72a081fca2fa8551$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72a081fca2fa8551$var$getElementKey(nameSoFar, i), invokeCallback += $72a081fca2fa8551$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72a081fca2fa8551$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72a081fca2fa8551$var$getElementKey(nameSoFar, i++), invokeCallback += $72a081fca2fa8551$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72a081fca2fa8551$var$mapIntoArray($72a081fca2fa8551$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72a081fca2fa8551$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72a081fca2fa8551$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72a081fca2fa8551$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72a081fca2fa8551$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72a081fca2fa8551$var$Children = {
    map: $72a081fca2fa8551$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72a081fca2fa8551$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72a081fca2fa8551$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72a081fca2fa8551$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72a081fca2fa8551$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72a081fca2fa8551$export$9c16c1426311996d = $72a081fca2fa8551$var$REACT_ACTIVITY_TYPE;
$72a081fca2fa8551$export$dca3b0875bd9a954 = $72a081fca2fa8551$var$Children;
$72a081fca2fa8551$export$16fa2f45be04daa8 = $72a081fca2fa8551$var$Component;
$72a081fca2fa8551$export$ffb0004e005737fa = $72a081fca2fa8551$var$REACT_FRAGMENT_TYPE;
$72a081fca2fa8551$export$e2c29f18771995cb = $72a081fca2fa8551$var$REACT_PROFILER_TYPE;
$72a081fca2fa8551$export$221d75b3f55bb0bd = $72a081fca2fa8551$var$PureComponent;
$72a081fca2fa8551$export$5f8d39834fd61797 = $72a081fca2fa8551$var$REACT_STRICT_MODE_TYPE;
$72a081fca2fa8551$export$74bf444e3cd11ea5 = $72a081fca2fa8551$var$REACT_SUSPENSE_TYPE;
$72a081fca2fa8551$export$1ced07cd6b1985ce = $72a081fca2fa8551$var$ReactSharedInternals;
$72a081fca2fa8551$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72a081fca2fa8551$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72a081fca2fa8551$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72a081fca2fa8551$export$8c538325882c7eec = function() {
    return null;
};
$72a081fca2fa8551$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72a081fca2fa8551$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72a081fca2fa8551$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72a081fca2fa8551$var$ReactElement(element.type, key, props);
};
$72a081fca2fa8551$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72a081fca2fa8551$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72a081fca2fa8551$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72a081fca2fa8551$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72a081fca2fa8551$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72a081fca2fa8551$var$ReactElement(type, key, props);
};
$72a081fca2fa8551$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72a081fca2fa8551$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72a081fca2fa8551$export$a8257692ac88316c = $72a081fca2fa8551$var$isValidElement;
$72a081fca2fa8551$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72a081fca2fa8551$var$lazyInitializer
    };
};
$72a081fca2fa8551$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72a081fca2fa8551$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72a081fca2fa8551$var$ReactSharedInternals.T, currentTransition = {};
    $72a081fca2fa8551$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72a081fca2fa8551$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72a081fca2fa8551$var$noop, $72a081fca2fa8551$var$reportGlobalError);
    } catch (error) {
        $72a081fca2fa8551$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72a081fca2fa8551$var$ReactSharedInternals.T = prevTransition;
    }
};
$72a081fca2fa8551$export$f93f40ac0ca7e3a8 = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useCacheRefresh();
};
$72a081fca2fa8551$export$1f96ae73734a86cc = function(usable) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.use(usable);
};
$72a081fca2fa8551$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72a081fca2fa8551$export$35808ee640e87ca7 = function(callback, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72a081fca2fa8551$export$fae74005e78b1a27 = function(Context) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useContext(Context);
};
$72a081fca2fa8551$export$dc8fbce3eb94dc1e = function() {};
$72a081fca2fa8551$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72a081fca2fa8551$export$6d9c69b0de29b591 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72a081fca2fa8551$export$7f54fc3180508a52 = function(callback) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72a081fca2fa8551$export$f680877a34711e37 = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useId();
};
$72a081fca2fa8551$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72a081fca2fa8551$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72a081fca2fa8551$export$e5c5a5f917a5871c = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72a081fca2fa8551$export$1538c33de8887b59 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72a081fca2fa8551$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72a081fca2fa8551$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72a081fca2fa8551$export$b8f5890fc79d6aca = function(initialValue) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useRef(initialValue);
};
$72a081fca2fa8551$export$60241385465d0a34 = function(initialState) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useState(initialState);
};
$72a081fca2fa8551$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72a081fca2fa8551$export$7b286972b8d8ccbf = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useTransition();
};
$72a081fca2fa8551$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("fjpcG", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $b25c2e442c996fe7$export$882461b6382ed46c, (v) => $b25c2e442c996fe7$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $b25c2e442c996fe7$export$757ceba2d55c277e, (v) => $b25c2e442c996fe7$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $b25c2e442c996fe7$export$83d89fbfd8236492, (v) => $b25c2e442c996fe7$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b25c2e442c996fe7$export$882461b6382ed46c;
var $b25c2e442c996fe7$export$757ceba2d55c277e;
var $b25c2e442c996fe7$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $2WGWz = parcelRequire("2WGWz");

var $9Np2q = parcelRequire("9Np2q");
function $b25c2e442c996fe7$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b25c2e442c996fe7$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $b25c2e442c996fe7$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b25c2e442c996fe7$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $b25c2e442c996fe7$var$assertIsMounted(fiber) {
    if ($b25c2e442c996fe7$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
}
function $b25c2e442c996fe7$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b25c2e442c996fe7$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b25c2e442c996fe7$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b25c2e442c996fe7$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b25c2e442c996fe7$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b25c2e442c996fe7$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b25c2e442c996fe7$var$assign = Object.assign, $b25c2e442c996fe7$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b25c2e442c996fe7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b25c2e442c996fe7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b25c2e442c996fe7$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b25c2e442c996fe7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b25c2e442c996fe7$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b25c2e442c996fe7$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b25c2e442c996fe7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b25c2e442c996fe7$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b25c2e442c996fe7$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b25c2e442c996fe7$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b25c2e442c996fe7$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b25c2e442c996fe7$var$getComponentNameFromType(type.type) || "Memo";
        case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b25c2e442c996fe7$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b25c2e442c996fe7$var$isArrayImpl = Array.isArray, $b25c2e442c996fe7$var$ReactSharedInternals = $2WGWz.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b25c2e442c996fe7$var$ReactDOMSharedInternals = $9Np2q.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b25c2e442c996fe7$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b25c2e442c996fe7$var$valueStack = [], $b25c2e442c996fe7$var$index = -1;
function $b25c2e442c996fe7$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b25c2e442c996fe7$var$pop(cursor) {
    0 > $b25c2e442c996fe7$var$index || (cursor.current = $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index], $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index] = null, $b25c2e442c996fe7$var$index--);
}
function $b25c2e442c996fe7$var$push(cursor, value) {
    $b25c2e442c996fe7$var$index++;
    $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index] = cursor.current;
    cursor.current = value;
}
var $b25c2e442c996fe7$var$contextStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$contextFiberStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$rootInstanceStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$hostTransitionProviderCursor = $b25c2e442c996fe7$var$createCursor(null);
function $b25c2e442c996fe7$var$pushHostContainer(fiber, nextRootInstance) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$rootInstanceStackCursor, nextRootInstance);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextFiberStackCursor, fiber);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $b25c2e442c996fe7$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $b25c2e442c996fe7$var$getOwnHostContext(nextRootInstance), fiber = $b25c2e442c996fe7$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, fiber);
}
function $b25c2e442c996fe7$var$popHostContainer() {
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextFiberStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$rootInstanceStackCursor);
}
function $b25c2e442c996fe7$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$hostTransitionProviderCursor, fiber);
    var context = $b25c2e442c996fe7$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b25c2e442c996fe7$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextFiberStackCursor, fiber), $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, JSCompiler_inline_result));
}
function $b25c2e442c996fe7$var$popHostContext(fiber) {
    $b25c2e442c996fe7$var$contextFiberStackCursor.current === fiber && ($b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor), $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextFiberStackCursor));
    $b25c2e442c996fe7$var$hostTransitionProviderCursor.current === fiber && ($b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$hostTransitionProviderCursor), $b25c2e442c996fe7$var$HostTransitionContext._currentValue = $b25c2e442c996fe7$var$sharedNotPendingObject);
}
var $b25c2e442c996fe7$var$prefix, $b25c2e442c996fe7$var$suffix;
function $b25c2e442c996fe7$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b25c2e442c996fe7$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b25c2e442c996fe7$var$prefix = match && match[1] || "";
        $b25c2e442c996fe7$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b25c2e442c996fe7$var$prefix + name + $b25c2e442c996fe7$var$suffix;
}
var $b25c2e442c996fe7$var$reentry = !1;
function $b25c2e442c996fe7$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b25c2e442c996fe7$var$reentry) return "";
    $b25c2e442c996fe7$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b25c2e442c996fe7$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b25c2e442c996fe7$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b25c2e442c996fe7$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Suspense Fallback") : $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $b25c2e442c996fe7$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $b25c2e442c996fe7$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b25c2e442c996fe7$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $b25c2e442c996fe7$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $b25c2e442c996fe7$var$shouldYield = $bIbqH.unstable_shouldYield, $b25c2e442c996fe7$var$requestPaint = $bIbqH.unstable_requestPaint, $b25c2e442c996fe7$var$now = $bIbqH.unstable_now, $b25c2e442c996fe7$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $b25c2e442c996fe7$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $b25c2e442c996fe7$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $b25c2e442c996fe7$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$LowPriority = $bIbqH.unstable_LowPriority, $b25c2e442c996fe7$var$IdlePriority = $bIbqH.unstable_IdlePriority, $b25c2e442c996fe7$var$log$1 = $bIbqH.log, $b25c2e442c996fe7$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $b25c2e442c996fe7$var$rendererID = null, $b25c2e442c996fe7$var$injectedHook = null;
function $b25c2e442c996fe7$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b25c2e442c996fe7$var$log$1 && $b25c2e442c996fe7$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.setStrictMode) try {
        $b25c2e442c996fe7$var$injectedHook.setStrictMode($b25c2e442c996fe7$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b25c2e442c996fe7$var$clz32 = Math.clz32 ? Math.clz32 : $b25c2e442c996fe7$var$clz32Fallback, $b25c2e442c996fe7$var$log = Math.log, $b25c2e442c996fe7$var$LN2 = Math.LN2;
function $b25c2e442c996fe7$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b25c2e442c996fe7$var$log(x) / $b25c2e442c996fe7$var$LN2 | 0) | 0;
}
var $b25c2e442c996fe7$var$nextTransitionUpdateLane = 256, $b25c2e442c996fe7$var$nextTransitionDeferredLane = 262144, $b25c2e442c996fe7$var$nextRetryLane = 4194304;
function $b25c2e442c996fe7$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b25c2e442c996fe7$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b25c2e442c996fe7$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b25c2e442c996fe7$var$claimNextRetryLane() {
    var lane = $b25c2e442c996fe7$var$nextRetryLane;
    $b25c2e442c996fe7$var$nextRetryLane <<= 1;
    0 === ($b25c2e442c996fe7$var$nextRetryLane & 62914560) && ($b25c2e442c996fe7$var$nextRetryLane = 4194304);
    return lane;
}
function $b25c2e442c996fe7$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b25c2e442c996fe7$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b25c2e442c996fe7$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $b25c2e442c996fe7$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b25c2e442c996fe7$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $b25c2e442c996fe7$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $b25c2e442c996fe7$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b25c2e442c996fe7$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $b25c2e442c996fe7$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b25c2e442c996fe7$var$resolveUpdatePriority() {
    var updatePriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b25c2e442c996fe7$var$getEventPriority(updatePriority.type);
}
function $b25c2e442c996fe7$var$runWithPriority(priority, fn) {
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        return $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b25c2e442c996fe7$var$randomKey = Math.random().toString(36).slice(2), $b25c2e442c996fe7$var$internalInstanceKey = "__reactFiber$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalPropsKey = "__reactProps$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalContainerInstanceKey = "__reactContainer$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlersKey = "__reactEvents$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlerListenersKey = "__reactListeners$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlesSetKey = "__reactHandles$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalRootNodeResourcesKey = "__reactResources$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalHoistableMarker = "__reactMarker$" + $b25c2e442c996fe7$var$randomKey;
function $b25c2e442c996fe7$var$detachDeletedInstance(node) {
    delete node[$b25c2e442c996fe7$var$internalInstanceKey];
    delete node[$b25c2e442c996fe7$var$internalPropsKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlersKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlerListenersKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlesSetKey];
}
function $b25c2e442c996fe7$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b25c2e442c996fe7$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b25c2e442c996fe7$var$internalContainerInstanceKey] || parentNode[$b25c2e442c996fe7$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b25c2e442c996fe7$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b25c2e442c996fe7$var$internalInstanceKey]) return parentNode;
                targetNode = $b25c2e442c996fe7$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b25c2e442c996fe7$var$getInstanceFromNode(node) {
    if (node = node[$b25c2e442c996fe7$var$internalInstanceKey] || node[$b25c2e442c996fe7$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b25c2e442c996fe7$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(33));
}
function $b25c2e442c996fe7$var$getResourcesFromRoot(root) {
    var resources = root[$b25c2e442c996fe7$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b25c2e442c996fe7$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b25c2e442c996fe7$var$markNodeAsHoistable(node) {
    node[$b25c2e442c996fe7$var$internalHoistableMarker] = !0;
}
var $b25c2e442c996fe7$var$allNativeEvents = new Set(), $b25c2e442c996fe7$var$registrationNameDependencies = {};
function $b25c2e442c996fe7$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b25c2e442c996fe7$var$registerDirectEvent(registrationName, dependencies);
    $b25c2e442c996fe7$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b25c2e442c996fe7$var$registerDirectEvent(registrationName, dependencies) {
    $b25c2e442c996fe7$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b25c2e442c996fe7$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b25c2e442c996fe7$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b25c2e442c996fe7$var$illegalAttributeNameCache = {}, $b25c2e442c996fe7$var$validatedAttributeNameCache = {};
function $b25c2e442c996fe7$var$isAttributeNameSafe(attributeName) {
    if ($b25c2e442c996fe7$var$hasOwnProperty.call($b25c2e442c996fe7$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b25c2e442c996fe7$var$hasOwnProperty.call($b25c2e442c996fe7$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b25c2e442c996fe7$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b25c2e442c996fe7$var$validatedAttributeNameCache[attributeName] = !0;
    $b25c2e442c996fe7$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b25c2e442c996fe7$var$setValueForAttribute(node, name, value) {
    if ($b25c2e442c996fe7$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b25c2e442c996fe7$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b25c2e442c996fe7$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $b25c2e442c996fe7$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b25c2e442c996fe7$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b25c2e442c996fe7$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b25c2e442c996fe7$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $b25c2e442c996fe7$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $b25c2e442c996fe7$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $b25c2e442c996fe7$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b25c2e442c996fe7$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b25c2e442c996fe7$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b25c2e442c996fe7$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b25c2e442c996fe7$var$getToStringValue(value);
        } else element.value !== "" + $b25c2e442c996fe7$var$getToStringValue(value) && (element.value = "" + $b25c2e442c996fe7$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b25c2e442c996fe7$var$setDefaultValue(element, type, $b25c2e442c996fe7$var$getToStringValue(value)) : null != defaultValue ? $b25c2e442c996fe7$var$setDefaultValue(element, type, $b25c2e442c996fe7$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b25c2e442c996fe7$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b25c2e442c996fe7$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $b25c2e442c996fe7$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $b25c2e442c996fe7$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b25c2e442c996fe7$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $b25c2e442c996fe7$var$track(element);
}
function $b25c2e442c996fe7$var$setDefaultValue(node, type, value) {
    "number" === type && $b25c2e442c996fe7$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b25c2e442c996fe7$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b25c2e442c996fe7$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b25c2e442c996fe7$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b25c2e442c996fe7$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b25c2e442c996fe7$var$getToStringValue(defaultValue) : "";
}
function $b25c2e442c996fe7$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(92));
            if ($b25c2e442c996fe7$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b25c2e442c996fe7$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $b25c2e442c996fe7$var$track(element);
}
function $b25c2e442c996fe7$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b25c2e442c996fe7$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b25c2e442c996fe7$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b25c2e442c996fe7$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b25c2e442c996fe7$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b25c2e442c996fe7$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b25c2e442c996fe7$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b25c2e442c996fe7$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b25c2e442c996fe7$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b25c2e442c996fe7$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b25c2e442c996fe7$var$sanitizeURL(url) {
    return $b25c2e442c996fe7$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $b25c2e442c996fe7$var$noop$1() {}
var $b25c2e442c996fe7$var$currentReplayingEvent = null;
function $b25c2e442c996fe7$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b25c2e442c996fe7$var$restoreTarget = null, $b25c2e442c996fe7$var$restoreQueue = null;
function $b25c2e442c996fe7$var$restoreStateOfTarget(target) {
    var internalInstance = $b25c2e442c996fe7$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b25c2e442c996fe7$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b25c2e442c996fe7$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b25c2e442c996fe7$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(90));
                            $b25c2e442c996fe7$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b25c2e442c996fe7$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b25c2e442c996fe7$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b25c2e442c996fe7$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b25c2e442c996fe7$var$isInsideEventHandler = !1;
function $b25c2e442c996fe7$var$batchedUpdates$1(fn, a, b) {
    if ($b25c2e442c996fe7$var$isInsideEventHandler) return fn(a, b);
    $b25c2e442c996fe7$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b25c2e442c996fe7$var$isInsideEventHandler = !1, null !== $b25c2e442c996fe7$var$restoreTarget || null !== $b25c2e442c996fe7$var$restoreQueue) {
            if ($b25c2e442c996fe7$var$flushSyncWork$1(), $b25c2e442c996fe7$var$restoreTarget && (a = $b25c2e442c996fe7$var$restoreTarget, fn = $b25c2e442c996fe7$var$restoreQueue, $b25c2e442c996fe7$var$restoreQueue = $b25c2e442c996fe7$var$restoreTarget = null, $b25c2e442c996fe7$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b25c2e442c996fe7$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b25c2e442c996fe7$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b25c2e442c996fe7$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b25c2e442c996fe7$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !1;
if ($b25c2e442c996fe7$var$canUseDOM) try {
    var $b25c2e442c996fe7$var$options = {};
    Object.defineProperty($b25c2e442c996fe7$var$options, "passive", {
        get: function() {
            $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b25c2e442c996fe7$var$options, $b25c2e442c996fe7$var$options);
    window.removeEventListener("test", $b25c2e442c996fe7$var$options, $b25c2e442c996fe7$var$options);
} catch (e) {
    $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !1;
}
var $b25c2e442c996fe7$var$root = null, $b25c2e442c996fe7$var$startText = null, $b25c2e442c996fe7$var$fallbackText = null;
function $b25c2e442c996fe7$var$getData() {
    if ($b25c2e442c996fe7$var$fallbackText) return $b25c2e442c996fe7$var$fallbackText;
    var start, startValue = $b25c2e442c996fe7$var$startText, startLength = startValue.length, end, endValue = "value" in $b25c2e442c996fe7$var$root ? $b25c2e442c996fe7$var$root.value : $b25c2e442c996fe7$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b25c2e442c996fe7$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b25c2e442c996fe7$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b25c2e442c996fe7$var$functionThatReturnsTrue() {
    return !0;
}
function $b25c2e442c996fe7$var$functionThatReturnsFalse() {
    return !1;
}
function $b25c2e442c996fe7$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b25c2e442c996fe7$var$functionThatReturnsTrue : $b25c2e442c996fe7$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b25c2e442c996fe7$var$functionThatReturnsFalse;
        return this;
    }
    $b25c2e442c996fe7$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b25c2e442c996fe7$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b25c2e442c996fe7$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b25c2e442c996fe7$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b25c2e442c996fe7$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b25c2e442c996fe7$var$SyntheticEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$EventInterface), $b25c2e442c996fe7$var$UIEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    view: 0,
    detail: 0
}), $b25c2e442c996fe7$var$SyntheticUIEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$UIEventInterface), $b25c2e442c996fe7$var$lastMovementX, $b25c2e442c996fe7$var$lastMovementY, $b25c2e442c996fe7$var$lastMouseEvent, $b25c2e442c996fe7$var$MouseEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b25c2e442c996fe7$var$lastMouseEvent && ($b25c2e442c996fe7$var$lastMouseEvent && "mousemove" === event.type ? ($b25c2e442c996fe7$var$lastMovementX = event.screenX - $b25c2e442c996fe7$var$lastMouseEvent.screenX, $b25c2e442c996fe7$var$lastMovementY = event.screenY - $b25c2e442c996fe7$var$lastMouseEvent.screenY) : $b25c2e442c996fe7$var$lastMovementY = $b25c2e442c996fe7$var$lastMovementX = 0, $b25c2e442c996fe7$var$lastMouseEvent = event);
        return $b25c2e442c996fe7$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b25c2e442c996fe7$var$lastMovementY;
    }
}), $b25c2e442c996fe7$var$SyntheticMouseEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$MouseEventInterface), $b25c2e442c996fe7$var$DragEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    dataTransfer: 0
}), $b25c2e442c996fe7$var$SyntheticDragEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$DragEventInterface), $b25c2e442c996fe7$var$FocusEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    relatedTarget: 0
}), $b25c2e442c996fe7$var$SyntheticFocusEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$FocusEventInterface), $b25c2e442c996fe7$var$AnimationEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b25c2e442c996fe7$var$SyntheticAnimationEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$AnimationEventInterface), $b25c2e442c996fe7$var$ClipboardEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b25c2e442c996fe7$var$SyntheticClipboardEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$ClipboardEventInterface), $b25c2e442c996fe7$var$CompositionEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    data: 0
}), $b25c2e442c996fe7$var$SyntheticCompositionEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$CompositionEventInterface), $b25c2e442c996fe7$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b25c2e442c996fe7$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b25c2e442c996fe7$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b25c2e442c996fe7$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b25c2e442c996fe7$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b25c2e442c996fe7$var$getEventModifierState() {
    return $b25c2e442c996fe7$var$modifierStateGetter;
}
var $b25c2e442c996fe7$var$KeyboardEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b25c2e442c996fe7$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b25c2e442c996fe7$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b25c2e442c996fe7$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b25c2e442c996fe7$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b25c2e442c996fe7$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b25c2e442c996fe7$var$SyntheticKeyboardEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$KeyboardEventInterface), $b25c2e442c996fe7$var$PointerEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b25c2e442c996fe7$var$SyntheticPointerEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$PointerEventInterface), $b25c2e442c996fe7$var$TouchEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState
}), $b25c2e442c996fe7$var$SyntheticTouchEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$TouchEventInterface), $b25c2e442c996fe7$var$TransitionEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b25c2e442c996fe7$var$SyntheticTransitionEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$TransitionEventInterface), $b25c2e442c996fe7$var$WheelEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b25c2e442c996fe7$var$SyntheticWheelEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$WheelEventInterface), $b25c2e442c996fe7$var$ToggleEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b25c2e442c996fe7$var$SyntheticToggleEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$ToggleEventInterface), $b25c2e442c996fe7$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b25c2e442c996fe7$var$canUseCompositionEvent = $b25c2e442c996fe7$var$canUseDOM && "CompositionEvent" in window, $b25c2e442c996fe7$var$documentMode = null;
$b25c2e442c996fe7$var$canUseDOM && "documentMode" in document && ($b25c2e442c996fe7$var$documentMode = document.documentMode);
var $b25c2e442c996fe7$var$canUseTextInputEvent = $b25c2e442c996fe7$var$canUseDOM && "TextEvent" in window && !$b25c2e442c996fe7$var$documentMode, $b25c2e442c996fe7$var$useFallbackCompositionData = $b25c2e442c996fe7$var$canUseDOM && (!$b25c2e442c996fe7$var$canUseCompositionEvent || $b25c2e442c996fe7$var$documentMode && 8 < $b25c2e442c996fe7$var$documentMode && 11 >= $b25c2e442c996fe7$var$documentMode), $b25c2e442c996fe7$var$SPACEBAR_CHAR = String.fromCharCode(32), $b25c2e442c996fe7$var$hasSpaceKeypress = !1;
function $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b25c2e442c996fe7$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b25c2e442c996fe7$var$isComposing = !1;
function $b25c2e442c996fe7$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b25c2e442c996fe7$var$hasSpaceKeypress = !0;
            return $b25c2e442c996fe7$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b25c2e442c996fe7$var$SPACEBAR_CHAR && $b25c2e442c996fe7$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b25c2e442c996fe7$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b25c2e442c996fe7$var$isComposing) return "compositionend" === domEventName || !$b25c2e442c996fe7$var$canUseCompositionEvent && $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b25c2e442c996fe7$var$getData(), $b25c2e442c996fe7$var$fallbackText = $b25c2e442c996fe7$var$startText = $b25c2e442c996fe7$var$root = null, $b25c2e442c996fe7$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b25c2e442c996fe7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b25c2e442c996fe7$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b25c2e442c996fe7$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b25c2e442c996fe7$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b25c2e442c996fe7$var$restoreTarget ? $b25c2e442c996fe7$var$restoreQueue ? $b25c2e442c996fe7$var$restoreQueue.push(target) : $b25c2e442c996fe7$var$restoreQueue = [
        target
    ] : $b25c2e442c996fe7$var$restoreTarget = target;
    inst = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b25c2e442c996fe7$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b25c2e442c996fe7$var$activeElement$1 = null, $b25c2e442c996fe7$var$activeElementInst$1 = null;
function $b25c2e442c996fe7$var$runEventInBatch(dispatchQueue) {
    $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, 0);
}
function $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b25c2e442c996fe7$var$getNodeFromInstance(targetInst);
    if ($b25c2e442c996fe7$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b25c2e442c996fe7$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b25c2e442c996fe7$var$isInputEventSupported = !1;
if ($b25c2e442c996fe7$var$canUseDOM) {
    var $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286;
    if ($b25c2e442c996fe7$var$canUseDOM) {
        var $b25c2e442c996fe7$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$b25c2e442c996fe7$var$isSupported$jscomp$inline_427) {
            var $b25c2e442c996fe7$var$element$jscomp$inline_428 = document.createElement("div");
            $b25c2e442c996fe7$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $b25c2e442c996fe7$var$isSupported$jscomp$inline_427 = "function" === typeof $b25c2e442c996fe7$var$element$jscomp$inline_428.oninput;
        }
        $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 = $b25c2e442c996fe7$var$isSupported$jscomp$inline_427;
    } else $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 = !1;
    $b25c2e442c996fe7$var$isInputEventSupported = $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $b25c2e442c996fe7$var$stopWatchingForValueChange() {
    $b25c2e442c996fe7$var$activeElement$1 && ($b25c2e442c996fe7$var$activeElement$1.detachEvent("onpropertychange", $b25c2e442c996fe7$var$handlePropertyChange), $b25c2e442c996fe7$var$activeElementInst$1 = $b25c2e442c996fe7$var$activeElement$1 = null);
}
function $b25c2e442c996fe7$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b25c2e442c996fe7$var$getInstIfValueChanged($b25c2e442c996fe7$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, $b25c2e442c996fe7$var$activeElementInst$1, nativeEvent, $b25c2e442c996fe7$var$getEventTarget(nativeEvent));
        $b25c2e442c996fe7$var$batchedUpdates$1($b25c2e442c996fe7$var$runEventInBatch, dispatchQueue);
    }
}
function $b25c2e442c996fe7$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b25c2e442c996fe7$var$stopWatchingForValueChange(), $b25c2e442c996fe7$var$activeElement$1 = target, $b25c2e442c996fe7$var$activeElementInst$1 = targetInst, $b25c2e442c996fe7$var$activeElement$1.attachEvent("onpropertychange", $b25c2e442c996fe7$var$handlePropertyChange)) : "focusout" === domEventName && $b25c2e442c996fe7$var$stopWatchingForValueChange();
}
function $b25c2e442c996fe7$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged($b25c2e442c996fe7$var$activeElementInst$1);
}
function $b25c2e442c996fe7$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst);
}
function $b25c2e442c996fe7$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst);
}
function $b25c2e442c996fe7$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b25c2e442c996fe7$var$objectIs = "function" === typeof Object.is ? Object.is : $b25c2e442c996fe7$var$is;
function $b25c2e442c996fe7$var$shallowEqual(objA, objB) {
    if ($b25c2e442c996fe7$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b25c2e442c996fe7$var$hasOwnProperty.call(objB, currentKey) || !$b25c2e442c996fe7$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b25c2e442c996fe7$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b25c2e442c996fe7$var$getNodeForCharacterOffset(root, offset) {
    var node = $b25c2e442c996fe7$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b25c2e442c996fe7$var$getLeafNode(node);
    }
}
function $b25c2e442c996fe7$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b25c2e442c996fe7$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b25c2e442c996fe7$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b25c2e442c996fe7$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b25c2e442c996fe7$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b25c2e442c996fe7$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $b25c2e442c996fe7$var$skipSelectionChangeEvent = $b25c2e442c996fe7$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b25c2e442c996fe7$var$activeElement = null, $b25c2e442c996fe7$var$activeElementInst = null, $b25c2e442c996fe7$var$lastSelection = null, $b25c2e442c996fe7$var$mouseDown = !1;
function $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b25c2e442c996fe7$var$mouseDown || null == $b25c2e442c996fe7$var$activeElement || $b25c2e442c996fe7$var$activeElement !== $b25c2e442c996fe7$var$getActiveElement(doc) || (doc = $b25c2e442c996fe7$var$activeElement, "selectionStart" in doc && $b25c2e442c996fe7$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b25c2e442c996fe7$var$lastSelection && $b25c2e442c996fe7$var$shallowEqual($b25c2e442c996fe7$var$lastSelection, doc) || ($b25c2e442c996fe7$var$lastSelection = doc, doc = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners($b25c2e442c996fe7$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b25c2e442c996fe7$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b25c2e442c996fe7$var$activeElement)));
}
function $b25c2e442c996fe7$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b25c2e442c996fe7$var$vendorPrefixes = {
    animationend: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionEnd")
}, $b25c2e442c996fe7$var$prefixedEventNames = {}, $b25c2e442c996fe7$var$style = {};
$b25c2e442c996fe7$var$canUseDOM && ($b25c2e442c996fe7$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b25c2e442c996fe7$var$vendorPrefixes.animationend.animation, delete $b25c2e442c996fe7$var$vendorPrefixes.animationiteration.animation, delete $b25c2e442c996fe7$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b25c2e442c996fe7$var$vendorPrefixes.transitionend.transition);
function $b25c2e442c996fe7$var$getVendorPrefixedEventName(eventName) {
    if ($b25c2e442c996fe7$var$prefixedEventNames[eventName]) return $b25c2e442c996fe7$var$prefixedEventNames[eventName];
    if (!$b25c2e442c996fe7$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b25c2e442c996fe7$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b25c2e442c996fe7$var$style) return $b25c2e442c996fe7$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b25c2e442c996fe7$var$ANIMATION_END = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationend"), $b25c2e442c996fe7$var$ANIMATION_ITERATION = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationiteration"), $b25c2e442c996fe7$var$ANIMATION_START = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationstart"), $b25c2e442c996fe7$var$TRANSITION_RUN = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionrun"), $b25c2e442c996fe7$var$TRANSITION_START = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionstart"), $b25c2e442c996fe7$var$TRANSITION_CANCEL = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitioncancel"), $b25c2e442c996fe7$var$TRANSITION_END = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionend"), $b25c2e442c996fe7$var$topLevelEventsToReactNames = new Map(), $b25c2e442c996fe7$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$b25c2e442c996fe7$var$simpleEventPluginEvents.push("scrollEnd");
function $b25c2e442c996fe7$var$registerSimpleEvent(domEventName, reactName) {
    $b25c2e442c996fe7$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b25c2e442c996fe7$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b25c2e442c996fe7$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b25c2e442c996fe7$var$concurrentQueues = [], $b25c2e442c996fe7$var$concurrentQueuesIndex = 0, $b25c2e442c996fe7$var$concurrentlyUpdatedLanes = 0;
function $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b25c2e442c996fe7$var$concurrentQueuesIndex, i = $b25c2e442c996fe7$var$concurrentlyUpdatedLanes = $b25c2e442c996fe7$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var queue = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var update = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var lane = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = fiber;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = queue;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = update;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = lane;
    $b25c2e442c996fe7$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $b25c2e442c996fe7$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $b25c2e442c996fe7$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b25c2e442c996fe7$var$nestedUpdateCount) throw $b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = null, Error($b25c2e442c996fe7$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b25c2e442c996fe7$var$emptyContextObject = {};
function $b25c2e442c996fe7$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b25c2e442c996fe7$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b25c2e442c996fe7$var$FiberNode(tag, pendingProps, key, mode);
}
function $b25c2e442c996fe7$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b25c2e442c996fe7$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b25c2e442c996fe7$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b25c2e442c996fe7$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b25c2e442c996fe7$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b25c2e442c996fe7$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b25c2e442c996fe7$var$isHostHoistableType(type, pendingProps, $b25c2e442c996fe7$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE:
            return $b25c2e442c996fe7$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b25c2e442c996fe7$var$REACT_PROFILER_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b25c2e442c996fe7$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b25c2e442c996fe7$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b25c2e442c996fe7$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b25c2e442c996fe7$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b25c2e442c996fe7$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b25c2e442c996fe7$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b25c2e442c996fe7$var$createFiberFromText(content, mode, lanes) {
    content = $b25c2e442c996fe7$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $b25c2e442c996fe7$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $b25c2e442c996fe7$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b25c2e442c996fe7$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $b25c2e442c996fe7$var$CapturedStacks = new WeakMap();
function $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b25c2e442c996fe7$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(source)
        };
        $b25c2e442c996fe7$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(source)
    };
}
var $b25c2e442c996fe7$var$forkStack = [], $b25c2e442c996fe7$var$forkStackIndex = 0, $b25c2e442c996fe7$var$treeForkProvider = null, $b25c2e442c996fe7$var$treeForkCount = 0, $b25c2e442c996fe7$var$idStack = [], $b25c2e442c996fe7$var$idStackIndex = 0, $b25c2e442c996fe7$var$treeContextProvider = null, $b25c2e442c996fe7$var$treeContextId = 1, $b25c2e442c996fe7$var$treeContextOverflow = "";
function $b25c2e442c996fe7$var$pushTreeFork(workInProgress, totalChildren) {
    $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex++] = $b25c2e442c996fe7$var$treeForkCount;
    $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex++] = $b25c2e442c996fe7$var$treeForkProvider;
    $b25c2e442c996fe7$var$treeForkProvider = workInProgress;
    $b25c2e442c996fe7$var$treeForkCount = totalChildren;
}
function $b25c2e442c996fe7$var$pushTreeId(workInProgress, totalChildren, index) {
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextId;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextOverflow;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextProvider;
    $b25c2e442c996fe7$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b25c2e442c996fe7$var$treeContextId;
    workInProgress = $b25c2e442c996fe7$var$treeContextOverflow;
    var baseLength = 32 - $b25c2e442c996fe7$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b25c2e442c996fe7$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b25c2e442c996fe7$var$treeContextId = 1 << 32 - $b25c2e442c996fe7$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b25c2e442c996fe7$var$treeContextOverflow = length + workInProgress;
    } else $b25c2e442c996fe7$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b25c2e442c996fe7$var$treeContextOverflow = workInProgress;
}
function $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b25c2e442c996fe7$var$pushTreeFork(workInProgress, 1), $b25c2e442c996fe7$var$pushTreeId(workInProgress, 1, 0));
}
function $b25c2e442c996fe7$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b25c2e442c996fe7$var$treeForkProvider;)$b25c2e442c996fe7$var$treeForkProvider = $b25c2e442c996fe7$var$forkStack[--$b25c2e442c996fe7$var$forkStackIndex], $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex] = null, $b25c2e442c996fe7$var$treeForkCount = $b25c2e442c996fe7$var$forkStack[--$b25c2e442c996fe7$var$forkStackIndex], $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex] = null;
    for(; workInProgress === $b25c2e442c996fe7$var$treeContextProvider;)$b25c2e442c996fe7$var$treeContextProvider = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null, $b25c2e442c996fe7$var$treeContextOverflow = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null, $b25c2e442c996fe7$var$treeContextId = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null;
}
function $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextId;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextOverflow;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextProvider;
    $b25c2e442c996fe7$var$treeContextId = suspendedContext.id;
    $b25c2e442c996fe7$var$treeContextOverflow = suspendedContext.overflow;
    $b25c2e442c996fe7$var$treeContextProvider = workInProgress;
}
var $b25c2e442c996fe7$var$hydrationParentFiber = null, $b25c2e442c996fe7$var$nextHydratableInstance = null, $b25c2e442c996fe7$var$isHydrating = !1, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, $b25c2e442c996fe7$var$HydrationMismatchException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(519));
function $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b25c2e442c996fe7$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(error, fiber));
    throw $b25c2e442c996fe7$var$HydrationMismatchException;
}
function $b25c2e442c996fe7$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b25c2e442c996fe7$var$internalInstanceKey] = fiber;
    instance[$b25c2e442c996fe7$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("cancel", instance);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b25c2e442c996fe7$var$mediaEventTypes.length; type++)$b25c2e442c996fe7$var$listenToNonDelegatedEvent($b25c2e442c996fe7$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", instance);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance);
            $b25c2e442c996fe7$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance), $b25c2e442c996fe7$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b25c2e442c996fe7$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", instance), $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b25c2e442c996fe7$var$noop$1), instance = !0) : instance = !1;
    instance || $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber, !0);
}
function $b25c2e442c996fe7$var$popToNextHostParent(fiber) {
    for($b25c2e442c996fe7$var$hydrationParentFiber = fiber.return; $b25c2e442c996fe7$var$hydrationParentFiber;)switch($b25c2e442c996fe7$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $b25c2e442c996fe7$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $b25c2e442c996fe7$var$rootOrSingletonContext = !0;
            return;
        default:
            $b25c2e442c996fe7$var$hydrationParentFiber = $b25c2e442c996fe7$var$hydrationParentFiber.return;
    }
}
function $b25c2e442c996fe7$var$popHydrationState(fiber) {
    if (fiber !== $b25c2e442c996fe7$var$hydrationParentFiber) return !1;
    if (!$b25c2e442c996fe7$var$isHydrating) return $b25c2e442c996fe7$var$popToNextHostParent(fiber), $b25c2e442c996fe7$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b25c2e442c996fe7$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $b25c2e442c996fe7$var$nextHydratableInstance && $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber);
    $b25c2e442c996fe7$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $b25c2e442c996fe7$var$nextHydratableInstance, $b25c2e442c996fe7$var$isSingletonScope(fiber.type) ? (fiber = $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton, $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = null, $b25c2e442c996fe7$var$nextHydratableInstance = fiber) : $b25c2e442c996fe7$var$nextHydratableInstance = tag) : $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$hydrationParentFiber ? $b25c2e442c996fe7$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b25c2e442c996fe7$var$resetHydrationState() {
    $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$hydrationParentFiber = null;
    $b25c2e442c996fe7$var$isHydrating = !1;
}
function $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $b25c2e442c996fe7$var$hydrationErrors;
    null !== queuedErrors && (null === $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors ? $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = queuedErrors : $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors.push.apply($b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, queuedErrors), $b25c2e442c996fe7$var$hydrationErrors = null);
    return queuedErrors;
}
function $b25c2e442c996fe7$var$queueHydrationError(error) {
    null === $b25c2e442c996fe7$var$hydrationErrors ? $b25c2e442c996fe7$var$hydrationErrors = [
        error
    ] : $b25c2e442c996fe7$var$hydrationErrors.push(error);
}
var $b25c2e442c996fe7$var$valueCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null, $b25c2e442c996fe7$var$lastContextDependency = null;
function $b25c2e442c996fe7$var$pushProvider(providerFiber, context, nextValue) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b25c2e442c996fe7$var$popProvider(context) {
    context._currentValue = $b25c2e442c996fe7$var$valueCursor.current;
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$valueCursor);
}
function $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b25c2e442c996fe7$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b25c2e442c996fe7$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b25c2e442c996fe7$var$HostTransitionContext) : current = [
                $b25c2e442c996fe7$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b25c2e442c996fe7$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b25c2e442c996fe7$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b25c2e442c996fe7$var$prepareToReadContext(workInProgress) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = workInProgress;
    $b25c2e442c996fe7$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b25c2e442c996fe7$var$readContext(context) {
    return $b25c2e442c996fe7$var$readContextForConsumer($b25c2e442c996fe7$var$currentlyRenderingFiber$1, context);
}
function $b25c2e442c996fe7$var$readContextDuringReconciliation(consumer, context) {
    null === $b25c2e442c996fe7$var$currentlyRenderingFiber$1 && $b25c2e442c996fe7$var$prepareToReadContext(consumer);
    return $b25c2e442c996fe7$var$readContextForConsumer(consumer, context);
}
function $b25c2e442c996fe7$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b25c2e442c996fe7$var$lastContextDependency) {
        if (null === consumer) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(308));
        $b25c2e442c996fe7$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$lastContextDependency.next = context;
    return value;
}
var $b25c2e442c996fe7$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b25c2e442c996fe7$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $b25c2e442c996fe7$var$NormalPriority = $bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$CacheContext = {
    $$typeof: $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b25c2e442c996fe7$var$createCache() {
    return {
        controller: new $b25c2e442c996fe7$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b25c2e442c996fe7$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b25c2e442c996fe7$var$scheduleCallback$2($b25c2e442c996fe7$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b25c2e442c996fe7$var$currentEntangledListeners = null, $b25c2e442c996fe7$var$currentEntangledPendingCount = 0, $b25c2e442c996fe7$var$currentEntangledLane = 0, $b25c2e442c996fe7$var$currentEntangledActionThenable = null;
function $b25c2e442c996fe7$var$entangleAsyncAction(transition, thenable) {
    if (null === $b25c2e442c996fe7$var$currentEntangledListeners) {
        var entangledListeners = $b25c2e442c996fe7$var$currentEntangledListeners = [];
        $b25c2e442c996fe7$var$currentEntangledPendingCount = 0;
        $b25c2e442c996fe7$var$currentEntangledLane = $b25c2e442c996fe7$var$requestTransitionLane();
        $b25c2e442c996fe7$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b25c2e442c996fe7$var$currentEntangledPendingCount++;
    thenable.then($b25c2e442c996fe7$var$pingEngtangledActionScope, $b25c2e442c996fe7$var$pingEngtangledActionScope);
    return thenable;
}
function $b25c2e442c996fe7$var$pingEngtangledActionScope() {
    if (0 === --$b25c2e442c996fe7$var$currentEntangledPendingCount && null !== $b25c2e442c996fe7$var$currentEntangledListeners) {
        null !== $b25c2e442c996fe7$var$currentEntangledActionThenable && ($b25c2e442c996fe7$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b25c2e442c996fe7$var$currentEntangledListeners;
        $b25c2e442c996fe7$var$currentEntangledListeners = null;
        $b25c2e442c996fe7$var$currentEntangledLane = 0;
        $b25c2e442c996fe7$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b25c2e442c996fe7$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b25c2e442c996fe7$var$prevOnStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
$b25c2e442c996fe7$var$ReactSharedInternals.S = function(transition, returnValue) {
    $b25c2e442c996fe7$var$globalMostRecentTransitionTime = $b25c2e442c996fe7$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b25c2e442c996fe7$var$entangleAsyncAction(transition, returnValue);
    null !== $b25c2e442c996fe7$var$prevOnStartTransitionFinish && $b25c2e442c996fe7$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b25c2e442c996fe7$var$resumedCache = $b25c2e442c996fe7$var$createCursor(null);
function $b25c2e442c996fe7$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b25c2e442c996fe7$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b25c2e442c996fe7$var$workInProgressRoot.pooledCache;
}
function $b25c2e442c996fe7$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$resumedCache, $b25c2e442c996fe7$var$resumedCache.current) : $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$resumedCache, prevCachePool.pool);
}
function $b25c2e442c996fe7$var$getSuspendedCache() {
    var cacheFromPool = $b25c2e442c996fe7$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b25c2e442c996fe7$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b25c2e442c996fe7$var$SuspenseException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(460)), $b25c2e442c996fe7$var$SuspenseyCommitException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(474)), $b25c2e442c996fe7$var$SuspenseActionException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(542)), $b25c2e442c996fe7$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b25c2e442c996fe7$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b25c2e442c996fe7$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b25c2e442c996fe7$var$noop$1, $b25c2e442c996fe7$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b25c2e442c996fe7$var$noop$1, $b25c2e442c996fe7$var$noop$1);
            else {
                thenableState = $b25c2e442c996fe7$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $b25c2e442c996fe7$var$suspendedThenable = thenable;
            throw $b25c2e442c996fe7$var$SuspenseException;
    }
}
function $b25c2e442c996fe7$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $b25c2e442c996fe7$var$suspendedThenable = x, $b25c2e442c996fe7$var$SuspenseException;
        throw x;
    }
}
var $b25c2e442c996fe7$var$suspendedThenable = null;
function $b25c2e442c996fe7$var$getSuspendedThenable() {
    if (null === $b25c2e442c996fe7$var$suspendedThenable) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(459));
    var thenable = $b25c2e442c996fe7$var$suspendedThenable;
    $b25c2e442c996fe7$var$suspendedThenable = null;
    return thenable;
}
function $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $b25c2e442c996fe7$var$SuspenseException || rejectedReason === $b25c2e442c996fe7$var$SuspenseActionException) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(483));
}
var $b25c2e442c996fe7$var$thenableState$1 = null, $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
function $b25c2e442c996fe7$var$unwrapThenable(thenable) {
    var index = $b25c2e442c996fe7$var$thenableIndexCounter$1;
    $b25c2e442c996fe7$var$thenableIndexCounter$1 += 1;
    null === $b25c2e442c996fe7$var$thenableState$1 && ($b25c2e442c996fe7$var$thenableState$1 = []);
    return $b25c2e442c996fe7$var$trackUsedThenable($b25c2e442c996fe7$var$thenableState$1, thenable, index);
}
function $b25c2e442c996fe7$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b25c2e442c996fe7$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b25c2e442c996fe7$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b25c2e442c996fe7$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b25c2e442c996fe7$var$REACT_LAZY_TYPE && $b25c2e442c996fe7$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b25c2e442c996fe7$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b25c2e442c996fe7$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b25c2e442c996fe7$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b25c2e442c996fe7$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b25c2e442c996fe7$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return lanes = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b25c2e442c996fe7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return newChild = $b25c2e442c996fe7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return newChild = $b25c2e442c996fe7$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b25c2e442c996fe7$var$REACT_LAZY_TYPE && $b25c2e442c996fe7$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b25c2e442c996fe7$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE ? (lanes = $b25c2e442c996fe7$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b25c2e442c996fe7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b25c2e442c996fe7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b25c2e442c996fe7$var$getIteratorFn(newChild)) {
                key = $b25c2e442c996fe7$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b25c2e442c996fe7$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b25c2e442c996fe7$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b25c2e442c996fe7$var$SuspenseException || x === $b25c2e442c996fe7$var$SuspenseActionException) throw x;
            var fiber = $b25c2e442c996fe7$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b25c2e442c996fe7$var$reconcileChildFibers = $b25c2e442c996fe7$var$createChildReconciler(!0), $b25c2e442c996fe7$var$mountChildFibers = $b25c2e442c996fe7$var$createChildReconciler(!1), $b25c2e442c996fe7$var$hasForceUpdate = !1;
function $b25c2e442c996fe7$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b25c2e442c996fe7$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b25c2e442c996fe7$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
        $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b25c2e442c996fe7$var$markRootEntangled(root, lane);
    }
}
function $b25c2e442c996fe7$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !1;
function $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b25c2e442c996fe7$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b25c2e442c996fe7$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b25c2e442c996fe7$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b25c2e442c996fe7$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b25c2e442c996fe7$var$currentEntangledLane && ($b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b25c2e442c996fe7$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b25c2e442c996fe7$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b25c2e442c996fe7$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b25c2e442c996fe7$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b25c2e442c996fe7$var$callCallback(callbacks[updateQueue], context);
}
var $b25c2e442c996fe7$var$currentTreeHiddenStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$prevEntangledRenderLanesCursor = $b25c2e442c996fe7$var$createCursor(0);
function $b25c2e442c996fe7$var$pushHiddenContext(fiber, context) {
    fiber = $b25c2e442c996fe7$var$entangledRenderLanes;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor, fiber);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$currentTreeHiddenStackCursor, context);
    $b25c2e442c996fe7$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b25c2e442c996fe7$var$reuseHiddenContextOnStack() {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor, $b25c2e442c996fe7$var$entangledRenderLanes);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$currentTreeHiddenStackCursor, $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current);
}
function $b25c2e442c996fe7$var$popHiddenContext() {
    $b25c2e442c996fe7$var$entangledRenderLanes = $b25c2e442c996fe7$var$prevEntangledRenderLanesCursor.current;
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$currentTreeHiddenStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor);
}
var $b25c2e442c996fe7$var$suspenseHandlerStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$shellBoundary = null;
function $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current & 1);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, handler);
    null === $b25c2e442c996fe7$var$shellBoundary && (null === current || null !== $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current ? $b25c2e442c996fe7$var$shellBoundary = handler : null !== current.memoizedState && ($b25c2e442c996fe7$var$shellBoundary = handler));
}
function $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, fiber);
    null === $b25c2e442c996fe7$var$shellBoundary && ($b25c2e442c996fe7$var$shellBoundary = fiber);
}
function $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current), $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, fiber), null === $b25c2e442c996fe7$var$shellBoundary && ($b25c2e442c996fe7$var$shellBoundary = fiber)) : $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack() {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current);
}
function $b25c2e442c996fe7$var$popSuspenseHandler(fiber) {
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseHandlerStackCursor);
    $b25c2e442c996fe7$var$shellBoundary === fiber && ($b25c2e442c996fe7$var$shellBoundary = null);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
}
var $b25c2e442c996fe7$var$suspenseStackCursor = $b25c2e442c996fe7$var$createCursor(0);
function $b25c2e442c996fe7$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $b25c2e442c996fe7$var$isSuspenseInstancePending(state) || $b25c2e442c996fe7$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $b25c2e442c996fe7$var$renderLanes = 0, $b25c2e442c996fe7$var$currentlyRenderingFiber = null, $b25c2e442c996fe7$var$currentHook = null, $b25c2e442c996fe7$var$workInProgressHook = null, $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1, $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b25c2e442c996fe7$var$localIdCounter = 0, $b25c2e442c996fe7$var$thenableIndexCounter = 0, $b25c2e442c996fe7$var$thenableState = null, $b25c2e442c996fe7$var$globalClientIdCounter = 0;
function $b25c2e442c996fe7$var$throwInvalidHookError() {
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(321));
}
function $b25c2e442c996fe7$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b25c2e442c996fe7$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b25c2e442c996fe7$var$renderLanes = nextRenderLanes;
    $b25c2e442c996fe7$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b25c2e442c996fe7$var$HooksDispatcherOnMount : $b25c2e442c996fe7$var$HooksDispatcherOnUpdate;
    $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b25c2e442c996fe7$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b25c2e442c996fe7$var$finishRenderingHooks(current) {
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b25c2e442c996fe7$var$currentHook && null !== $b25c2e442c996fe7$var$currentHook.next;
    $b25c2e442c996fe7$var$renderLanes = 0;
    $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1;
    $b25c2e442c996fe7$var$thenableIndexCounter = 0;
    $b25c2e442c996fe7$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(300));
    null === current || $b25c2e442c996fe7$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b25c2e442c996fe7$var$checkIfContextChanged(current) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0));
}
function $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b25c2e442c996fe7$var$thenableState = null);
        $b25c2e442c996fe7$var$thenableIndexCounter = 0;
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b25c2e442c996fe7$var$TransitionAwareHostComponent() {
    var dispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b25c2e442c996fe7$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b25c2e442c996fe7$var$currentHook ? $b25c2e442c996fe7$var$currentHook.memoizedState : null) !== dispatcher && ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $b25c2e442c996fe7$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b25c2e442c996fe7$var$localIdCounter;
    $b25c2e442c996fe7$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b25c2e442c996fe7$var$resetHooksOnUnwind(workInProgress) {
    if ($b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b25c2e442c996fe7$var$renderLanes = 0;
    $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b25c2e442c996fe7$var$thenableIndexCounter = $b25c2e442c996fe7$var$localIdCounter = 0;
    $b25c2e442c996fe7$var$thenableState = null;
}
function $b25c2e442c996fe7$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState = $b25c2e442c996fe7$var$workInProgressHook = hook : $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$workInProgressHook.next = hook;
    return $b25c2e442c996fe7$var$workInProgressHook;
}
function $b25c2e442c996fe7$var$updateWorkInProgressHook() {
    if (null === $b25c2e442c996fe7$var$currentHook) {
        var nextCurrentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b25c2e442c996fe7$var$currentHook.next;
    var nextWorkInProgressHook = null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState : $b25c2e442c996fe7$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b25c2e442c996fe7$var$workInProgressHook = nextWorkInProgressHook, $b25c2e442c996fe7$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(467));
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(310));
        }
        $b25c2e442c996fe7$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b25c2e442c996fe7$var$currentHook.memoizedState,
            baseState: $b25c2e442c996fe7$var$currentHook.baseState,
            baseQueue: $b25c2e442c996fe7$var$currentHook.baseQueue,
            queue: $b25c2e442c996fe7$var$currentHook.queue,
            next: null
        };
        null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState = $b25c2e442c996fe7$var$workInProgressHook = nextCurrentHook : $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b25c2e442c996fe7$var$workInProgressHook;
}
function $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $b25c2e442c996fe7$var$useThenable(thenable) {
    var index = $b25c2e442c996fe7$var$thenableIndexCounter;
    $b25c2e442c996fe7$var$thenableIndexCounter += 1;
    null === $b25c2e442c996fe7$var$thenableState && ($b25c2e442c996fe7$var$thenableState = []);
    thenable = $b25c2e442c996fe7$var$trackUsedThenable($b25c2e442c996fe7$var$thenableState, thenable, index);
    index = $b25c2e442c996fe7$var$currentlyRenderingFiber;
    null === (null === $b25c2e442c996fe7$var$workInProgressHook ? index.memoizedState : $b25c2e442c996fe7$var$workInProgressHook.next) && (index = index.alternate, $b25c2e442c996fe7$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b25c2e442c996fe7$var$HooksDispatcherOnMount : $b25c2e442c996fe7$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b25c2e442c996fe7$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b25c2e442c996fe7$var$useThenable(usable);
        if (usable.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return $b25c2e442c996fe7$var$readContext(usable);
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(438, String(usable)));
}
function $b25c2e442c996fe7$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b25c2e442c996fe7$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b25c2e442c996fe7$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b25c2e442c996fe7$var$updateReducer(reducer) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    return $b25c2e442c996fe7$var$updateReducerImpl(hook, $b25c2e442c996fe7$var$currentHook, reducer);
}
function $b25c2e442c996fe7$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b25c2e442c996fe7$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b25c2e442c996fe7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($b25c2e442c996fe7$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b25c2e442c996fe7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= revertLane, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= updateLane, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b25c2e442c996fe7$var$objectIs(pendingQueue, hook.memoizedState) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $b25c2e442c996fe7$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b25c2e442c996fe7$var$rerenderReducer(reducer) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b25c2e442c996fe7$var$objectIs(newState, hook.memoizedState) || ($b25c2e442c996fe7$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b25c2e442c996fe7$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b25c2e442c996fe7$var$currentlyRenderingFiber, hook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b25c2e442c996fe7$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b25c2e442c996fe7$var$objectIs(($b25c2e442c996fe7$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b25c2e442c996fe7$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $b25c2e442c996fe7$var$updateEffect($b25c2e442c996fe7$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b25c2e442c996fe7$var$workInProgressHook && $b25c2e442c996fe7$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b25c2e442c996fe7$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b25c2e442c996fe7$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $b25c2e442c996fe7$var$workInProgressRoot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b25c2e442c996fe7$var$renderLanes & 127) || $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b25c2e442c996fe7$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) && $b25c2e442c996fe7$var$forceStoreRerender(fiber);
}
function $b25c2e442c996fe7$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) && $b25c2e442c996fe7$var$forceStoreRerender(fiber);
    });
}
function $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b25c2e442c996fe7$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b25c2e442c996fe7$var$forceStoreRerender(fiber) {
    var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b25c2e442c996fe7$var$mountStateImpl(initialState) {
    var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b25c2e442c996fe7$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b25c2e442c996fe7$var$updateReducerImpl(hook, $b25c2e442c996fe7$var$currentHook, "function" === typeof reducer ? reducer : $b25c2e442c996fe7$var$basicStateReducer);
}
function $b25c2e442c996fe7$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b25c2e442c996fe7$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b25c2e442c996fe7$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b25c2e442c996fe7$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, currentTransition = {};
        $b25c2e442c996fe7$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b25c2e442c996fe7$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $b25c2e442c996fe7$var$onActionError(actionQueue, node, error$66);
    }
}
function $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b25c2e442c996fe7$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b25c2e442c996fe7$var$onActionError(actionQueue, node, error);
    }) : $b25c2e442c996fe7$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b25c2e442c996fe7$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b25c2e442c996fe7$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b25c2e442c996fe7$var$runActionStateAction(actionQueue, nextState)));
}
function $b25c2e442c996fe7$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b25c2e442c996fe7$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b25c2e442c996fe7$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b25c2e442c996fe7$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b25c2e442c996fe7$var$mountActionState(action, initialStateProp) {
    if ($b25c2e442c996fe7$var$isHydrating) {
        var ssrFormState = $b25c2e442c996fe7$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b25c2e442c996fe7$var$currentlyRenderingFiber;
                if ($b25c2e442c996fe7$var$isHydrating) {
                    if ($b25c2e442c996fe7$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b25c2e442c996fe7$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b25c2e442c996fe7$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b25c2e442c996fe7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b25c2e442c996fe7$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b25c2e442c996fe7$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b25c2e442c996fe7$var$dispatchSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b25c2e442c996fe7$var$mountStateImpl(!1);
    inRootOrSingleton = $b25c2e442c996fe7$var$dispatchOptimisticSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b25c2e442c996fe7$var$dispatchActionState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b25c2e442c996fe7$var$updateActionState(action) {
    var stateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    return $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, $b25c2e442c996fe7$var$currentHook, action);
}
function $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b25c2e442c996fe7$var$updateReducerImpl(stateHook, currentStateHook, $b25c2e442c996fe7$var$actionStateReducer)[0];
    stateHook = $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $b25c2e442c996fe7$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $b25c2e442c996fe7$var$SuspenseException) throw $b25c2e442c996fe7$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 2048, $b25c2e442c996fe7$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $b25c2e442c996fe7$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $b25c2e442c996fe7$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b25c2e442c996fe7$var$rerenderActionState(action) {
    var stateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), currentStateHook = $b25c2e442c996fe7$var$currentHook;
    if (null !== currentStateHook) return $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b25c2e442c996fe7$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b25c2e442c996fe7$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $b25c2e442c996fe7$var$updateRef() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $b25c2e442c996fe7$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b25c2e442c996fe7$var$currentHook && null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, $b25c2e442c996fe7$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $b25c2e442c996fe7$var$mountEffect(create, deps) {
    $b25c2e442c996fe7$var$mountEffectImpl(8390656, 8, create, deps);
}
function $b25c2e442c996fe7$var$updateEffect(create, deps) {
    $b25c2e442c996fe7$var$updateEffectImpl(2048, 8, create, deps);
}
function $b25c2e442c996fe7$var$useEffectEventImpl(payload) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $b25c2e442c996fe7$var$updateEvent(callback) {
    var ref = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
    $b25c2e442c996fe7$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $b25c2e442c996fe7$var$updateInsertionEffect(create, deps) {
    return $b25c2e442c996fe7$var$updateEffectImpl(4, 2, create, deps);
}
function $b25c2e442c996fe7$var$updateLayoutEffect(create, deps) {
    return $b25c2e442c996fe7$var$updateEffectImpl(4, 4, create, deps);
}
function $b25c2e442c996fe7$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b25c2e442c996fe7$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b25c2e442c996fe7$var$updateEffectImpl(4, 4, $b25c2e442c996fe7$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b25c2e442c996fe7$var$mountDebugValue() {}
function $b25c2e442c996fe7$var$updateCallback(callback, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b25c2e442c996fe7$var$updateMemo(nextCreate, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b25c2e442c996fe7$var$renderLanes & 1073741824) && 0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b25c2e442c996fe7$var$requestDeferredLane();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= hook;
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b25c2e442c996fe7$var$objectIs(value, prevValue)) return value;
    if (null !== $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current) return hook = $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue), $b25c2e442c996fe7$var$objectIs(hook, prevValue) || ($b25c2e442c996fe7$var$didReceiveUpdate = !0), hook;
    if (0 === ($b25c2e442c996fe7$var$renderLanes & 42) || 0 !== ($b25c2e442c996fe7$var$renderLanes & 1073741824) && 0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 261930)) return $b25c2e442c996fe7$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b25c2e442c996fe7$var$requestDeferredLane();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= hook;
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b25c2e442c996fe7$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, currentTransition = {};
    $b25c2e442c996fe7$var$ReactSharedInternals.T = currentTransition;
    $b25c2e442c996fe7$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b25c2e442c996fe7$var$chainThenableValue(returnValue, finishedState);
            $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b25c2e442c996fe7$var$requestUpdateLane(fiber));
        } else $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, finishedState, $b25c2e442c996fe7$var$requestUpdateLane(fiber));
    } catch (error) {
        $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b25c2e442c996fe7$var$requestUpdateLane());
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$noop() {}
function $b25c2e442c996fe7$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(476));
    var queue = $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber).queue;
    $b25c2e442c996fe7$var$startTransition(formFiber, queue, pendingState, $b25c2e442c996fe7$var$sharedNotPendingObject, null === action ? $b25c2e442c996fe7$var$noop : function() {
        $b25c2e442c996fe7$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b25c2e442c996fe7$var$sharedNotPendingObject,
        baseState: $b25c2e442c996fe7$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
            lastRenderedState: $b25c2e442c996fe7$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b25c2e442c996fe7$var$requestFormReset$1(formFiber) {
    var stateHook = $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $b25c2e442c996fe7$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $b25c2e442c996fe7$var$requestUpdateLane());
}
function $b25c2e442c996fe7$var$useHostTransitionStatus() {
    return $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$HostTransitionContext);
}
function $b25c2e442c996fe7$var$updateId() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$updateRefresh() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b25c2e442c996fe7$var$requestUpdateLane();
                fiber = $b25c2e442c996fe7$var$createUpdate(lane);
                var root$69 = $b25c2e442c996fe7$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(root$69, provider, lane), $b25c2e442c996fe7$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $b25c2e442c996fe7$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b25c2e442c996fe7$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b25c2e442c996fe7$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber) ? $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(action, fiber, lane), $b25c2e442c996fe7$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b25c2e442c996fe7$var$dispatchSetState(fiber, queue, action) {
    var lane = $b25c2e442c996fe7$var$requestUpdateLane();
    $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b25c2e442c996fe7$var$objectIs(eagerState, currentState)) return $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b25c2e442c996fe7$var$workInProgressRoot && $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b25c2e442c996fe7$var$scheduleUpdateOnFiber(action, fiber, lane), $b25c2e442c996fe7$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b25c2e442c996fe7$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b25c2e442c996fe7$var$currentlyRenderingFiber || null !== alternate && alternate === $b25c2e442c996fe7$var$currentlyRenderingFiber;
}
function $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, update) {
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b25c2e442c996fe7$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b25c2e442c996fe7$var$markRootEntangled(root, lane);
    }
}
var $b25c2e442c996fe7$var$ContextOnlyDispatcher = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$throwInvalidHookError,
    useContext: $b25c2e442c996fe7$var$throwInvalidHookError,
    useEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useImperativeHandle: $b25c2e442c996fe7$var$throwInvalidHookError,
    useLayoutEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useInsertionEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useMemo: $b25c2e442c996fe7$var$throwInvalidHookError,
    useReducer: $b25c2e442c996fe7$var$throwInvalidHookError,
    useRef: $b25c2e442c996fe7$var$throwInvalidHookError,
    useState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useDebugValue: $b25c2e442c996fe7$var$throwInvalidHookError,
    useDeferredValue: $b25c2e442c996fe7$var$throwInvalidHookError,
    useTransition: $b25c2e442c996fe7$var$throwInvalidHookError,
    useSyncExternalStore: $b25c2e442c996fe7$var$throwInvalidHookError,
    useId: $b25c2e442c996fe7$var$throwInvalidHookError,
    useHostTransitionStatus: $b25c2e442c996fe7$var$throwInvalidHookError,
    useFormState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useActionState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useOptimistic: $b25c2e442c996fe7$var$throwInvalidHookError,
    useMemoCache: $b25c2e442c996fe7$var$throwInvalidHookError,
    useCacheRefresh: $b25c2e442c996fe7$var$throwInvalidHookError
};
$b25c2e442c996fe7$var$ContextOnlyDispatcher.useEffectEvent = $b25c2e442c996fe7$var$throwInvalidHookError;
var $b25c2e442c996fe7$var$HooksDispatcherOnMount = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: function(callback, deps) {
        $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b25c2e442c996fe7$var$mountEffectImpl(4194308, 4, $b25c2e442c996fe7$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b25c2e442c996fe7$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b25c2e442c996fe7$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b25c2e442c996fe7$var$dispatchReducerAction.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b25c2e442c996fe7$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b25c2e442c996fe7$var$dispatchSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        return $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b25c2e442c996fe7$var$mountStateImpl(!1);
        stateHook = $b25c2e442c996fe7$var$startTransition.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b25c2e442c996fe7$var$currentlyRenderingFiber, hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        if ($b25c2e442c996fe7$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b25c2e442c996fe7$var$workInProgressRoot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(349));
            0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 127) || $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b25c2e442c996fe7$var$mountEffect($b25c2e442c996fe7$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b25c2e442c996fe7$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b25c2e442c996fe7$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook(), identifierPrefix = $b25c2e442c996fe7$var$workInProgressRoot.identifierPrefix;
        if ($b25c2e442c996fe7$var$isHydrating) {
            var JSCompiler_inline_result = $b25c2e442c996fe7$var$treeContextOverflow;
            var idWithLeadingBit = $b25c2e442c996fe7$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b25c2e442c996fe7$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b25c2e442c996fe7$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $b25c2e442c996fe7$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$mountActionState,
    useActionState: $b25c2e442c996fe7$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $b25c2e442c996fe7$var$dispatchOptimisticSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: function() {
        return $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = $b25c2e442c996fe7$var$refreshCache.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $b25c2e442c996fe7$var$HooksDispatcherOnUpdate = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$updateCallback,
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$updateEffect,
    useImperativeHandle: $b25c2e442c996fe7$var$updateImperativeHandle,
    useInsertionEffect: $b25c2e442c996fe7$var$updateInsertionEffect,
    useLayoutEffect: $b25c2e442c996fe7$var$updateLayoutEffect,
    useMemo: $b25c2e442c996fe7$var$updateMemo,
    useReducer: $b25c2e442c996fe7$var$updateReducer,
    useRef: $b25c2e442c996fe7$var$updateRef,
    useState: function() {
        return $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer);
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, $b25c2e442c996fe7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer)[0], start = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b25c2e442c996fe7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b25c2e442c996fe7$var$updateSyncExternalStore,
    useId: $b25c2e442c996fe7$var$updateId,
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$updateActionState,
    useActionState: $b25c2e442c996fe7$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return $b25c2e442c996fe7$var$updateOptimisticImpl(hook, $b25c2e442c996fe7$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: $b25c2e442c996fe7$var$updateRefresh
};
$b25c2e442c996fe7$var$HooksDispatcherOnUpdate.useEffectEvent = $b25c2e442c996fe7$var$updateEvent;
var $b25c2e442c996fe7$var$HooksDispatcherOnRerender = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$updateCallback,
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$updateEffect,
    useImperativeHandle: $b25c2e442c996fe7$var$updateImperativeHandle,
    useInsertionEffect: $b25c2e442c996fe7$var$updateInsertionEffect,
    useLayoutEffect: $b25c2e442c996fe7$var$updateLayoutEffect,
    useMemo: $b25c2e442c996fe7$var$updateMemo,
    useReducer: $b25c2e442c996fe7$var$rerenderReducer,
    useRef: $b25c2e442c996fe7$var$updateRef,
    useState: function() {
        return $b25c2e442c996fe7$var$rerenderReducer($b25c2e442c996fe7$var$basicStateReducer);
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return null === $b25c2e442c996fe7$var$currentHook ? $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue) : $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, $b25c2e442c996fe7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b25c2e442c996fe7$var$rerenderReducer($b25c2e442c996fe7$var$basicStateReducer)[0], start = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b25c2e442c996fe7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b25c2e442c996fe7$var$updateSyncExternalStore,
    useId: $b25c2e442c996fe7$var$updateId,
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$rerenderActionState,
    useActionState: $b25c2e442c996fe7$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        if (null !== $b25c2e442c996fe7$var$currentHook) return $b25c2e442c996fe7$var$updateOptimisticImpl(hook, $b25c2e442c996fe7$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: $b25c2e442c996fe7$var$updateRefresh
};
$b25c2e442c996fe7$var$HooksDispatcherOnRerender.useEffectEvent = $b25c2e442c996fe7$var$updateEvent;
function $b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b25c2e442c996fe7$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b25c2e442c996fe7$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(payload, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(payload, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(callback, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(callback, inst, lane));
    }
};
function $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b25c2e442c996fe7$var$shallowEqual(oldProps, newProps) || !$b25c2e442c996fe7$var$shallowEqual(oldState, newState) : !0;
}
function $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b25c2e442c996fe7$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b25c2e442c996fe7$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b25c2e442c996fe7$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $b25c2e442c996fe7$var$defaultOnUncaughtError(error) {
    $b25c2e442c996fe7$var$reportGlobalError(error);
}
function $b25c2e442c996fe7$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b25c2e442c996fe7$var$defaultOnRecoverableError(error) {
    $b25c2e442c996fe7$var$reportGlobalError(error);
}
function $b25c2e442c996fe7$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $b25c2e442c996fe7$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $b25c2e442c996fe7$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b25c2e442c996fe7$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b25c2e442c996fe7$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b25c2e442c996fe7$var$createClassErrorUpdate(lane) {
    lane = $b25c2e442c996fe7$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b25c2e442c996fe7$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b25c2e442c996fe7$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b25c2e442c996fe7$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed ? $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b25c2e442c996fe7$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b25c2e442c996fe7$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $b25c2e442c996fe7$var$shellBoundary ? $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b25c2e442c996fe7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b25c2e442c996fe7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes);
        $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b25c2e442c996fe7$var$isHydrating) return returnFiber = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b25c2e442c996fe7$var$HydrationMismatchException && (root = Error($b25c2e442c996fe7$var$formatProdErrorMessage(422), {
        cause: value
    }), $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b25c2e442c996fe7$var$HydrationMismatchException && (returnFiber = Error($b25c2e442c996fe7$var$formatProdErrorMessage(423), {
        cause: value
    }), $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b25c2e442c996fe7$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b25c2e442c996fe7$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b25c2e442c996fe7$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b25c2e442c996fe7$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors ? $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b25c2e442c996fe7$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b25c2e442c996fe7$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed || !$b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b25c2e442c996fe7$var$createClassErrorUpdate(rootRenderLanes), $b25c2e442c996fe7$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b25c2e442c996fe7$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b25c2e442c996fe7$var$SelectiveHydrationException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(461)), $b25c2e442c996fe7$var$didReceiveUpdate = !1;
function $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b25c2e442c996fe7$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b25c2e442c996fe7$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    nextProps = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && key && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b25c2e442c996fe7$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b25c2e442c996fe7$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b25c2e442c996fe7$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b25c2e442c996fe7$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b25c2e442c996fe7$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b25c2e442c996fe7$var$pushHiddenContext(workInProgress, prevState) : $b25c2e442c996fe7$var$reuseHiddenContextOnStack(), $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($b25c2e442c996fe7$var$pushTransition(workInProgress, prevState.cachePool), $b25c2e442c996fe7$var$pushHiddenContext(workInProgress, prevState), $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null), $b25c2e442c996fe7$var$reuseHiddenContextOnStack(), $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $b25c2e442c996fe7$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b25c2e442c996fe7$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null);
    $b25c2e442c996fe7$var$reuseHiddenContextOnStack();
    $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $b25c2e442c996fe7$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($b25c2e442c996fe7$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, current);
            $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $b25c2e442c996fe7$var$nextHydratableInstance) ? (current = $b25c2e442c996fe7$var$canHydrateHydrationBoundary(current, $b25c2e442c996fe7$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b25c2e442c996fe7$var$treeContextProvider ? {
                    id: $b25c2e442c996fe7$var$treeContextId,
                    overflow: $b25c2e442c996fe7$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(558));
        } else if ($b25c2e442c996fe7$var$didReceiveUpdate || $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $b25c2e442c996fe7$var$didReceiveUpdate || didSuspend) {
            nextProps = $b25c2e442c996fe7$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $b25c2e442c996fe7$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(current, dehydrated), $b25c2e442c996fe7$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $b25c2e442c996fe7$var$SelectiveHydrationException;
            $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(dehydrated.nextSibling), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$isHydrating = !0, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, null !== current && $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $b25c2e442c996fe7$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $b25c2e442c996fe7$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    Component = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && nextProps && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b25c2e442c996fe7$var$finishRenderingHooks(current);
    Component = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && Component && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b25c2e442c996fe7$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b25c2e442c996fe7$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b25c2e442c996fe7$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b25c2e442c996fe7$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b25c2e442c996fe7$var$readContext(contextType) : $b25c2e442c996fe7$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b25c2e442c996fe7$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b25c2e442c996fe7$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b25c2e442c996fe7$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b25c2e442c996fe7$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b25c2e442c996fe7$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b25c2e442c996fe7$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b25c2e442c996fe7$var$hasForceUpdate || $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b25c2e442c996fe7$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b25c2e442c996fe7$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b25c2e442c996fe7$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b25c2e442c996fe7$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b25c2e442c996fe7$var$hasForceUpdate || null !== current && null !== current.dependencies && $b25c2e442c996fe7$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b25c2e442c996fe7$var$hasForceUpdate || $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b25c2e442c996fe7$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b25c2e442c996fe7$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b25c2e442c996fe7$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b25c2e442c996fe7$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b25c2e442c996fe7$var$getSuspendedCache()
    };
}
function $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b25c2e442c996fe7$var$workInProgressDeferredLane);
    return current;
}
function $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b25c2e442c996fe7$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b25c2e442c996fe7$var$isHydrating) {
            showFallback ? $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $b25c2e442c996fe7$var$nextHydratableInstance) ? (current = $b25c2e442c996fe7$var$canHydrateHydrationBoundary(current, $b25c2e442c996fe7$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b25c2e442c996fe7$var$treeContextProvider ? {
                    id: $b25c2e442c996fe7$var$treeContextId,
                    overflow: $b25c2e442c996fe7$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            $b25c2e442c996fe7$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $b25c2e442c996fe7$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps);
        $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $b25c2e442c996fe7$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, workInProgress = $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps));
        else if ($b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b25c2e442c996fe7$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b25c2e442c996fe7$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b25c2e442c996fe7$var$didReceiveUpdate || $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b25c2e442c996fe7$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b25c2e442c996fe7$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $b25c2e442c996fe7$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(current, nextProps), $b25c2e442c996fe7$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b25c2e442c996fe7$var$SelectiveHydrationException;
            $b25c2e442c996fe7$var$isSuspenseInstancePending(nextPrimaryChildren) || $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $b25c2e442c996fe7$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(nextPrimaryChildren.nextSibling), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$isHydrating = !0, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, null !== current && $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $b25c2e442c996fe7$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $b25c2e442c996fe7$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $b25c2e442c996fe7$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $b25c2e442c996fe7$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $b25c2e442c996fe7$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, $b25c2e442c996fe7$var$bailoutOffscreenComponent(current.child, nextProps);
    $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b25c2e442c996fe7$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $b25c2e442c996fe7$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $b25c2e442c996fe7$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, suspenseContext);
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $b25c2e442c996fe7$var$isHydrating ? $b25c2e442c996fe7$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b25c2e442c996fe7$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b25c2e442c996fe7$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b25c2e442c996fe7$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b25c2e442c996fe7$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b25c2e442c996fe7$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b25c2e442c996fe7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, current.memoizedState.cache);
            $b25c2e442c996fe7$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b25c2e442c996fe7$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b25c2e442c996fe7$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, current.memoizedState.cache);
    }
    return $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b25c2e442c996fe7$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b25c2e442c996fe7$var$didReceiveUpdate = !0;
        else {
            if (!$b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b25c2e442c996fe7$var$didReceiveUpdate = !1, $b25c2e442c996fe7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b25c2e442c996fe7$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b25c2e442c996fe7$var$didReceiveUpdate = !1, $b25c2e442c996fe7$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b25c2e442c996fe7$var$pushTreeId(workInProgress, $b25c2e442c996fe7$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $b25c2e442c996fe7$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $b25c2e442c996fe7$var$shouldConstruct(current) ? (props = $b25c2e442c996fe7$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $b25c2e442c996fe7$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b25c2e442c996fe7$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b25c2e442c996fe7$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $b25c2e442c996fe7$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b25c2e442c996fe7$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b25c2e442c996fe7$var$getComponentNameFromType(current) || current;
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $b25c2e442c996fe7$var$resolveClassComponentProps(props, workInProgress.pendingProps), $b25c2e442c996fe7$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress);
                $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props);
                props !== prevState.cache && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, [
                    $b25c2e442c996fe7$var$CacheContext
                ], renderLanes, !0);
                $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $b25c2e442c996fe7$var$createCapturedValueAtFiber(Error($b25c2e442c996fe7$var$formatProdErrorMessage(424)), workInProgress);
                        $b25c2e442c996fe7$var$queueHydrationError($$typeof);
                        workInProgress = $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(current.firstChild);
                        $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress;
                        $b25c2e442c996fe7$var$isHydrating = !0;
                        $b25c2e442c996fe7$var$hydrationErrors = null;
                        $b25c2e442c996fe7$var$rootOrSingletonContext = !0;
                        renderLanes = $b25c2e442c996fe7$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $b25c2e442c996fe7$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b25c2e442c996fe7$var$markRef(current, workInProgress), null === current ? (renderLanes = $b25c2e442c996fe7$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b25c2e442c996fe7$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer($b25c2e442c996fe7$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress, props[$b25c2e442c996fe7$var$internalPropsKey] = current, $b25c2e442c996fe7$var$setInitialProperties(props, renderLanes, current), $b25c2e442c996fe7$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $b25c2e442c996fe7$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b25c2e442c996fe7$var$pushHostContext(workInProgress), null === current && $b25c2e442c996fe7$var$isHydrating && (props = workInProgress.stateNode = $b25c2e442c996fe7$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootInstanceStackCursor.current), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$rootOrSingletonContext = !0, $$typeof = $b25c2e442c996fe7$var$nextHydratableInstance, $b25c2e442c996fe7$var$isSingletonScope(workInProgress.type) ? ($b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(props.firstChild)) : $b25c2e442c996fe7$var$nextHydratableInstance = $$typeof), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $b25c2e442c996fe7$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $b25c2e442c996fe7$var$isHydrating) {
                if ($$typeof = props = $b25c2e442c996fe7$var$nextHydratableInstance) props = $b25c2e442c996fe7$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(props.firstChild), $b25c2e442c996fe7$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            }
            $b25c2e442c996fe7$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $b25c2e442c996fe7$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $b25c2e442c996fe7$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, $b25c2e442c996fe7$var$TransitionAwareHostComponent, null, null, renderLanes), $b25c2e442c996fe7$var$HostTransitionContext._currentValue = $$typeof);
            $b25c2e442c996fe7$var$markRef(current, workInProgress);
            $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b25c2e442c996fe7$var$isHydrating) {
                if (current = renderLanes = $b25c2e442c996fe7$var$nextHydratableInstance) renderLanes = $b25c2e442c996fe7$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $b25c2e442c996fe7$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $b25c2e442c996fe7$var$pushProvider(workInProgress, workInProgress.type, props.value), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $b25c2e442c996fe7$var$prepareToReadContext(workInProgress), $$typeof = $b25c2e442c996fe7$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $b25c2e442c996fe7$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $b25c2e442c996fe7$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $b25c2e442c996fe7$var$prepareToReadContext(workInProgress), props = $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext), null === current ? ($$typeof = $b25c2e442c996fe7$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $b25c2e442c996fe7$var$workInProgressRoot, prevState = $b25c2e442c996fe7$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $b25c2e442c996fe7$var$initializeUpdateQueue(workInProgress), $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress), $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props)) : (props = prevState.cache, $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props), props !== $$typeof.cache && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, [
                $b25c2e442c996fe7$var$CacheContext
            ], renderLanes, !0))), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b25c2e442c996fe7$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($b25c2e442c996fe7$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $b25c2e442c996fe7$var$suspendedThenable = $b25c2e442c996fe7$var$noopSuspenseyCommitThenable, $b25c2e442c996fe7$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b25c2e442c996fe7$var$preloadResource(resource)) {
        if ($b25c2e442c996fe7$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $b25c2e442c996fe7$var$suspendedThenable = $b25c2e442c996fe7$var$noopSuspenseyCommitThenable, $b25c2e442c996fe7$var$SuspenseyCommitException;
    }
}
function $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b25c2e442c996fe7$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b25c2e442c996fe7$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b25c2e442c996fe7$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $b25c2e442c996fe7$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b25c2e442c996fe7$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b25c2e442c996fe7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
            $b25c2e442c996fe7$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b25c2e442c996fe7$var$popHydrationState(workInProgress) ? $b25c2e442c996fe7$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable());
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($b25c2e442c996fe7$var$markUpdate(workInProgress), null !== nextResource ? ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($b25c2e442c996fe7$var$markUpdate(workInProgress), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $b25c2e442c996fe7$var$popHostContext(workInProgress);
            renderLanes = $b25c2e442c996fe7$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b25c2e442c996fe7$var$contextStackCursor.current;
                $b25c2e442c996fe7$var$popHydrationState(workInProgress) ? $b25c2e442c996fe7$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b25c2e442c996fe7$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b25c2e442c996fe7$var$markUpdate(workInProgress));
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b25c2e442c996fe7$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $b25c2e442c996fe7$var$contextStackCursor.current;
                if ($b25c2e442c996fe7$var$popHydrationState(workInProgress)) $b25c2e442c996fe7$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer($b25c2e442c996fe7$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    nextResource[$b25c2e442c996fe7$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($b25c2e442c996fe7$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
                }
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                current = $b25c2e442c996fe7$var$rootInstanceStackCursor.current;
                if ($b25c2e442c996fe7$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b25c2e442c996fe7$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b25c2e442c996fe7$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $b25c2e442c996fe7$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(557));
                        current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    } else $b25c2e442c996fe7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(558));
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b25c2e442c996fe7$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
                        type[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    } else $b25c2e442c996fe7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b25c2e442c996fe7$var$popHostContainer(), null === current && $b25c2e442c996fe7$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b25c2e442c996fe7$var$popProvider(workInProgress.type), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 19:
            $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $b25c2e442c996fe7$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b25c2e442c996fe7$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current & 1 | 2);
                            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $b25c2e442c996fe7$var$now() > $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $b25c2e442c996fe7$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, current), $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$b25c2e442c996fe7$var$isHydrating) return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b25c2e442c996fe7$var$now() - newProps.renderingStartTime > $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $b25c2e442c996fe7$var$now(), current.sibling = null, renderLanes = $b25c2e442c996fe7$var$suspenseStackCursor.current, $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b25c2e442c996fe7$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b25c2e442c996fe7$var$unwindWork(current, workInProgress) {
    $b25c2e442c996fe7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), $b25c2e442c996fe7$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b25c2e442c996fe7$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(340));
                $b25c2e442c996fe7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(340));
                $b25c2e442c996fe7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor), null;
        case 4:
            return $b25c2e442c996fe7$var$popHostContainer(), null;
        case 10:
            return $b25c2e442c996fe7$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$popHiddenContext(), null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b25c2e442c996fe7$var$unwindInterruptedWork(current, interruptedWork) {
    $b25c2e442c996fe7$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
            $b25c2e442c996fe7$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b25c2e442c996fe7$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b25c2e442c996fe7$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
            break;
        case 10:
            $b25c2e442c996fe7$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            $b25c2e442c996fe7$var$popHiddenContext();
            null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache);
            break;
        case 24:
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
    }
}
function $b25c2e442c996fe7$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b25c2e442c996fe7$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b25c2e442c996fe7$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b25c2e442c996fe7$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b25c2e442c996fe7$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $b25c2e442c996fe7$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b25c2e442c996fe7$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b25c2e442c996fe7$var$internalPropsKey] = newProps;
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $b25c2e442c996fe7$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $b25c2e442c996fe7$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b25c2e442c996fe7$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $b25c2e442c996fe7$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b25c2e442c996fe7$var$noop$1));
    else if (4 !== tag && (27 === tag && $b25c2e442c996fe7$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $b25c2e442c996fe7$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $b25c2e442c996fe7$var$setInitialProperties(singleton, type, props);
        singleton[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
        singleton[$b25c2e442c996fe7$var$internalPropsKey] = props;
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = !1, $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = !1, $b25c2e442c996fe7$var$needsFormReset = !1, $b25c2e442c996fe7$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b25c2e442c996fe7$var$nextEffect = null;
function $b25c2e442c996fe7$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b25c2e442c996fe7$var$eventsEnabled = $b25c2e442c996fe7$var$_enabled;
    root = $b25c2e442c996fe7$var$getActiveElementDeep(root);
    if ($b25c2e442c996fe7$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b25c2e442c996fe7$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b25c2e442c996fe7$var$_enabled = !1;
    for($b25c2e442c996fe7$var$nextEffect = firstChild; null !== $b25c2e442c996fe7$var$nextEffect;)if (firstChild = $b25c2e442c996fe7$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $b25c2e442c996fe7$var$nextEffect = root;
    else for(; null !== $b25c2e442c996fe7$var$nextEffect;){
        firstChild = $b25c2e442c996fe7$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b25c2e442c996fe7$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b25c2e442c996fe7$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b25c2e442c996fe7$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b25c2e442c996fe7$var$nextEffect = root;
            break;
        }
        $b25c2e442c996fe7$var$nextEffect = firstChild.return;
    }
}
function $b25c2e442c996fe7$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b25c2e442c996fe7$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $b25c2e442c996fe7$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostMount(finishedWork);
            flags & 512 && $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $b25c2e442c996fe7$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $b25c2e442c996fe7$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $b25c2e442c996fe7$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
                prevProps = $b25c2e442c996fe7$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
                $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = flags;
                ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevProps;
                $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b25c2e442c996fe7$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b25c2e442c996fe7$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b25c2e442c996fe7$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b25c2e442c996fe7$var$hostParent = null, $b25c2e442c996fe7$var$hostParentIsContainer = !1;
function $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onCommitFiberUnmount) try {
        $b25c2e442c996fe7$var$injectedHook.onCommitFiberUnmount($b25c2e442c996fe7$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b25c2e442c996fe7$var$hostParent, prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$isSingletonScope(deletedFiber.type) && ($b25c2e442c996fe7$var$hostParent = deletedFiber.stateNode, $b25c2e442c996fe7$var$hostParentIsContainer = !1);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$releaseSingletonInstance(deletedFiber.stateNode);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $b25c2e442c996fe7$var$hostParent;
            prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$hostParent = null;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $b25c2e442c996fe7$var$hostParent) {
                if ($b25c2e442c996fe7$var$hostParentIsContainer) try {
                    (9 === $b25c2e442c996fe7$var$hostParent.nodeType ? $b25c2e442c996fe7$var$hostParent.body : "HTML" === $b25c2e442c996fe7$var$hostParent.nodeName ? $b25c2e442c996fe7$var$hostParent.ownerDocument.body : $b25c2e442c996fe7$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b25c2e442c996fe7$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b25c2e442c996fe7$var$hostParent && ($b25c2e442c996fe7$var$hostParentIsContainer ? (finishedRoot = $b25c2e442c996fe7$var$hostParent, $b25c2e442c996fe7$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot)) : $b25c2e442c996fe7$var$clearHydrationBoundary($b25c2e442c996fe7$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b25c2e442c996fe7$var$hostParent;
            prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b25c2e442c996fe7$var$hostParentIsContainer = !0;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b25c2e442c996fe7$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || ($b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = (prevHostParent = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b25c2e442c996fe7$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b25c2e442c996fe7$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b25c2e442c996fe7$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $b25c2e442c996fe7$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($b25c2e442c996fe7$var$isSingletonScope(parent.type)) {
                        $b25c2e442c996fe7$var$hostParent = parent.stateNode;
                        $b25c2e442c996fe7$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $b25c2e442c996fe7$var$hostParent = parent.stateNode;
                    $b25c2e442c996fe7$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $b25c2e442c996fe7$var$hostParent = parent.stateNode.containerInfo;
                    $b25c2e442c996fe7$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b25c2e442c996fe7$var$hostParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(160));
        $b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b25c2e442c996fe7$var$hostParent = null;
        $b25c2e442c996fe7$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b25c2e442c996fe7$var$currentHoistableRoot = null;
function $b25c2e442c996fe7$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b25c2e442c996fe7$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b25c2e442c996fe7$var$commitHookEffectListMount(3, finishedWork), $b25c2e442c996fe7$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            flags & 64 && $b25c2e442c996fe7$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b25c2e442c996fe7$var$internalHoistableMarker] || currentResource[$b25c2e442c996fe7$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
                                        $b25c2e442c996fe7$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b25c2e442c996fe7$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b25c2e442c996fe7$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
                                $b25c2e442c996fe7$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b25c2e442c996fe7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b25c2e442c996fe7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b25c2e442c996fe7$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b25c2e442c996fe7$var$needsFormReset = !0);
            break;
        case 6:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b25c2e442c996fe7$var$tagCaches = null;
            hoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(root.containerInfo);
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$currentHoistableRoot = hoistableRoot;
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b25c2e442c996fe7$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b25c2e442c996fe7$var$needsFormReset && ($b25c2e442c996fe7$var$needsFormReset = !1, $b25c2e442c996fe7$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            $b25c2e442c996fe7$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b25c2e442c996fe7$var$globalMostRecentFallbackTime = $b25c2e442c996fe7$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $b25c2e442c996fe7$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
            $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $b25c2e442c996fe7$var$offscreenSubtreeIsHidden || $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(instance, !0) : $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork), $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
    }
}
function $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($b25c2e442c996fe7$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($b25c2e442c996fe7$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b25c2e442c996fe7$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b25c2e442c996fe7$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b25c2e442c996fe7$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $b25c2e442c996fe7$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $b25c2e442c996fe7$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b25c2e442c996fe7$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostMount(finishedWork);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b25c2e442c996fe7$var$releaseCache(previousCache));
}
function $b25c2e442c996fe7$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b25c2e442c996fe7$var$releaseCache(current));
}
function $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b25c2e442c996fe7$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b25c2e442c996fe7$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b25c2e442c996fe7$var$suspenseyCommitFlag = 8192;
function $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $b25c2e442c996fe7$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $b25c2e442c996fe7$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b25c2e442c996fe7$var$suspendResource(suspendedState, $b25c2e442c996fe7$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $b25c2e442c996fe7$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b25c2e442c996fe7$var$suspenseyCommitFlag, $b25c2e442c996fe7$var$suspenseyCommitFlag = 16777216, $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $b25c2e442c996fe7$var$suspenseyCommitFlag = previousHoistableRoot) : $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b25c2e442c996fe7$var$nextEffect = childToDelete;
            $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b25c2e442c996fe7$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b25c2e442c996fe7$var$nextEffect = childToDelete;
            $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b25c2e442c996fe7$var$nextEffect;){
        var fiber = $b25c2e442c996fe7$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b25c2e442c996fe7$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b25c2e442c996fe7$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b25c2e442c996fe7$var$nextEffect;){
            cache = $b25c2e442c996fe7$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b25c2e442c996fe7$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b25c2e442c996fe7$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b25c2e442c996fe7$var$nextEffect = sibling;
                break a;
            }
            $b25c2e442c996fe7$var$nextEffect = returnFiber;
        }
    }
}
var $b25c2e442c996fe7$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext).controller.signal;
    }
}, $b25c2e442c996fe7$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b25c2e442c996fe7$var$executionContext = 0, $b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgress = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0, $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = !1, $b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !1, $b25c2e442c996fe7$var$entangledRenderLanes = 0, $b25c2e442c996fe7$var$workInProgressRootExitStatus = 0, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes = 0, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes = 0, $b25c2e442c996fe7$var$workInProgressRootPingedLanes = 0, $b25c2e442c996fe7$var$workInProgressDeferredLane = 0, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = 0, $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = null, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = null, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b25c2e442c996fe7$var$globalMostRecentFallbackTime = 0, $b25c2e442c996fe7$var$globalMostRecentTransitionTime = 0, $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = Infinity, $b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = null, $b25c2e442c996fe7$var$pendingEffectsStatus = 0, $b25c2e442c996fe7$var$pendingEffectsRoot = null, $b25c2e442c996fe7$var$pendingFinishedWork = null, $b25c2e442c996fe7$var$pendingEffectsLanes = 0, $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = 0, $b25c2e442c996fe7$var$pendingPassiveTransitions = null, $b25c2e442c996fe7$var$pendingRecoverableErrors = null, $b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = null;
function $b25c2e442c996fe7$var$requestUpdateLane() {
    return 0 !== ($b25c2e442c996fe7$var$executionContext & 2) && 0 !== $b25c2e442c996fe7$var$workInProgressRootRenderLanes ? $b25c2e442c996fe7$var$workInProgressRootRenderLanes & -$b25c2e442c996fe7$var$workInProgressRootRenderLanes : null !== $b25c2e442c996fe7$var$ReactSharedInternals.T ? $b25c2e442c996fe7$var$requestTransitionLane() : $b25c2e442c996fe7$var$resolveUpdatePriority();
}
function $b25c2e442c996fe7$var$requestDeferredLane() {
    if (0 === $b25c2e442c996fe7$var$workInProgressDeferredLane) {
        if (0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912) || $b25c2e442c996fe7$var$isHydrating) {
            var lane = $b25c2e442c996fe7$var$nextTransitionDeferredLane;
            $b25c2e442c996fe7$var$nextTransitionDeferredLane <<= 1;
            0 === ($b25c2e442c996fe7$var$nextTransitionDeferredLane & 3932160) && ($b25c2e442c996fe7$var$nextTransitionDeferredLane = 262144);
            $b25c2e442c996fe7$var$workInProgressDeferredLane = lane;
        } else $b25c2e442c996fe7$var$workInProgressDeferredLane = 536870912;
    }
    lane = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $b25c2e442c996fe7$var$workInProgressDeferredLane;
}
function $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b25c2e442c996fe7$var$workInProgressRoot && (2 === $b25c2e442c996fe7$var$workInProgressSuspendedReason || 9 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $b25c2e442c996fe7$var$prepareFreshStack(root, 0), $b25c2e442c996fe7$var$markRootSuspended(root, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1);
    $b25c2e442c996fe7$var$markRootUpdated$1(root, lane);
    if (0 === ($b25c2e442c996fe7$var$executionContext & 2) || root !== $b25c2e442c996fe7$var$workInProgressRoot) root === $b25c2e442c996fe7$var$workInProgressRoot && (0 === ($b25c2e442c996fe7$var$executionContext & 2) && ($b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && $b25c2e442c996fe7$var$markRootSuspended(root, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1)), $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
}
function $b25c2e442c996fe7$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b25c2e442c996fe7$var$renderRootConcurrent(root$jscomp$0, lanes) : $b25c2e442c996fe7$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b25c2e442c996fe7$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b25c2e442c996fe7$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b25c2e442c996fe7$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b25c2e442c996fe7$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b25c2e442c996fe7$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b25c2e442c996fe7$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors;
                            $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors ? $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors.push.apply($b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b25c2e442c996fe7$var$prepareFreshStack(root$jscomp$0, 0);
                $b25c2e442c996fe7$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $b25c2e442c996fe7$var$markRootSuspended(shouldTimeSlice, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !$b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $b25c2e442c996fe7$var$globalMostRecentFallbackTime + 300 - $b25c2e442c996fe7$var$now(), 10 < exitStatus)) {
                    $b25c2e442c996fe7$var$markRootSuspended(shouldTimeSlice, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !$b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b25c2e442c996fe7$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $b25c2e442c996fe7$var$scheduleTimeout($b25c2e442c996fe7$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, $b25c2e442c996fe7$var$workInProgressTransitions, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $b25c2e442c996fe7$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, $b25c2e442c996fe7$var$workInProgressTransitions, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $b25c2e442c996fe7$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b25c2e442c996fe7$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $b25c2e442c996fe7$var$noop$1
        };
        $b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $b25c2e442c996fe7$var$globalMostRecentFallbackTime - $b25c2e442c996fe7$var$now() : (lanes & 4194048) === lanes ? $b25c2e442c996fe7$var$globalMostRecentTransitionTime - $b25c2e442c996fe7$var$now() : 0;
        timeoutOffset = $b25c2e442c996fe7$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($b25c2e442c996fe7$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $b25c2e442c996fe7$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b25c2e442c996fe7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $b25c2e442c996fe7$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b25c2e442c996fe7$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b25c2e442c996fe7$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b25c2e442c996fe7$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $b25c2e442c996fe7$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b25c2e442c996fe7$var$flushSyncWork$1() {
    return 0 === ($b25c2e442c996fe7$var$executionContext & 6) ? ($b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b25c2e442c996fe7$var$resetWorkInProgressStack() {
    if (null !== $b25c2e442c996fe7$var$workInProgress) {
        if (0 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) var interruptedWork = $b25c2e442c996fe7$var$workInProgress.return;
        else interruptedWork = $b25c2e442c996fe7$var$workInProgress, $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null, $b25c2e442c996fe7$var$resetHooksOnUnwind(interruptedWork), $b25c2e442c996fe7$var$thenableState$1 = null, $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0, interruptedWork = $b25c2e442c996fe7$var$workInProgress;
        for(; null !== interruptedWork;)$b25c2e442c996fe7$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b25c2e442c996fe7$var$workInProgress = null;
    }
}
function $b25c2e442c996fe7$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b25c2e442c996fe7$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b25c2e442c996fe7$var$pendingEffectsLanes = 0;
    $b25c2e442c996fe7$var$resetWorkInProgressStack();
    $b25c2e442c996fe7$var$workInProgressRoot = root;
    $b25c2e442c996fe7$var$workInProgress = timeoutHandle = $b25c2e442c996fe7$var$createWorkInProgress(root.current, null);
    $b25c2e442c996fe7$var$workInProgressRootRenderLanes = lanes;
    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
    $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, lanes);
    $b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !1;
    $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = $b25c2e442c996fe7$var$workInProgressDeferredLane = $b25c2e442c996fe7$var$workInProgressRootPingedLanes = $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes = $b25c2e442c996fe7$var$workInProgressRootSkippedLanes = $b25c2e442c996fe7$var$workInProgressRootExitStatus = 0;
    $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = null;
    $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $b25c2e442c996fe7$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $b25c2e442c996fe7$var$entangledRenderLanes = lanes;
    $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b25c2e442c996fe7$var$handleThrow(root, thrownValue) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    thrownValue === $b25c2e442c996fe7$var$SuspenseException || thrownValue === $b25c2e442c996fe7$var$SuspenseActionException ? (thrownValue = $b25c2e442c996fe7$var$getSuspendedThenable(), $b25c2e442c996fe7$var$workInProgressSuspendedReason = 3) : thrownValue === $b25c2e442c996fe7$var$SuspenseyCommitException ? (thrownValue = $b25c2e442c996fe7$var$getSuspendedThenable(), $b25c2e442c996fe7$var$workInProgressSuspendedReason = 4) : $b25c2e442c996fe7$var$workInProgressSuspendedReason = thrownValue === $b25c2e442c996fe7$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b25c2e442c996fe7$var$workInProgressThrownValue = thrownValue;
    null === $b25c2e442c996fe7$var$workInProgress && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 1, $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b25c2e442c996fe7$var$shouldRemainOnPreviousScreen() {
    var handler = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 4194048) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes ? null === $b25c2e442c996fe7$var$shellBoundary ? !0 : !1 : ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 62914560) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes || 0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912) ? handler === $b25c2e442c996fe7$var$shellBoundary : !1;
}
function $b25c2e442c996fe7$var$pushDispatcher() {
    var prevDispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.H;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b25c2e442c996fe7$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b25c2e442c996fe7$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.A;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = $b25c2e442c996fe7$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible() {
    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 4;
    $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings || ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 4194048) !== $b25c2e442c996fe7$var$workInProgressRootRenderLanes && null !== $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current || ($b25c2e442c996fe7$var$workInProgressRootIsPrerendering = !0);
    0 === ($b25c2e442c996fe7$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b25c2e442c996fe7$var$workInProgressRoot || $b25c2e442c996fe7$var$markRootSuspended($b25c2e442c996fe7$var$workInProgressRoot, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1);
}
function $b25c2e442c996fe7$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
    $b25c2e442c996fe7$var$executionContext |= 2;
    var prevDispatcher = $b25c2e442c996fe7$var$pushDispatcher(), prevAsyncDispatcher = $b25c2e442c996fe7$var$pushAsyncDispatcher();
    if ($b25c2e442c996fe7$var$workInProgressRoot !== root || $b25c2e442c996fe7$var$workInProgressRootRenderLanes !== lanes) $b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b25c2e442c996fe7$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && null !== $b25c2e442c996fe7$var$workInProgress) {
            var unitOfWork = $b25c2e442c996fe7$var$workInProgress, thrownValue = $b25c2e442c996fe7$var$workInProgressThrownValue;
            switch($b25c2e442c996fe7$var$workInProgressSuspendedReason){
                case 8:
                    $b25c2e442c996fe7$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b25c2e442c996fe7$var$workInProgressSuspendedReason;
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b25c2e442c996fe7$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b25c2e442c996fe7$var$workInProgressSuspendedReason, $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b25c2e442c996fe7$var$workLoopSync();
        exitStatus = $b25c2e442c996fe7$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $b25c2e442c996fe7$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = prevDispatcher;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b25c2e442c996fe7$var$workInProgress && ($b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0, $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b25c2e442c996fe7$var$workLoopSync() {
    for(; null !== $b25c2e442c996fe7$var$workInProgress;)$b25c2e442c996fe7$var$performUnitOfWork($b25c2e442c996fe7$var$workInProgress);
}
function $b25c2e442c996fe7$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
    $b25c2e442c996fe7$var$executionContext |= 2;
    var prevDispatcher = $b25c2e442c996fe7$var$pushDispatcher(), prevAsyncDispatcher = $b25c2e442c996fe7$var$pushAsyncDispatcher();
    $b25c2e442c996fe7$var$workInProgressRoot !== root || $b25c2e442c996fe7$var$workInProgressRootRenderLanes !== lanes ? ($b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = $b25c2e442c996fe7$var$now() + 500, $b25c2e442c996fe7$var$prepareFreshStack(root, lanes)) : $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && null !== $b25c2e442c996fe7$var$workInProgress) {
            lanes = $b25c2e442c996fe7$var$workInProgress;
            var thrownValue = $b25c2e442c996fe7$var$workInProgressThrownValue;
            b: switch($b25c2e442c996fe7$var$workInProgressSuspendedReason){
                case 1:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($b25c2e442c996fe7$var$isThenableResolved(thrownValue)) {
                        $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                        $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                        $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && 9 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason || $b25c2e442c996fe7$var$workInProgressRoot !== root || ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 7);
                        $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b25c2e442c996fe7$var$isThenableResolved(thrownValue) ? ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(lanes)) : ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b25c2e442c996fe7$var$workInProgress.tag){
                        case 26:
                            resource = $b25c2e442c996fe7$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b25c2e442c996fe7$var$workInProgress;
                            if (resource ? $b25c2e442c996fe7$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                                $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b25c2e442c996fe7$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b25c2e442c996fe7$var$workInProgress = returnFiber, $b25c2e442c996fe7$var$completeUnitOfWork(returnFiber)) : $b25c2e442c996fe7$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b25c2e442c996fe7$var$resetWorkInProgressStack();
                    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(462));
            }
        }
        $b25c2e442c996fe7$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $b25c2e442c996fe7$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = prevDispatcher;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
    if (null !== $b25c2e442c996fe7$var$workInProgress) return 0;
    $b25c2e442c996fe7$var$workInProgressRoot = null;
    $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0;
    $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates();
    return $b25c2e442c996fe7$var$workInProgressRootExitStatus;
}
function $b25c2e442c996fe7$var$workLoopConcurrentByScheduler() {
    for(; null !== $b25c2e442c996fe7$var$workInProgress && !$b25c2e442c996fe7$var$shouldYield();)$b25c2e442c996fe7$var$performUnitOfWork($b25c2e442c996fe7$var$workInProgress);
}
function $b25c2e442c996fe7$var$performUnitOfWork(unitOfWork) {
    var next = $b25c2e442c996fe7$var$beginWork(unitOfWork.alternate, unitOfWork, $b25c2e442c996fe7$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) : $b25c2e442c996fe7$var$workInProgress = next;
}
function $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b25c2e442c996fe7$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b25c2e442c996fe7$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b25c2e442c996fe7$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b25c2e442c996fe7$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b25c2e442c996fe7$var$resetHooksOnUnwind(next);
        default:
            $b25c2e442c996fe7$var$unwindInterruptedWork(current, next), next = $b25c2e442c996fe7$var$workInProgress = $b25c2e442c996fe7$var$resetWorkInProgress(next, $b25c2e442c996fe7$var$entangledRenderLanes), next = $b25c2e442c996fe7$var$beginWork(current, next, $b25c2e442c996fe7$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) : $b25c2e442c996fe7$var$workInProgress = next;
}
function $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$resetHooksOnUnwind(unitOfWork);
    $b25c2e442c996fe7$var$thenableState$1 = null;
    $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b25c2e442c996fe7$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b25c2e442c996fe7$var$workInProgressRootRenderLanes)) {
            $b25c2e442c996fe7$var$workInProgressRootExitStatus = 1;
            $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b25c2e442c996fe7$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b25c2e442c996fe7$var$workInProgress = returnFiber, error;
        $b25c2e442c996fe7$var$workInProgressRootExitStatus = 1;
        $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b25c2e442c996fe7$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b25c2e442c996fe7$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b25c2e442c996fe7$var$workInProgressRootIsPrerendering || 0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b25c2e442c996fe7$var$unwindUnitOfWork(unitOfWork, root);
    } else $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork);
}
function $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b25c2e442c996fe7$var$unwindUnitOfWork(completedWork, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b25c2e442c996fe7$var$completeWork(completedWork.alternate, completedWork, $b25c2e442c996fe7$var$entangledRenderLanes);
        if (null !== next) {
            $b25c2e442c996fe7$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b25c2e442c996fe7$var$workInProgress = completedWork;
            return;
        }
        $b25c2e442c996fe7$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 5);
}
function $b25c2e442c996fe7$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b25c2e442c996fe7$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b25c2e442c996fe7$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b25c2e442c996fe7$var$workInProgress = unitOfWork;
            return;
        }
        $b25c2e442c996fe7$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 6;
    $b25c2e442c996fe7$var$workInProgress = null;
}
function $b25c2e442c996fe7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $b25c2e442c996fe7$var$flushPendingEffects();
    while (0 !== $b25c2e442c996fe7$var$pendingEffectsStatus);
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $b25c2e442c996fe7$var$concurrentlyUpdatedLanes;
        $b25c2e442c996fe7$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $b25c2e442c996fe7$var$workInProgressRoot && ($b25c2e442c996fe7$var$workInProgress = $b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0);
        $b25c2e442c996fe7$var$pendingFinishedWork = finishedWork;
        $b25c2e442c996fe7$var$pendingEffectsRoot = root;
        $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
        $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $b25c2e442c996fe7$var$pendingPassiveTransitions = transitions;
        $b25c2e442c996fe7$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $b25c2e442c996fe7$var$scheduleCallback$1($b25c2e442c996fe7$var$NormalPriority$1, function() {
            $b25c2e442c996fe7$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            transitions = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $b25c2e442c996fe7$var$executionContext = spawnedLane, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = transitions, $b25c2e442c996fe7$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $b25c2e442c996fe7$var$pendingEffectsStatus = 1;
        $b25c2e442c996fe7$var$flushMutationEffects();
        $b25c2e442c996fe7$var$flushLayoutEffects();
        $b25c2e442c996fe7$var$flushSpawnedWork();
    }
}
function $b25c2e442c996fe7$var$flushMutationEffects() {
    if (1 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $b25c2e442c996fe7$var$selectionInformation, curFocusedElem = $b25c2e442c996fe7$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $b25c2e442c996fe7$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $b25c2e442c996fe7$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $b25c2e442c996fe7$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $b25c2e442c996fe7$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $b25c2e442c996fe7$var$_enabled = !!$b25c2e442c996fe7$var$eventsEnabled;
                $b25c2e442c996fe7$var$selectionInformation = $b25c2e442c996fe7$var$eventsEnabled = null;
            } finally{
                $b25c2e442c996fe7$var$executionContext = prevExecutionContext, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $b25c2e442c996fe7$var$pendingEffectsStatus = 2;
    }
}
function $b25c2e442c996fe7$var$flushLayoutEffects() {
    if (2 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $b25c2e442c996fe7$var$executionContext = prevExecutionContext, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $b25c2e442c996fe7$var$pendingEffectsStatus = 3;
    }
}
function $b25c2e442c996fe7$var$flushSpawnedWork() {
    if (4 === $b25c2e442c996fe7$var$pendingEffectsStatus || 3 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        $b25c2e442c996fe7$var$requestPaint();
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, lanes = $b25c2e442c996fe7$var$pendingEffectsLanes, recoverableErrors = $b25c2e442c996fe7$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $b25c2e442c996fe7$var$pendingEffectsStatus = 5 : ($b25c2e442c996fe7$var$pendingEffectsStatus = 0, $b25c2e442c996fe7$var$pendingFinishedWork = $b25c2e442c996fe7$var$pendingEffectsRoot = null, $b25c2e442c996fe7$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $b25c2e442c996fe7$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onCommitFiberRoot) try {
            $b25c2e442c996fe7$var$injectedHook.onCommitFiberRoot($b25c2e442c996fe7$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            remainingLanes = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $b25c2e442c996fe7$var$ReactSharedInternals.T = finishedWork, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($b25c2e442c996fe7$var$pendingEffectsLanes & 3) && $b25c2e442c996fe7$var$flushPendingEffects();
        $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $b25c2e442c996fe7$var$rootWithNestedUpdates ? $b25c2e442c996fe7$var$nestedUpdateCount++ : ($b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = root) : $b25c2e442c996fe7$var$nestedUpdateCount = 0;
        $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $b25c2e442c996fe7$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b25c2e442c996fe7$var$releaseCache(remainingLanes)));
}
function $b25c2e442c996fe7$var$flushPendingEffects() {
    $b25c2e442c996fe7$var$flushMutationEffects();
    $b25c2e442c996fe7$var$flushLayoutEffects();
    $b25c2e442c996fe7$var$flushSpawnedWork();
    return $b25c2e442c996fe7$var$flushPassiveEffects();
}
function $b25c2e442c996fe7$var$flushPassiveEffects() {
    if (5 !== $b25c2e442c996fe7$var$pendingEffectsStatus) return !1;
    var root = $b25c2e442c996fe7$var$pendingEffectsRoot, remainingLanes = $b25c2e442c996fe7$var$pendingEffectsRemainingLanes;
    $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $b25c2e442c996fe7$var$lanesToEventPriority($b25c2e442c996fe7$var$pendingEffectsLanes), prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
        renderPriority = $b25c2e442c996fe7$var$pendingPassiveTransitions;
        $b25c2e442c996fe7$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $b25c2e442c996fe7$var$pendingEffectsRoot, lanes = $b25c2e442c996fe7$var$pendingEffectsLanes;
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        $b25c2e442c996fe7$var$pendingFinishedWork = $b25c2e442c996fe7$var$pendingEffectsRoot = null;
        $b25c2e442c996fe7$var$pendingEffectsLanes = 0;
        if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(331));
        var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
        $b25c2e442c996fe7$var$executionContext |= 4;
        $b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $b25c2e442c996fe7$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
        $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onPostCommitFiberRoot) try {
            $b25c2e442c996fe7$var$injectedHook.onPostCommitFiberRoot($b25c2e442c996fe7$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition, $b25c2e442c996fe7$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b25c2e442c996fe7$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b25c2e442c996fe7$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b25c2e442c996fe7$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b25c2e442c996fe7$var$markRootUpdated$1(rootFiber, 2), $b25c2e442c996fe7$var$ensureRootIsScheduled(rootFiber));
}
function $b25c2e442c996fe7$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed || !$b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b25c2e442c996fe7$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b25c2e442c996fe7$var$createClassErrorUpdate(2);
                instance = $b25c2e442c996fe7$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b25c2e442c996fe7$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b25c2e442c996fe7$var$markRootUpdated$1(instance, 2), $b25c2e442c996fe7$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b25c2e442c996fe7$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b25c2e442c996fe7$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b25c2e442c996fe7$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b25c2e442c996fe7$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b25c2e442c996fe7$var$workInProgressRoot === root && ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b25c2e442c996fe7$var$workInProgressRootExitStatus || 3 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 62914560) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes && 300 > $b25c2e442c996fe7$var$now() - $b25c2e442c996fe7$var$globalMostRecentFallbackTime ? 0 === ($b25c2e442c996fe7$var$executionContext & 2) && $b25c2e442c996fe7$var$prepareFreshStack(root, 0) : $b25c2e442c996fe7$var$workInProgressRootPingedLanes |= pingedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes === $b25c2e442c996fe7$var$workInProgressRootRenderLanes && ($b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = 0));
    $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
}
function $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b25c2e442c996fe7$var$claimNextRetryLane());
    boundaryFiber = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b25c2e442c996fe7$var$markRootUpdated$1(boundaryFiber, retryLane), $b25c2e442c996fe7$var$ensureRootIsScheduled(boundaryFiber));
}
function $b25c2e442c996fe7$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b25c2e442c996fe7$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b25c2e442c996fe7$var$scheduleCallback$1(priorityLevel, callback) {
    return $b25c2e442c996fe7$var$scheduleCallback$3(priorityLevel, callback);
}
var $b25c2e442c996fe7$var$firstScheduledRoot = null, $b25c2e442c996fe7$var$lastScheduledRoot = null, $b25c2e442c996fe7$var$didScheduleMicrotask = !1, $b25c2e442c996fe7$var$mightHavePendingSyncWork = !1, $b25c2e442c996fe7$var$isFlushingWork = !1, $b25c2e442c996fe7$var$currentEventTransitionLane = 0;
function $b25c2e442c996fe7$var$ensureRootIsScheduled(root) {
    root !== $b25c2e442c996fe7$var$lastScheduledRoot && null === root.next && (null === $b25c2e442c996fe7$var$lastScheduledRoot ? $b25c2e442c996fe7$var$firstScheduledRoot = $b25c2e442c996fe7$var$lastScheduledRoot = root : $b25c2e442c996fe7$var$lastScheduledRoot = $b25c2e442c996fe7$var$lastScheduledRoot.next = root);
    $b25c2e442c996fe7$var$mightHavePendingSyncWork = !0;
    $b25c2e442c996fe7$var$didScheduleMicrotask || ($b25c2e442c996fe7$var$didScheduleMicrotask = !0, $b25c2e442c996fe7$var$scheduleImmediateRootScheduleTask());
}
function $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b25c2e442c996fe7$var$isFlushingWork && $b25c2e442c996fe7$var$mightHavePendingSyncWork) {
        $b25c2e442c996fe7$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $b25c2e442c996fe7$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b25c2e442c996fe7$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b25c2e442c996fe7$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b25c2e442c996fe7$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b25c2e442c996fe7$var$getNextLanes(root$170, root$170 === $b25c2e442c996fe7$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b25c2e442c996fe7$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $b25c2e442c996fe7$var$isFlushingWork = !1;
    }
}
function $b25c2e442c996fe7$var$processRootScheduleInImmediateTask() {
    $b25c2e442c996fe7$var$processRootScheduleInMicrotask();
}
function $b25c2e442c996fe7$var$processRootScheduleInMicrotask() {
    $b25c2e442c996fe7$var$mightHavePendingSyncWork = $b25c2e442c996fe7$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b25c2e442c996fe7$var$currentEventTransitionLane && $b25c2e442c996fe7$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b25c2e442c996fe7$var$currentEventTransitionLane);
    for(var currentTime = $b25c2e442c996fe7$var$now(), prev = null, root = $b25c2e442c996fe7$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b25c2e442c996fe7$var$firstScheduledRoot = next : prev.next = next, null === next && ($b25c2e442c996fe7$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b25c2e442c996fe7$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $b25c2e442c996fe7$var$pendingEffectsStatus && 5 !== $b25c2e442c996fe7$var$pendingEffectsStatus || $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $b25c2e442c996fe7$var$currentEventTransitionLane && ($b25c2e442c996fe7$var$currentEventTransitionLane = 0);
}
function $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $b25c2e442c996fe7$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $b25c2e442c996fe7$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b25c2e442c996fe7$var$workInProgressRoot;
    suspendedLanes = $b25c2e442c996fe7$var$workInProgressRootRenderLanes;
    suspendedLanes = $b25c2e442c996fe7$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $b25c2e442c996fe7$var$workInProgressSuspendedReason || 9 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes);
        switch($b25c2e442c996fe7$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b25c2e442c996fe7$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b25c2e442c996fe7$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b25c2e442c996fe7$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b25c2e442c996fe7$var$NormalPriority$1;
        }
        pingedLanes = $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b25c2e442c996fe7$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $b25c2e442c996fe7$var$pendingEffectsStatus && 5 !== $b25c2e442c996fe7$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($b25c2e442c996fe7$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b25c2e442c996fe7$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b25c2e442c996fe7$var$getNextLanes(root, root === $b25c2e442c996fe7$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b25c2e442c996fe7$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, $b25c2e442c996fe7$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b25c2e442c996fe7$var$performSyncWorkOnRoot(root, lanes) {
    if ($b25c2e442c996fe7$var$flushPendingEffects()) return null;
    $b25c2e442c996fe7$var$performWorkOnRoot(root, lanes, !0);
}
function $b25c2e442c996fe7$var$scheduleImmediateRootScheduleTask() {
    $b25c2e442c996fe7$var$scheduleMicrotask(function() {
        0 !== ($b25c2e442c996fe7$var$executionContext & 6) ? $b25c2e442c996fe7$var$scheduleCallback$3($b25c2e442c996fe7$var$ImmediatePriority, $b25c2e442c996fe7$var$processRootScheduleInImmediateTask) : $b25c2e442c996fe7$var$processRootScheduleInMicrotask();
    });
}
function $b25c2e442c996fe7$var$requestTransitionLane() {
    if (0 === $b25c2e442c996fe7$var$currentEventTransitionLane) {
        var actionScopeLane = $b25c2e442c996fe7$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $b25c2e442c996fe7$var$nextTransitionUpdateLane, $b25c2e442c996fe7$var$nextTransitionUpdateLane <<= 1, 0 === ($b25c2e442c996fe7$var$nextTransitionUpdateLane & 261888) && ($b25c2e442c996fe7$var$nextTransitionUpdateLane = 256));
        $b25c2e442c996fe7$var$currentEventTransitionLane = actionScopeLane;
    }
    return $b25c2e442c996fe7$var$currentEventTransitionLane;
}
function $b25c2e442c996fe7$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b25c2e442c996fe7$var$sanitizeURL("" + actionProp);
}
function $b25c2e442c996fe7$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b25c2e442c996fe7$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b25c2e442c996fe7$var$coerceFormActionProp((nativeEventTarget[$b25c2e442c996fe7$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b25c2e442c996fe7$var$internalPropsKey] || null) ? $b25c2e442c996fe7$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b25c2e442c996fe7$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b25c2e442c996fe7$var$currentEventTransitionLane) {
                                var formData = submitter ? $b25c2e442c996fe7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b25c2e442c996fe7$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b25c2e442c996fe7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b25c2e442c996fe7$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b25c2e442c996fe7$var$i$jscomp$inline_1577 = 0; $b25c2e442c996fe7$var$i$jscomp$inline_1577 < $b25c2e442c996fe7$var$simpleEventPluginEvents.length; $b25c2e442c996fe7$var$i$jscomp$inline_1577++){
    var $b25c2e442c996fe7$var$eventName$jscomp$inline_1578 = $b25c2e442c996fe7$var$simpleEventPluginEvents[$b25c2e442c996fe7$var$i$jscomp$inline_1577], $b25c2e442c996fe7$var$domEventName$jscomp$inline_1579 = $b25c2e442c996fe7$var$eventName$jscomp$inline_1578.toLowerCase(), $b25c2e442c996fe7$var$capitalizedEvent$jscomp$inline_1580 = $b25c2e442c996fe7$var$eventName$jscomp$inline_1578[0].toUpperCase() + $b25c2e442c996fe7$var$eventName$jscomp$inline_1578.slice(1);
    $b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$domEventName$jscomp$inline_1579, "on" + $b25c2e442c996fe7$var$capitalizedEvent$jscomp$inline_1580);
}
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_END, "onAnimationEnd");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_ITERATION, "onAnimationIteration");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_START, "onAnimationStart");
$b25c2e442c996fe7$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b25c2e442c996fe7$var$registerSimpleEvent("focusin", "onFocus");
$b25c2e442c996fe7$var$registerSimpleEvent("focusout", "onBlur");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_RUN, "onTransitionRun");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_START, "onTransitionStart");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_CANCEL, "onTransitionCancel");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_END, "onTransitionEnd");
$b25c2e442c996fe7$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b25c2e442c996fe7$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b25c2e442c996fe7$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b25c2e442c996fe7$var$mediaEventTypes));
function $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b25c2e442c996fe7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b25c2e442c996fe7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b25c2e442c996fe7$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b25c2e442c996fe7$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b25c2e442c996fe7$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b25c2e442c996fe7$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b25c2e442c996fe7$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b25c2e442c996fe7$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b25c2e442c996fe7$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b25c2e442c996fe7$var$listeningMarker]) {
        rootContainerElement[$b25c2e442c996fe7$var$listeningMarker] = !0;
        $b25c2e442c996fe7$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b25c2e442c996fe7$var$nonDelegatedEvents.has(domEventName) || $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b25c2e442c996fe7$var$listeningMarker] || (ownerDocument[$b25c2e442c996fe7$var$listeningMarker] = !0, $b25c2e442c996fe7$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b25c2e442c996fe7$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b25c2e442c996fe7$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b25c2e442c996fe7$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b25c2e442c996fe7$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b25c2e442c996fe7$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b25c2e442c996fe7$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b25c2e442c996fe7$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b25c2e442c996fe7$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b25c2e442c996fe7$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b25c2e442c996fe7$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b25c2e442c996fe7$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticTouchEvent;
                        break;
                    case $b25c2e442c996fe7$var$ANIMATION_END:
                    case $b25c2e442c996fe7$var$ANIMATION_ITERATION:
                    case $b25c2e442c996fe7$var$ANIMATION_START:
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticAnimationEvent;
                        break;
                    case $b25c2e442c996fe7$var$TRANSITION_END:
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b25c2e442c996fe7$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b25c2e442c996fe7$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b25c2e442c996fe7$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b25c2e442c996fe7$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b25c2e442c996fe7$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b25c2e442c996fe7$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b25c2e442c996fe7$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b25c2e442c996fe7$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b25c2e442c996fe7$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b25c2e442c996fe7$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b25c2e442c996fe7$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b25c2e442c996fe7$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $b25c2e442c996fe7$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b25c2e442c996fe7$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForChangeEvent;
                else if ($b25c2e442c996fe7$var$isTextInputElement(reactName)) {
                    if ($b25c2e442c996fe7$var$isInputEventSupported) getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b25c2e442c996fe7$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b25c2e442c996fe7$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b25c2e442c996fe7$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b25c2e442c996fe7$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b25c2e442c996fe7$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b25c2e442c996fe7$var$activeElement = handleEventFunc, $b25c2e442c996fe7$var$activeElementInst = targetInst, $b25c2e442c996fe7$var$lastSelection = null;
                    break;
                case "focusout":
                    $b25c2e442c996fe7$var$lastSelection = $b25c2e442c996fe7$var$activeElementInst = $b25c2e442c996fe7$var$activeElement = null;
                    break;
                case "mousedown":
                    $b25c2e442c996fe7$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b25c2e442c996fe7$var$mouseDown = !1;
                    $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b25c2e442c996fe7$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b25c2e442c996fe7$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b25c2e442c996fe7$var$isComposing ? $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b25c2e442c996fe7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b25c2e442c996fe7$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b25c2e442c996fe7$var$isComposing && (fallbackData = $b25c2e442c996fe7$var$getData()) : ($b25c2e442c996fe7$var$root = nativeEventTarget, $b25c2e442c996fe7$var$startText = "value" in $b25c2e442c996fe7$var$root ? $b25c2e442c996fe7$var$root.value : $b25c2e442c996fe7$var$root.textContent, $b25c2e442c996fe7$var$isComposing = !0)), handleEventFunc = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b25c2e442c996fe7$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b25c2e442c996fe7$var$canUseTextInputEvent ? $b25c2e442c996fe7$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b25c2e442c996fe7$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b25c2e442c996fe7$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b25c2e442c996fe7$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b25c2e442c996fe7$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b25c2e442c996fe7$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b25c2e442c996fe7$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b25c2e442c996fe7$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b25c2e442c996fe7$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $b25c2e442c996fe7$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b25c2e442c996fe7$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b25c2e442c996fe7$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b25c2e442c996fe7$var$getListener(target, registrationName), null != stateNode && listeners.push($b25c2e442c996fe7$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b25c2e442c996fe7$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b25c2e442c996fe7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b25c2e442c996fe7$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b25c2e442c996fe7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b25c2e442c996fe7$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b25c2e442c996fe7$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b25c2e442c996fe7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b25c2e442c996fe7$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b25c2e442c996fe7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b25c2e442c996fe7$var$setProp(domElement, tag, "name", props.name, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b25c2e442c996fe7$var$setProp(domElement, tag, "encType", props.encType, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "method", props.method, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b25c2e442c996fe7$var$noop$1);
            break;
        case "onScroll":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            $b25c2e442c996fe7$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b25c2e442c996fe7$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b25c2e442c996fe7$var$aliases.get(key) || key, $b25c2e442c996fe7$var$setValueForAttribute(domElement, key, value);
    }
}
function $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b25c2e442c996fe7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b25c2e442c996fe7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b25c2e442c996fe7$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b25c2e442c996fe7$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b25c2e442c996fe7$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b25c2e442c996fe7$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b25c2e442c996fe7$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b25c2e442c996fe7$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                    default:
                        $b25c2e442c996fe7$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b25c2e442c996fe7$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b25c2e442c996fe7$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b25c2e442c996fe7$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $b25c2e442c996fe7$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b25c2e442c996fe7$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b25c2e442c996fe7$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b25c2e442c996fe7$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("cancel", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b25c2e442c996fe7$var$mediaEventTypes.length; hasSrc++)$b25c2e442c996fe7$var$listenToNonDelegatedEvent($b25c2e442c996fe7$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement), $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b25c2e442c996fe7$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b25c2e442c996fe7$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b25c2e442c996fe7$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b25c2e442c996fe7$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $b25c2e442c996fe7$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b25c2e442c996fe7$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b25c2e442c996fe7$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, tag, !0) : $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b25c2e442c996fe7$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b25c2e442c996fe7$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($b25c2e442c996fe7$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $b25c2e442c996fe7$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $b25c2e442c996fe7$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $b25c2e442c996fe7$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $b25c2e442c996fe7$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $b25c2e442c996fe7$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $b25c2e442c996fe7$var$eventsEnabled = null, $b25c2e442c996fe7$var$selectionInformation = null;
function $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b25c2e442c996fe7$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b25c2e442c996fe7$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b25c2e442c996fe7$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b25c2e442c996fe7$var$currentPopstateTransitionEvent = null;
function $b25c2e442c996fe7$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b25c2e442c996fe7$var$currentPopstateTransitionEvent) return !1;
        $b25c2e442c996fe7$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b25c2e442c996fe7$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b25c2e442c996fe7$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b25c2e442c996fe7$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b25c2e442c996fe7$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b25c2e442c996fe7$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b25c2e442c996fe7$var$localPromise ? function(callback) {
    return $b25c2e442c996fe7$var$localPromise.resolve(null).then(callback).catch($b25c2e442c996fe7$var$handleErrorInNextTick);
} : $b25c2e442c996fe7$var$scheduleTimeout;
function $b25c2e442c996fe7$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b25c2e442c996fe7$var$isSingletonScope(type) {
    return "head" === type;
}
function $b25c2e442c996fe7$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b25c2e442c996fe7$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $b25c2e442c996fe7$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $b25c2e442c996fe7$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$b25c2e442c996fe7$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $b25c2e442c996fe7$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $b25c2e442c996fe7$var$retryIfBlockedOn(hydrationInstance);
}
function $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $b25c2e442c996fe7$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b25c2e442c996fe7$var$clearContainerSparingly(node);
                $b25c2e442c996fe7$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b25c2e442c996fe7$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b25c2e442c996fe7$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b25c2e442c996fe7$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b25c2e442c996fe7$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b25c2e442c996fe7$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $b25c2e442c996fe7$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $b25c2e442c996fe7$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $b25c2e442c996fe7$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = null;
function $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $b25c2e442c996fe7$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $b25c2e442c996fe7$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b25c2e442c996fe7$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(451));
    }
}
function $b25c2e442c996fe7$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $b25c2e442c996fe7$var$detachDeletedInstance(instance);
}
var $b25c2e442c996fe7$var$preloadPropsMap = new Map(), $b25c2e442c996fe7$var$preconnectsSet = new Set();
function $b25c2e442c996fe7$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $b25c2e442c996fe7$var$previousDispatcher = $b25c2e442c996fe7$var$ReactDOMSharedInternals.d;
$b25c2e442c996fe7$var$ReactDOMSharedInternals.d = {
    f: $b25c2e442c996fe7$var$flushSyncWork,
    r: $b25c2e442c996fe7$var$requestFormReset,
    D: $b25c2e442c996fe7$var$prefetchDNS,
    C: $b25c2e442c996fe7$var$preconnect,
    L: $b25c2e442c996fe7$var$preload,
    m: $b25c2e442c996fe7$var$preloadModule,
    X: $b25c2e442c996fe7$var$preinitScript,
    S: $b25c2e442c996fe7$var$preinitStyle,
    M: $b25c2e442c996fe7$var$preinitModuleScript
};
function $b25c2e442c996fe7$var$flushSyncWork() {
    var previousWasRendering = $b25c2e442c996fe7$var$previousDispatcher.f(), wasRendering = $b25c2e442c996fe7$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b25c2e442c996fe7$var$requestFormReset(form) {
    var formInst = $b25c2e442c996fe7$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b25c2e442c996fe7$var$requestFormReset$1(formInst) : $b25c2e442c996fe7$var$previousDispatcher.r(form);
}
var $b25c2e442c996fe7$var$globalDocument = "undefined" === typeof document ? null : document;
function $b25c2e442c996fe7$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b25c2e442c996fe7$var$preconnectsSet.has(limitedEscapedHref) || ($b25c2e442c996fe7$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b25c2e442c996fe7$var$setInitialProperties(href, "link", rel), $b25c2e442c996fe7$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b25c2e442c996fe7$var$prefetchDNS(href) {
    $b25c2e442c996fe7$var$previousDispatcher.D(href);
    $b25c2e442c996fe7$var$preconnectAs("dns-prefetch", href, null);
}
function $b25c2e442c996fe7$var$preconnect(href, crossOrigin) {
    $b25c2e442c996fe7$var$previousDispatcher.C(href, crossOrigin);
    $b25c2e442c996fe7$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b25c2e442c996fe7$var$preload(href, as, options) {
    $b25c2e442c996fe7$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b25c2e442c996fe7$var$getStyleKey(href);
                break;
            case "script":
                key = $b25c2e442c996fe7$var$getScriptKey(href);
        }
        $b25c2e442c996fe7$var$preloadPropsMap.has(key) || (href = $b25c2e442c996fe7$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b25c2e442c996fe7$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b25c2e442c996fe7$var$setInitialProperties(as, "link", href), $b25c2e442c996fe7$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b25c2e442c996fe7$var$preloadModule(href, options) {
    $b25c2e442c996fe7$var$previousDispatcher.m(href, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b25c2e442c996fe7$var$getScriptKey(href);
        }
        if (!$b25c2e442c996fe7$var$preloadPropsMap.has(key) && (href = $b25c2e442c996fe7$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b25c2e442c996fe7$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b25c2e442c996fe7$var$setInitialProperties(as, "link", href);
            $b25c2e442c996fe7$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b25c2e442c996fe7$var$preinitStyle(href, precedence, options) {
    $b25c2e442c996fe7$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b25c2e442c996fe7$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b25c2e442c996fe7$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b25c2e442c996fe7$var$markNodeAsHoistable(link);
                $b25c2e442c996fe7$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b25c2e442c996fe7$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b25c2e442c996fe7$var$preinitScript(src, options) {
    $b25c2e442c996fe7$var$previousDispatcher.X(src, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b25c2e442c996fe7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)), resource || (src = $b25c2e442c996fe7$var$assign({
            src: src,
            async: !0
        }, options), (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b25c2e442c996fe7$var$markNodeAsHoistable(resource), $b25c2e442c996fe7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b25c2e442c996fe7$var$preinitModuleScript(src, options) {
    $b25c2e442c996fe7$var$previousDispatcher.M(src, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b25c2e442c996fe7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)), resource || (src = $b25c2e442c996fe7$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b25c2e442c996fe7$var$markNodeAsHoistable(resource), $b25c2e442c996fe7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b25c2e442c996fe7$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b25c2e442c996fe7$var$rootInstanceStackCursor.current) ? $b25c2e442c996fe7$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b25c2e442c996fe7$var$getStyleKey(pendingProps.href), pendingProps = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b25c2e442c996fe7$var$getStyleKey(pendingProps.href);
                var styles$243 = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $b25c2e442c996fe7$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b25c2e442c996fe7$var$preloadPropsMap.set(type, pendingProps), styles$243 || $b25c2e442c996fe7$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b25c2e442c996fe7$var$getScriptKey(pendingProps), pendingProps = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(444, type));
    }
}
function $b25c2e442c996fe7$var$getStyleKey(href) {
    return 'href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(rawProps) {
    return $b25c2e442c996fe7$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b25c2e442c996fe7$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b25c2e442c996fe7$var$setInitialProperties(key, "link", preloadProps), $b25c2e442c996fe7$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b25c2e442c996fe7$var$getScriptKey(src) {
    return '[src="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b25c2e442c996fe7$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b25c2e442c996fe7$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b25c2e442c996fe7$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b25c2e442c996fe7$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
            $b25c2e442c996fe7$var$setInitialProperties(instance, "style", styleProps);
            $b25c2e442c996fe7$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b25c2e442c996fe7$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $b25c2e442c996fe7$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b25c2e442c996fe7$var$preloadPropsMap.get(styleProps)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b25c2e442c996fe7$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $b25c2e442c996fe7$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $b25c2e442c996fe7$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $b25c2e442c996fe7$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b25c2e442c996fe7$var$preloadPropsMap.get(instance$249)) instance = $b25c2e442c996fe7$var$assign({}, props), $b25c2e442c996fe7$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b25c2e442c996fe7$var$markNodeAsHoistable(styleProps);
            $b25c2e442c996fe7$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b25c2e442c996fe7$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b25c2e442c996fe7$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b25c2e442c996fe7$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b25c2e442c996fe7$var$tagCaches = null;
function $b25c2e442c996fe7$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b25c2e442c996fe7$var$tagCaches) {
        var cache = new Map();
        var caches = $b25c2e442c996fe7$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b25c2e442c996fe7$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b25c2e442c996fe7$var$internalHoistableMarker] || node[$b25c2e442c996fe7$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b25c2e442c996fe7$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $b25c2e442c996fe7$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b25c2e442c996fe7$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b25c2e442c996fe7$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(props);
            (key = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b25c2e442c996fe7$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b25c2e442c996fe7$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $b25c2e442c996fe7$var$estimatedBytesWithinLimit = 0;
function $b25c2e442c996fe7$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $b25c2e442c996fe7$var$estimatedBytesWithinLimit && ($b25c2e442c996fe7$var$estimatedBytesWithinLimit = 62500 * $b25c2e442c996fe7$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $b25c2e442c996fe7$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $b25c2e442c996fe7$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $b25c2e442c996fe7$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b25c2e442c996fe7$var$precedencesByRoot = null;
function $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b25c2e442c996fe7$var$precedencesByRoot = new Map(), resources.forEach($b25c2e442c996fe7$var$insertStylesheetIntoRoot, state), $b25c2e442c996fe7$var$precedencesByRoot = null, $b25c2e442c996fe7$var$onUnsuspend.call(state));
}
function $b25c2e442c996fe7$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b25c2e442c996fe7$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b25c2e442c996fe7$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b25c2e442c996fe7$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b25c2e442c996fe7$var$HostTransitionContext = {
    $$typeof: $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b25c2e442c996fe7$var$sharedNotPendingObject,
    _currentValue2: $b25c2e442c996fe7$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b25c2e442c996fe7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b25c2e442c996fe7$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b25c2e442c996fe7$var$createLaneMap(0);
    this.hiddenUpdates = $b25c2e442c996fe7$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b25c2e442c996fe7$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $b25c2e442c996fe7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b25c2e442c996fe7$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b25c2e442c996fe7$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b25c2e442c996fe7$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b25c2e442c996fe7$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b25c2e442c996fe7$var$emptyContextObject;
    parentComponent = $b25c2e442c996fe7$var$emptyContextObject;
    return parentComponent;
}
function $b25c2e442c996fe7$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b25c2e442c996fe7$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b25c2e442c996fe7$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b25c2e442c996fe7$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b25c2e442c996fe7$var$entangleTransitions(element, rootFiber, lane));
}
function $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane);
}
function $b25c2e442c996fe7$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $b25c2e442c996fe7$var$requestUpdateLane();
        lane = $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(lane);
        var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, lane);
        $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $b25c2e442c996fe7$var$_enabled = !0;
function $b25c2e442c996fe7$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T;
    $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2, $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T;
    $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 8, $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b25c2e442c996fe7$var$_enabled) {
        var blockedOn = $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b25c2e442c996fe7$var$return_targetInst, targetContainer), $b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b25c2e442c996fe7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b25c2e442c996fe7$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b25c2e442c996fe7$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b25c2e442c996fe7$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b25c2e442c996fe7$var$ensureRootIsScheduled(fiber);
                                0 === ($b25c2e442c996fe7$var$executionContext & 6) && ($b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = $b25c2e442c996fe7$var$now() + 500, $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 2), $b25c2e442c996fe7$var$flushSyncWork$1(), $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b25c2e442c996fe7$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b25c2e442c996fe7$var$getEventTarget(nativeEvent);
    return $b25c2e442c996fe7$var$findInstanceBlockingTarget(nativeEvent);
}
var $b25c2e442c996fe7$var$return_targetInst = null;
function $b25c2e442c996fe7$var$findInstanceBlockingTarget(targetNode) {
    $b25c2e442c996fe7$var$return_targetInst = null;
    targetNode = $b25c2e442c996fe7$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b25c2e442c996fe7$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $b25c2e442c996fe7$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b25c2e442c996fe7$var$return_targetInst = targetNode;
    return null;
}
function $b25c2e442c996fe7$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b25c2e442c996fe7$var$getCurrentPriorityLevel()){
                case $b25c2e442c996fe7$var$ImmediatePriority:
                    return 2;
                case $b25c2e442c996fe7$var$UserBlockingPriority:
                    return 8;
                case $b25c2e442c996fe7$var$NormalPriority$1:
                case $b25c2e442c996fe7$var$LowPriority:
                    return 32;
                case $b25c2e442c996fe7$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b25c2e442c996fe7$var$hasScheduledReplayAttempt = !1, $b25c2e442c996fe7$var$queuedFocus = null, $b25c2e442c996fe7$var$queuedDrag = null, $b25c2e442c996fe7$var$queuedMouse = null, $b25c2e442c996fe7$var$queuedPointers = new Map(), $b25c2e442c996fe7$var$queuedPointerCaptures = new Map(), $b25c2e442c996fe7$var$queuedExplicitHydrationTargets = [], $b25c2e442c996fe7$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b25c2e442c996fe7$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b25c2e442c996fe7$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b25c2e442c996fe7$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b25c2e442c996fe7$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b25c2e442c996fe7$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b25c2e442c996fe7$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b25c2e442c996fe7$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b25c2e442c996fe7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b25c2e442c996fe7$var$queuedFocus = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b25c2e442c996fe7$var$queuedDrag = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b25c2e442c996fe7$var$queuedMouse = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b25c2e442c996fe7$var$queuedPointers.set(pointerId, $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b25c2e442c996fe7$var$queuedPointerCaptures.set(pointerId, $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b25c2e442c996fe7$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b25c2e442c996fe7$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b25c2e442c996fe7$var$runWithPriority(queuedTarget.priority, function() {
                        $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $b25c2e442c996fe7$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b25c2e442c996fe7$var$runWithPriority(queuedTarget.priority, function() {
                        $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b25c2e442c996fe7$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b25c2e442c996fe7$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b25c2e442c996fe7$var$currentReplayingEvent = null;
        } else return targetContainers = $b25c2e442c996fe7$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b25c2e442c996fe7$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b25c2e442c996fe7$var$replayUnblockedEvents() {
    $b25c2e442c996fe7$var$hasScheduledReplayAttempt = !1;
    null !== $b25c2e442c996fe7$var$queuedFocus && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedFocus) && ($b25c2e442c996fe7$var$queuedFocus = null);
    null !== $b25c2e442c996fe7$var$queuedDrag && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedDrag) && ($b25c2e442c996fe7$var$queuedDrag = null);
    null !== $b25c2e442c996fe7$var$queuedMouse && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedMouse) && ($b25c2e442c996fe7$var$queuedMouse = null);
    $b25c2e442c996fe7$var$queuedPointers.forEach($b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap);
    $b25c2e442c996fe7$var$queuedPointerCaptures.forEach($b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap);
}
function $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b25c2e442c996fe7$var$hasScheduledReplayAttempt || ($b25c2e442c996fe7$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$replayUnblockedEvents)));
}
var $b25c2e442c996fe7$var$lastScheduledReplayQueue = null;
function $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b25c2e442c996fe7$var$lastScheduledReplayQueue !== formReplayingQueue && ($b25c2e442c996fe7$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $b25c2e442c996fe7$var$lastScheduledReplayQueue === formReplayingQueue && ($b25c2e442c996fe7$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b25c2e442c996fe7$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b25c2e442c996fe7$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b25c2e442c996fe7$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b25c2e442c996fe7$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b25c2e442c996fe7$var$queuedFocus && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedFocus, unblocked);
    null !== $b25c2e442c996fe7$var$queuedDrag && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedDrag, unblocked);
    null !== $b25c2e442c996fe7$var$queuedMouse && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedMouse, unblocked);
    $b25c2e442c996fe7$var$queuedPointers.forEach(unblock);
    $b25c2e442c996fe7$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length && (i = $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b25c2e442c996fe7$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b25c2e442c996fe7$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b25c2e442c996fe7$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b25c2e442c996fe7$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $b25c2e442c996fe7$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.render = $b25c2e442c996fe7$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b25c2e442c996fe7$var$requestUpdateLane();
    $b25c2e442c996fe7$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.unmount = $b25c2e442c996fe7$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $b25c2e442c996fe7$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b25c2e442c996fe7$var$flushSyncWork$1();
        container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = null;
    }
};
function $b25c2e442c996fe7$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b25c2e442c996fe7$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b25c2e442c996fe7$var$attemptExplicitHydrationTarget(target);
    }
};
var $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $2WGWz.version;
if ("19.2.4" !== $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(527, $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$b25c2e442c996fe7$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b25c2e442c996fe7$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b25c2e442c996fe7$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b25c2e442c996fe7$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b25c2e442c996fe7$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b25c2e442c996fe7$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b25c2e442c996fe7$var$hook$jscomp$inline_2348.isDisabled && $b25c2e442c996fe7$var$hook$jscomp$inline_2348.supportsFiber) try {
        $b25c2e442c996fe7$var$rendererID = $b25c2e442c996fe7$var$hook$jscomp$inline_2348.inject($b25c2e442c996fe7$var$internals$jscomp$inline_2347), $b25c2e442c996fe7$var$injectedHook = $b25c2e442c996fe7$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$b25c2e442c996fe7$export$882461b6382ed46c = function(container, options) {
    if (!$b25c2e442c996fe7$var$isValidContainer(container)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b25c2e442c996fe7$var$defaultOnUncaughtError, onCaughtError = $b25c2e442c996fe7$var$defaultOnCaughtError, onRecoverableError = $b25c2e442c996fe7$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $b25c2e442c996fe7$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator);
    container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = options.current;
    $b25c2e442c996fe7$var$listenToAllSupportedEvents(container);
    return new $b25c2e442c996fe7$var$ReactDOMRoot(options);
};
$b25c2e442c996fe7$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b25c2e442c996fe7$var$isValidContainer(container)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b25c2e442c996fe7$var$defaultOnUncaughtError, onCaughtError = $b25c2e442c996fe7$var$defaultOnCaughtError, onRecoverableError = $b25c2e442c996fe7$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b25c2e442c996fe7$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $b25c2e442c996fe7$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b25c2e442c996fe7$var$requestUpdateLane();
    isStrictMode = $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $b25c2e442c996fe7$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b25c2e442c996fe7$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $b25c2e442c996fe7$var$markRootUpdated$1(initialChildren, options);
    $b25c2e442c996fe7$var$ensureRootIsScheduled(initialChildren);
    container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = initialChildren.current;
    $b25c2e442c996fe7$var$listenToAllSupportedEvents(container);
    return new $b25c2e442c996fe7$var$ReactDOMHydrationRoot(initialChildren);
};
$b25c2e442c996fe7$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("2WGWz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Q9Iw"));

});

parcelRegister("9Np2q", function(module, exports) {
'use strict';
function $721c1cb7ddad561f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($721c1cb7ddad561f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$721c1cb7ddad561f$var$checkDCE();

module.exports = (parcelRequire("b7EY2"));

});
parcelRegister("b7EY2", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $8190206a2fec7346$export$69ce8ef3fe5cead0, (v) => $8190206a2fec7346$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $8190206a2fec7346$export$d39a5bbd09211389, (v) => $8190206a2fec7346$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $8190206a2fec7346$export$cd75ccfd720a3cd4, (v) => $8190206a2fec7346$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $8190206a2fec7346$export$a0816fa17a9e79be, (v) => $8190206a2fec7346$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $8190206a2fec7346$export$7292efcadded39f3, (v) => $8190206a2fec7346$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $8190206a2fec7346$export$da407abadb9b8f86, (v) => $8190206a2fec7346$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $8190206a2fec7346$export$314cfea32580671c, (v) => $8190206a2fec7346$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $8190206a2fec7346$export$513ccb98c53b8039, (v) => $8190206a2fec7346$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $8190206a2fec7346$export$dbca993bc2d264a, (v) => $8190206a2fec7346$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $8190206a2fec7346$export$4797a8006f0655d0, (v) => $8190206a2fec7346$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $8190206a2fec7346$export$c78a37762a8d58e1, (v) => $8190206a2fec7346$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $8190206a2fec7346$export$606f11b2eb45ecc6, (v) => $8190206a2fec7346$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $8190206a2fec7346$export$f7e8a0bf92324b1e, (v) => $8190206a2fec7346$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $8190206a2fec7346$export$83d89fbfd8236492, (v) => $8190206a2fec7346$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8190206a2fec7346$export$69ce8ef3fe5cead0;
var $8190206a2fec7346$export$d39a5bbd09211389;
var $8190206a2fec7346$export$cd75ccfd720a3cd4;
var $8190206a2fec7346$export$a0816fa17a9e79be;
var $8190206a2fec7346$export$7292efcadded39f3;
var $8190206a2fec7346$export$da407abadb9b8f86;
var $8190206a2fec7346$export$314cfea32580671c;
var $8190206a2fec7346$export$513ccb98c53b8039;
var $8190206a2fec7346$export$dbca993bc2d264a;
var $8190206a2fec7346$export$4797a8006f0655d0;
var $8190206a2fec7346$export$c78a37762a8d58e1;
var $8190206a2fec7346$export$606f11b2eb45ecc6;
var $8190206a2fec7346$export$f7e8a0bf92324b1e;
var $8190206a2fec7346$export$83d89fbfd8236492;
"use strict";

var $2WGWz = parcelRequire("2WGWz");
function $8190206a2fec7346$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8190206a2fec7346$var$noop() {}
var $8190206a2fec7346$var$Internals = {
    d: {
        f: $8190206a2fec7346$var$noop,
        r: function() {
            throw Error($8190206a2fec7346$var$formatProdErrorMessage(522));
        },
        D: $8190206a2fec7346$var$noop,
        C: $8190206a2fec7346$var$noop,
        L: $8190206a2fec7346$var$noop,
        m: $8190206a2fec7346$var$noop,
        X: $8190206a2fec7346$var$noop,
        S: $8190206a2fec7346$var$noop,
        M: $8190206a2fec7346$var$noop
    },
    p: 0,
    findDOMNode: null
}, $8190206a2fec7346$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $8190206a2fec7346$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8190206a2fec7346$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $8190206a2fec7346$var$ReactSharedInternals = $2WGWz.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $8190206a2fec7346$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$8190206a2fec7346$export$69ce8ef3fe5cead0 = $8190206a2fec7346$var$Internals;
$8190206a2fec7346$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($8190206a2fec7346$var$formatProdErrorMessage(299));
    return $8190206a2fec7346$var$createPortal$1(children, container, null, key);
};
$8190206a2fec7346$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $8190206a2fec7346$var$ReactSharedInternals.T, previousUpdatePriority = $8190206a2fec7346$var$Internals.p;
    try {
        if ($8190206a2fec7346$var$ReactSharedInternals.T = null, $8190206a2fec7346$var$Internals.p = 2, fn) return fn();
    } finally{
        $8190206a2fec7346$var$ReactSharedInternals.T = previousTransition, $8190206a2fec7346$var$Internals.p = previousUpdatePriority, $8190206a2fec7346$var$Internals.d.f();
    }
};
$8190206a2fec7346$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $8190206a2fec7346$var$Internals.d.C(href, options));
};
$8190206a2fec7346$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $8190206a2fec7346$var$Internals.d.D(href);
};
$8190206a2fec7346$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $8190206a2fec7346$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $8190206a2fec7346$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$8190206a2fec7346$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $8190206a2fec7346$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $8190206a2fec7346$var$Internals.d.M(href);
    }
};
$8190206a2fec7346$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(as, options.crossOrigin);
        $8190206a2fec7346$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$8190206a2fec7346$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $8190206a2fec7346$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $8190206a2fec7346$var$Internals.d.m(href);
    }
};
$8190206a2fec7346$export$4797a8006f0655d0 = function(form) {
    $8190206a2fec7346$var$Internals.d.r(form);
};
$8190206a2fec7346$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$8190206a2fec7346$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $8190206a2fec7346$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$8190206a2fec7346$export$f7e8a0bf92324b1e = function() {
    return $8190206a2fec7346$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$8190206a2fec7346$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

var $419c6008abfcce61$exports = {};
'use strict';

$419c6008abfcce61$exports = (parcelRequire("iw2gE"));



var $2WGWz = parcelRequire("2WGWz");
var $9304165f01abb7b7$exports = {};
'use strict';
function $9304165f01abb7b7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9304165f01abb7b7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9304165f01abb7b7$var$checkDCE();

$9304165f01abb7b7$exports = (parcelRequire("fjpcG"));




var $2WGWz = parcelRequire("2WGWz");
function $f00ecd7152f735d6$export$2e2bcd8739ae039(t, e) {
    return $f00ecd7152f735d6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f00ecd7152f735d6$export$2e2bcd8739ae039(t, e);
}


function $f071840576d80560$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $f00ecd7152f735d6$export$2e2bcd8739ae039)(t, o);
}



var $2WGWz = parcelRequire("2WGWz");
var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();


function $df45674546b9d52d$export$2e2bcd8739ae039() {
    return $df45674546b9d52d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df45674546b9d52d$export$2e2bcd8739ae039.apply(null, arguments);
}


function $1f958e154a600d4b$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $1f958e154a600d4b$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $1f958e154a600d4b$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $1f958e154a600d4b$var$isAbsolute(to);
    var isFromAbs = from && $1f958e154a600d4b$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $1f958e154a600d4b$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $1f958e154a600d4b$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $1f958e154a600d4b$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $1f958e154a600d4b$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$1f958e154a600d4b$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $1f958e154a600d4b$export$2e2bcd8739ae039 = $1f958e154a600d4b$var$resolvePathname;


function $d02339da850136e6$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $d02339da850136e6$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d02339da850136e6$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $d02339da850136e6$var$valueOf(a);
        var bValue = $d02339da850136e6$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $d02339da850136e6$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $d02339da850136e6$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $d02339da850136e6$export$2e2bcd8739ae039 = $d02339da850136e6$var$valueEqual;



var $7a3ddb66cda07bbd$var$isProduction = true;
var $7a3ddb66cda07bbd$var$prefix = 'Invariant failed';
function $7a3ddb66cda07bbd$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($7a3ddb66cda07bbd$var$isProduction) throw new Error($7a3ddb66cda07bbd$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($7a3ddb66cda07bbd$var$prefix, ": ").concat(provided) : $7a3ddb66cda07bbd$var$prefix;
    throw new Error(value);
}


function $a8a86f6d331f99cc$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $a8a86f6d331f99cc$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $a8a86f6d331f99cc$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $a8a86f6d331f99cc$var$stripBasename(path, prefix) {
    return $a8a86f6d331f99cc$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $a8a86f6d331f99cc$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $a8a86f6d331f99cc$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $a8a86f6d331f99cc$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $a8a86f6d331f99cc$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $a8a86f6d331f99cc$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $1f958e154a600d4b$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $a8a86f6d331f99cc$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $d02339da850136e6$export$2e2bcd8739ae039)(a.state, b.state);
}
function $a8a86f6d331f99cc$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $a8a86f6d331f99cc$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $a8a86f6d331f99cc$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $a8a86f6d331f99cc$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $a8a86f6d331f99cc$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $a8a86f6d331f99cc$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $a8a86f6d331f99cc$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $a8a86f6d331f99cc$var$PopStateEvent = 'popstate';
var $a8a86f6d331f99cc$var$HashChangeEvent = 'hashchange';
function $a8a86f6d331f99cc$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $a8a86f6d331f99cc$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$a8a86f6d331f99cc$var$canUseDOM && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $a8a86f6d331f99cc$var$supportsHistory();
    var needsHashChangeListener = !$a8a86f6d331f99cc$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $a8a86f6d331f99cc$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $a8a86f6d331f99cc$var$stripTrailingSlash($a8a86f6d331f99cc$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $a8a86f6d331f99cc$var$stripBasename(path, basename);
        return $a8a86f6d331f99cc$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $a8a86f6d331f99cc$var$createTransitionManager();
    function setState(nextState) {
        (0, $df45674546b9d52d$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($a8a86f6d331f99cc$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($a8a86f6d331f99cc$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($a8a86f6d331f99cc$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $a8a86f6d331f99cc$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $a8a86f6d331f99cc$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $a8a86f6d331f99cc$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($a8a86f6d331f99cc$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($a8a86f6d331f99cc$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($a8a86f6d331f99cc$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($a8a86f6d331f99cc$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $a8a86f6d331f99cc$var$HashChangeEvent$1 = 'hashchange';
var $a8a86f6d331f99cc$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $a8a86f6d331f99cc$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $a8a86f6d331f99cc$var$stripLeadingSlash,
        decodePath: $a8a86f6d331f99cc$var$addLeadingSlash
    },
    slash: {
        encodePath: $a8a86f6d331f99cc$var$addLeadingSlash,
        decodePath: $a8a86f6d331f99cc$var$addLeadingSlash
    }
};
function $a8a86f6d331f99cc$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $a8a86f6d331f99cc$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $a8a86f6d331f99cc$var$pushHashPath(path) {
    window.location.hash = path;
}
function $a8a86f6d331f99cc$var$replaceHashPath(path) {
    window.location.replace($a8a86f6d331f99cc$var$stripHash(window.location.href) + '#' + path);
}
function $a8a86f6d331f99cc$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$a8a86f6d331f99cc$var$canUseDOM && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $a8a86f6d331f99cc$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $a8a86f6d331f99cc$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $a8a86f6d331f99cc$var$stripTrailingSlash($a8a86f6d331f99cc$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $a8a86f6d331f99cc$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($a8a86f6d331f99cc$var$getHashPath());
        if (basename) path = $a8a86f6d331f99cc$var$stripBasename(path, basename);
        return $a8a86f6d331f99cc$export$90c043f1c57770b8(path);
    }
    var transitionManager = $a8a86f6d331f99cc$var$createTransitionManager();
    function setState(nextState) {
        (0, $df45674546b9d52d$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $a8a86f6d331f99cc$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $a8a86f6d331f99cc$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $a8a86f6d331f99cc$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($a8a86f6d331f99cc$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($a8a86f6d331f99cc$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $a8a86f6d331f99cc$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $a8a86f6d331f99cc$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $a8a86f6d331f99cc$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $a8a86f6d331f99cc$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $a8a86f6d331f99cc$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $a8a86f6d331f99cc$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $a8a86f6d331f99cc$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $a8a86f6d331f99cc$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $a8a86f6d331f99cc$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($a8a86f6d331f99cc$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $a8a86f6d331f99cc$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $a8a86f6d331f99cc$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $a8a86f6d331f99cc$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $a8a86f6d331f99cc$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($a8a86f6d331f99cc$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($a8a86f6d331f99cc$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($a8a86f6d331f99cc$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $a8a86f6d331f99cc$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $a8a86f6d331f99cc$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $a8a86f6d331f99cc$var$createTransitionManager();
    function setState(nextState) {
        (0, $df45674546b9d52d$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $a8a86f6d331f99cc$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $a8a86f6d331f99cc$export$90c043f1c57770b8(entry, undefined, createKey()) : $a8a86f6d331f99cc$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $a8a86f6d331f99cc$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $a8a86f6d331f99cc$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $a8a86f6d331f99cc$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $a8a86f6d331f99cc$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $95eb54aa412f7030$exports = {};
var $c13a601c0f58f413$exports = {};
$c13a601c0f58f413$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $95eb54aa412f7030$exports = $95eb54aa412f7030$var$pathToRegexp;
$95eb54aa412f7030$exports.parse = $95eb54aa412f7030$var$parse;
$95eb54aa412f7030$exports.compile = $95eb54aa412f7030$var$compile;
$95eb54aa412f7030$exports.tokensToFunction = $95eb54aa412f7030$var$tokensToFunction;
$95eb54aa412f7030$exports.tokensToRegExp = $95eb54aa412f7030$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $95eb54aa412f7030$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $95eb54aa412f7030$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $95eb54aa412f7030$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $95eb54aa412f7030$var$escapeGroup(pattern) : asterisk ? '.*' : $95eb54aa412f7030$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $95eb54aa412f7030$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $95eb54aa412f7030$var$escapeString(delimiter) + ']+?';
    return $95eb54aa412f7030$var$escapeString(prevText) + '|(?:(?!' + $95eb54aa412f7030$var$escapeString(prevText) + ')[^' + $95eb54aa412f7030$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $95eb54aa412f7030$var$compile(str, options) {
    return $95eb54aa412f7030$var$tokensToFunction($95eb54aa412f7030$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $95eb54aa412f7030$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $95eb54aa412f7030$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $95eb54aa412f7030$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $95eb54aa412f7030$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $95eb54aa412f7030$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($c13a601c0f58f413$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $95eb54aa412f7030$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $95eb54aa412f7030$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $95eb54aa412f7030$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $95eb54aa412f7030$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $95eb54aa412f7030$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $95eb54aa412f7030$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $95eb54aa412f7030$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $95eb54aa412f7030$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($95eb54aa412f7030$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $95eb54aa412f7030$var$flags(options));
    return $95eb54aa412f7030$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $95eb54aa412f7030$var$stringToRegexp(path, keys, options) {
    return $95eb54aa412f7030$var$tokensToRegExp($95eb54aa412f7030$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $95eb54aa412f7030$var$tokensToRegExp(tokens, keys, options) {
    if (!$c13a601c0f58f413$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $95eb54aa412f7030$var$escapeString(token);
        else {
            var prefix = $95eb54aa412f7030$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $95eb54aa412f7030$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $95eb54aa412f7030$var$attachKeys(new RegExp('^' + route, $95eb54aa412f7030$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $95eb54aa412f7030$var$pathToRegexp(path, keys, options) {
    if (!$c13a601c0f58f413$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $95eb54aa412f7030$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($c13a601c0f58f413$exports(path)) return $95eb54aa412f7030$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $95eb54aa412f7030$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $6df612c424d59fc3$exports = {};
'use strict';

$6df612c424d59fc3$exports = (parcelRequire("dhnve"));


function $75f7b2d7416e4014$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $35f9bc7c0d546ba3$exports = {};
'use strict';

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $35f9bc7c0d546ba3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $35f9bc7c0d546ba3$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$TYPE_STATICS = {};
$35f9bc7c0d546ba3$var$TYPE_STATICS[$6df612c424d59fc3$exports.ForwardRef] = $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS;
$35f9bc7c0d546ba3$var$TYPE_STATICS[$6df612c424d59fc3$exports.Memo] = $35f9bc7c0d546ba3$var$MEMO_STATICS;
function $35f9bc7c0d546ba3$var$getStatics(component) {
    // React v16.11 and below
    if ($6df612c424d59fc3$exports.isMemo(component)) return $35f9bc7c0d546ba3$var$MEMO_STATICS;
     // React v16.12 and above
    return $35f9bc7c0d546ba3$var$TYPE_STATICS[component['$$typeof']] || $35f9bc7c0d546ba3$var$REACT_STATICS;
}
var $35f9bc7c0d546ba3$var$defineProperty = Object.defineProperty;
var $35f9bc7c0d546ba3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $35f9bc7c0d546ba3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $35f9bc7c0d546ba3$var$getPrototypeOf = Object.getPrototypeOf;
var $35f9bc7c0d546ba3$var$objectPrototype = Object.prototype;
function $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($35f9bc7c0d546ba3$var$objectPrototype) {
            var inheritedComponent = $35f9bc7c0d546ba3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $35f9bc7c0d546ba3$var$objectPrototype) $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $35f9bc7c0d546ba3$var$getOwnPropertyNames(sourceComponent);
        if ($35f9bc7c0d546ba3$var$getOwnPropertySymbols) keys = keys.concat($35f9bc7c0d546ba3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $35f9bc7c0d546ba3$var$getStatics(targetComponent);
        var sourceStatics = $35f9bc7c0d546ba3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$35f9bc7c0d546ba3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $35f9bc7c0d546ba3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$35f9bc7c0d546ba3$exports = $35f9bc7c0d546ba3$var$hoistNonReactStatics;


var $80c9b230a4f51b6a$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $80c9b230a4f51b6a$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $80c9b230a4f51b6a$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $80c9b230a4f51b6a$var$commonjsGlobal[key] = ($80c9b230a4f51b6a$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $80c9b230a4f51b6a$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $80c9b230a4f51b6a$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $80c9b230a4f51b6a$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $80c9b230a4f51b6a$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $80c9b230a4f51b6a$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $f071840576d80560$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $80c9b230a4f51b6a$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($80c9b230a4f51b6a$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $80c9b230a4f51b6a$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $f071840576d80560$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $80c9b230a4f51b6a$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $80c9b230a4f51b6a$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $80c9b230a4f51b6a$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $80c9b230a4f51b6a$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createContext || $80c9b230a4f51b6a$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $80c9b230a4f51b6a$var$createNamedContext = function createNamedContext(name) {
    var context = $80c9b230a4f51b6a$var$createContext();
    context.displayName = name;
    return context;
};
var $80c9b230a4f51b6a$export$c213558b66925821 = /*#__PURE__*/ $80c9b230a4f51b6a$var$createNamedContext("Router-History");
var $80c9b230a4f51b6a$export$63baa8ccbe60bb07 = /*#__PURE__*/ $80c9b230a4f51b6a$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $80c9b230a4f51b6a$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $80c9b230a4f51b6a$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $a8a86f6d331f99cc$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
var $80c9b230a4f51b6a$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $80c9b230a4f51b6a$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $80c9b230a4f51b6a$var$messageType;
var $80c9b230a4f51b6a$var$cache = {};
var $80c9b230a4f51b6a$var$cacheLimit = 10000;
var $80c9b230a4f51b6a$var$cacheCount = 0;
function $80c9b230a4f51b6a$var$compilePath(path) {
    if ($80c9b230a4f51b6a$var$cache[path]) return $80c9b230a4f51b6a$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($95eb54aa412f7030$exports))).compile(path);
    if ($80c9b230a4f51b6a$var$cacheCount < $80c9b230a4f51b6a$var$cacheLimit) {
        $80c9b230a4f51b6a$var$cache[path] = generator;
        $80c9b230a4f51b6a$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $80c9b230a4f51b6a$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $80c9b230a4f51b6a$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $80c9b230a4f51b6a$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $a8a86f6d331f99cc$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $80c9b230a4f51b6a$export$82476f982757e71e(to, computedMatch.params) : (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, to, {
            pathname: $80c9b230a4f51b6a$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $a8a86f6d331f99cc$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $a8a86f6d331f99cc$export$c3e8bb440bd55b18)(prevLocation, (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $80c9b230a4f51b6a$var$cache$1 = {};
var $80c9b230a4f51b6a$var$cacheLimit$1 = 10000;
var $80c9b230a4f51b6a$var$cacheCount$1 = 0;
function $80c9b230a4f51b6a$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $80c9b230a4f51b6a$var$cache$1[cacheKey] || ($80c9b230a4f51b6a$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($95eb54aa412f7030$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($80c9b230a4f51b6a$var$cacheCount$1 < $80c9b230a4f51b6a$var$cacheLimit$1) {
        pathCache[path] = result;
        $80c9b230a4f51b6a$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $80c9b230a4f51b6a$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $80c9b230a4f51b6a$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $80c9b230a4f51b6a$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Children.count(children) === 0;
}
function $80c9b230a4f51b6a$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $80c9b230a4f51b6a$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $80c9b230a4f51b6a$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $80c9b230a4f51b6a$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
function $80c9b230a4f51b6a$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $80c9b230a4f51b6a$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, location, {
        pathname: $80c9b230a4f51b6a$var$addLeadingSlash(basename) + location.pathname
    });
}
function $80c9b230a4f51b6a$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $80c9b230a4f51b6a$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $80c9b230a4f51b6a$var$createURL(location) {
    return typeof location === "string" ? location : (0, $a8a86f6d331f99cc$export$fe53371bee54353d)(location);
}
function $80c9b230a4f51b6a$var$staticHandler(methodName) {
    return function() {
        (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
    };
}
function $80c9b230a4f51b6a$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $80c9b230a4f51b6a$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $80c9b230a4f51b6a$var$noop;
        };
        _this.handleBlock = function() {
            return $80c9b230a4f51b6a$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $80c9b230a4f51b6a$var$addBasename(basename, (0, $a8a86f6d331f99cc$export$90c043f1c57770b8)(location));
        context.url = $80c9b230a4f51b6a$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $75f7b2d7416e4014$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $80c9b230a4f51b6a$var$addLeadingSlash(basename + $80c9b230a4f51b6a$var$createURL(path));
            },
            action: "POP",
            location: $80c9b230a4f51b6a$var$stripBasename(basename, (0, $a8a86f6d331f99cc$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $80c9b230a4f51b6a$var$staticHandler("go"),
            goBack: $80c9b230a4f51b6a$var$staticHandler("goBack"),
            goForward: $80c9b230a4f51b6a$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$55185c17a0fcbe46, (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $80c9b230a4f51b6a$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $80c9b230a4f51b6a$export$81336c211d5ff295(location.pathname, (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $80c9b230a4f51b6a$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $75f7b2d7416e4014$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($80c9b230a4f51b6a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement(Component, (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($35f9bc7c0d546ba3$exports)))(C, Component);
}
var $80c9b230a4f51b6a$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).useContext;
function $80c9b230a4f51b6a$export$3420e1dc2c4a518c() {
    return $80c9b230a4f51b6a$var$useContext($80c9b230a4f51b6a$export$c213558b66925821);
}
function $80c9b230a4f51b6a$export$45d76561a5302f2b() {
    return $80c9b230a4f51b6a$var$useContext($80c9b230a4f51b6a$export$63baa8ccbe60bb07).location;
}
function $80c9b230a4f51b6a$export$99eaa27ddbbb95ef() {
    var match = $80c9b230a4f51b6a$var$useContext($80c9b230a4f51b6a$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $80c9b230a4f51b6a$export$632be4bb944c1bc7(path) {
    var location = $80c9b230a4f51b6a$export$45d76561a5302f2b();
    var match = $80c9b230a4f51b6a$var$useContext($80c9b230a4f51b6a$export$63baa8ccbe60bb07).match;
    return path ? $80c9b230a4f51b6a$export$81336c211d5ff295(location.pathname, path) : match;
}
var $80c9b230a4f51b6a$var$global$1, $80c9b230a4f51b6a$var$key, $80c9b230a4f51b6a$var$buildNames, $80c9b230a4f51b6a$var$initialBuildName, $80c9b230a4f51b6a$var$secondaryBuildName;




var $2WGWz = parcelRequire("2WGWz");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $e3cf8f15688cff98$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $a8a86f6d331f99cc$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement((0, $80c9b230a4f51b6a$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $e3cf8f15688cff98$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $f071840576d80560$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $a8a86f6d331f99cc$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement((0, $80c9b230a4f51b6a$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).Component);
var $e3cf8f15688cff98$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $e3cf8f15688cff98$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $a8a86f6d331f99cc$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $e3cf8f15688cff98$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $e3cf8f15688cff98$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).forwardRef;
if (typeof $e3cf8f15688cff98$var$forwardRef === "undefined") $e3cf8f15688cff98$var$forwardRef = $e3cf8f15688cff98$var$forwardRefShim;
function $e3cf8f15688cff98$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $e3cf8f15688cff98$var$LinkAnchor = $e3cf8f15688cff98$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $75f7b2d7416e4014$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$e3cf8f15688cff98$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($e3cf8f15688cff98$var$forwardRefShim !== $e3cf8f15688cff98$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $e3cf8f15688cff98$export$a6c7ac8248d6e38a = $e3cf8f15688cff98$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $e3cf8f15688cff98$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $75f7b2d7416e4014$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement((0, $80c9b230a4f51b6a$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $e3cf8f15688cff98$var$normalizeToLocation($e3cf8f15688cff98$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $e3cf8f15688cff98$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $a8a86f6d331f99cc$export$fe53371bee54353d)(context.location) === (0, $a8a86f6d331f99cc$export$fe53371bee54353d)($e3cf8f15688cff98$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($e3cf8f15688cff98$var$forwardRefShim !== $e3cf8f15688cff98$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement(component, props);
    });
});
var $e3cf8f15688cff98$var$toType, $e3cf8f15688cff98$var$refType;
var $e3cf8f15688cff98$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $e3cf8f15688cff98$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).forwardRef;
if (typeof $e3cf8f15688cff98$var$forwardRef$1 === "undefined") $e3cf8f15688cff98$var$forwardRef$1 = $e3cf8f15688cff98$var$forwardRefShim$1;
function $e3cf8f15688cff98$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $e3cf8f15688cff98$export$b0d92dbee9b5b60d = $e3cf8f15688cff98$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $75f7b2d7416e4014$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement((0, $80c9b230a4f51b6a$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $e3cf8f15688cff98$var$normalizeToLocation($e3cf8f15688cff98$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $80c9b230a4f51b6a$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $e3cf8f15688cff98$var$joinClassnames(className, activeClassName);
            style = (0, $df45674546b9d52d$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $df45674546b9d52d$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($e3cf8f15688cff98$var$forwardRefShim$1 !== $e3cf8f15688cff98$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).createElement($e3cf8f15688cff98$export$a6c7ac8248d6e38a, props);
    });
});
var $e3cf8f15688cff98$var$ariaCurrentType;




var $2WGWz = parcelRequire("2WGWz");


parcelRequire("2WGWz");



var $2WGWz = parcelRequire("2WGWz");
const $d8dc7d600134d582$var$ThemeContext = /*#__PURE__*/ (0, $2WGWz.createContext)(undefined);
const $d8dc7d600134d582$export$d8964aec282183a3 = ({ children: children })=>{
    const [isDarkMode, setIsDarkMode] = (0, $2WGWz.useState)(()=>{
        // Check localStorage or system preference
        const saved = localStorage.getItem('darkMode');
        if (saved !== null) return saved === 'true';
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    });
    (0, $2WGWz.useEffect)(()=>{
        // Update document class and localStorage
        if (isDarkMode) document.documentElement.classList.add('dark');
        else document.documentElement.classList.remove('dark');
        localStorage.setItem('darkMode', isDarkMode.toString());
    }, [
        isDarkMode
    ]);
    const toggleDarkMode = ()=>{
        setIsDarkMode((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($d8dc7d600134d582$var$ThemeContext.Provider, {
        value: {
            isDarkMode: isDarkMode,
            toggleDarkMode: toggleDarkMode
        },
        children: children
    });
};
const $d8dc7d600134d582$export$93d4e7f90805808f = ()=>{
    const context = (0, $2WGWz.useContext)($d8dc7d600134d582$var$ThemeContext);
    if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};


const $e1131a681a58b314$var$Header = ({ roomName: roomName, roomCode: roomCode })=>{
    const { isDarkMode: isDarkMode, toggleDarkMode: toggleDarkMode } = (0, $d8dc7d600134d582$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("header", {
        className: "bg-gradient-to-r from-primary-dark to-primary dark:from-gray-800 dark:to-gray-900 text-white shadow-md",
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
            className: "container mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center",
            children: [
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h1", {
                    className: "text-2xl font-bold",
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $e3cf8f15688cff98$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "text-white no-underline hover:text-blue-100 dark:hover:text-blue-200 transition-colors duration-200 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-6 w-6 mr-2",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                                })
                            }),
                            "Planning Poker"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                    className: "mt-2 sm:mt-0 flex items-center gap-4",
                    children: [
                        roomName && roomCode && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                            className: "text-center sm:text-right",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                                    className: "text-xl font-semibold",
                                    children: roomName
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                    className: "flex items-center justify-center sm:justify-end mt-1",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                            className: "text-blue-100 dark:text-blue-200",
                                            children: "Room Code:"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                            className: "ml-2 bg-white dark:bg-gray-700 text-primary dark:text-blue-300 font-mono px-2 py-1 rounded text-sm font-bold",
                                            children: roomCode
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                            onClick: ()=>navigator.clipboard.writeText(`https://poker.bwatson.uk/?join=${roomCode}`),
                                            className: "ml-2 text-white hover:text-blue-100 dark:hover:text-blue-200 focus:outline-none",
                                            title: "Copy room code URL to clipboard",
                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "h-5 w-5",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                            onClick: toggleDarkMode,
                            className: "p-2 rounded-lg hover:bg-white/10 dark:hover:bg-black/20 transition-colors",
                            title: isDarkMode ? 'Switch to light mode' : 'Switch to dark mode',
                            children: isDarkMode ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                className: "w-6 h-6",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                                })
                            }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                className: "w-6 h-6",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $e1131a681a58b314$export$2e2bcd8739ae039 = $e1131a681a58b314$var$Header;


// src/utils/authUtils.ts
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This value is retrieved and hardcoded by the NPM postinstall script
const $123463f6479073c7$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $4e6a98b76c0d0a37$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $4e6a98b76c0d0a37$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $4e6a98b76c0d0a37$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $4e6a98b76c0d0a37$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $4e6a98b76c0d0a37$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4e6a98b76c0d0a37$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $4e6a98b76c0d0a37$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $4e6a98b76c0d0a37$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($4e6a98b76c0d0a37$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $4e6a98b76c0d0a37$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $4e6a98b76c0d0a37$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $4e6a98b76c0d0a37$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $4e6a98b76c0d0a37$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $4e6a98b76c0d0a37$var$stringToByteArray$1(str);
    return $4e6a98b76c0d0a37$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $4e6a98b76c0d0a37$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $4e6a98b76c0d0a37$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $4e6a98b76c0d0a37$export$c62426fdd000a97e = function(str) {
    try {
        return $4e6a98b76c0d0a37$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $4e6a98b76c0d0a37$export$6c40052bed430212(value) {
    return $4e6a98b76c0d0a37$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $4e6a98b76c0d0a37$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$4e6a98b76c0d0a37$var$isValidKey(prop)) continue;
        target[prop] = $4e6a98b76c0d0a37$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $4e6a98b76c0d0a37$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $4e6a98b76c0d0a37$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4e6a98b76c0d0a37$var$getDefaultsFromGlobal = ()=>$4e6a98b76c0d0a37$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $4e6a98b76c0d0a37$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $4e6a98b76c0d0a37$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $4e6a98b76c0d0a37$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $4e6a98b76c0d0a37$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $123463f6479073c7$export$6d3c090e66a883b1)() || $4e6a98b76c0d0a37$var$getDefaultsFromGlobal() || $4e6a98b76c0d0a37$var$getDefaultsFromEnvVariable() || $4e6a98b76c0d0a37$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $4e6a98b76c0d0a37$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $4e6a98b76c0d0a37$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $4e6a98b76c0d0a37$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $4e6a98b76c0d0a37$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $4e6a98b76c0d0a37$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $4e6a98b76c0d0a37$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $4e6a98b76c0d0a37$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $4e6a98b76c0d0a37$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $4e6a98b76c0d0a37$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $4e6a98b76c0d0a37$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch (_a) {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $4e6a98b76c0d0a37$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e6a98b76c0d0a37$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $4e6a98b76c0d0a37$export$4b5284a3025a455(JSON.stringify(header)),
        $4e6a98b76c0d0a37$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $4e6a98b76c0d0a37$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $4e6a98b76c0d0a37$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($4e6a98b76c0d0a37$var$emulatorStatus))if ($4e6a98b76c0d0a37$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $4e6a98b76c0d0a37$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $4e6a98b76c0d0a37$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $4e6a98b76c0d0a37$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$4e6a98b76c0d0a37$export$5b4d24b45140ad90(window.location.host) || $4e6a98b76c0d0a37$var$emulatorStatus[name] === isRunningEmulator || $4e6a98b76c0d0a37$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $4e6a98b76c0d0a37$var$previouslyDismissed) return;
    $4e6a98b76c0d0a37$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $4e6a98b76c0d0a37$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $4e6a98b76c0d0a37$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $4e6a98b76c0d0a37$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $4e6a98b76c0d0a37$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $4e6a98b76c0d0a37$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($4e6a98b76c0d0a37$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $4e6a98b76c0d0a37$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $4e6a98b76c0d0a37$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $4e6a98b76c0d0a37$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $4e6a98b76c0d0a37$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $4e6a98b76c0d0a37$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $4e6a98b76c0d0a37$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $4e6a98b76c0d0a37$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $4e6a98b76c0d0a37$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $4e6a98b76c0d0a37$export$f2f6a8999f8ebd30() {
    return $4e6a98b76c0d0a37$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $4e6a98b76c0d0a37$export$7e7b1a9668aaed8() {
    const ua = $4e6a98b76c0d0a37$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $4e6a98b76c0d0a37$export$202944b2d2824246() {
    return $4e6a98b76c0d0a37$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7() {
    return $4e6a98b76c0d0a37$export$588c7fdda06fbb0a.NODE_CLIENT === true || $4e6a98b76c0d0a37$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $4e6a98b76c0d0a37$export$95df08bae54cb4df() {
    return !$4e6a98b76c0d0a37$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $4e6a98b76c0d0a37$export$ef10bcfb06572016() {
    return !$4e6a98b76c0d0a37$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $4e6a98b76c0d0a37$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $4e6a98b76c0d0a37$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $4e6a98b76c0d0a37$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $4e6a98b76c0d0a37$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $4e6a98b76c0d0a37$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $4e6a98b76c0d0a37$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $4e6a98b76c0d0a37$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $4e6a98b76c0d0a37$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $4e6a98b76c0d0a37$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $4e6a98b76c0d0a37$var$replaceTemplate(template, data) {
    return template.replace($4e6a98b76c0d0a37$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $4e6a98b76c0d0a37$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $4e6a98b76c0d0a37$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $4e6a98b76c0d0a37$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4e6a98b76c0d0a37$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $4e6a98b76c0d0a37$export$c5a53ce6a17cf18d($4e6a98b76c0d0a37$export$c62426fdd000a97e(parts[0]) || '');
        claims = $4e6a98b76c0d0a37$export$c5a53ce6a17cf18d($4e6a98b76c0d0a37$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4e6a98b76c0d0a37$export$5f870fcca7ae6a88 = function(token) {
    const claims = $4e6a98b76c0d0a37$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4e6a98b76c0d0a37$export$701c661ec91095f2 = function(token) {
    const claims = $4e6a98b76c0d0a37$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4e6a98b76c0d0a37$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $4e6a98b76c0d0a37$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $4e6a98b76c0d0a37$export$fc970ed23da99565 = function(token) {
    const claims = $4e6a98b76c0d0a37$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e6a98b76c0d0a37$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $4e6a98b76c0d0a37$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $4e6a98b76c0d0a37$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $4e6a98b76c0d0a37$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $4e6a98b76c0d0a37$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($4e6a98b76c0d0a37$var$isObject(aProp) && $4e6a98b76c0d0a37$var$isObject(bProp)) {
            if (!$4e6a98b76c0d0a37$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $4e6a98b76c0d0a37$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $4e6a98b76c0d0a37$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $4e6a98b76c0d0a37$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $4e6a98b76c0d0a37$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $4e6a98b76c0d0a37$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $4e6a98b76c0d0a37$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $4e6a98b76c0d0a37$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $4e6a98b76c0d0a37$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $4e6a98b76c0d0a37$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $4e6a98b76c0d0a37$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($4e6a98b76c0d0a37$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $4e6a98b76c0d0a37$var$noop;
        if (observer.error === undefined) observer.error = $4e6a98b76c0d0a37$var$noop;
        if (observer.complete === undefined) observer.complete = $4e6a98b76c0d0a37$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4e6a98b76c0d0a37$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $4e6a98b76c0d0a37$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $4e6a98b76c0d0a37$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $4e6a98b76c0d0a37$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $4e6a98b76c0d0a37$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $4e6a98b76c0d0a37$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($4e6a98b76c0d0a37$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($4e6a98b76c0d0a37$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $4e6a98b76c0d0a37$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($4e6a98b76c0d0a37$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $4e6a98b76c0d0a37$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $4e6a98b76c0d0a37$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $4e6a98b76c0d0a37$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $4e6a98b76c0d0a37$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $4e6a98b76c0d0a37$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $4e6a98b76c0d0a37$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $4e6a98b76c0d0a37$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $4e6a98b76c0d0a37$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $4e6a98b76c0d0a37$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $4e6a98b76c0d0a37$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $4e6a98b76c0d0a37$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($4e6a98b76c0d0a37$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $4e6a98b76c0d0a37$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $4e6a98b76c0d0a37$var$indicator(i);
}
function $4e6a98b76c0d0a37$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e6a98b76c0d0a37$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}



/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $3ba5282a700177ce$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $3ba5282a700177ce$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($3ba5282a700177ce$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $3ba5282a700177ce$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $3ba5282a700177ce$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $3ba5282a700177ce$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $3ba5282a700177ce$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $3ba5282a700177ce$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $3ba5282a700177ce$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


var $7c898bf562ba0419$exports = {};

$parcel$export($7c898bf562ba0419$exports, "_DEFAULT_ENTRY_NAME", () => $7c898bf562ba0419$export$9f30fa0c10967f7f);
$parcel$export($7c898bf562ba0419$exports, "_apps", () => $7c898bf562ba0419$export$b4e3c36c855b14b5);
$parcel$export($7c898bf562ba0419$exports, "_serverApps", () => $7c898bf562ba0419$export$fb03ad8d3d5c5f76);
$parcel$export($7c898bf562ba0419$exports, "_components", () => $7c898bf562ba0419$export$9566bce3835c0f28);
$parcel$export($7c898bf562ba0419$exports, "_addComponent", () => $7c898bf562ba0419$export$fa5244b94c62d36a);
$parcel$export($7c898bf562ba0419$exports, "_addOrOverwriteComponent", () => $7c898bf562ba0419$export$4393112b42e2b41d);
$parcel$export($7c898bf562ba0419$exports, "_registerComponent", () => $7c898bf562ba0419$export$c930050e7bb63965);
$parcel$export($7c898bf562ba0419$exports, "_getProvider", () => $7c898bf562ba0419$export$fa0d6da0f5838f50);
$parcel$export($7c898bf562ba0419$exports, "_removeServiceInstance", () => $7c898bf562ba0419$export$48d18de2ff1c45a5);
$parcel$export($7c898bf562ba0419$exports, "_isFirebaseApp", () => $7c898bf562ba0419$export$110778f8e98b8257);
$parcel$export($7c898bf562ba0419$exports, "_isFirebaseServerApp", () => $7c898bf562ba0419$export$643c8bc6c389f34e);
$parcel$export($7c898bf562ba0419$exports, "_clearComponents", () => $7c898bf562ba0419$export$3685d89b9c3cdfaf);
$parcel$export($7c898bf562ba0419$exports, "registerVersion", () => $7c898bf562ba0419$export$d29d5299a7137abc);
$parcel$export($7c898bf562ba0419$exports, "deleteApp", () => $7c898bf562ba0419$export$6eec44aa53d5ea34);
$parcel$export($7c898bf562ba0419$exports, "SDK_VERSION", () => $7c898bf562ba0419$export$31499a9cd224b78c);
$parcel$export($7c898bf562ba0419$exports, "initializeApp", () => $7c898bf562ba0419$export$c55cfd413944906d);
$parcel$export($7c898bf562ba0419$exports, "initializeServerApp", () => $7c898bf562ba0419$export$45a407ab953b136b);
$parcel$export($7c898bf562ba0419$exports, "getApp", () => $7c898bf562ba0419$export$f9962582c9e66d99);
$parcel$export($7c898bf562ba0419$exports, "getApps", () => $7c898bf562ba0419$export$68ddedf7d44b3bdf);
$parcel$export($7c898bf562ba0419$exports, "onLog", () => $7c898bf562ba0419$export$a82ad227dc8163dc);
$parcel$export($7c898bf562ba0419$exports, "setLogLevel", () => $7c898bf562ba0419$export$c622e99c0ce7b1c9);
$parcel$export($7c898bf562ba0419$exports, "FirebaseError", () => $4e6a98b76c0d0a37$export$dd24e9cd51226c56);

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $ff3e0e0e6ac6e856$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $ff3e0e0e6ac6e856$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($ff3e0e0e6ac6e856$export$243e62d78d3b544d || ($ff3e0e0e6ac6e856$export$243e62d78d3b544d = {}));
const $ff3e0e0e6ac6e856$var$levelStringToEnum = {
    'debug': $ff3e0e0e6ac6e856$export$243e62d78d3b544d.DEBUG,
    'verbose': $ff3e0e0e6ac6e856$export$243e62d78d3b544d.VERBOSE,
    'info': $ff3e0e0e6ac6e856$export$243e62d78d3b544d.INFO,
    'warn': $ff3e0e0e6ac6e856$export$243e62d78d3b544d.WARN,
    'error': $ff3e0e0e6ac6e856$export$243e62d78d3b544d.ERROR,
    'silent': $ff3e0e0e6ac6e856$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $ff3e0e0e6ac6e856$var$defaultLogLevel = $ff3e0e0e6ac6e856$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $ff3e0e0e6ac6e856$var$ConsoleMethod = {
    [$ff3e0e0e6ac6e856$export$243e62d78d3b544d.DEBUG]: 'log',
    [$ff3e0e0e6ac6e856$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$ff3e0e0e6ac6e856$export$243e62d78d3b544d.INFO]: 'info',
    [$ff3e0e0e6ac6e856$export$243e62d78d3b544d.WARN]: 'warn',
    [$ff3e0e0e6ac6e856$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $ff3e0e0e6ac6e856$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $ff3e0e0e6ac6e856$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $ff3e0e0e6ac6e856$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $ff3e0e0e6ac6e856$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $ff3e0e0e6ac6e856$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $ff3e0e0e6ac6e856$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $ff3e0e0e6ac6e856$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $ff3e0e0e6ac6e856$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $ff3e0e0e6ac6e856$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $ff3e0e0e6ac6e856$export$c622e99c0ce7b1c9(level) {
    $ff3e0e0e6ac6e856$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $ff3e0e0e6ac6e856$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $ff3e0e0e6ac6e856$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $ff3e0e0e6ac6e856$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $ff3e0e0e6ac6e856$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $a6c43262c30cd8d1$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $a6c43262c30cd8d1$var$idbProxyableTypes;
let $a6c43262c30cd8d1$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $a6c43262c30cd8d1$var$getIdbProxyableTypes() {
    return $a6c43262c30cd8d1$var$idbProxyableTypes || ($a6c43262c30cd8d1$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $a6c43262c30cd8d1$var$getCursorAdvanceMethods() {
    return $a6c43262c30cd8d1$var$cursorAdvanceMethods || ($a6c43262c30cd8d1$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $a6c43262c30cd8d1$var$cursorRequestMap = new WeakMap();
const $a6c43262c30cd8d1$var$transactionDoneMap = new WeakMap();
const $a6c43262c30cd8d1$var$transactionStoreNamesMap = new WeakMap();
const $a6c43262c30cd8d1$var$transformCache = new WeakMap();
const $a6c43262c30cd8d1$export$407448d2b89b1813 = new WeakMap();
function $a6c43262c30cd8d1$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($a6c43262c30cd8d1$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $a6c43262c30cd8d1$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $a6c43262c30cd8d1$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $a6c43262c30cd8d1$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($a6c43262c30cd8d1$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $a6c43262c30cd8d1$var$transactionDoneMap.set(tx, done);
}
let $a6c43262c30cd8d1$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $a6c43262c30cd8d1$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $a6c43262c30cd8d1$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $a6c43262c30cd8d1$export$43caf9889c228507(callback) {
    $a6c43262c30cd8d1$var$idbProxyTraps = callback($a6c43262c30cd8d1$var$idbProxyTraps);
}
function $a6c43262c30cd8d1$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($a6c43262c30cd8d1$export$3b14a55fb2447963(this), storeNames, ...args);
        $a6c43262c30cd8d1$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($a6c43262c30cd8d1$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($a6c43262c30cd8d1$export$3b14a55fb2447963(this), args);
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b($a6c43262c30cd8d1$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $a6c43262c30cd8d1$export$efccba1c4a2ef57b(func.apply($a6c43262c30cd8d1$export$3b14a55fb2447963(this), args));
    };
}
function $a6c43262c30cd8d1$var$transformCachableValue(value) {
    if (typeof value === 'function') return $a6c43262c30cd8d1$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $a6c43262c30cd8d1$var$cacheDonePromiseForTransaction(value);
    if ($a6c43262c30cd8d1$export$23f2a1d2818174ef(value, $a6c43262c30cd8d1$var$getIdbProxyableTypes())) return new Proxy(value, $a6c43262c30cd8d1$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $a6c43262c30cd8d1$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $a6c43262c30cd8d1$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($a6c43262c30cd8d1$var$transformCache.has(value)) return $a6c43262c30cd8d1$var$transformCache.get(value);
    const newValue = $a6c43262c30cd8d1$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $a6c43262c30cd8d1$var$transformCache.set(value, newValue);
        $a6c43262c30cd8d1$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $a6c43262c30cd8d1$export$3b14a55fb2447963 = (value)=>$a6c43262c30cd8d1$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $dcd2f819ff509019$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $dcd2f819ff509019$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $a6c43262c30cd8d1$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $dcd2f819ff509019$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $dcd2f819ff509019$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $dcd2f819ff509019$var$cachedMethods = new Map();
function $dcd2f819ff509019$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($dcd2f819ff509019$var$cachedMethods.get(prop)) return $dcd2f819ff509019$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $dcd2f819ff509019$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $dcd2f819ff509019$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $dcd2f819ff509019$var$cachedMethods.set(prop, method);
    return method;
}
(0, $a6c43262c30cd8d1$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$dcd2f819ff509019$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$dcd2f819ff509019$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $7c898bf562ba0419$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($7c898bf562ba0419$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $7c898bf562ba0419$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $7c898bf562ba0419$var$name$q = "@firebase/app";
const $7c898bf562ba0419$var$version$1 = "0.13.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7c898bf562ba0419$var$logger = new (0, $ff3e0e0e6ac6e856$export$efa9a398d6368992)('@firebase/app');
const $7c898bf562ba0419$var$name$p = "@firebase/app-compat";
const $7c898bf562ba0419$var$name$o = "@firebase/analytics-compat";
const $7c898bf562ba0419$var$name$n = "@firebase/analytics";
const $7c898bf562ba0419$var$name$m = "@firebase/app-check-compat";
const $7c898bf562ba0419$var$name$l = "@firebase/app-check";
const $7c898bf562ba0419$var$name$k = "@firebase/auth";
const $7c898bf562ba0419$var$name$j = "@firebase/auth-compat";
const $7c898bf562ba0419$var$name$i = "@firebase/database";
const $7c898bf562ba0419$var$name$h = "@firebase/data-connect";
const $7c898bf562ba0419$var$name$g = "@firebase/database-compat";
const $7c898bf562ba0419$var$name$f = "@firebase/functions";
const $7c898bf562ba0419$var$name$e = "@firebase/functions-compat";
const $7c898bf562ba0419$var$name$d = "@firebase/installations";
const $7c898bf562ba0419$var$name$c = "@firebase/installations-compat";
const $7c898bf562ba0419$var$name$b = "@firebase/messaging";
const $7c898bf562ba0419$var$name$a = "@firebase/messaging-compat";
const $7c898bf562ba0419$var$name$9 = "@firebase/performance";
const $7c898bf562ba0419$var$name$8 = "@firebase/performance-compat";
const $7c898bf562ba0419$var$name$7 = "@firebase/remote-config";
const $7c898bf562ba0419$var$name$6 = "@firebase/remote-config-compat";
const $7c898bf562ba0419$var$name$5 = "@firebase/storage";
const $7c898bf562ba0419$var$name$4 = "@firebase/storage-compat";
const $7c898bf562ba0419$var$name$3 = "@firebase/firestore";
const $7c898bf562ba0419$var$name$2 = "@firebase/ai";
const $7c898bf562ba0419$var$name$1 = "@firebase/firestore-compat";
const $7c898bf562ba0419$var$name = "firebase";
const $7c898bf562ba0419$var$version = "11.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $7c898bf562ba0419$export$9f30fa0c10967f7f = '[DEFAULT]';
const $7c898bf562ba0419$var$PLATFORM_LOG_STRING = {
    [$7c898bf562ba0419$var$name$q]: 'fire-core',
    [$7c898bf562ba0419$var$name$p]: 'fire-core-compat',
    [$7c898bf562ba0419$var$name$n]: 'fire-analytics',
    [$7c898bf562ba0419$var$name$o]: 'fire-analytics-compat',
    [$7c898bf562ba0419$var$name$l]: 'fire-app-check',
    [$7c898bf562ba0419$var$name$m]: 'fire-app-check-compat',
    [$7c898bf562ba0419$var$name$k]: 'fire-auth',
    [$7c898bf562ba0419$var$name$j]: 'fire-auth-compat',
    [$7c898bf562ba0419$var$name$i]: 'fire-rtdb',
    [$7c898bf562ba0419$var$name$h]: 'fire-data-connect',
    [$7c898bf562ba0419$var$name$g]: 'fire-rtdb-compat',
    [$7c898bf562ba0419$var$name$f]: 'fire-fn',
    [$7c898bf562ba0419$var$name$e]: 'fire-fn-compat',
    [$7c898bf562ba0419$var$name$d]: 'fire-iid',
    [$7c898bf562ba0419$var$name$c]: 'fire-iid-compat',
    [$7c898bf562ba0419$var$name$b]: 'fire-fcm',
    [$7c898bf562ba0419$var$name$a]: 'fire-fcm-compat',
    [$7c898bf562ba0419$var$name$9]: 'fire-perf',
    [$7c898bf562ba0419$var$name$8]: 'fire-perf-compat',
    [$7c898bf562ba0419$var$name$7]: 'fire-rc',
    [$7c898bf562ba0419$var$name$6]: 'fire-rc-compat',
    [$7c898bf562ba0419$var$name$5]: 'fire-gcs',
    [$7c898bf562ba0419$var$name$4]: 'fire-gcs-compat',
    [$7c898bf562ba0419$var$name$3]: 'fire-fst',
    [$7c898bf562ba0419$var$name$1]: 'fire-fst-compat',
    [$7c898bf562ba0419$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$7c898bf562ba0419$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $7c898bf562ba0419$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $7c898bf562ba0419$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c898bf562ba0419$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $7c898bf562ba0419$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $7c898bf562ba0419$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $7c898bf562ba0419$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $7c898bf562ba0419$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($7c898bf562ba0419$export$9566bce3835c0f28.has(componentName)) {
        $7c898bf562ba0419$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $7c898bf562ba0419$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $7c898bf562ba0419$export$b4e3c36c855b14b5.values())$7c898bf562ba0419$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $7c898bf562ba0419$export$fb03ad8d3d5c5f76.values())$7c898bf562ba0419$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $7c898bf562ba0419$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $7c898bf562ba0419$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $7c898bf562ba0419$export$9f30fa0c10967f7f) {
    $7c898bf562ba0419$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $7c898bf562ba0419$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $7c898bf562ba0419$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $7c898bf562ba0419$export$3685d89b9c3cdfaf() {
    $7c898bf562ba0419$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7c898bf562ba0419$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $7c898bf562ba0419$var$ERROR_FACTORY = new (0, $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40)('app', 'Firebase', $7c898bf562ba0419$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $7c898bf562ba0419$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $7c898bf562ba0419$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $7c898bf562ba0419$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $4e6a98b76c0d0a37$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $7c898bf562ba0419$var$FirebaseServerAppImpl extends $7c898bf562ba0419$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $7c898bf562ba0419$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $7c898bf562ba0419$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $7c898bf562ba0419$export$d29d5299a7137abc($7c898bf562ba0419$var$name$q, $7c898bf562ba0419$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $7c898bf562ba0419$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $7c898bf562ba0419$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $7c898bf562ba0419$export$31499a9cd224b78c = $7c898bf562ba0419$var$version;
function $7c898bf562ba0419$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $7c898bf562ba0419$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $7c898bf562ba0419$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $4e6a98b76c0d0a37$export$3dfb6827a9f89756)());
    if (!options) throw $7c898bf562ba0419$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $7c898bf562ba0419$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $4e6a98b76c0d0a37$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $4e6a98b76c0d0a37$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $7c898bf562ba0419$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $3ba5282a700177ce$export$436a80eea5d5c0c5)(name);
    for (const component of $7c898bf562ba0419$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $7c898bf562ba0419$var$FirebaseAppImpl(options, config, container);
    $7c898bf562ba0419$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $7c898bf562ba0419$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $4e6a98b76c0d0a37$export$4e09c449d6c407f7)() && !(0, $4e6a98b76c0d0a37$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $7c898bf562ba0419$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = true;
    let appOptions;
    if ($7c898bf562ba0419$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $7c898bf562ba0419$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $7c898bf562ba0419$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $3ba5282a700177ce$export$436a80eea5d5c0c5)(nameString);
    for (const component of $7c898bf562ba0419$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $7c898bf562ba0419$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $7c898bf562ba0419$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $7c898bf562ba0419$export$f9962582c9e66d99(name = $7c898bf562ba0419$export$9f30fa0c10967f7f) {
    const app = $7c898bf562ba0419$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $7c898bf562ba0419$export$9f30fa0c10967f7f && (0, $4e6a98b76c0d0a37$export$3dfb6827a9f89756)()) return $7c898bf562ba0419$export$c55cfd413944906d();
    if (!app) throw $7c898bf562ba0419$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $7c898bf562ba0419$export$68ddedf7d44b3bdf() {
    return Array.from($7c898bf562ba0419$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $7c898bf562ba0419$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($7c898bf562ba0419$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $7c898bf562ba0419$export$b4e3c36c855b14b5.delete(name);
    } else if ($7c898bf562ba0419$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $7c898bf562ba0419$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $7c898bf562ba0419$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $7c898bf562ba0419$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $7c898bf562ba0419$var$logger.warn(warning.join(' '));
        return;
    }
    $7c898bf562ba0419$export$c930050e7bb63965(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $7c898bf562ba0419$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $7c898bf562ba0419$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $ff3e0e0e6ac6e856$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $7c898bf562ba0419$export$c622e99c0ce7b1c9(logLevel) {
    (0, $ff3e0e0e6ac6e856$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7c898bf562ba0419$var$DB_NAME = 'firebase-heartbeat-database';
const $7c898bf562ba0419$var$DB_VERSION = 1;
const $7c898bf562ba0419$var$STORE_NAME = 'firebase-heartbeat-store';
let $7c898bf562ba0419$var$dbPromise = null;
function $7c898bf562ba0419$var$getDbPromise() {
    if (!$7c898bf562ba0419$var$dbPromise) $7c898bf562ba0419$var$dbPromise = (0, $dcd2f819ff509019$export$ca0ed41b1a2af7e)($7c898bf562ba0419$var$DB_NAME, $7c898bf562ba0419$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($7c898bf562ba0419$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $7c898bf562ba0419$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $7c898bf562ba0419$var$dbPromise;
}
async function $7c898bf562ba0419$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $7c898bf562ba0419$var$getDbPromise();
        const tx = db.transaction($7c898bf562ba0419$var$STORE_NAME);
        const result = await tx.objectStore($7c898bf562ba0419$var$STORE_NAME).get($7c898bf562ba0419$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56)) $7c898bf562ba0419$var$logger.warn(e.message);
        else {
            const idbGetError = $7c898bf562ba0419$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $7c898bf562ba0419$var$logger.warn(idbGetError.message);
        }
    }
}
async function $7c898bf562ba0419$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $7c898bf562ba0419$var$getDbPromise();
        const tx = db.transaction($7c898bf562ba0419$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($7c898bf562ba0419$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $7c898bf562ba0419$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56)) $7c898bf562ba0419$var$logger.warn(e.message);
        else {
            const idbGetError = $7c898bf562ba0419$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $7c898bf562ba0419$var$logger.warn(idbGetError.message);
        }
    }
}
function $7c898bf562ba0419$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7c898bf562ba0419$var$MAX_HEADER_BYTES = 1024;
const $7c898bf562ba0419$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $7c898bf562ba0419$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $7c898bf562ba0419$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $7c898bf562ba0419$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $7c898bf562ba0419$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $7c898bf562ba0419$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $7c898bf562ba0419$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $7c898bf562ba0419$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $7c898bf562ba0419$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $4e6a98b76c0d0a37$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $7c898bf562ba0419$var$logger.warn(e);
            return '';
        }
    }
}
function $7c898bf562ba0419$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $7c898bf562ba0419$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $7c898bf562ba0419$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($7c898bf562ba0419$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($7c898bf562ba0419$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $7c898bf562ba0419$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $4e6a98b76c0d0a37$export$3865db50535c2055)()) return false;
        else return (0, $4e6a98b76c0d0a37$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $7c898bf562ba0419$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $7c898bf562ba0419$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $7c898bf562ba0419$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $7c898bf562ba0419$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $4e6a98b76c0d0a37$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $7c898bf562ba0419$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7c898bf562ba0419$var$registerCoreComponents(variant) {
    $7c898bf562ba0419$export$c930050e7bb63965(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('platform-logger', (container)=>new $7c898bf562ba0419$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $7c898bf562ba0419$export$c930050e7bb63965(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('heartbeat', (container)=>new $7c898bf562ba0419$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $7c898bf562ba0419$export$d29d5299a7137abc($7c898bf562ba0419$var$name$q, $7c898bf562ba0419$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    $7c898bf562ba0419$export$d29d5299a7137abc($7c898bf562ba0419$var$name$q, $7c898bf562ba0419$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $7c898bf562ba0419$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $7c898bf562ba0419$var$registerCoreComponents('');



/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Global context object for a collection of services using
 * a shared authentication state.
 *
 * marked as internal because it references internal types exported from @firebase/app
 * @internal
 */ class $fa83d0b019b2237e$var$FirebaseAppImpl {
    constructor(_delegate, firebase){
        this._delegate = _delegate;
        this.firebase = firebase;
        // add itself to container
        (0, $7c898bf562ba0419$export$fa5244b94c62d36a)(_delegate, new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('app-compat', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
        this.container = _delegate.container;
    }
    get automaticDataCollectionEnabled() {
        return this._delegate.automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this._delegate.automaticDataCollectionEnabled = val;
    }
    get name() {
        return this._delegate.name;
    }
    get options() {
        return this._delegate.options;
    }
    delete() {
        return new Promise((resolve)=>{
            this._delegate.checkDestroyed();
            resolve();
        }).then(()=>{
            this.firebase.INTERNAL.removeApp(this.name);
            return (0, $7c898bf562ba0419$export$6eec44aa53d5ea34)(this._delegate);
        });
    }
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */ _getService(name, instanceIdentifier = (0, $7c898bf562ba0419$export$9f30fa0c10967f7f)) {
        var _a;
        this._delegate.checkDestroyed();
        // Initialize instance if InstantiationMode is `EXPLICIT`.
        const provider = this._delegate.container.getProvider(name);
        if (!provider.isInitialized() && ((_a = provider.getComponent()) === null || _a === void 0 ? void 0 : _a.instantiationMode) === "EXPLICIT" /* InstantiationMode.EXPLICIT */ ) provider.initialize();
        // getImmediate will always succeed because _getService is only called for registered components.
        return provider.getImmediate({
            identifier: instanceIdentifier
        });
    }
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get it again.
     *
     * NOTE: currently only firestore uses this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */ _removeServiceInstance(name, instanceIdentifier = (0, $7c898bf562ba0419$export$9f30fa0c10967f7f)) {
        this._delegate.container// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .getProvider(name).clearInstance(instanceIdentifier);
    }
    /**
     * @param component the component being added to this app's container
     * @internal
     */ _addComponent(component) {
        (0, $7c898bf562ba0419$export$fa5244b94c62d36a)(this._delegate, component);
    }
    _addOrOverwriteComponent(component) {
        (0, $7c898bf562ba0419$export$4393112b42e2b41d)(this._delegate, component);
    }
    toJSON() {
        return {
            name: this.name,
            automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
            options: this.options
        };
    }
}
// TODO: investigate why the following needs to be commented out
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
// (FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
//   FirebaseAppImpl.prototype.delete ||
//   console.log('dc');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fa83d0b019b2237e$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance."
};
const $fa83d0b019b2237e$var$ERROR_FACTORY = new (0, $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40)('app-compat', 'Firebase', $fa83d0b019b2237e$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */ function $fa83d0b019b2237e$var$createFirebaseNamespaceCore(firebaseAppImpl) {
    const apps = {};
    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const components = new Map<string, Component<any>>();
    // A namespace is a plain JavaScript Object.
    const namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeAppCompat,
        app: // @ts-ignore
        app,
        registerVersion: $7c898bf562ba0419$export$d29d5299a7137abc,
        setLogLevel: $7c898bf562ba0419$export$c622e99c0ce7b1c9,
        onLog: $7c898bf562ba0419$export$a82ad227dc8163dc,
        // @ts-ignore
        apps: null,
        SDK_VERSION: $7c898bf562ba0419$export$31499a9cd224b78c,
        INTERNAL: {
            registerComponent: registerComponentCompat,
            removeApp: removeApp,
            useAsService: useAsService,
            modularAPIs: $7c898bf562ba0419$exports
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */ function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */ function app(name) {
        name = name || $7c898bf562ba0419$export$9f30fa0c10967f7f;
        if (!(0, $4e6a98b76c0d0a37$export$2344b14b097df817)(apps, name)) throw $fa83d0b019b2237e$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
            appName: name
        });
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    /**
     * Create a new App instance (name must be unique).
     *
     * This function is idempotent. It can be called more than once and return the same instance using the same options and config.
     */ function initializeAppCompat(options, rawConfig = {}) {
        const app = $7c898bf562ba0419$export$c55cfd413944906d(options, rawConfig);
        if ((0, $4e6a98b76c0d0a37$export$2344b14b097df817)(apps, app.name)) return apps[app.name];
        const appCompat = new firebaseAppImpl(app, namespace);
        apps[app.name] = appCompat;
        return appCompat;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */ function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map((name)=>apps[name]);
    }
    function registerComponentCompat(component) {
        const componentName = component.name;
        const componentNameWithoutCompat = componentName.replace('-compat', '');
        if ($7c898bf562ba0419$export$c930050e7bb63965(component) && component.type === "PUBLIC" /* ComponentType.PUBLIC */ ) {
            // create service namespace for public components
            // The Service namespace is an accessor function ...
            const serviceNamespace = (appArg = app())=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentNameWithoutCompat] !== 'function') // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw $fa83d0b019b2237e$var$ERROR_FACTORY.create("invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ , {
                    appName: componentName
                });
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentNameWithoutCompat]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) (0, $4e6a98b76c0d0a37$export$54e9fb29908872fa)(serviceNamespace, component.serviceProps);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentNameWithoutCompat] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentNameWithoutCompat] = // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function(...args) {
                const serviceFxn = this._getService.bind(this, componentName);
                return serviceFxn.apply(this, component.multipleInstances ? args : []);
            };
        }
        return component.type === "PUBLIC" /* ComponentType.PUBLIC */  ? namespace[componentNameWithoutCompat] : null;
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') return null;
        const useService = name;
        return useService;
    }
    return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */ function $fa83d0b019b2237e$var$createFirebaseNamespace() {
    const namespace = $fa83d0b019b2237e$var$createFirebaseNamespaceCore($fa83d0b019b2237e$var$FirebaseAppImpl);
    namespace.INTERNAL = Object.assign(Object.assign({}, namespace.INTERNAL), {
        createFirebaseNamespace: $fa83d0b019b2237e$var$createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: $4e6a98b76c0d0a37$export$364097d812234b3f,
        ErrorFactory: $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40,
        deepExtend: $4e6a98b76c0d0a37$export$54e9fb29908872fa
    });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */ function extendNamespace(props) {
        (0, $4e6a98b76c0d0a37$export$54e9fb29908872fa)(namespace, props);
    }
    return namespace;
}
const $fa83d0b019b2237e$var$firebase$1 = $fa83d0b019b2237e$var$createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fa83d0b019b2237e$var$logger = new (0, $ff3e0e0e6ac6e856$export$efa9a398d6368992)('@firebase/app-compat');
const $fa83d0b019b2237e$var$name = "@firebase/app-compat";
const $fa83d0b019b2237e$var$version = "0.4.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fa83d0b019b2237e$var$registerCoreComponents(variant) {
    // Register `app` package.
    (0, $7c898bf562ba0419$export$d29d5299a7137abc)($fa83d0b019b2237e$var$name, $fa83d0b019b2237e$var$version, variant);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ try {
    const globals = (0, $4e6a98b76c0d0a37$export$a4e55266d2135a7f)();
    // Firebase Lite detection
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (globals.firebase !== undefined) {
        $fa83d0b019b2237e$var$logger.warn(`
      Warning: Firebase is already defined in the global scope. Please make sure
      Firebase library is only loaded once.
    `);
        // eslint-disable-next-line
        const sdkVersion = globals.firebase.SDK_VERSION;
        if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) $fa83d0b019b2237e$var$logger.warn(`
        Warning: You are trying to load Firebase while using Firebase Performance standalone script.
        You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.
        `);
    }
} catch (_a) {
// ignore errors thrown by getGlobal
}
const $fa83d0b019b2237e$export$2e2bcd8739ae039 = $fa83d0b019b2237e$var$firebase$1;
$fa83d0b019b2237e$var$registerCoreComponents();


var $a9b0e11e6ebecfd8$var$name = "firebase";
var $a9b0e11e6ebecfd8$var$version = "11.10.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $fa83d0b019b2237e$export$2e2bcd8739ae039).registerVersion($a9b0e11e6ebecfd8$var$name, $a9b0e11e6ebecfd8$var$version, 'app-compat');









var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


const $9ff5424ed9b4a5e9$var$name = "@firebase/database";
const $9ff5424ed9b4a5e9$var$version = "1.0.20";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $9ff5424ed9b4a5e9$var$SDK_VERSION = '';
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $9ff5424ed9b4a5e9$export$c9fb972242fcb3c4(version) {
    $9ff5424ed9b4a5e9$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $9ff5424ed9b4a5e9$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $4e6a98b76c0d0a37$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $9ff5424ed9b4a5e9$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $4e6a98b76c0d0a37$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $9ff5424ed9b4a5e9$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $9ff5424ed9b4a5e9$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $9ff5424ed9b4a5e9$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $9ff5424ed9b4a5e9$var$PersistentStorage = $9ff5424ed9b4a5e9$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ const $9ff5424ed9b4a5e9$var$SessionStorage = $9ff5424ed9b4a5e9$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$logClient = new (0, $ff3e0e0e6ac6e856$export$efa9a398d6368992)('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $9ff5424ed9b4a5e9$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $9ff5424ed9b4a5e9$var$sha1 = function(str) {
    const utf8Bytes = (0, $4e6a98b76c0d0a37$export$655666783217a925)(str);
    const sha1 = new (0, $4e6a98b76c0d0a37$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $4e6a98b76c0d0a37$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $9ff5424ed9b4a5e9$var$buildLogMessage_ = function(...varArgs) {
    let message = '';
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $9ff5424ed9b4a5e9$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $9ff5424ed9b4a5e9$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $9ff5424ed9b4a5e9$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $9ff5424ed9b4a5e9$var$enableLogging$1 = function(logger_, persistent) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $9ff5424ed9b4a5e9$var$logClient.logLevel = (0, $ff3e0e0e6ac6e856$export$243e62d78d3b544d).VERBOSE;
        $9ff5424ed9b4a5e9$var$logger = $9ff5424ed9b4a5e9$var$logClient.log.bind($9ff5424ed9b4a5e9$var$logClient);
        if (persistent) $9ff5424ed9b4a5e9$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $9ff5424ed9b4a5e9$var$logger = logger_;
    else {
        $9ff5424ed9b4a5e9$var$logger = null;
        $9ff5424ed9b4a5e9$var$SessionStorage.remove('logging_enabled');
    }
};
const $9ff5424ed9b4a5e9$var$log = function(...varArgs) {
    if ($9ff5424ed9b4a5e9$var$firstLog_ === true) {
        $9ff5424ed9b4a5e9$var$firstLog_ = false;
        if ($9ff5424ed9b4a5e9$var$logger === null && $9ff5424ed9b4a5e9$var$SessionStorage.get('logging_enabled') === true) $9ff5424ed9b4a5e9$var$enableLogging$1(true);
    }
    if ($9ff5424ed9b4a5e9$var$logger) {
        const message = $9ff5424ed9b4a5e9$var$buildLogMessage_.apply(null, varArgs);
        $9ff5424ed9b4a5e9$var$logger(message);
    }
};
const $9ff5424ed9b4a5e9$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $9ff5424ed9b4a5e9$var$log(prefix, ...varArgs);
    };
};
const $9ff5424ed9b4a5e9$var$error = function(...varArgs) {
    const message = 'FIREBASE INTERNAL ERROR: ' + $9ff5424ed9b4a5e9$var$buildLogMessage_(...varArgs);
    $9ff5424ed9b4a5e9$var$logClient.error(message);
};
const $9ff5424ed9b4a5e9$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$9ff5424ed9b4a5e9$var$buildLogMessage_(...varArgs)}`;
    $9ff5424ed9b4a5e9$var$logClient.error(message);
    throw new Error(message);
};
const $9ff5424ed9b4a5e9$var$warn = function(...varArgs) {
    const message = 'FIREBASE WARNING: ' + $9ff5424ed9b4a5e9$var$buildLogMessage_(...varArgs);
    $9ff5424ed9b4a5e9$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $9ff5424ed9b4a5e9$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $9ff5424ed9b4a5e9$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $9ff5424ed9b4a5e9$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $9ff5424ed9b4a5e9$var$executeWhenDOMReady = function(fn) {
    if ((0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', ()=>{
                if (document.readyState === 'complete') wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $9ff5424ed9b4a5e9$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $9ff5424ed9b4a5e9$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $9ff5424ed9b4a5e9$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $9ff5424ed9b4a5e9$var$MIN_NAME || b === $9ff5424ed9b4a5e9$var$MAX_NAME) return -1;
    else if (b === $9ff5424ed9b4a5e9$var$MIN_NAME || a === $9ff5424ed9b4a5e9$var$MAX_NAME) return 1;
    else {
        const aAsInt = $9ff5424ed9b4a5e9$var$tryParseInt(a), bAsInt = $9ff5424ed9b4a5e9$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $9ff5424ed9b4a5e9$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $9ff5424ed9b4a5e9$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(obj));
};
const $9ff5424ed9b4a5e9$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = '{';
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(keys[i]);
        key += ':';
        key += $9ff5424ed9b4a5e9$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $9ff5424ed9b4a5e9$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $9ff5424ed9b4a5e9$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $9ff5424ed9b4a5e9$var$doubleToIEEE754String = function(v) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!$9ff5424ed9b4a5e9$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join('');
    // Return the data as a hex string. --MJL
    let hexByteString = '';
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $9ff5424ed9b4a5e9$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $9ff5424ed9b4a5e9$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a JavaScript Error
 */ function $9ff5424ed9b4a5e9$var$errorForServerCode(code, query) {
    let reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    const error = new Error(code + ' at ' + query._path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $9ff5424ed9b4a5e9$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $9ff5424ed9b4a5e9$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in keys, the maximum possible 32-bit integer.
 */ const $9ff5424ed9b4a5e9$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $9ff5424ed9b4a5e9$var$tryParseInt = function(str) {
    if ($9ff5424ed9b4a5e9$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $9ff5424ed9b4a5e9$var$INTEGER_32_MIN && intVal <= $9ff5424ed9b4a5e9$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $9ff5424ed9b4a5e9$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || '';
            $9ff5424ed9b4a5e9$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $9ff5424ed9b4a5e9$var$beingCrawled = function() {
    const userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $9ff5424ed9b4a5e9$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === 'number' && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== 'undefined' && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno['unrefTimer']) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $9ff5424ed9b4a5e9$var$AppCheckTokenProvider {
    constructor(app, appCheckProvider){
        this.appCheckProvider = appCheckProvider;
        this.appName = app.name;
        if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(app) && app.settings.appCheckToken) this.serverAppAppCheckToken = app.settings.appCheckToken;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (this.serverAppAppCheckToken) {
            if (forceRefresh) throw new Error('Attempted reuse of `FirebaseServerApp.appCheckToken` after previous usage failed.');
            return Promise.resolve({
                token: this.serverAppAppCheckToken
            });
        }
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $9ff5424ed9b4a5e9$var$warn(`Provided AppCheck credentials for the app named "${this.appName}" ` + 'are invalid. This usually indicates your app was not initialized correctly.');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $9ff5424ed9b4a5e9$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $9ff5424ed9b4a5e9$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $9ff5424ed9b4a5e9$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $9ff5424ed9b4a5e9$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $9ff5424ed9b4a5e9$var$EmulatorTokenProvider.OWNER = 'owner';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$PROTOCOL_VERSION = '5';
const $9ff5424ed9b4a5e9$var$VERSION_PARAM = 'v';
const $9ff5424ed9b4a5e9$var$TRANSPORT_SESSION_PARAM = 's';
const $9ff5424ed9b4a5e9$var$REFERER_PARAM = 'r';
const $9ff5424ed9b4a5e9$var$FORGE_REF = 'f';
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $9ff5424ed9b4a5e9$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $9ff5424ed9b4a5e9$var$LAST_SESSION_PARAM = 'ls';
const $9ff5424ed9b4a5e9$var$APPLICATION_ID_PARAM = 'p';
const $9ff5424ed9b4a5e9$var$APP_CHECK_TOKEN_PARAM = 'ac';
const $9ff5424ed9b4a5e9$var$WEBSOCKET = 'websocket';
const $9ff5424ed9b4a5e9$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $9ff5424ed9b4a5e9$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = '', includeNamespaceInQueryParams = false, isUsingEmulator = false, emulatorOptions = null){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this.emulatorOptions = emulatorOptions;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf('.') + 1);
        this.internalHost = $9ff5424ed9b4a5e9$var$PersistentStorage.get('host:' + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === 's-';
    }
    isCustomHost() {
        return this._domain !== 'firebaseio.com' && this._domain !== 'firebaseio-demo.com';
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $9ff5424ed9b4a5e9$var$PersistentStorage.set('host:' + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    }
    toURLString() {
        const protocol = this.secure ? 'https://' : 'http://';
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : '';
        return `${protocol}${this.host}/${query}`;
    }
}
function $9ff5424ed9b4a5e9$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $9ff5424ed9b4a5e9$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(typeof type === 'string', 'typeof type must == string');
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(typeof params === 'object', 'typeof params must == object');
    let connURL;
    if (type === $9ff5424ed9b4a5e9$var$WEBSOCKET) connURL = (repoInfo.secure ? 'wss://' : 'ws://') + repoInfo.internalHost + '/.ws?';
    else if (type === $9ff5424ed9b4a5e9$var$LONG_POLLING) connURL = (repoInfo.secure ? 'https://' : 'http://') + repoInfo.internalHost + '/.lp?';
    else throw new Error('Unknown connection type: ' + type);
    if ($9ff5424ed9b4a5e9$var$repoInfoNeedsQueryParam(repoInfo)) params['ns'] = repoInfo.namespace;
    const pairs = [];
    $9ff5424ed9b4a5e9$var$each(params, (key, value)=>{
        pairs.push(key + '=' + value);
    });
    return connURL + pairs.join('&');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $9ff5424ed9b4a5e9$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $4e6a98b76c0d0a37$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $4e6a98b76c0d0a37$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$collections = {};
const $9ff5424ed9b4a5e9$var$reporters = {};
function $9ff5424ed9b4a5e9$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$9ff5424ed9b4a5e9$var$collections[hashString]) $9ff5424ed9b4a5e9$var$collections[hashString] = new $9ff5424ed9b4a5e9$var$StatsCollection();
    return $9ff5424ed9b4a5e9$var$collections[hashString];
}
function $9ff5424ed9b4a5e9$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$9ff5424ed9b4a5e9$var$reporters[hashString]) $9ff5424ed9b4a5e9$var$reporters[hashString] = creatorFunction();
    return $9ff5424ed9b4a5e9$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $9ff5424ed9b4a5e9$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $9ff5424ed9b4a5e9$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
const $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $9ff5424ed9b4a5e9$var$MAX_URL_DATA_SIZE = 1870;
const $9ff5424ed9b4a5e9$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $9ff5424ed9b4a5e9$var$MAX_PAYLOAD_SIZE = $9ff5424ed9b4a5e9$var$MAX_URL_DATA_SIZE - $9ff5424ed9b4a5e9$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $9ff5424ed9b4a5e9$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $9ff5424ed9b4a5e9$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $9ff5424ed9b4a5e9$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $9ff5424ed9b4a5e9$var$logWrapper(connId);
        this.stats_ = $9ff5424ed9b4a5e9$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$9ff5424ed9b4a5e9$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $9ff5424ed9b4a5e9$var$repoInfoConnectionURL(repoInfo, $9ff5424ed9b4a5e9$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $9ff5424ed9b4a5e9$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($9ff5424ed9b4a5e9$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $9ff5424ed9b4a5e9$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $9ff5424ed9b4a5e9$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$9ff5424ed9b4a5e9$var$VERSION_PARAM] = $9ff5424ed9b4a5e9$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$9ff5424ed9b4a5e9$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$9ff5424ed9b4a5e9$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$9ff5424ed9b4a5e9$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$9ff5424ed9b4a5e9$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== 'undefined' && location.hostname && $9ff5424ed9b4a5e9$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$9ff5424ed9b4a5e9$var$REFERER_PARAM] = $9ff5424ed9b4a5e9$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_('Connecting via long-poll to ' + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $9ff5424ed9b4a5e9$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $9ff5424ed9b4a5e9$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)()) return false;
        else if ($9ff5424ed9b4a5e9$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$9ff5424ed9b4a5e9$var$BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$9ff5424ed9b4a5e9$var$isChromeExtensionContentScript() && !$9ff5424ed9b4a5e9$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $4e6a98b76c0d0a37$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $9ff5424ed9b4a5e9$var$splitStringBySize(base64data, $9ff5424ed9b4a5e9$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        const urlParams = {};
        urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $9ff5424ed9b4a5e9$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are received from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $9ff5424ed9b4a5e9$var$LUIDGenerator();
            window[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $9ff5424ed9b4a5e9$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $9ff5424ed9b4a5e9$var$log('frame writing exception');
                if (e.stack) $9ff5424ed9b4a5e9$var$log(e.stack);
                $9ff5424ed9b4a5e9$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $9ff5424ed9b4a5e9$var$log('No IE domain setting required');
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = '';
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = '';
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $9ff5424ed9b4a5e9$var$SEG_HEADER_SIZE + curDataString.length <= $9ff5424ed9b4a5e9$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $9ff5424ed9b4a5e9$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($9ff5424ed9b4a5e9$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $9ff5424ed9b4a5e9$var$log('Long-poll script failed to load: ' + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $9ff5424ed9b4a5e9$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $9ff5424ed9b4a5e9$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $9ff5424ed9b4a5e9$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $9ff5424ed9b4a5e9$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $9ff5424ed9b4a5e9$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $9ff5424ed9b4a5e9$var$logWrapper(this.connId);
        this.stats_ = $9ff5424ed9b4a5e9$var$statsManagerGetCollection(repoInfo);
        this.connURL = $9ff5424ed9b4a5e9$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$9ff5424ed9b4a5e9$var$VERSION_PARAM] = $9ff5424ed9b4a5e9$var$PROTOCOL_VERSION;
        if (!(0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)() && typeof location !== 'undefined' && location.hostname && $9ff5424ed9b4a5e9$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$9ff5424ed9b4a5e9$var$REFERER_PARAM] = $9ff5424ed9b4a5e9$var$FORGE_REF;
        if (transportSessionId) urlParams[$9ff5424ed9b4a5e9$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$9ff5424ed9b4a5e9$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$9ff5424ed9b4a5e9$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$9ff5424ed9b4a5e9$var$APPLICATION_ID_PARAM] = applicationId;
        return $9ff5424ed9b4a5e9$var$repoInfoConnectionURL(repoInfo, $9ff5424ed9b4a5e9$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $9ff5424ed9b4a5e9$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            let options;
            if ((0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        'User-Agent': `Firebase/${$9ff5424ed9b4a5e9$var$PROTOCOL_VERSION}/${$9ff5424ed9b4a5e9$var$SDK_VERSION}/${$371a3837fd81d701$exports.platform}/${device}`,
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers['Authorization'] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers['X-Firebase-AppCheck'] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
            }
            this.mySock = new $9ff5424ed9b4a5e9$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_('Websocket connected.');
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_('Websocket connection was disconnected.');
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $9ff5424ed9b4a5e9$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $9ff5424ed9b4a5e9$var$WebSocketImpl !== null && !$9ff5424ed9b4a5e9$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $9ff5424ed9b4a5e9$var$PersistentStorage.isInMemoryStorage || $9ff5424ed9b4a5e9$var$PersistentStorage.get('previous_websocket_failure') === true;
    }
    markConnectionHealthy() {
        $9ff5424ed9b4a5e9$var$PersistentStorage.remove('previous_websocket_failure');
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join('');
            this.frames = null;
            const jsonMess = (0, $4e6a98b76c0d0a37$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $9ff5424ed9b4a5e9$var$splitStringBySize(dataStr, $9ff5424ed9b4a5e9$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_('0');
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($9ff5424ed9b4a5e9$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $9ff5424ed9b4a5e9$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $9ff5424ed9b4a5e9$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $9ff5424ed9b4a5e9$var$TransportManager {
    static get ALL_TRANSPORTS() {
        return [
            $9ff5424ed9b4a5e9$var$BrowserPollConnection,
            $9ff5424ed9b4a5e9$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $9ff5424ed9b4a5e9$var$WebSocketConnection && $9ff5424ed9b4a5e9$var$WebSocketConnection['isAvailable']();
        let isSkipPollConnection = isWebSocketsAvailable && !$9ff5424ed9b4a5e9$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $9ff5424ed9b4a5e9$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $9ff5424ed9b4a5e9$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $9ff5424ed9b4a5e9$var$TransportManager.ALL_TRANSPORTS)if (transport && transport['isAvailable']()) transports.push(transport);
            $9ff5424ed9b4a5e9$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$9ff5424ed9b4a5e9$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $9ff5424ed9b4a5e9$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $9ff5424ed9b4a5e9$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $9ff5424ed9b4a5e9$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $9ff5424ed9b4a5e9$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $9ff5424ed9b4a5e9$var$MESSAGE_TYPE = 't';
const $9ff5424ed9b4a5e9$var$MESSAGE_DATA = 'd';
const $9ff5424ed9b4a5e9$var$CONTROL_SHUTDOWN = 's';
const $9ff5424ed9b4a5e9$var$CONTROL_RESET = 'r';
const $9ff5424ed9b4a5e9$var$CONTROL_ERROR = 'e';
const $9ff5424ed9b4a5e9$var$CONTROL_PONG = 'o';
const $9ff5424ed9b4a5e9$var$SWITCH_ACK = 'a';
const $9ff5424ed9b4a5e9$var$END_TRANSMISSION = 'n';
const $9ff5424ed9b4a5e9$var$PING = 'p';
const $9ff5424ed9b4a5e9$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $9ff5424ed9b4a5e9$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $9ff5424ed9b4a5e9$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $9ff5424ed9b4a5e9$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $9ff5424ed9b4a5e9$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $9ff5424ed9b4a5e9$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_('Connection exceeded healthy timeout but has received ' + this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $9ff5424ed9b4a5e9$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_('Connection exceeded healthy timeout but has sent ' + this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    this.log_('Closing unhealthy connection after timeout.');
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_('Secondary connection lost.');
                this.onSecondaryConnectionLost_();
            } else this.log_('closing an old connection');
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_('message on old connection');
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($9ff5424ed9b4a5e9$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$9ff5424ed9b4a5e9$var$MESSAGE_TYPE];
            if (cmd === $9ff5424ed9b4a5e9$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $9ff5424ed9b4a5e9$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $9ff5424ed9b4a5e9$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $9ff5424ed9b4a5e9$var$requireKey('t', parsedData);
        const data = $9ff5424ed9b4a5e9$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $9ff5424ed9b4a5e9$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $9ff5424ed9b4a5e9$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $9ff5424ed9b4a5e9$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $9ff5424ed9b4a5e9$var$requireKey('t', parsedData);
        const data = $9ff5424ed9b4a5e9$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $9ff5424ed9b4a5e9$var$requireKey($9ff5424ed9b4a5e9$var$MESSAGE_TYPE, controlData);
        if ($9ff5424ed9b4a5e9$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$9ff5424ed9b4a5e9$var$MESSAGE_DATA];
            if (cmd === $9ff5424ed9b4a5e9$var$SERVER_HELLO) {
                const handshakePayload = Object.assign({}, payload);
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $9ff5424ed9b4a5e9$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $9ff5424ed9b4a5e9$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $9ff5424ed9b4a5e9$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $9ff5424ed9b4a5e9$var$CONTROL_ERROR) $9ff5424ed9b4a5e9$var$error('Server Error: ' + payload);
            else if (cmd === $9ff5424ed9b4a5e9$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $9ff5424ed9b4a5e9$var$error('Unknown control packet command: ' + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($9ff5424ed9b4a5e9$var$PROTOCOL_VERSION !== version) $9ff5424ed9b4a5e9$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $9ff5424ed9b4a5e9$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_('Timed out trying to upgrade.');
                this.secondaryConn_.close();
            }
        }, Math.floor($9ff5424ed9b4a5e9$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $9ff5424ed9b4a5e9$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($9ff5424ed9b4a5e9$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $9ff5424ed9b4a5e9$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $9ff5424ed9b4a5e9$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $9ff5424ed9b4a5e9$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $9ff5424ed9b4a5e9$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $9ff5424ed9b4a5e9$var$OnlineMonitor extends $9ff5424ed9b4a5e9$var$EventEmitter {
    static getInstance() {
        return new $9ff5424ed9b4a5e9$var$OnlineMonitor();
    }
    constructor(){
        super([
            'online'
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, $4e6a98b76c0d0a37$export$872f8323f01d7ae0)()) {
            window.addEventListener('online', ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger('online', false);
                }
            }, false);
        }
    }
    getInitialEvent(eventType) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $9ff5424ed9b4a5e9$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $9ff5424ed9b4a5e9$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $9ff5424ed9b4a5e9$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = '';
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    }
}
function $9ff5424ed9b4a5e9$var$newEmptyPath() {
    return new $9ff5424ed9b4a5e9$var$Path('');
}
function $9ff5424ed9b4a5e9$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $9ff5424ed9b4a5e9$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $9ff5424ed9b4a5e9$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $9ff5424ed9b4a5e9$var$Path(path.pieces_, pieceNum);
}
function $9ff5424ed9b4a5e9$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $9ff5424ed9b4a5e9$var$pathToUrlEncodedString(path) {
    let pathString = '';
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(path.pieces_[i]));
    return pathString || '/';
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $9ff5424ed9b4a5e9$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $9ff5424ed9b4a5e9$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $9ff5424ed9b4a5e9$var$Path(pieces, 0);
}
function $9ff5424ed9b4a5e9$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $9ff5424ed9b4a5e9$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split('/');
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $9ff5424ed9b4a5e9$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $9ff5424ed9b4a5e9$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $9ff5424ed9b4a5e9$var$newRelativePath(outerPath, innerPath) {
    const outer = $9ff5424ed9b4a5e9$var$pathGetFront(outerPath), inner = $9ff5424ed9b4a5e9$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $9ff5424ed9b4a5e9$var$newRelativePath($9ff5424ed9b4a5e9$var$pathPopFront(outerPath), $9ff5424ed9b4a5e9$var$pathPopFront(innerPath));
    else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $9ff5424ed9b4a5e9$var$pathCompare(left, right) {
    const leftKeys = $9ff5424ed9b4a5e9$var$pathSlice(left, 0);
    const rightKeys = $9ff5424ed9b4a5e9$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $9ff5424ed9b4a5e9$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $9ff5424ed9b4a5e9$var$pathEquals(path, other) {
    if ($9ff5424ed9b4a5e9$var$pathGetLength(path) !== $9ff5424ed9b4a5e9$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $9ff5424ed9b4a5e9$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($9ff5424ed9b4a5e9$var$pathGetLength(path) > $9ff5424ed9b4a5e9$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $9ff5424ed9b4a5e9$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $9ff5424ed9b4a5e9$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $4e6a98b76c0d0a37$export$9536dc0a75b20bf9)(this.parts_[i]);
        $9ff5424ed9b4a5e9$var$validationPathCheckValid(this);
    }
}
function $9ff5424ed9b4a5e9$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $4e6a98b76c0d0a37$export$9536dc0a75b20bf9)(child);
    $9ff5424ed9b4a5e9$var$validationPathCheckValid(validationPath);
}
function $9ff5424ed9b4a5e9$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $4e6a98b76c0d0a37$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $9ff5424ed9b4a5e9$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $9ff5424ed9b4a5e9$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + 'has a key path longer than ' + $9ff5424ed9b4a5e9$var$MAX_PATH_LENGTH_BYTES + ' bytes (' + validationPath.byteLength_ + ').');
    if (validationPath.parts_.length > $9ff5424ed9b4a5e9$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + $9ff5424ed9b4a5e9$var$MAX_PATH_DEPTH + ') or object contains a cycle ' + $9ff5424ed9b4a5e9$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $9ff5424ed9b4a5e9$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return '';
    return "in property '" + validationPath.parts_.join('.') + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$VisibilityMonitor extends $9ff5424ed9b4a5e9$var$EventEmitter {
    static getInstance() {
        return new $9ff5424ed9b4a5e9$var$VisibilityMonitor();
    }
    constructor(){
        super([
            'visible'
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger('visible', visible);
            }
        }, false);
    }
    getInitialEvent(eventType) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$RECONNECT_MIN_DELAY = 1000;
const $9ff5424ed9b4a5e9$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $9ff5424ed9b4a5e9$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $9ff5424ed9b4a5e9$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $9ff5424ed9b4a5e9$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $9ff5424ed9b4a5e9$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $9ff5424ed9b4a5e9$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $9ff5424ed9b4a5e9$var$PersistentConnection extends $9ff5424ed9b4a5e9$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $9ff5424ed9b4a5e9$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $9ff5424ed9b4a5e9$var$logWrapper('p:' + this.id + ':');
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        $9ff5424ed9b4a5e9$var$VisibilityMonitor.getInstance().on('visible', this.onVisible_, this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $9ff5424ed9b4a5e9$var$OnlineMonitor.getInstance().on('online', this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(msg));
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: 'g',
            request: request,
            onComplete: (message)=>{
                const payload = message['d'];
                if (message['s'] === 'ok') deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'listen() called for non-default but complete query');
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest('g', get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query._queryObject;
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ 'd'];
            const status = message[/*status*/ 's'];
            // print warnings in any case...
            $9ff5424ed9b4a5e9$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_('listen response', message);
                if (status !== 'ok') this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === 'object' && (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $4e6a98b76c0d0a37$export$e51ae4db7b428f67)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $9ff5424ed9b4a5e9$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $4e6a98b76c0d0a37$export$fc970ed23da99565)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_('App check token refreshed');
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest('unappeck', {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $4e6a98b76c0d0a37$export$9565ca3d387f8aa0)(token) ? 'auth' : 'gauth';
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ 's'];
                const data = res[/*data*/ 'd'] || 'error';
                if (this.authToken_ === token) {
                    if (status === 'ok') this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest('appcheck', {
            'token': this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ 's'];
            const data = res[/*data*/ 'd'] || 'error';
            if (status === 'ok') this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'unlisten() called for non-default but complete query');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + ' response', message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, (result)=>{
                const status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    const errorReason = result[/* data */ 'd'];
                    this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(message));
            const reqNum = message['r'];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    }
    onDataPush_(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'apc') this.onAppCheckRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $9ff5424ed9b4a5e9$var$error('Unrecognized action received from server: ' + (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(action) + '\nAre you using the latest client?');
    }
    onReady_(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $9ff5424ed9b4a5e9$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = Math.max(0, new Date().getTime() - this.lastConnectionAttemptTime_);
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $9ff5424ed9b4a5e9$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ':' + $9ff5424ed9b4a5e9$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $9ff5424ed9b4a5e9$var$log('getToken() completed. Creating connection.');
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $9ff5424ed9b4a5e9$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $9ff5424ed9b4a5e9$var$warn(reason + ' (' + this.repoInfo_.toString() + ')');
                        this.interrupt($9ff5424ed9b4a5e9$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $9ff5424ed9b4a5e9$var$log('getToken() completed but was canceled');
            } catch (error) {
                this.log_('Failed to get token: ' + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $9ff5424ed9b4a5e9$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $9ff5424ed9b4a5e9$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $9ff5424ed9b4a5e9$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, $4e6a98b76c0d0a37$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = 'default';
        else queryId = query.map((q)=>$9ff5424ed9b4a5e9$var$ObjectToUniqueKey(q)).join('$');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $9ff5424ed9b4a5e9$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $9ff5424ed9b4a5e9$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $9ff5424ed9b4a5e9$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $9ff5424ed9b4a5e9$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $9ff5424ed9b4a5e9$var$log('App check token revoked: ' + statusCode + '/' + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $9ff5424ed9b4a5e9$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = 'js';
        if ((0, $4e6a98b76c0d0a37$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = 'admin_node';
            else clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + $9ff5424ed9b4a5e9$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, $4e6a98b76c0d0a37$export$872f8323f01d7ae0)()) stats['framework.cordova'] = 1;
        else if ((0, $4e6a98b76c0d0a37$export$f7a1e23e542d38e3)()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $9ff5424ed9b4a5e9$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $4e6a98b76c0d0a37$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$9ff5424ed9b4a5e9$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $9ff5424ed9b4a5e9$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $9ff5424ed9b4a5e9$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $9ff5424ed9b4a5e9$var$NamedNode($9ff5424ed9b4a5e9$var$MIN_NAME, oldNode);
        const newWrapped = new $9ff5424ed9b4a5e9$var$NamedNode($9ff5424ed9b4a5e9$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9ff5424ed9b4a5e9$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$__EMPTY_NODE;
class $9ff5424ed9b4a5e9$var$KeyIndex extends $9ff5424ed9b4a5e9$var$Index {
    static get __EMPTY_NODE() {
        return $9ff5424ed9b4a5e9$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $9ff5424ed9b4a5e9$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $9ff5424ed9b4a5e9$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $4e6a98b76c0d0a37$export$a39cad550e7ab28a)('KeyIndex.isDefinedOn not expected to be called.');
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9ff5424ed9b4a5e9$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $9ff5424ed9b4a5e9$var$NamedNode($9ff5424ed9b4a5e9$var$MAX_NAME, $9ff5424ed9b4a5e9$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $9ff5424ed9b4a5e9$var$NamedNode(indexValue, $9ff5424ed9b4a5e9$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.key';
    }
}
const $9ff5424ed9b4a5e9$var$KEY_INDEX = new $9ff5424ed9b4a5e9$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $9ff5424ed9b4a5e9$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $9ff5424ed9b4a5e9$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $9ff5424ed9b4a5e9$var$LLRBNode.RED;
        this.left = left != null ? left : $9ff5424ed9b4a5e9$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $9ff5424ed9b4a5e9$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $9ff5424ed9b4a5e9$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $9ff5424ed9b4a5e9$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $9ff5424ed9b4a5e9$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $9ff5424ed9b4a5e9$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $9ff5424ed9b4a5e9$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$9ff5424ed9b4a5e9$var$LLRBNode.RED = true;
$9ff5424ed9b4a5e9$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $9ff5424ed9b4a5e9$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $9ff5424ed9b4a5e9$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $9ff5424ed9b4a5e9$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $9ff5424ed9b4a5e9$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $9ff5424ed9b4a5e9$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $9ff5424ed9b4a5e9$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $9ff5424ed9b4a5e9$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $9ff5424ed9b4a5e9$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $9ff5424ed9b4a5e9$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $9ff5424ed9b4a5e9$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $9ff5424ed9b4a5e9$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $9ff5424ed9b4a5e9$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $9ff5424ed9b4a5e9$var$SortedMap.EMPTY_NODE = new $9ff5424ed9b4a5e9$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ff5424ed9b4a5e9$var$NAME_ONLY_COMPARATOR(left, right) {
    return $9ff5424ed9b4a5e9$var$nameCompare(left.name, right.name);
}
function $9ff5424ed9b4a5e9$var$NAME_COMPARATOR(left, right) {
    return $9ff5424ed9b4a5e9$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$MAX_NODE$2;
function $9ff5424ed9b4a5e9$var$setMaxNode$1(val) {
    $9ff5424ed9b4a5e9$var$MAX_NODE$2 = val;
}
const $9ff5424ed9b4a5e9$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $9ff5424ed9b4a5e9$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $9ff5424ed9b4a5e9$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(val, '.sv'), 'Priority must be a string or number.');
    } else (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(priorityNode === $9ff5424ed9b4a5e9$var$MAX_NODE$2 || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(priorityNode === $9ff5424ed9b4a5e9$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $9ff5424ed9b4a5e9$var$LeafNode {
    static set __childrenNodeConstructor(val) {
        $9ff5424ed9b4a5e9$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $9ff5424ed9b4a5e9$var$__childrenNodeConstructor;
    }
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $9ff5424ed9b4a5e9$var$validatePriorityNode(this.priorityNode_);
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $9ff5424ed9b4a5e9$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return $9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) return this;
        else if ($9ff5424ed9b4a5e9$var$pathGetFront(path) === '.priority') return this.priorityNode_;
        else return $9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return $9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $9ff5424ed9b4a5e9$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(front !== '.priority' || $9ff5424ed9b4a5e9$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, $9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($9ff5424ed9b4a5e9$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $9ff5424ed9b4a5e9$var$priorityHashText(this.priorityNode_.val()) + ':';
            const type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $9ff5424ed9b4a5e9$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $9ff5424ed9b4a5e9$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $9ff5424ed9b4a5e9$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $9ff5424ed9b4a5e9$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $9ff5424ed9b4a5e9$var$LeafNode.VALUE_TYPE_ORDER = [
    'object',
    'boolean',
    'number',
    'string'
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$nodeFromJSON$1;
let $9ff5424ed9b4a5e9$var$MAX_NODE$1;
function $9ff5424ed9b4a5e9$var$setNodeFromJSON(val) {
    $9ff5424ed9b4a5e9$var$nodeFromJSON$1 = val;
}
function $9ff5424ed9b4a5e9$var$setMaxNode(val) {
    $9ff5424ed9b4a5e9$var$MAX_NODE$1 = val;
}
class $9ff5424ed9b4a5e9$var$PriorityIndex extends $9ff5424ed9b4a5e9$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $9ff5424ed9b4a5e9$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9ff5424ed9b4a5e9$var$NamedNode.MIN;
    }
    maxPost() {
        return new $9ff5424ed9b4a5e9$var$NamedNode($9ff5424ed9b4a5e9$var$MAX_NAME, new $9ff5424ed9b4a5e9$var$LeafNode('[PRIORITY-POST]', $9ff5424ed9b4a5e9$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $9ff5424ed9b4a5e9$var$nodeFromJSON$1(indexValue);
        return new $9ff5424ed9b4a5e9$var$NamedNode(name, new $9ff5424ed9b4a5e9$var$LeafNode('[PRIORITY-POST]', priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.priority';
    }
}
const $9ff5424ed9b4a5e9$var$PRIORITY_INDEX = new $9ff5424ed9b4a5e9$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$LOG_2 = Math.log(2);
class $9ff5424ed9b4a5e9$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $9ff5424ed9b4a5e9$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join('1'), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $9ff5424ed9b4a5e9$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $9ff5424ed9b4a5e9$var$LLRBNode(key, namedNode.node, $9ff5424ed9b4a5e9$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $9ff5424ed9b4a5e9$var$LLRBNode(key, namedNode.node, $9ff5424ed9b4a5e9$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $9ff5424ed9b4a5e9$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $9ff5424ed9b4a5e9$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $9ff5424ed9b4a5e9$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $9ff5424ed9b4a5e9$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $9ff5424ed9b4a5e9$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $9ff5424ed9b4a5e9$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$_defaultIndexMap;
const $9ff5424ed9b4a5e9$var$fallbackObject = {};
class $9ff5424ed9b4a5e9$var$IndexMap {
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$fallbackObject && $9ff5424ed9b4a5e9$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
        $9ff5424ed9b4a5e9$var$_defaultIndexMap = $9ff5424ed9b4a5e9$var$_defaultIndexMap || new $9ff5424ed9b4a5e9$var$IndexMap({
            '.priority': $9ff5424ed9b4a5e9$var$fallbackObject
        }, {
            '.priority': $9ff5424ed9b4a5e9$var$PRIORITY_INDEX
        });
        return $9ff5424ed9b4a5e9$var$_defaultIndexMap;
    }
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    get(indexKey) {
        const sortedMap = (0, $4e6a98b76c0d0a37$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $9ff5424ed9b4a5e9$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(indexDefinition !== $9ff5424ed9b4a5e9$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($9ff5424ed9b4a5e9$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $9ff5424ed9b4a5e9$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $9ff5424ed9b4a5e9$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $9ff5424ed9b4a5e9$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $4e6a98b76c0d0a37$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $4e6a98b76c0d0a37$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $9ff5424ed9b4a5e9$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($9ff5424ed9b4a5e9$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $9ff5424ed9b4a5e9$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $9ff5424ed9b4a5e9$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $9ff5424ed9b4a5e9$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $9ff5424ed9b4a5e9$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $4e6a98b76c0d0a37$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $9ff5424ed9b4a5e9$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $9ff5424ed9b4a5e9$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $9ff5424ed9b4a5e9$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $9ff5424ed9b4a5e9$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $9ff5424ed9b4a5e9$var$ChildrenNode {
    static get EMPTY_NODE() {
        return $9ff5424ed9b4a5e9$var$EMPTY_NODE || ($9ff5424ed9b4a5e9$var$EMPTY_NODE = new $9ff5424ed9b4a5e9$var$ChildrenNode(new $9ff5424ed9b4a5e9$var$SortedMap($9ff5424ed9b4a5e9$var$NAME_COMPARATOR), null, $9ff5424ed9b4a5e9$var$IndexMap.Default));
    }
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $9ff5424ed9b4a5e9$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $9ff5424ed9b4a5e9$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $9ff5424ed9b4a5e9$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $9ff5424ed9b4a5e9$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $9ff5424ed9b4a5e9$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($9ff5424ed9b4a5e9$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            const namedNode = new $9ff5424ed9b4a5e9$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $9ff5424ed9b4a5e9$var$EMPTY_NODE : this.priorityNode_;
            return new $9ff5424ed9b4a5e9$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $9ff5424ed9b4a5e9$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$pathGetFront(path) !== '.priority' || $9ff5424ed9b4a5e9$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            const newImmediateChild = this.getImmediateChild(front).updateChild($9ff5424ed9b4a5e9$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $9ff5424ed9b4a5e9$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.getPriority().isEmpty()) toHash += 'priority:' + $9ff5424ed9b4a5e9$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== '') toHash += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash === '' ? '' : $9ff5424ed9b4a5e9$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $9ff5424ed9b4a5e9$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $9ff5424ed9b4a5e9$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $9ff5424ed9b4a5e9$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $9ff5424ed9b4a5e9$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $9ff5424ed9b4a5e9$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $9ff5424ed9b4a5e9$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $9ff5424ed9b4a5e9$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $9ff5424ed9b4a5e9$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $9ff5424ed9b4a5e9$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($9ff5424ed9b4a5e9$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($9ff5424ed9b4a5e9$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $9ff5424ed9b4a5e9$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$9ff5424ed9b4a5e9$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $9ff5424ed9b4a5e9$var$MaxNode extends $9ff5424ed9b4a5e9$var$ChildrenNode {
    constructor(){
        super(new $9ff5424ed9b4a5e9$var$SortedMap($9ff5424ed9b4a5e9$var$NAME_COMPARATOR), $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE, $9ff5424ed9b4a5e9$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $9ff5424ed9b4a5e9$var$MAX_NODE = new $9ff5424ed9b4a5e9$var$MaxNode();
Object.defineProperties($9ff5424ed9b4a5e9$var$NamedNode, {
    MIN: {
        value: new $9ff5424ed9b4a5e9$var$NamedNode($9ff5424ed9b4a5e9$var$MIN_NAME, $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $9ff5424ed9b4a5e9$var$NamedNode($9ff5424ed9b4a5e9$var$MAX_NAME, $9ff5424ed9b4a5e9$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $9ff5424ed9b4a5e9$var$KeyIndex.__EMPTY_NODE = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
$9ff5424ed9b4a5e9$var$LeafNode.__childrenNodeConstructor = $9ff5424ed9b4a5e9$var$ChildrenNode;
$9ff5424ed9b4a5e9$var$setMaxNode$1($9ff5424ed9b4a5e9$var$MAX_NODE);
$9ff5424ed9b4a5e9$var$setMaxNode($9ff5424ed9b4a5e9$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $9ff5424ed9b4a5e9$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        const jsonLeaf = json;
        return new $9ff5424ed9b4a5e9$var$LeafNode(jsonLeaf, $9ff5424ed9b4a5e9$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $9ff5424ed9b4a5e9$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $9ff5424ed9b4a5e9$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                const childNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $9ff5424ed9b4a5e9$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
        const childSet = $9ff5424ed9b4a5e9$var$buildChildSet(children, $9ff5424ed9b4a5e9$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $9ff5424ed9b4a5e9$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $9ff5424ed9b4a5e9$var$buildChildSet(children, $9ff5424ed9b4a5e9$var$PRIORITY_INDEX.getCompare());
            return new $9ff5424ed9b4a5e9$var$ChildrenNode(childSet, $9ff5424ed9b4a5e9$var$nodeFromJSON(priority), new $9ff5424ed9b4a5e9$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $9ff5424ed9b4a5e9$var$PRIORITY_INDEX
            }));
        } else return new $9ff5424ed9b4a5e9$var$ChildrenNode(childSet, $9ff5424ed9b4a5e9$var$nodeFromJSON(priority), $9ff5424ed9b4a5e9$var$IndexMap.Default);
    } else {
        let node = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
        $9ff5424ed9b4a5e9$var$each(json, (key, childData)=>{
            if ((0, $4e6a98b76c0d0a37$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    const childNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($9ff5424ed9b4a5e9$var$nodeFromJSON(priority));
    }
}
$9ff5424ed9b4a5e9$var$setNodeFromJSON($9ff5424ed9b4a5e9$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$PathIndex extends $9ff5424ed9b4a5e9$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!$9ff5424ed9b4a5e9$var$pathIsEmpty(indexPath_) && $9ff5424ed9b4a5e9$var$pathGetFront(indexPath_) !== '.priority', "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $9ff5424ed9b4a5e9$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(indexValue);
        const node = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $9ff5424ed9b4a5e9$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $9ff5424ed9b4a5e9$var$MAX_NODE);
        return new $9ff5424ed9b4a5e9$var$NamedNode($9ff5424ed9b4a5e9$var$MAX_NAME, node);
    }
    toString() {
        return $9ff5424ed9b4a5e9$var$pathSlice(this.indexPath_, 0).join('/');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$ValueIndex extends $9ff5424ed9b4a5e9$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $9ff5424ed9b4a5e9$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9ff5424ed9b4a5e9$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9ff5424ed9b4a5e9$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(indexValue);
        return new $9ff5424ed9b4a5e9$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.value';
    }
}
const $9ff5424ed9b4a5e9$var$VALUE_INDEX = new $9ff5424ed9b4a5e9$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ff5424ed9b4a5e9$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $9ff5424ed9b4a5e9$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $9ff5424ed9b4a5e9$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $9ff5424ed9b4a5e9$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $9ff5424ed9b4a5e9$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $9ff5424ed9b4a5e9$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildRemoved(key, oldChild));
                else (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $9ff5424ed9b4a5e9$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $9ff5424ed9b4a5e9$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $9ff5424ed9b4a5e9$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $9ff5424ed9b4a5e9$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $9ff5424ed9b4a5e9$var$NamedNode(key, newChild))) newChild = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $9ff5424ed9b4a5e9$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $9ff5424ed9b4a5e9$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $9ff5424ed9b4a5e9$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $9ff5424ed9b4a5e9$var$NamedNode(key, newChild))) newChild = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, '');
        const newChildNamedNode = new $9ff5424ed9b4a5e9$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($9ff5424ed9b4a5e9$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $9ff5424ed9b4a5e9$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $9ff5424ed9b4a5e9$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $9ff5424ed9b4a5e9$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $9ff5424ed9b4a5e9$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== '';
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $9ff5424ed9b4a5e9$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $9ff5424ed9b4a5e9$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $9ff5424ed9b4a5e9$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $9ff5424ed9b4a5e9$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $9ff5424ed9b4a5e9$var$LimitedFilter(queryParams);
    else return new $9ff5424ed9b4a5e9$var$RangedFilter(queryParams);
}
function $9ff5424ed9b4a5e9$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $9ff5424ed9b4a5e9$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $9ff5424ed9b4a5e9$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = '';
    }
    return newParams;
}
function $9ff5424ed9b4a5e9$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $9ff5424ed9b4a5e9$var$KEY_INDEX || !!key) params = $9ff5424ed9b4a5e9$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $9ff5424ed9b4a5e9$var$queryParamsStartAt(queryParams, indexValue, $9ff5424ed9b4a5e9$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $9ff5424ed9b4a5e9$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = '';
    }
    return newParams;
}
function $9ff5424ed9b4a5e9$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $9ff5424ed9b4a5e9$var$KEY_INDEX || !!key) params = $9ff5424ed9b4a5e9$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $9ff5424ed9b4a5e9$var$queryParamsEndAt(queryParams, indexValue, $9ff5424ed9b4a5e9$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $9ff5424ed9b4a5e9$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $9ff5424ed9b4a5e9$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $9ff5424ed9b4a5e9$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $9ff5424ed9b4a5e9$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $9ff5424ed9b4a5e9$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(queryParams.index_ instanceof $9ff5424ed9b4a5e9$var$PathIndex, 'Unrecognized index type!');
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += ',' + (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += ',' + (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $9ff5424ed9b4a5e9$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === '') {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $9ff5424ed9b4a5e9$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $9ff5424ed9b4a5e9$var$ReadonlyRestClient extends $9ff5424ed9b4a5e9$var$ServerActions {
    reportStats(stats) {
        throw new Error('Method not implemented.');
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $9ff5424ed9b4a5e9$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $9ff5424ed9b4a5e9$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $9ff5424ed9b4a5e9$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $4e6a98b76c0d0a37$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = 'ok';
                else if (error === 401) status = 'permission_denied';
                else status = 'rest_error:' + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $9ff5424ed9b4a5e9$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $9ff5424ed9b4a5e9$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters['format'] = 'export';
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters['auth'] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters['ac'] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host + pathString + '?' + 'ns=' + this.repoInfo_.namespace + (0, $4e6a98b76c0d0a37$export$ac4103b836844853)(queryStringParameters);
            this.log_('Sending REST request for ' + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $4e6a98b76c0d0a37$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $9ff5424ed9b4a5e9$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $9ff5424ed9b4a5e9$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $9ff5424ed9b4a5e9$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ff5424ed9b4a5e9$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $9ff5424ed9b4a5e9$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $9ff5424ed9b4a5e9$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $9ff5424ed9b4a5e9$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $9ff5424ed9b4a5e9$var$pathPopFront(path);
        $9ff5424ed9b4a5e9$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (key, tree)=>{
                    $9ff5424ed9b4a5e9$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $9ff5424ed9b4a5e9$var$Path(key), tree);
                });
                return $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $9ff5424ed9b4a5e9$var$pathGetFront(path);
            path = $9ff5424ed9b4a5e9$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $9ff5424ed9b4a5e9$var$Path(prefixPath.toString() + '/' + key);
        $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $9ff5424ed9b4a5e9$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $9ff5424ed9b4a5e9$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $9ff5424ed9b4a5e9$var$FIRST_STATS_MIN_TIME = 10000;
const $9ff5424ed9b4a5e9$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $9ff5424ed9b4a5e9$var$REPORT_STATS_INTERVAL = 300000;
class $9ff5424ed9b4a5e9$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $9ff5424ed9b4a5e9$var$StatsListener(collection);
        const timeout = $9ff5424ed9b4a5e9$var$FIRST_STATS_MIN_TIME + ($9ff5424ed9b4a5e9$var$FIRST_STATS_MAX_TIME - $9ff5424ed9b4a5e9$var$FIRST_STATS_MIN_TIME) * Math.random();
        $9ff5424ed9b4a5e9$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $9ff5424ed9b4a5e9$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $9ff5424ed9b4a5e9$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $9ff5424ed9b4a5e9$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $9ff5424ed9b4a5e9$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($9ff5424ed9b4a5e9$var$OperationType || ($9ff5424ed9b4a5e9$var$OperationType = {}));
function $9ff5424ed9b4a5e9$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $9ff5424ed9b4a5e9$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $9ff5424ed9b4a5e9$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $9ff5424ed9b4a5e9$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $9ff5424ed9b4a5e9$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$9ff5424ed9b4a5e9$var$pathIsEmpty(this.path)) {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$pathGetFront(this.path) === childName, 'operationForChild called for unrelated child.');
            return new $9ff5424ed9b4a5e9$var$AckUserWrite($9ff5424ed9b4a5e9$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $9ff5424ed9b4a5e9$var$Path(childName));
            return new $9ff5424ed9b4a5e9$var$AckUserWrite($9ff5424ed9b4a5e9$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $9ff5424ed9b4a5e9$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(this.path)) return new $9ff5424ed9b4a5e9$var$ListenComplete(this.source, $9ff5424ed9b4a5e9$var$newEmptyPath());
        else return new $9ff5424ed9b4a5e9$var$ListenComplete(this.source, $9ff5424ed9b4a5e9$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $9ff5424ed9b4a5e9$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(this.path)) return new $9ff5424ed9b4a5e9$var$Overwrite(this.source, $9ff5424ed9b4a5e9$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $9ff5424ed9b4a5e9$var$Overwrite(this.source, $9ff5424ed9b4a5e9$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $9ff5424ed9b4a5e9$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $9ff5424ed9b4a5e9$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $9ff5424ed9b4a5e9$var$Overwrite(this.source, $9ff5424ed9b4a5e9$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $9ff5424ed9b4a5e9$var$Merge(this.source, $9ff5424ed9b4a5e9$var$newEmptyPath(), childTree);
        } else {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $9ff5424ed9b4a5e9$var$Merge(this.source, $9ff5424ed9b4a5e9$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $9ff5424ed9b4a5e9$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $9ff5424ed9b4a5e9$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $9ff5424ed9b4a5e9$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($9ff5424ed9b4a5e9$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$9ff5424ed9b4a5e9$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $9ff5424ed9b4a5e9$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $9ff5424ed9b4a5e9$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === 'value' || change.type === 'child_removed') return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $9ff5424ed9b4a5e9$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $4e6a98b76c0d0a37$export$a39cad550e7ab28a)('Should only compare child_ events.');
    const aWrapped = new $9ff5424ed9b4a5e9$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $9ff5424ed9b4a5e9$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ff5424ed9b4a5e9$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $9ff5424ed9b4a5e9$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $9ff5424ed9b4a5e9$var$newViewCache(new $9ff5424ed9b4a5e9$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $9ff5424ed9b4a5e9$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $9ff5424ed9b4a5e9$var$newViewCache(viewCache.eventCache, new $9ff5424ed9b4a5e9$var$CacheNode(serverSnap, complete, filtered));
}
function $9ff5424ed9b4a5e9$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $9ff5424ed9b4a5e9$var$EmptyChildren = ()=>{
    if (!$9ff5424ed9b4a5e9$var$emptyChildrenSingleton) $9ff5424ed9b4a5e9$var$emptyChildrenSingleton = new $9ff5424ed9b4a5e9$var$SortedMap($9ff5424ed9b4a5e9$var$stringCompare);
    return $9ff5424ed9b4a5e9$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $9ff5424ed9b4a5e9$var$ImmutableTree {
    static fromObject(obj) {
        let tree = new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
        $9ff5424ed9b4a5e9$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $9ff5424ed9b4a5e9$var$Path(childPath), childSnap);
        });
        return tree;
    }
    constructor(value, children = $9ff5424ed9b4a5e9$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $9ff5424ed9b4a5e9$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $9ff5424ed9b4a5e9$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($9ff5424ed9b4a5e9$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $9ff5424ed9b4a5e9$var$pathChild(new $9ff5424ed9b4a5e9$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $9ff5424ed9b4a5e9$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($9ff5424ed9b4a5e9$var$pathPopFront(relativePath));
            else return new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath)) return new $9ff5424ed9b4a5e9$var$ImmutableTree(toSet, this.children);
        else {
            const front = $9ff5424ed9b4a5e9$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
            const newChild = child.set($9ff5424ed9b4a5e9$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $9ff5424ed9b4a5e9$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
            else return new $9ff5424ed9b4a5e9$var$ImmutableTree(null, this.children);
        } else {
            const front = $9ff5424ed9b4a5e9$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($9ff5424ed9b4a5e9$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
                else return new $9ff5424ed9b4a5e9$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $9ff5424ed9b4a5e9$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($9ff5424ed9b4a5e9$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $9ff5424ed9b4a5e9$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
            const newChild = child.setTree($9ff5424ed9b4a5e9$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $9ff5424ed9b4a5e9$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($9ff5424ed9b4a5e9$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($9ff5424ed9b4a5e9$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $9ff5424ed9b4a5e9$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($9ff5424ed9b4a5e9$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $9ff5424ed9b4a5e9$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($9ff5424ed9b4a5e9$var$pathPopFront(pathToFollow), $9ff5424ed9b4a5e9$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $9ff5424ed9b4a5e9$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $9ff5424ed9b4a5e9$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($9ff5424ed9b4a5e9$var$pathPopFront(pathToFollow), $9ff5424ed9b4a5e9$var$pathChild(currentRelativePath, front), f);
            else return new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($9ff5424ed9b4a5e9$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($9ff5424ed9b4a5e9$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $9ff5424ed9b4a5e9$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $9ff5424ed9b4a5e9$var$CompoundWrite(new $9ff5424ed9b4a5e9$var$ImmutableTree(null));
    }
}
function $9ff5424ed9b4a5e9$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) return new $9ff5424ed9b4a5e9$var$CompoundWrite(new $9ff5424ed9b4a5e9$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $9ff5424ed9b4a5e9$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $9ff5424ed9b4a5e9$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $9ff5424ed9b4a5e9$var$CompoundWrite(newWriteTree);
        }
    }
}
function $9ff5424ed9b4a5e9$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $9ff5424ed9b4a5e9$var$each(updates, (childKey, node)=>{
        newWrite = $9ff5424ed9b4a5e9$var$compoundWriteAddWrite(newWrite, $9ff5424ed9b4a5e9$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $9ff5424ed9b4a5e9$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) return $9ff5424ed9b4a5e9$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $9ff5424ed9b4a5e9$var$ImmutableTree(null));
        return new $9ff5424ed9b4a5e9$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $9ff5424ed9b4a5e9$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($9ff5424ed9b4a5e9$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $9ff5424ed9b4a5e9$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $9ff5424ed9b4a5e9$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $9ff5424ed9b4a5e9$var$CompoundWrite(new $9ff5424ed9b4a5e9$var$ImmutableTree(shadowingNode));
        else return new $9ff5424ed9b4a5e9$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $9ff5424ed9b4a5e9$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $9ff5424ed9b4a5e9$var$compoundWriteApply(compoundWrite, node) {
    return $9ff5424ed9b4a5e9$var$applySubtreeWrite($9ff5424ed9b4a5e9$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $9ff5424ed9b4a5e9$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite = childTree.value;
            } else node = $9ff5424ed9b4a5e9$var$applySubtreeWrite($9ff5424ed9b4a5e9$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($9ff5424ed9b4a5e9$var$pathChild(relativePath, '.priority'), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $9ff5424ed9b4a5e9$var$writeTreeChildWrites(writeTree, path) {
    return $9ff5424ed9b4a5e9$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $9ff5424ed9b4a5e9$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older write on top of newer ones');
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $9ff5424ed9b4a5e9$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $9ff5424ed9b4a5e9$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older merge on top of newer ones');
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $9ff5424ed9b4a5e9$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $9ff5424ed9b4a5e9$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $9ff5424ed9b4a5e9$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(idx >= 0, 'removeWrite called with nonexistent writeId.');
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $9ff5424ed9b4a5e9$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($9ff5424ed9b4a5e9$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $9ff5424ed9b4a5e9$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $9ff5424ed9b4a5e9$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $9ff5424ed9b4a5e9$var$each(children, (childName)=>{
                writeTree.visibleWrites = $9ff5424ed9b4a5e9$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $9ff5424ed9b4a5e9$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $9ff5424ed9b4a5e9$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $9ff5424ed9b4a5e9$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $9ff5424ed9b4a5e9$var$pathContains($9ff5424ed9b4a5e9$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $9ff5424ed9b4a5e9$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $9ff5424ed9b4a5e9$var$writeTreeLayerTree_(writeTree.allWrites, $9ff5424ed9b4a5e9$var$writeTreeDefaultFilter_, $9ff5424ed9b4a5e9$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $9ff5424ed9b4a5e9$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $9ff5424ed9b4a5e9$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $9ff5424ed9b4a5e9$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($9ff5424ed9b4a5e9$var$pathContains(treeRoot, writePath)) {
                    relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $9ff5424ed9b4a5e9$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($9ff5424ed9b4a5e9$var$pathContains(writePath, treeRoot)) {
                    relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $9ff5424ed9b4a5e9$var$compoundWriteAddWrite(compoundWrite, $9ff5424ed9b4a5e9$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($9ff5424ed9b4a5e9$var$pathContains(treeRoot, writePath)) {
                    relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $9ff5424ed9b4a5e9$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($9ff5424ed9b4a5e9$var$pathContains(writePath, treeRoot)) {
                    relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(writePath, treeRoot);
                    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath)) compoundWrite = $9ff5424ed9b4a5e9$var$compoundWriteAddWrites(compoundWrite, $9ff5424ed9b4a5e9$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $4e6a98b76c0d0a37$export$e51ae4db7b428f67)(write.children, $9ff5424ed9b4a5e9$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($9ff5424ed9b4a5e9$var$pathPopFront(relativePath));
                            compoundWrite = $9ff5424ed9b4a5e9$var$compoundWriteAddWrite(compoundWrite, $9ff5424ed9b4a5e9$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $4e6a98b76c0d0a37$export$a39cad550e7ab28a)('WriteRecord should have .snap or .children');
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $9ff5424ed9b4a5e9$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($9ff5424ed9b4a5e9$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$9ff5424ed9b4a5e9$var$compoundWriteHasCompleteWrite(subMerge, $9ff5424ed9b4a5e9$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
                return $9ff5424ed9b4a5e9$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $9ff5424ed9b4a5e9$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$9ff5424ed9b4a5e9$var$compoundWriteHasCompleteWrite(merge, $9ff5424ed9b4a5e9$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($9ff5424ed9b4a5e9$var$pathContains(write.path, treePath) || $9ff5424ed9b4a5e9$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $9ff5424ed9b4a5e9$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
                return $9ff5424ed9b4a5e9$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $9ff5424ed9b4a5e9$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $9ff5424ed9b4a5e9$var$compoundWriteApply($9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(merge, new $9ff5424ed9b4a5e9$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $9ff5424ed9b4a5e9$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
    const path = $9ff5424ed9b4a5e9$var$pathChild(treePath, childPath);
    if ($9ff5424ed9b4a5e9$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($9ff5424ed9b4a5e9$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $9ff5424ed9b4a5e9$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $9ff5424ed9b4a5e9$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $9ff5424ed9b4a5e9$var$pathChild(treePath, childKey);
    const shadowingNode = $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $9ff5424ed9b4a5e9$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $9ff5424ed9b4a5e9$var$writeTreeShadowingWrite(writeTree, path) {
    return $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $9ff5424ed9b4a5e9$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $9ff5424ed9b4a5e9$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $9ff5424ed9b4a5e9$var$compoundWriteGetCompleteNode(merge, $9ff5424ed9b4a5e9$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $9ff5424ed9b4a5e9$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $9ff5424ed9b4a5e9$var$newWriteTree() {
    return {
        visibleWrites: $9ff5424ed9b4a5e9$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $9ff5424ed9b4a5e9$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $9ff5424ed9b4a5e9$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $9ff5424ed9b4a5e9$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $9ff5424ed9b4a5e9$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $9ff5424ed9b4a5e9$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $9ff5424ed9b4a5e9$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $9ff5424ed9b4a5e9$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $9ff5424ed9b4a5e9$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $9ff5424ed9b4a5e9$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $9ff5424ed9b4a5e9$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $9ff5424ed9b4a5e9$var$writeTreeRefChild(writeTreeRef, childName) {
    return $9ff5424ed9b4a5e9$var$newWriteTreeRef($9ff5424ed9b4a5e9$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $9ff5424ed9b4a5e9$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , 'Only child changes supported for tracking');
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $9ff5424ed9b4a5e9$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $9ff5424ed9b4a5e9$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $9ff5424ed9b4a5e9$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $9ff5424ed9b4a5e9$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $4e6a98b76c0d0a37$export$a39cad550e7ab28a)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $9ff5424ed9b4a5e9$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $9ff5424ed9b4a5e9$var$NO_COMPLETE_CHILD_SOURCE = new $9ff5424ed9b4a5e9$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $9ff5424ed9b4a5e9$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $9ff5424ed9b4a5e9$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $9ff5424ed9b4a5e9$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ff5424ed9b4a5e9$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $9ff5424ed9b4a5e9$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Event snap not indexed');
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Server snap not indexed');
}
function $9ff5424ed9b4a5e9$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $9ff5424ed9b4a5e9$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $9ff5424ed9b4a5e9$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(overwrite.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$9ff5424ed9b4a5e9$var$pathIsEmpty(overwrite.path);
            newViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $9ff5424ed9b4a5e9$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(merge.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $9ff5424ed9b4a5e9$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $9ff5424ed9b4a5e9$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $9ff5424ed9b4a5e9$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $9ff5424ed9b4a5e9$var$OperationType.LISTEN_COMPLETE) newViewCache = $9ff5424ed9b4a5e9$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $4e6a98b76c0d0a37$export$a39cad550e7ab28a)('Unknown operation type: ' + operation.type);
    const changes = accumulator.getChanges();
    $9ff5424ed9b4a5e9$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $9ff5424ed9b4a5e9$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $9ff5424ed9b4a5e9$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($9ff5424ed9b4a5e9$var$changeValue($9ff5424ed9b4a5e9$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $9ff5424ed9b4a5e9$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($9ff5424ed9b4a5e9$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), 'If change path is empty, we must have complete server data');
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $9ff5424ed9b4a5e9$var$ChildrenNode ? serverCache : $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventCache(writesCache, $9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $9ff5424ed9b4a5e9$var$pathGetFront(changePath);
            if (childKey === '.priority') {
                (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $9ff5424ed9b4a5e9$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $9ff5424ed9b4a5e9$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $9ff5424ed9b4a5e9$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $9ff5424ed9b4a5e9$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $9ff5424ed9b4a5e9$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $9ff5424ed9b4a5e9$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $9ff5424ed9b4a5e9$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $9ff5424ed9b4a5e9$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $9ff5424ed9b4a5e9$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $9ff5424ed9b4a5e9$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $9ff5424ed9b4a5e9$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $9ff5424ed9b4a5e9$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $9ff5424ed9b4a5e9$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $9ff5424ed9b4a5e9$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $9ff5424ed9b4a5e9$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $9ff5424ed9b4a5e9$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $9ff5424ed9b4a5e9$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $9ff5424ed9b4a5e9$var$pathGetFront(changePath);
        if (childKey === '.priority') {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $9ff5424ed9b4a5e9$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $9ff5424ed9b4a5e9$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($9ff5424ed9b4a5e9$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($9ff5424ed9b4a5e9$var$pathGetBack(childChangePath) === '.priority' && childNode.getChild($9ff5424ed9b4a5e9$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $9ff5424ed9b4a5e9$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $9ff5424ed9b4a5e9$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $9ff5424ed9b4a5e9$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $9ff5424ed9b4a5e9$var$pathChild(path, relativePath);
        if ($9ff5424ed9b4a5e9$var$viewProcessorCacheHasChild(viewCache, $9ff5424ed9b4a5e9$var$pathGetFront(writePath))) curViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $9ff5424ed9b4a5e9$var$pathChild(path, relativePath);
        if (!$9ff5424ed9b4a5e9$var$viewProcessorCacheHasChild(viewCache, $9ff5424ed9b4a5e9$var$pathGetFront(writePath))) curViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $9ff5424ed9b4a5e9$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $9ff5424ed9b4a5e9$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $9ff5424ed9b4a5e9$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $9ff5424ed9b4a5e9$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $9ff5424ed9b4a5e9$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $9ff5424ed9b4a5e9$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $9ff5424ed9b4a5e9$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $9ff5424ed9b4a5e9$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $9ff5424ed9b4a5e9$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($9ff5424ed9b4a5e9$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $9ff5424ed9b4a5e9$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($9ff5424ed9b4a5e9$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($9ff5424ed9b4a5e9$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $9ff5424ed9b4a5e9$var$Path(name), node);
            });
            return $9ff5424ed9b4a5e9$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $9ff5424ed9b4a5e9$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $9ff5424ed9b4a5e9$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $9ff5424ed9b4a5e9$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $9ff5424ed9b4a5e9$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $9ff5424ed9b4a5e9$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $9ff5424ed9b4a5e9$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $9ff5424ed9b4a5e9$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $9ff5424ed9b4a5e9$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($9ff5424ed9b4a5e9$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $9ff5424ed9b4a5e9$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(path) || $9ff5424ed9b4a5e9$var$pathGetFront(path) === '.priority') {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventCache(writesCache, $9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(serverChildren instanceof $9ff5424ed9b4a5e9$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                newNode = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $9ff5424ed9b4a5e9$var$pathGetFront(path);
            let newChild = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $9ff5424ed9b4a5e9$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE, $9ff5424ed9b4a5e9$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventCache(writesCache, $9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $9ff5424ed9b4a5e9$var$writeTreeRefShadowingWrite(writesCache, $9ff5424ed9b4a5e9$var$newEmptyPath()) != null;
        return $9ff5424ed9b4a5e9$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $9ff5424ed9b4a5e9$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $9ff5424ed9b4a5e9$var$IndexedFilter(params.getIndex());
        const filter = $9ff5424ed9b4a5e9$var$queryParamsGetNodeFilter(params);
        this.processor_ = $9ff5424ed9b4a5e9$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $9ff5424ed9b4a5e9$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $9ff5424ed9b4a5e9$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $9ff5424ed9b4a5e9$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $9ff5424ed9b4a5e9$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $9ff5424ed9b4a5e9$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $9ff5424ed9b4a5e9$var$viewGetCompleteNode(view) {
    return $9ff5424ed9b4a5e9$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $9ff5424ed9b4a5e9$var$viewGetCompleteServerCache(view, path) {
    const cache = $9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$9ff5424ed9b4a5e9$var$pathIsEmpty(path) && !cache.getImmediateChild($9ff5424ed9b4a5e9$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $9ff5424ed9b4a5e9$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $9ff5424ed9b4a5e9$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $9ff5424ed9b4a5e9$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(eventRegistration == null, 'A cancel should cancel all event registrations.');
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $9ff5424ed9b4a5e9$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $9ff5424ed9b4a5e9$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$viewCacheGetCompleteServerSnap(view.viewCache_), 'We should always have a full cache before handling merges');
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$viewCacheGetCompleteEventSnap(view.viewCache_), 'Missing event cache, even though we have a server cache');
    }
    const oldViewCache = view.viewCache_;
    const result = $9ff5424ed9b4a5e9$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $9ff5424ed9b4a5e9$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), 'Once a server snap is complete, it should never go back');
    view.viewCache_ = result.viewCache;
    return $9ff5424ed9b4a5e9$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $9ff5424ed9b4a5e9$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($9ff5424ed9b4a5e9$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($9ff5424ed9b4a5e9$var$changeValue(eventSnap.getNode()));
    return $9ff5424ed9b4a5e9$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $9ff5424ed9b4a5e9$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $9ff5424ed9b4a5e9$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $9ff5424ed9b4a5e9$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $9ff5424ed9b4a5e9$var$syncPointSetReferenceConstructor(val) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!$9ff5424ed9b4a5e9$var$referenceConstructor$1, '__referenceConstructor has already been defined');
    $9ff5424ed9b4a5e9$var$referenceConstructor$1 = val;
}
function $9ff5424ed9b4a5e9$var$syncPointGetReferenceConstructor() {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$referenceConstructor$1, 'Reference.ts has not been loaded');
    return $9ff5424ed9b4a5e9$var$referenceConstructor$1;
}
function $9ff5424ed9b4a5e9$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $9ff5424ed9b4a5e9$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(view != null, 'SyncTree gave us an op for an invalid query.');
        return $9ff5424ed9b4a5e9$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($9ff5424ed9b4a5e9$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $9ff5424ed9b4a5e9$var$ChildrenNode) {
            eventCache = $9ff5424ed9b4a5e9$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $9ff5424ed9b4a5e9$var$newViewCache(new $9ff5424ed9b4a5e9$var$CacheNode(eventCache, eventCacheComplete, false), new $9ff5424ed9b4a5e9$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $9ff5424ed9b4a5e9$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $9ff5424ed9b4a5e9$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $9ff5424ed9b4a5e9$var$viewAddEventRegistration(view, eventRegistration);
    return $9ff5424ed9b4a5e9$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $9ff5424ed9b4a5e9$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $9ff5424ed9b4a5e9$var$syncPointHasCompleteView(syncPoint);
    if (queryId === 'default') // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($9ff5424ed9b4a5e9$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($9ff5424ed9b4a5e9$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($9ff5424ed9b4a5e9$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($9ff5424ed9b4a5e9$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$9ff5424ed9b4a5e9$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($9ff5424ed9b4a5e9$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $9ff5424ed9b4a5e9$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $9ff5424ed9b4a5e9$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $9ff5424ed9b4a5e9$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $9ff5424ed9b4a5e9$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $9ff5424ed9b4a5e9$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $9ff5424ed9b4a5e9$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $9ff5424ed9b4a5e9$var$syncPointHasCompleteView(syncPoint) {
    return $9ff5424ed9b4a5e9$var$syncPointGetCompleteView(syncPoint) != null;
}
function $9ff5424ed9b4a5e9$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9ff5424ed9b4a5e9$var$referenceConstructor;
function $9ff5424ed9b4a5e9$var$syncTreeSetReferenceConstructor(val) {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!$9ff5424ed9b4a5e9$var$referenceConstructor, '__referenceConstructor has already been defined');
    $9ff5424ed9b4a5e9$var$referenceConstructor = val;
}
function $9ff5424ed9b4a5e9$var$syncTreeGetReferenceConstructor() {
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$referenceConstructor, 'Reference.ts has not been loaded');
    return $9ff5424ed9b4a5e9$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $9ff5424ed9b4a5e9$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $9ff5424ed9b4a5e9$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $9ff5424ed9b4a5e9$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $9ff5424ed9b4a5e9$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9ff5424ed9b4a5e9$var$Overwrite($9ff5424ed9b4a5e9$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $9ff5424ed9b4a5e9$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $9ff5424ed9b4a5e9$var$ImmutableTree.fromObject(changedChildren);
    return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9ff5424ed9b4a5e9$var$Merge($9ff5424ed9b4a5e9$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $9ff5424ed9b4a5e9$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $9ff5424ed9b4a5e9$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $9ff5424ed9b4a5e9$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($9ff5424ed9b4a5e9$var$newEmptyPath(), true);
        else $9ff5424ed9b4a5e9$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $9ff5424ed9b4a5e9$var$Path(pathString), true);
        });
        return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9ff5424ed9b4a5e9$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9ff5424ed9b4a5e9$var$Overwrite($9ff5424ed9b4a5e9$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $9ff5424ed9b4a5e9$var$ImmutableTree.fromObject(changedChildren);
    return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9ff5424ed9b4a5e9$var$Merge($9ff5424ed9b4a5e9$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyListenComplete(syncTree, path) {
    return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9ff5424ed9b4a5e9$var$ListenComplete($9ff5424ed9b4a5e9$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $9ff5424ed9b4a5e9$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $9ff5424ed9b4a5e9$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(queryPath, path);
        const op = new $9ff5424ed9b4a5e9$var$ListenComplete($9ff5424ed9b4a5e9$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $9ff5424ed9b4a5e9$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === 'default' || $9ff5424ed9b4a5e9$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $9ff5424ed9b4a5e9$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($9ff5424ed9b4a5e9$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$9ff5424ed9b4a5e9$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $9ff5424ed9b4a5e9$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $9ff5424ed9b4a5e9$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($9ff5424ed9b4a5e9$var$syncTreeQueryForListening_(newQuery), $9ff5424ed9b4a5e9$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($9ff5424ed9b4a5e9$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($9ff5424ed9b4a5e9$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($9ff5424ed9b4a5e9$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $9ff5424ed9b4a5e9$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $9ff5424ed9b4a5e9$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $9ff5424ed9b4a5e9$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(queryPath, path);
        const op = new $9ff5424ed9b4a5e9$var$Overwrite($9ff5424ed9b4a5e9$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $9ff5424ed9b4a5e9$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $9ff5424ed9b4a5e9$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(queryPath, path);
        const changeTree = $9ff5424ed9b4a5e9$var$ImmutableTree.fromObject(changedChildren);
        const op = new $9ff5424ed9b4a5e9$var$Merge($9ff5424ed9b4a5e9$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $9ff5424ed9b4a5e9$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $9ff5424ed9b4a5e9$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $9ff5424ed9b4a5e9$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $9ff5424ed9b4a5e9$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(syncPoint, $9ff5424ed9b4a5e9$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(childSyncPoint, $9ff5424ed9b4a5e9$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $9ff5424ed9b4a5e9$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $9ff5424ed9b4a5e9$var$syncTreeMakeQueryKey_(query);
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
        const tag = $9ff5424ed9b4a5e9$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $9ff5424ed9b4a5e9$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $9ff5424ed9b4a5e9$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $9ff5424ed9b4a5e9$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($9ff5424ed9b4a5e9$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $9ff5424ed9b4a5e9$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(pathSoFar, path);
        const serverCache = $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $9ff5424ed9b4a5e9$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $9ff5424ed9b4a5e9$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $9ff5424ed9b4a5e9$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(syncPoint, $9ff5424ed9b4a5e9$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $9ff5424ed9b4a5e9$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $9ff5424ed9b4a5e9$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $9ff5424ed9b4a5e9$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $9ff5424ed9b4a5e9$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $9ff5424ed9b4a5e9$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $9ff5424ed9b4a5e9$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($9ff5424ed9b4a5e9$var$pathIsEmpty(operation.path)) return $9ff5424ed9b4a5e9$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($9ff5424ed9b4a5e9$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(syncPoint, $9ff5424ed9b4a5e9$var$newEmptyPath());
        let events = [];
        const childName = $9ff5424ed9b4a5e9$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $9ff5424ed9b4a5e9$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($9ff5424ed9b4a5e9$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($9ff5424ed9b4a5e9$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($9ff5424ed9b4a5e9$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $9ff5424ed9b4a5e9$var$syncPointGetCompleteServerCache(syncPoint, $9ff5424ed9b4a5e9$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $9ff5424ed9b4a5e9$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($9ff5424ed9b4a5e9$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($9ff5424ed9b4a5e9$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $9ff5424ed9b4a5e9$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $9ff5424ed9b4a5e9$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $9ff5424ed9b4a5e9$var$viewGetServerCache(view) || $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === 'ok') {
                if (tag) return $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $9ff5424ed9b4a5e9$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $9ff5424ed9b4a5e9$var$errorForServerCode(status, query);
                return $9ff5424ed9b4a5e9$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $9ff5424ed9b4a5e9$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $9ff5424ed9b4a5e9$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $9ff5424ed9b4a5e9$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + '$' + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $9ff5424ed9b4a5e9$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $9ff5424ed9b4a5e9$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf('$');
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $9ff5424ed9b4a5e9$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $9ff5424ed9b4a5e9$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $9ff5424ed9b4a5e9$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $9ff5424ed9b4a5e9$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $9ff5424ed9b4a5e9$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $9ff5424ed9b4a5e9$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $9ff5424ed9b4a5e9$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $9ff5424ed9b4a5e9$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $9ff5424ed9b4a5e9$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($9ff5424ed9b4a5e9$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $9ff5424ed9b4a5e9$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $9ff5424ed9b4a5e9$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $9ff5424ed9b4a5e9$var$syncTreeGetNextQueryTag_() {
    return $9ff5424ed9b4a5e9$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $9ff5424ed9b4a5e9$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $9ff5424ed9b4a5e9$var$syncTreeTagForQuery(syncTree, query);
    const listener = $9ff5424ed9b4a5e9$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($9ff5424ed9b4a5e9$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(!$9ff5424ed9b4a5e9$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$9ff5424ed9b4a5e9$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $9ff5424ed9b4a5e9$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $9ff5424ed9b4a5e9$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($9ff5424ed9b4a5e9$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $9ff5424ed9b4a5e9$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($9ff5424ed9b4a5e9$var$syncTreeQueryForListening_(queryToStop), $9ff5424ed9b4a5e9$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9ff5424ed9b4a5e9$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $9ff5424ed9b4a5e9$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $9ff5424ed9b4a5e9$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $9ff5424ed9b4a5e9$var$pathChild(this.path_, childName);
        return new $9ff5424ed9b4a5e9$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $9ff5424ed9b4a5e9$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $9ff5424ed9b4a5e9$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $9ff5424ed9b4a5e9$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $9ff5424ed9b4a5e9$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $9ff5424ed9b4a5e9$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
const $9ff5424ed9b4a5e9$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(false, 'Unexpected server value: ' + op);
    }
};
const $9ff5424ed9b4a5e9$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    const delta = op['increment'];
    if (typeof delta !== 'number') (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(false, 'Unexpected increment value: ' + delta);
    const existingNode = existing.node();
    (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $9ff5424ed9b4a5e9$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $9ff5424ed9b4a5e9$var$resolveDeferredValue(node, new $9ff5424ed9b4a5e9$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $9ff5424ed9b4a5e9$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $9ff5424ed9b4a5e9$var$resolveDeferredValue(node, new $9ff5424ed9b4a5e9$var$ExistingValueProvider(existing), serverValues);
};
function $9ff5424ed9b4a5e9$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $9ff5424ed9b4a5e9$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $9ff5424ed9b4a5e9$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $9ff5424ed9b4a5e9$var$LeafNode(value, $9ff5424ed9b4a5e9$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $9ff5424ed9b4a5e9$var$LeafNode(priority));
        childrenNode.forEachChild($9ff5424ed9b4a5e9$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $9ff5424ed9b4a5e9$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $9ff5424ed9b4a5e9$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = '', parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $9ff5424ed9b4a5e9$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $9ff5424ed9b4a5e9$var$Path ? pathObj : new $9ff5424ed9b4a5e9$var$Path(pathObj);
    let child = tree, next = $9ff5424ed9b4a5e9$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $4e6a98b76c0d0a37$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $9ff5424ed9b4a5e9$var$Tree(next, child, childNode);
        path = $9ff5424ed9b4a5e9$var$pathPopFront(path);
        next = $9ff5424ed9b4a5e9$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $9ff5424ed9b4a5e9$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $9ff5424ed9b4a5e9$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $9ff5424ed9b4a5e9$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $9ff5424ed9b4a5e9$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whether the tree is empty (no value or children).
 */ function $9ff5424ed9b4a5e9$var$treeIsEmpty(tree) {
    return $9ff5424ed9b4a5e9$var$treeGetValue(tree) === undefined && !$9ff5424ed9b4a5e9$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $9ff5424ed9b4a5e9$var$treeForEachChild(tree, action) {
    $9ff5424ed9b4a5e9$var$each(tree.node.children, (child, childTree)=>{
        action(new $9ff5424ed9b4a5e9$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $9ff5424ed9b4a5e9$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $9ff5424ed9b4a5e9$var$treeForEachChild(tree, (child)=>{
        $9ff5424ed9b4a5e9$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $9ff5424ed9b4a5e9$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $9ff5424ed9b4a5e9$var$treeGetPath(tree) {
    return new $9ff5424ed9b4a5e9$var$Path(tree.parent === null ? tree.name : $9ff5424ed9b4a5e9$var$treeGetPath(tree.parent) + '/' + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $9ff5424ed9b4a5e9$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $9ff5424ed9b4a5e9$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $9ff5424ed9b4a5e9$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $9ff5424ed9b4a5e9$var$treeIsEmpty(child);
    const childExists = (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $9ff5424ed9b4a5e9$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $9ff5424ed9b4a5e9$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $9ff5424ed9b4a5e9$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $9ff5424ed9b4a5e9$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $9ff5424ed9b4a5e9$var$MAX_LEAF_SIZE_ = 10485760;
const $9ff5424ed9b4a5e9$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$9ff5424ed9b4a5e9$var$INVALID_KEY_REGEX_.test(key);
};
const $9ff5424ed9b4a5e9$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$9ff5424ed9b4a5e9$var$INVALID_PATH_REGEX_.test(pathString);
};
const $9ff5424ed9b4a5e9$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $9ff5424ed9b4a5e9$var$isValidPathString(pathString);
};
const $9ff5424ed9b4a5e9$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$9ff5424ed9b4a5e9$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $9ff5424ed9b4a5e9$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $9ff5424ed9b4a5e9$var$validateFirebaseData((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, 'value'), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $9ff5424ed9b4a5e9$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $9ff5424ed9b4a5e9$var$Path ? new $9ff5424ed9b4a5e9$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + $9ff5424ed9b4a5e9$var$validationPathToErrorString(path));
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + $9ff5424ed9b4a5e9$var$validationPathToErrorString(path) + ' with contents = ' + data.toString());
    if ($9ff5424ed9b4a5e9$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + $9ff5424ed9b4a5e9$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $9ff5424ed9b4a5e9$var$MAX_LEAF_SIZE_ / 3 && (0, $4e6a98b76c0d0a37$export$9536dc0a75b20bf9)(data) > $9ff5424ed9b4a5e9$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $9ff5424ed9b4a5e9$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + $9ff5424ed9b4a5e9$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        let hasDotValue = false;
        let hasActualChild = false;
        $9ff5424ed9b4a5e9$var$each(data, (key, value)=>{
            if (key === '.value') hasDotValue = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild = true;
                if (!$9ff5424ed9b4a5e9$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + $9ff5424ed9b4a5e9$var$validationPathToErrorString(path) + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $9ff5424ed9b4a5e9$var$validationPathPush(path, key);
            $9ff5424ed9b4a5e9$var$validateFirebaseData(errorPrefix, value, path);
            $9ff5424ed9b4a5e9$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $9ff5424ed9b4a5e9$var$validationPathToErrorString(path) + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $9ff5424ed9b4a5e9$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $9ff5424ed9b4a5e9$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$9ff5424ed9b4a5e9$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($9ff5424ed9b4a5e9$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $9ff5424ed9b4a5e9$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $9ff5424ed9b4a5e9$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, 'values');
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    const mergePaths = [];
    $9ff5424ed9b4a5e9$var$each(data, (key, value)=>{
        const curPath = new $9ff5424ed9b4a5e9$var$Path(key);
        $9ff5424ed9b4a5e9$var$validateFirebaseData(errorPrefix$1, value, $9ff5424ed9b4a5e9$var$pathChild(path, curPath));
        if ($9ff5424ed9b4a5e9$var$pathGetBack(curPath) === '.priority') {
            if (!$9ff5424ed9b4a5e9$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $9ff5424ed9b4a5e9$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $9ff5424ed9b4a5e9$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($9ff5424ed9b4a5e9$var$isInvalidJSONNumber(priority)) throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, 'priority') + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$9ff5424ed9b4a5e9$var$isValidPriority(priority)) throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, 'priority') + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
const $9ff5424ed9b4a5e9$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$9ff5424ed9b4a5e9$var$isValidKey(key)) throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $9ff5424ed9b4a5e9$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$9ff5424ed9b4a5e9$var$isValidPathString(pathString)) throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $9ff5424ed9b4a5e9$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $9ff5424ed9b4a5e9$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $9ff5424ed9b4a5e9$export$8d83036122ae444e = function(fnName, path) {
    if ($9ff5424ed9b4a5e9$var$pathGetFront(path) === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $9ff5424ed9b4a5e9$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$9ff5424ed9b4a5e9$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$9ff5424ed9b4a5e9$var$isValidRootPathString(pathString)) throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, 'url') + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $9ff5424ed9b4a5e9$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $9ff5424ed9b4a5e9$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$9ff5424ed9b4a5e9$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $9ff5424ed9b4a5e9$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $9ff5424ed9b4a5e9$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$9ff5424ed9b4a5e9$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $9ff5424ed9b4a5e9$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $9ff5424ed9b4a5e9$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$9ff5424ed9b4a5e9$var$pathContains(eventPath, changedPath) || $9ff5424ed9b4a5e9$var$pathContains(changedPath, eventPath));
}
function $9ff5424ed9b4a5e9$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $9ff5424ed9b4a5e9$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $9ff5424ed9b4a5e9$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($9ff5424ed9b4a5e9$var$logger) $9ff5424ed9b4a5e9$var$log('event: ' + eventData.toString());
            $9ff5424ed9b4a5e9$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $9ff5424ed9b4a5e9$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $9ff5424ed9b4a5e9$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $9ff5424ed9b4a5e9$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $9ff5424ed9b4a5e9$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $9ff5424ed9b4a5e9$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    }
}
function $9ff5424ed9b4a5e9$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $9ff5424ed9b4a5e9$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $9ff5424ed9b4a5e9$var$beingCrawled()) {
        repo.server_ = new $9ff5424ed9b4a5e9$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $9ff5424ed9b4a5e9$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$9ff5424ed9b4a5e9$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== 'undefined' && authOverride !== null) {
            if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
            try {
                (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error('Invalid authOverride provided: ' + e);
            }
        }
        repo.persistentConnection_ = new $9ff5424ed9b4a5e9$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $9ff5424ed9b4a5e9$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $9ff5424ed9b4a5e9$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $9ff5424ed9b4a5e9$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $9ff5424ed9b4a5e9$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $9ff5424ed9b4a5e9$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $9ff5424ed9b4a5e9$var$SnapshotHolder();
    repo.infoSyncTree_ = new $9ff5424ed9b4a5e9$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $9ff5424ed9b4a5e9$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete('ok');
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $9ff5424ed9b4a5e9$var$repoUpdateInfo(repo, 'connected', false);
    repo.serverSyncTree_ = new $9ff5424ed9b4a5e9$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $9ff5424ed9b4a5e9$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $9ff5424ed9b4a5e9$var$Path('.info/serverTimeOffset'));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $9ff5424ed9b4a5e9$var$repoGenerateServerValues(repo) {
    return $9ff5424ed9b4a5e9$var$generateWithValues({
        timestamp: $9ff5424ed9b4a5e9$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $9ff5424ed9b4a5e9$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $9ff5424ed9b4a5e9$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $4e6a98b76c0d0a37$export$871de8747c9eaa88)(data, (raw)=>$9ff5424ed9b4a5e9$var$nodeFromJSON(raw));
            events = $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $9ff5424ed9b4a5e9$var$nodeFromJSON(data);
            events = $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $4e6a98b76c0d0a37$export$871de8747c9eaa88)(data, (raw)=>$9ff5424ed9b4a5e9$var$nodeFromJSON(raw));
        events = $9ff5424ed9b4a5e9$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $9ff5424ed9b4a5e9$var$nodeFromJSON(data);
        events = $9ff5424ed9b4a5e9$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $9ff5424ed9b4a5e9$var$repoRerunTransactions(repo, path);
    $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $9ff5424ed9b4a5e9$var$repoOnConnectStatus(repo, connectStatus) {
    $9ff5424ed9b4a5e9$var$repoUpdateInfo(repo, 'connected', connectStatus);
    if (connectStatus === false) $9ff5424ed9b4a5e9$var$repoRunOnDisconnectEvents(repo);
}
function $9ff5424ed9b4a5e9$var$repoOnServerInfoUpdate(repo, updates) {
    $9ff5424ed9b4a5e9$var$each(updates, (key, value)=>{
        $9ff5424ed9b4a5e9$var$repoUpdateInfo(repo, key, value);
    });
}
function $9ff5424ed9b4a5e9$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $9ff5424ed9b4a5e9$var$Path('/.info/' + pathString);
    const newNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $9ff5424ed9b4a5e9$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $9ff5424ed9b4a5e9$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $9ff5424ed9b4a5e9$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $9ff5424ed9b4a5e9$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $9ff5424ed9b4a5e9$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $9ff5424ed9b4a5e9$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $9ff5424ed9b4a5e9$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $9ff5424ed9b4a5e9$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $9ff5424ed9b4a5e9$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $9ff5424ed9b4a5e9$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $9ff5424ed9b4a5e9$var$repoLog(repo, 'get for query ' + (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(query) + ' failed: ' + err);
        return Promise.reject(new Error(err));
    });
}
function $9ff5424ed9b4a5e9$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $9ff5424ed9b4a5e9$var$repoLog(repo, 'set', {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $9ff5424ed9b4a5e9$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $9ff5424ed9b4a5e9$var$nodeFromJSON(newVal, newPriority);
    const existing = $9ff5424ed9b4a5e9$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $9ff5424ed9b4a5e9$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $9ff5424ed9b4a5e9$var$repoGetNextWriteId(repo);
    const events = $9ff5424ed9b4a5e9$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $9ff5424ed9b4a5e9$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === 'ok';
        if (!success) $9ff5424ed9b4a5e9$var$warn('set at ' + path + ' failed: ' + status);
        const clearEvents = $9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $9ff5424ed9b4a5e9$var$repoAbortTransactions(repo, path);
    $9ff5424ed9b4a5e9$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $9ff5424ed9b4a5e9$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $9ff5424ed9b4a5e9$var$repoLog(repo, 'update', {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $9ff5424ed9b4a5e9$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $9ff5424ed9b4a5e9$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $9ff5424ed9b4a5e9$var$resolveDeferredValueTree($9ff5424ed9b4a5e9$var$pathChild(path, changedKey), $9ff5424ed9b4a5e9$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $9ff5424ed9b4a5e9$var$repoGetNextWriteId(repo);
        const events = $9ff5424ed9b4a5e9$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $9ff5424ed9b4a5e9$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === 'ok';
            if (!success) $9ff5424ed9b4a5e9$var$warn('update at ' + path + ' failed: ' + status);
            const clearEvents = $9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $9ff5424ed9b4a5e9$var$repoRerunTransactions(repo, path) : path;
            $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $9ff5424ed9b4a5e9$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $9ff5424ed9b4a5e9$var$repoAbortTransactions(repo, $9ff5424ed9b4a5e9$var$pathChild(path, changedPath));
            $9ff5424ed9b4a5e9$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $9ff5424ed9b4a5e9$var$log("update() called with empty data.  Don't do anything.");
        $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $9ff5424ed9b4a5e9$var$repoRunOnDisconnectEvents(repo) {
    $9ff5424ed9b4a5e9$var$repoLog(repo, 'onDisconnectEvents');
    const serverValues = $9ff5424ed9b4a5e9$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $9ff5424ed9b4a5e9$var$newSparseSnapshotTree();
    $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $9ff5424ed9b4a5e9$var$newEmptyPath(), (path, node)=>{
        const resolved = $9ff5424ed9b4a5e9$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $9ff5424ed9b4a5e9$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $9ff5424ed9b4a5e9$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($9ff5424ed9b4a5e9$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $9ff5424ed9b4a5e9$var$repoAbortTransactions(repo, path);
        $9ff5424ed9b4a5e9$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $9ff5424ed9b4a5e9$var$newSparseSnapshotTree();
    $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $9ff5424ed9b4a5e9$var$newEmptyPath(), events);
}
function $9ff5424ed9b4a5e9$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === 'ok') $9ff5424ed9b4a5e9$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9ff5424ed9b4a5e9$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $9ff5424ed9b4a5e9$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9ff5424ed9b4a5e9$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $9ff5424ed9b4a5e9$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9ff5424ed9b4a5e9$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $4e6a98b76c0d0a37$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $9ff5424ed9b4a5e9$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === 'ok') $9ff5424ed9b4a5e9$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(childNode);
            $9ff5424ed9b4a5e9$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $9ff5424ed9b4a5e9$var$pathChild(path, childName), newChildNode);
        });
        $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9ff5424ed9b4a5e9$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($9ff5424ed9b4a5e9$var$pathGetFront(query._path) === '.info') events = $9ff5424ed9b4a5e9$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $9ff5424ed9b4a5e9$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $9ff5424ed9b4a5e9$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($9ff5424ed9b4a5e9$var$pathGetFront(query._path) === '.info') events = $9ff5424ed9b4a5e9$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $9ff5424ed9b4a5e9$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $9ff5424ed9b4a5e9$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($9ff5424ed9b4a5e9$var$INTERRUPT_REASON);
}
function $9ff5424ed9b4a5e9$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($9ff5424ed9b4a5e9$var$INTERRUPT_REASON);
}
function $9ff5424ed9b4a5e9$var$repoLog(repo, ...varArgs) {
    let prefix = '';
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ':';
    $9ff5424ed9b4a5e9$var$log(prefix, ...varArgs);
}
function $9ff5424ed9b4a5e9$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $9ff5424ed9b4a5e9$var$exceptionGuard(()=>{
        if (status === 'ok') callback(null);
        else {
            const code = (status || 'error').toUpperCase();
            let message = code;
            if (errorReason) message += ': ' + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $9ff5424ed9b4a5e9$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $9ff5424ed9b4a5e9$var$repoLog(repo, 'transaction on ' + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $9ff5424ed9b4a5e9$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $9ff5424ed9b4a5e9$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $9ff5424ed9b4a5e9$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $9ff5424ed9b4a5e9$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $9ff5424ed9b4a5e9$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $9ff5424ed9b4a5e9$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === 'object' && newVal !== null && (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $4e6a98b76c0d0a37$export$e51ae4db7b428f67)(newVal, '.priority');
            (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)($9ff5424ed9b4a5e9$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $9ff5424ed9b4a5e9$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $9ff5424ed9b4a5e9$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $9ff5424ed9b4a5e9$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $9ff5424ed9b4a5e9$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $9ff5424ed9b4a5e9$var$repoGetNextWriteId(repo);
        const events = $9ff5424ed9b4a5e9$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $9ff5424ed9b4a5e9$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $9ff5424ed9b4a5e9$var$repoGetLatestState(repo, path, excludeSets) {
    return $9ff5424ed9b4a5e9$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $9ff5424ed9b4a5e9$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $9ff5424ed9b4a5e9$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $9ff5424ed9b4a5e9$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($9ff5424ed9b4a5e9$var$treeGetValue(node)) {
        const queue = $9ff5424ed9b4a5e9$var$repoBuildTransactionQueue(repo, node);
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(queue.length > 0, 'Sending zero length transaction queue');
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $9ff5424ed9b4a5e9$var$repoSendTransactionQueue(repo, $9ff5424ed9b4a5e9$var$treeGetPath(node), queue);
    } else if ($9ff5424ed9b4a5e9$var$treeHasChildren(node)) $9ff5424ed9b4a5e9$var$treeForEachChild(node, (childNode)=>{
        $9ff5424ed9b4a5e9$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $9ff5424ed9b4a5e9$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $9ff5424ed9b4a5e9$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(txn.status === 0 /* TransactionStatus.RUN */ , 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $9ff5424ed9b4a5e9$var$repoLog(repo, 'transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $9ff5424ed9b4a5e9$var$repoPruneCompletedTransactionsBelowNode(repo, $9ff5424ed9b4a5e9$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $9ff5424ed9b4a5e9$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$9ff5424ed9b4a5e9$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $9ff5424ed9b4a5e9$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $9ff5424ed9b4a5e9$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $9ff5424ed9b4a5e9$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $9ff5424ed9b4a5e9$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $9ff5424ed9b4a5e9$var$treeGetPath(rootMostTransactionNode);
    const queue = $9ff5424ed9b4a5e9$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $9ff5424ed9b4a5e9$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $9ff5424ed9b4a5e9$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $9ff5424ed9b4a5e9$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $9ff5424ed9b4a5e9$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat($9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $9ff5424ed9b4a5e9$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $9ff5424ed9b4a5e9$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    let newDataNode = $9ff5424ed9b4a5e9$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === 'object' && newData != null && (0, $4e6a98b76c0d0a37$export$2344b14b097df817)(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $9ff5424ed9b4a5e9$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $9ff5424ed9b4a5e9$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $9ff5424ed9b4a5e9$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($9ff5424ed9b4a5e9$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat($9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $9ff5424ed9b4a5e9$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$9ff5424ed9b4a5e9$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $9ff5424ed9b4a5e9$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $9ff5424ed9b4a5e9$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $9ff5424ed9b4a5e9$var$pathGetFront(path);
    while(front !== null && $9ff5424ed9b4a5e9$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $9ff5424ed9b4a5e9$var$treeSubTree(transactionNode, front);
        path = $9ff5424ed9b4a5e9$var$pathPopFront(path);
        front = $9ff5424ed9b4a5e9$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $9ff5424ed9b4a5e9$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $9ff5424ed9b4a5e9$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $9ff5424ed9b4a5e9$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $9ff5424ed9b4a5e9$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $9ff5424ed9b4a5e9$var$treeForEachChild(node, (child)=>{
        $9ff5424ed9b4a5e9$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $9ff5424ed9b4a5e9$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $9ff5424ed9b4a5e9$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $9ff5424ed9b4a5e9$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $9ff5424ed9b4a5e9$var$treeForEachChild(node, (childNode)=>{
        $9ff5424ed9b4a5e9$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $9ff5424ed9b4a5e9$var$repoAbortTransactions(repo, path) {
    const affectedPath = $9ff5424ed9b4a5e9$var$treeGetPath($9ff5424ed9b4a5e9$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $9ff5424ed9b4a5e9$var$treeSubTree(repo.transactionQueueTree_, path);
    $9ff5424ed9b4a5e9$var$treeForEachAncestor(transactionNode, (node)=>{
        $9ff5424ed9b4a5e9$var$repoAbortTransactionsOnNode(repo, node);
    });
    $9ff5424ed9b4a5e9$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $9ff5424ed9b4a5e9$var$treeForEachDescendant(transactionNode, (node)=>{
        $9ff5424ed9b4a5e9$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $9ff5424ed9b4a5e9$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $9ff5424ed9b4a5e9$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = 'set';
            } else {
                (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(queue[i].status === 0 /* TransactionStatus.RUN */ , 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($9ff5424ed9b4a5e9$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $9ff5424ed9b4a5e9$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $9ff5424ed9b4a5e9$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $9ff5424ed9b4a5e9$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$9ff5424ed9b4a5e9$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ff5424ed9b4a5e9$var$decodePath(pathString) {
    let pathStringDecoded = '';
    const pieces = pathString.split('/');
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $9ff5424ed9b4a5e9$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    for (const segment of queryString.split('&')){
        if (segment.length === 0) continue;
        const kv = segment.split('=');
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $9ff5424ed9b4a5e9$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $9ff5424ed9b4a5e9$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $9ff5424ed9b4a5e9$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $9ff5424ed9b4a5e9$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $9ff5424ed9b4a5e9$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $9ff5424ed9b4a5e9$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $9ff5424ed9b4a5e9$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $9ff5424ed9b4a5e9$var$Path(parsedUrl.pathString)
    };
};
const $9ff5424ed9b4a5e9$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        let colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $9ff5424ed9b4a5e9$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $9ff5424ed9b4a5e9$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $9ff5424ed9b4a5e9$var$PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $9ff5424ed9b4a5e9$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $9ff5424ed9b4a5e9$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(now === 0, 'Cannot push at time == 0');
        let id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $9ff5424ed9b4a5e9$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $9ff5424ed9b4a5e9$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === 'value') return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, $4e6a98b76c0d0a37$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $9ff5424ed9b4a5e9$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return 'cancel';
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ':cancel';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $9ff5424ed9b4a5e9$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(this.hasCancelCallback, 'Raising a cancel event on a listener with no cancel callback');
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $9ff5424ed9b4a5e9$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        $9ff5424ed9b4a5e9$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $9ff5424ed9b4a5e9$export$8d83036122ae444e('OnDisconnect.remove', this._path);
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        $9ff5424ed9b4a5e9$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $9ff5424ed9b4a5e9$export$8d83036122ae444e('OnDisconnect.set', this._path);
        $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('OnDisconnect.set', value, this._path, false);
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        $9ff5424ed9b4a5e9$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $9ff5424ed9b4a5e9$export$8d83036122ae444e('OnDisconnect.setWithPriority', this._path);
        $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', value, this._path, false);
        $9ff5424ed9b4a5e9$var$validatePriority('OnDisconnect.setWithPriority', priority, false);
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        $9ff5424ed9b4a5e9$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $9ff5424ed9b4a5e9$export$8d83036122ae444e('OnDisconnect.update', this._path);
        $9ff5424ed9b4a5e9$var$validateFirebaseMergeDataArg('OnDisconnect.update', values, this._path, false);
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        $9ff5424ed9b4a5e9$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $9ff5424ed9b4a5e9$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(this._path)) return null;
        else return $9ff5424ed9b4a5e9$var$pathGetBack(this._path);
    }
    get ref() {
        return new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $9ff5424ed9b4a5e9$var$queryParamsGetQueryObject(this._queryParams);
        const id = $9ff5424ed9b4a5e9$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $9ff5424ed9b4a5e9$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $9ff5424ed9b4a5e9$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $9ff5424ed9b4a5e9$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $9ff5424ed9b4a5e9$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $9ff5424ed9b4a5e9$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $9ff5424ed9b4a5e9$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $9ff5424ed9b4a5e9$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $9ff5424ed9b4a5e9$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $9ff5424ed9b4a5e9$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $9ff5424ed9b4a5e9$var$PRIORITY_INDEX) {
        if (startNode != null && !$9ff5424ed9b4a5e9$var$isValidPriority(startNode) || endNode != null && !$9ff5424ed9b4a5e9$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(params.getIndex() instanceof $9ff5424ed9b4a5e9$var$PathIndex || params.getIndex() === $9ff5424ed9b4a5e9$var$VALUE_INDEX, 'unknown index type.');
        if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $9ff5424ed9b4a5e9$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c extends $9ff5424ed9b4a5e9$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $9ff5424ed9b4a5e9$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $9ff5424ed9b4a5e9$var$pathParent(this._path);
        return parentPath === null ? null : new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $9ff5424ed9b4a5e9$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $9ff5424ed9b4a5e9$var$Path(path);
        const childRef = $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d(this.ref, path);
        return new $9ff5424ed9b4a5e9$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $9ff5424ed9b4a5e9$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `IteratedDataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $9ff5424ed9b4a5e9$export$80b98bcbc246c942(node, $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d(this.ref, key), $9ff5424ed9b4a5e9$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $9ff5424ed9b4a5e9$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $9ff5424ed9b4a5e9$export$eff4d24c3ff7876e(db, path) {
    db = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('ref');
    return path !== undefined ? $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $9ff5424ed9b4a5e9$export$291fc3c05735451(db, url) {
    db = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('refFromURL');
    const parsedURL = $9ff5424ed9b4a5e9$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $9ff5424ed9b4a5e9$var$validateUrl('refFromURL', parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $9ff5424ed9b4a5e9$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + ' but expected ' + db._repo.repoInfo_.host + ')');
    return $9ff5424ed9b4a5e9$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(parent);
    if ($9ff5424ed9b4a5e9$var$pathGetFront(parent._path) === null) $9ff5424ed9b4a5e9$var$validateRootPathString('child', 'path', path, false);
    else $9ff5424ed9b4a5e9$export$8637b026ace8abb1('child', 'path', path, false);
    return new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(parent._repo, $9ff5424ed9b4a5e9$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $9ff5424ed9b4a5e9$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(ref);
    return new $9ff5424ed9b4a5e9$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $9ff5424ed9b4a5e9$export$4cbf152802aa238(parent, value) {
    parent = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(parent);
    $9ff5424ed9b4a5e9$export$8d83036122ae444e('push', parent._path);
    $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('push', value, parent._path, true);
    const now = $9ff5424ed9b4a5e9$var$repoServerTime(parent._repo);
    const name = $9ff5424ed9b4a5e9$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thenablePushRef = $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $9ff5424ed9b4a5e9$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thenablePushRef.then = promise.then.bind(promise);
    thenablePushRef.catch = promise.then.bind(promise, undefined);
    return thenablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $9ff5424ed9b4a5e9$export$cd7f480d6b8286c3(ref) {
    $9ff5424ed9b4a5e9$export$8d83036122ae444e('remove', ref._path);
    return $9ff5424ed9b4a5e9$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $9ff5424ed9b4a5e9$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(ref);
    $9ff5424ed9b4a5e9$export$8d83036122ae444e('set', ref._path);
    $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('set', value, ref._path, false);
    const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
    $9ff5424ed9b4a5e9$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $9ff5424ed9b4a5e9$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(ref);
    $9ff5424ed9b4a5e9$export$8d83036122ae444e('setPriority', ref._path);
    $9ff5424ed9b4a5e9$var$validatePriority('setPriority', priority, false);
    const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
    $9ff5424ed9b4a5e9$var$repoSetWithPriority(ref._repo, $9ff5424ed9b4a5e9$var$pathChild(ref._path, '.priority'), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $9ff5424ed9b4a5e9$export$1fa5d5bf488088f3(ref, value, priority) {
    $9ff5424ed9b4a5e9$export$8d83036122ae444e('setWithPriority', ref._path);
    $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('setWithPriority', value, ref._path, false);
    $9ff5424ed9b4a5e9$var$validatePriority('setWithPriority', priority, false);
    if (ref.key === '.length' || ref.key === '.keys') throw 'setWithPriority failed: ' + ref.key + ' is a read-only object.';
    const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
    $9ff5424ed9b4a5e9$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $9ff5424ed9b4a5e9$export$722fbec263ad908a(ref, values) {
    $9ff5424ed9b4a5e9$var$validateFirebaseMergeDataArg('update', values, ref._path, false);
    const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
    $9ff5424ed9b4a5e9$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $9ff5424ed9b4a5e9$export$3988ae62b71be9a3(query) {
    query = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(query);
    const callbackContext = new $9ff5424ed9b4a5e9$var$CallbackContext(()=>{});
    const container = new $9ff5424ed9b4a5e9$var$ValueEventRegistration(callbackContext);
    return $9ff5424ed9b4a5e9$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $9ff5424ed9b4a5e9$export$80b98bcbc246c942(node, new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $9ff5424ed9b4a5e9$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === 'value';
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $9ff5424ed9b4a5e9$var$DataEvent('value', this, new $9ff5424ed9b4a5e9$export$80b98bcbc246c942(change.snapshotNode, new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $9ff5424ed9b4a5e9$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $9ff5424ed9b4a5e9$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $9ff5424ed9b4a5e9$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $9ff5424ed9b4a5e9$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $4e6a98b76c0d0a37$export$a7a9523472993e97)(change.childName != null, 'Child events should have a childName.');
        const childRef = $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d(new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $9ff5424ed9b4a5e9$var$DataEvent(change.type, this, new $9ff5424ed9b4a5e9$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $9ff5424ed9b4a5e9$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $9ff5424ed9b4a5e9$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === 'object') {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === 'function') cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $9ff5424ed9b4a5e9$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $9ff5424ed9b4a5e9$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === 'value' ? new $9ff5424ed9b4a5e9$var$ValueEventRegistration(callbackContext) : new $9ff5424ed9b4a5e9$var$ChildEventRegistration(eventType, callbackContext);
    $9ff5424ed9b4a5e9$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$9ff5424ed9b4a5e9$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $9ff5424ed9b4a5e9$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $9ff5424ed9b4a5e9$var$addEventListener(query, 'value', callback, cancelCallbackOrListenOptions, options);
}
function $9ff5424ed9b4a5e9$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $9ff5424ed9b4a5e9$var$addEventListener(query, 'child_added', callback, cancelCallbackOrListenOptions, options);
}
function $9ff5424ed9b4a5e9$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $9ff5424ed9b4a5e9$var$addEventListener(query, 'child_changed', callback, cancelCallbackOrListenOptions, options);
}
function $9ff5424ed9b4a5e9$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $9ff5424ed9b4a5e9$var$addEventListener(query, 'child_moved', callback, cancelCallbackOrListenOptions, options);
}
function $9ff5424ed9b4a5e9$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $9ff5424ed9b4a5e9$var$addEventListener(query, 'child_removed', callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $9ff5424ed9b4a5e9$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $9ff5424ed9b4a5e9$var$CallbackContext(callback) : null;
    if (eventType === 'value') container = new $9ff5424ed9b4a5e9$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $9ff5424ed9b4a5e9$var$ChildEventRegistration(eventType, expCallback);
    $9ff5424ed9b4a5e9$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
}
class $9ff5424ed9b4a5e9$var$QueryEndAtConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endAt';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('endAt', this._value, query._path, true);
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $9ff5424ed9b4a5e9$var$validateLimit(newParams);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $9ff5424ed9b4a5e9$export$28ec54a8428bdb3f(value, key) {
    $9ff5424ed9b4a5e9$var$validateKey('endAt', 'key', key, true);
    return new $9ff5424ed9b4a5e9$var$QueryEndAtConstraint(value, key);
}
class $9ff5424ed9b4a5e9$var$QueryEndBeforeConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endBefore';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('endBefore', this._value, query._path, false);
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $9ff5424ed9b4a5e9$var$validateLimit(newParams);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $9ff5424ed9b4a5e9$export$57203950645b8b11(value, key) {
    $9ff5424ed9b4a5e9$var$validateKey('endBefore', 'key', key, true);
    return new $9ff5424ed9b4a5e9$var$QueryEndBeforeConstraint(value, key);
}
class $9ff5424ed9b4a5e9$var$QueryStartAtConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAt';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('startAt', this._value, query._path, true);
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $9ff5424ed9b4a5e9$var$validateLimit(newParams);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $9ff5424ed9b4a5e9$export$859941c5fc8eba6b(value = null, key) {
    $9ff5424ed9b4a5e9$var$validateKey('startAt', 'key', key, true);
    return new $9ff5424ed9b4a5e9$var$QueryStartAtConstraint(value, key);
}
class $9ff5424ed9b4a5e9$var$QueryStartAfterConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAfter';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('startAfter', this._value, query._path, false);
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $9ff5424ed9b4a5e9$var$validateLimit(newParams);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $9ff5424ed9b4a5e9$export$dd8dee5f7b804673(value, key) {
    $9ff5424ed9b4a5e9$var$validateKey('startAfter', 'key', key, true);
    return new $9ff5424ed9b4a5e9$var$QueryStartAfterConstraint(value, key);
}
class $9ff5424ed9b4a5e9$var$QueryLimitToFirstConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToFirst';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, $9ff5424ed9b4a5e9$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $9ff5424ed9b4a5e9$export$9d02e839f813b99d(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToFirst: First argument must be a positive integer.');
    return new $9ff5424ed9b4a5e9$var$QueryLimitToFirstConstraint(limit);
}
class $9ff5424ed9b4a5e9$var$QueryLimitToLastConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToLast';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, $9ff5424ed9b4a5e9$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $9ff5424ed9b4a5e9$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToLast: First argument must be a positive integer.');
    return new $9ff5424ed9b4a5e9$var$QueryLimitToLastConstraint(limit);
}
class $9ff5424ed9b4a5e9$var$QueryOrderByChildConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
        this.type = 'orderByChild';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateNoPreviousOrderByCall(query, 'orderByChild');
        const parsedPath = new $9ff5424ed9b4a5e9$var$Path(this._path);
        if ($9ff5424ed9b4a5e9$var$pathIsEmpty(parsedPath)) throw new Error('orderByChild: cannot pass in empty path. Use orderByValue() instead.');
        const index = new $9ff5424ed9b4a5e9$var$PathIndex(parsedPath);
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsOrderBy(query._queryParams, index);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $9ff5424ed9b4a5e9$export$5162bd9025f8e144(path) {
    if (path === '$key') throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === '$priority') throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === '$value') throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $9ff5424ed9b4a5e9$export$8637b026ace8abb1('orderByChild', 'path', path, false);
    return new $9ff5424ed9b4a5e9$var$QueryOrderByChildConstraint(path);
}
class $9ff5424ed9b4a5e9$var$QueryOrderByKeyConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByKey';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateNoPreviousOrderByCall(query, 'orderByKey');
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsOrderBy(query._queryParams, $9ff5424ed9b4a5e9$var$KEY_INDEX);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $9ff5424ed9b4a5e9$export$d5ab8b3bbd8afbf8() {
    return new $9ff5424ed9b4a5e9$var$QueryOrderByKeyConstraint();
}
class $9ff5424ed9b4a5e9$var$QueryOrderByPriorityConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByPriority';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateNoPreviousOrderByCall(query, 'orderByPriority');
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsOrderBy(query._queryParams, $9ff5424ed9b4a5e9$var$PRIORITY_INDEX);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $9ff5424ed9b4a5e9$export$19e8ae5500cf2e55() {
    return new $9ff5424ed9b4a5e9$var$QueryOrderByPriorityConstraint();
}
class $9ff5424ed9b4a5e9$var$QueryOrderByValueConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByValue';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateNoPreviousOrderByCall(query, 'orderByValue');
        const newParams = $9ff5424ed9b4a5e9$var$queryParamsOrderBy(query._queryParams, $9ff5424ed9b4a5e9$var$VALUE_INDEX);
        $9ff5424ed9b4a5e9$var$validateQueryEndpoints(newParams);
        return new $9ff5424ed9b4a5e9$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $9ff5424ed9b4a5e9$export$7f2f62793c39d0c0() {
    return new $9ff5424ed9b4a5e9$var$QueryOrderByValueConstraint();
}
class $9ff5424ed9b4a5e9$var$QueryEqualToValueConstraint extends $9ff5424ed9b4a5e9$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'equalTo';
    }
    _apply(query) {
        $9ff5424ed9b4a5e9$var$validateFirebaseDataArg('equalTo', this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $9ff5424ed9b4a5e9$var$QueryEndAtConstraint(this._value, this._key)._apply(new $9ff5424ed9b4a5e9$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $9ff5424ed9b4a5e9$export$bdcdec1f91f16dff(value, key) {
    $9ff5424ed9b4a5e9$var$validateKey('equalTo', 'key', key, true);
    return new $9ff5424ed9b4a5e9$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $9ff5424ed9b4a5e9$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $9ff5424ed9b4a5e9$var$syncPointSetReferenceConstructor($9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c);
$9ff5424ed9b4a5e9$var$syncTreeSetReferenceConstructor($9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $9ff5424ed9b4a5e9$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
/**
 * Creates and caches `Repo` instances.
 */ const $9ff5424ed9b4a5e9$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $9ff5424ed9b4a5e9$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $9ff5424ed9b4a5e9$var$repoManagerApplyEmulatorSettings(repo, hostAndPort, emulatorOptions, tokenProvider) {
    const portIndex = hostAndPort.lastIndexOf(':');
    const host = hostAndPort.substring(0, portIndex);
    const useSsl = (0, $4e6a98b76c0d0a37$export$5b4d24b45140ad90)(host);
    repo.repoInfo_ = new $9ff5424ed9b4a5e9$var$RepoInfo(hostAndPort, /* secure= */ useSsl, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true, emulatorOptions);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $9ff5424ed9b4a5e9$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $9ff5424ed9b4a5e9$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $9ff5424ed9b4a5e9$var$log('Using default host for project ', app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $9ff5424ed9b4a5e9$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $9ff5424ed9b4a5e9$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $9ff5424ed9b4a5e9$var$EmulatorTokenProvider($9ff5424ed9b4a5e9$var$EmulatorTokenProvider.OWNER) : new $9ff5424ed9b4a5e9$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $9ff5424ed9b4a5e9$var$validateUrl('Invalid Firebase Database URL', parsedUrl);
    if (!$9ff5424ed9b4a5e9$var$pathIsEmpty(parsedUrl.path)) $9ff5424ed9b4a5e9$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $9ff5424ed9b4a5e9$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $9ff5424ed9b4a5e9$var$AppCheckTokenProvider(app, appCheckProvider));
    return new $9ff5424ed9b4a5e9$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $9ff5424ed9b4a5e9$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $9ff5424ed9b4a5e9$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $9ff5424ed9b4a5e9$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $9ff5424ed9b4a5e9$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $9ff5424ed9b4a5e9$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $9ff5424ed9b4a5e9$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $9ff5424ed9b4a5e9$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $9ff5424ed9b4a5e9$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
    repo = new $9ff5424ed9b4a5e9$var$Repo(repoInfo, $9ff5424ed9b4a5e9$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $9ff5424ed9b4a5e9$var$repoManagerForceRestClient(forceRestClient) {
    $9ff5424ed9b4a5e9$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $9ff5424ed9b4a5e9$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this['type'] = 'database';
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $9ff5424ed9b4a5e9$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options['databaseAuthVariableOverride']);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(this._repo, $9ff5424ed9b4a5e9$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $9ff5424ed9b4a5e9$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $9ff5424ed9b4a5e9$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    }
}
function $9ff5424ed9b4a5e9$var$checkTransportInit() {
    if ($9ff5424ed9b4a5e9$var$TransportManager.IS_TRANSPORT_INITIALIZED) $9ff5424ed9b4a5e9$var$warn('Transport has already been initialized. Please call this function before calling ref or setting up a listener');
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $9ff5424ed9b4a5e9$export$752b38c15a5377b6() {
    $9ff5424ed9b4a5e9$var$checkTransportInit();
    $9ff5424ed9b4a5e9$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $9ff5424ed9b4a5e9$export$387cff57f2608869() {
    $9ff5424ed9b4a5e9$var$checkTransportInit();
    $9ff5424ed9b4a5e9$var$WebSocketConnection.forceDisallow();
    $9ff5424ed9b4a5e9$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated with the provided
 * {@link @firebase/app#FirebaseApp}. Initializes a new instance with default settings if
 * no instance exists or if the existing instance uses a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $9ff5424ed9b4a5e9$export$d0dd861204d0bf72(app = (0, $7c898bf562ba0419$export$f9962582c9e66d99)(), url) {
    const db = (0, $7c898bf562ba0419$export$fa0d6da0f5838f50)(app, 'database').getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $4e6a98b76c0d0a37$export$a3febcf1f14a3a0c)('database');
        if (emulator) $9ff5424ed9b4a5e9$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $9ff5424ed9b4a5e9$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('useEmulator');
    const hostAndPort = `${host}:${port}`;
    const repo = db._repoInternal;
    if (db._instanceStarted) {
        // If the instance has already been started, then silenty fail if this function is called again
        // with the same parameters. If the parameters differ then assert.
        if (hostAndPort === db._repoInternal.repoInfo_.host && (0, $4e6a98b76c0d0a37$export$9cb4719e2e525b7a)(options, repo.repoInfo_.emulatorOptions)) return;
        $9ff5424ed9b4a5e9$var$fatal('connectDatabaseEmulator() cannot initialize or alter the emulator configuration after the database instance has started.');
    }
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $9ff5424ed9b4a5e9$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $9ff5424ed9b4a5e9$var$EmulatorTokenProvider($9ff5424ed9b4a5e9$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === 'string' ? options.mockUserToken : (0, $4e6a98b76c0d0a37$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $9ff5424ed9b4a5e9$var$EmulatorTokenProvider(token);
    }
    // Workaround to get cookies in Firebase Studio
    if ((0, $4e6a98b76c0d0a37$export$5b4d24b45140ad90)(host)) {
        (0, $4e6a98b76c0d0a37$export$c0f0d0ce4283a937)(host);
        (0, $4e6a98b76c0d0a37$export$fd3d2954543183b1)('Database', true);
    }
    // Modify the repo to apply emulator settings
    $9ff5424ed9b4a5e9$var$repoManagerApplyEmulatorSettings(repo, hostAndPort, options, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $9ff5424ed9b4a5e9$export$bee838355d017f0a(db) {
    db = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOffline');
    $9ff5424ed9b4a5e9$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $9ff5424ed9b4a5e9$export$e0eecaabee32dd(db) {
    db = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOnline');
    $9ff5424ed9b4a5e9$var$repoResume(db._repo);
}
function $9ff5424ed9b4a5e9$export$4e1d237eb9e560af(logger, persistent) {
    $9ff5424ed9b4a5e9$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9ff5424ed9b4a5e9$var$registerDatabase(variant) {
    $9ff5424ed9b4a5e9$export$c9fb972242fcb3c4((0, $7c898bf562ba0419$export$31499a9cd224b78c));
    (0, $7c898bf562ba0419$export$c930050e7bb63965)(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('database', (container, { instanceIdentifier: url })=>{
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider('auth-internal');
        const appCheckProvider = container.getProvider('app-check-internal');
        return $9ff5424ed9b4a5e9$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $7c898bf562ba0419$export$d29d5299a7137abc)($9ff5424ed9b4a5e9$var$name, $9ff5424ed9b4a5e9$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $7c898bf562ba0419$export$d29d5299a7137abc)($9ff5424ed9b4a5e9$var$name, $9ff5424ed9b4a5e9$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9ff5424ed9b4a5e9$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $9ff5424ed9b4a5e9$export$3ff8e7e00c3264b7() {
    return $9ff5424ed9b4a5e9$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $9ff5424ed9b4a5e9$export$a2647aa13413c947(delta) {
    return {
        '.sv': {
            'increment': delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $9ff5424ed9b4a5e9$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $9ff5424ed9b4a5e9$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(ref);
    $9ff5424ed9b4a5e9$export$8d83036122ae444e('Reference.transaction', ref._path);
    if (ref.key === '.length' || ref.key === '.keys') throw 'Reference.transaction failed: ' + ref.key + ' is a read-only object.';
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $9ff5424ed9b4a5e9$export$80b98bcbc246c942(node, new $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c(ref._repo, ref._path), $9ff5424ed9b4a5e9$var$PRIORITY_INDEX);
            deferred.resolve(new $9ff5424ed9b4a5e9$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $9ff5424ed9b4a5e9$export$ad30f661f41f4d90(ref, ()=>{});
    $9ff5424ed9b4a5e9$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $9ff5424ed9b4a5e9$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$9ff5424ed9b4a5e9$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$9ff5424ed9b4a5e9$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$9ff5424ed9b4a5e9$var$Connection;
/**
 * @internal
 */ const $9ff5424ed9b4a5e9$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $9ff5424ed9b4a5e9$var$PersistentConnection.prototype.put;
    $9ff5424ed9b4a5e9$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $9ff5424ed9b4a5e9$var$PersistentConnection.prototype.put = oldPut;
    };
};
$9ff5424ed9b4a5e9$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $9ff5424ed9b4a5e9$export$868c9f20a76f0839 = function(forceRestClient) {
    $9ff5424ed9b4a5e9$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 * @internal
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAppCheckImpl - custom app check implementation
 * @param customAuthImpl - custom auth implementation
 */ function $9ff5424ed9b4a5e9$export$8efb8ed30f837963({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, nodeAdmin: nodeAdmin = false }) {
    $9ff5424ed9b4a5e9$export$c9fb972242fcb3c4(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const componentContainer = new (0, $3ba5282a700177ce$export$436a80eea5d5c0c5)('database-standalone');
    const authProvider = new (0, $3ba5282a700177ce$export$2881499e37b75b9a)('auth-internal', componentContainer);
    let appCheckProvider;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $3ba5282a700177ce$export$2881499e37b75b9a)('app-check-internal', componentContainer);
        appCheckProvider.setComponent(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    authProvider.setComponent(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    return $9ff5424ed9b4a5e9$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin);
}
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $9ff5424ed9b4a5e9$var$registerDatabase();




const $cba605d8a10a72d4$var$name = "@firebase/database-compat";
const $cba605d8a10a72d4$var$version = "2.0.11";
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $cba605d8a10a72d4$var$logClient = new (0, $ff3e0e0e6ac6e856$export$efa9a398d6368992)('@firebase/database-compat');
const $cba605d8a10a72d4$var$warn = function(msg) {
    const message = 'FIREBASE WARNING: ' + msg;
    $cba605d8a10a72d4$var$logClient.warn(message);
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $cba605d8a10a72d4$var$validateBoolean = function(fnName, argumentName, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== 'boolean') throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, argumentName) + 'must be a boolean.');
};
const $cba605d8a10a72d4$var$validateEventType = function(fnName, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch(eventType){
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $cba605d8a10a72d4$var$OnDisconnect {
    constructor(_delegate){
        this._delegate = _delegate;
    }
    cancel(onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('OnDisconnect.cancel', 0, 1, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('OnDisconnect.cancel', 'onComplete', onComplete, true);
        const result = this._delegate.cancel();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('OnDisconnect.remove', 0, 1, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('OnDisconnect.remove', 'onComplete', onComplete, true);
        const result = this._delegate.remove();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    set(value, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('OnDisconnect.set', 1, 2, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('OnDisconnect.set', 'onComplete', onComplete, true);
        const result = this._delegate.set(value);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(value, priority, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('OnDisconnect.setWithPriority', 'onComplete', onComplete, true);
        const result = this._delegate.setWithPriority(value, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(objectToMerge, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('OnDisconnect.update', 1, 2, arguments.length);
        if (Array.isArray(objectToMerge)) {
            const newObjectToMerge = {};
            for(let i = 0; i < objectToMerge.length; ++i)newObjectToMerge['' + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $cba605d8a10a72d4$var$warn("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('OnDisconnect.update', 'onComplete', onComplete, true);
        const result = this._delegate.update(objectToMerge);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $cba605d8a10a72d4$var$TransactionResult {
    /**
     * A type for the resolve value of Firebase.transaction.
     */ constructor(committed, snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('TransactionResult.toJSON', 0, 1, arguments.length);
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */ class $cba605d8a10a72d4$var$DataSnapshot {
    constructor(_database, _delegate){
        this._database = _database;
        this._delegate = _delegate;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ val() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.val', 0, 0, arguments.length);
        return this._delegate.val();
    }
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ exportVal() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this._delegate.exportVal();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @returns Whether the snapshot contains a non-null value, or is empty.
     */ exists() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.exists', 0, 0, arguments.length);
        return this._delegate.exists();
    }
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param path - Path to a child.
     * @returns DataSnapshot for child node.
     */ child(path) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        path = String(path);
        (0, $9ff5424ed9b4a5e9$export$8637b026ace8abb1)('DataSnapshot.child', 'path', path, false);
        return new $cba605d8a10a72d4$var$DataSnapshot(this._database, this._delegate.child(path));
    }
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param path - Path to a child.
     * @returns Whether the child exists.
     */ hasChild(path) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.hasChild', 1, 1, arguments.length);
        (0, $9ff5424ed9b4a5e9$export$8637b026ace8abb1)('DataSnapshot.hasChild', 'path', path, false);
        return this._delegate.hasChild(path);
    }
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @returns The priority.
     */ getPriority() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.getPriority', 0, 0, arguments.length);
        return this._delegate.priority;
    }
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param action - Callback function to be called
     * for each child.
     * @returns True if forEach was canceled by action returning true for
     * one of the child nodes.
     */ forEach(action) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.forEach', 1, 1, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('DataSnapshot.forEach', 'action', action, false);
        return this._delegate.forEach((expDataSnapshot)=>action(new $cba605d8a10a72d4$var$DataSnapshot(this._database, expDataSnapshot)));
    }
    /**
     * Returns whether this DataSnapshot has children.
     * @returns True if the DataSnapshot contains 1 or more child nodes.
     */ hasChildren() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.hasChildren', 0, 0, arguments.length);
        return this._delegate.hasChildren();
    }
    get key() {
        return this._delegate.key;
    }
    /**
     * Returns the number of children for this DataSnapshot.
     * @returns The number of children that this DataSnapshot contains.
     */ numChildren() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this._delegate.size;
    }
    /**
     * @returns The Firebase reference for the location this snapshot's data came
     * from.
     */ getRef() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('DataSnapshot.ref', 0, 0, arguments.length);
        return new $cba605d8a10a72d4$var$Reference(this._database, this._delegate.ref);
    }
    get ref() {
        return this.getRef();
    }
}
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */ class $cba605d8a10a72d4$var$Query {
    constructor(database, _delegate){
        this.database = database;
        this._delegate = _delegate;
    }
    on(eventType, callback, cancelCallbackOrContext, context) {
        var _a;
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.on', 2, 4, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Query.on', 'callback', callback, false);
        const ret = $cba605d8a10a72d4$var$Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        const valueCallback = (expSnapshot, previousChildName)=>{
            callback.call(ret.context, new $cba605d8a10a72d4$var$DataSnapshot(this.database, expSnapshot), previousChildName);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = (_a = ret.cancel) === null || _a === void 0 ? void 0 : _a.bind(ret.context);
        switch(eventType){
            case 'value':
                (0, $9ff5424ed9b4a5e9$export$ad30f661f41f4d90)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_added':
                (0, $9ff5424ed9b4a5e9$export$fdc3e67b2775c753)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_removed':
                (0, $9ff5424ed9b4a5e9$export$8362b530316d1aba)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_changed':
                (0, $9ff5424ed9b4a5e9$export$a3fdf31223dcb03)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_moved':
                (0, $9ff5424ed9b4a5e9$export$1b001b15904d2a7f)(this._delegate, valueCallback, cancelCallback);
                return callback;
            default:
                throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)('Query.on', 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
    }
    off(eventType, callback, context) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.off', 0, 3, arguments.length);
        $cba605d8a10a72d4$var$validateEventType('Query.off', eventType, true);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Query.off', 'callback', callback, true);
        (0, $4e6a98b76c0d0a37$export$df77539402cfb523)('Query.off', 'context', context, true);
        if (callback) {
            const valueCallback = ()=>{};
            valueCallback.userCallback = callback;
            valueCallback.context = context;
            (0, $9ff5424ed9b4a5e9$export$8c8705df4a2dcec9)(this._delegate, eventType, valueCallback);
        } else (0, $9ff5424ed9b4a5e9$export$8c8705df4a2dcec9)(this._delegate, eventType);
    }
    /**
     * Get the server-value for this query, or return a cached value if not connected.
     */ get() {
        return (0, $9ff5424ed9b4a5e9$export$3988ae62b71be9a3)(this._delegate).then((expSnapshot)=>{
            return new $cba605d8a10a72d4$var$DataSnapshot(this.database, expSnapshot);
        });
    }
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     */ once(eventType, callback, failureCallbackOrContext, context) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.once', 1, 4, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Query.once', 'callback', callback, true);
        const ret = $cba605d8a10a72d4$var$Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        const deferred = new (0, $4e6a98b76c0d0a37$export$85f6557964517f1a)();
        const valueCallback = (expSnapshot, previousChildName)=>{
            const result = new $cba605d8a10a72d4$var$DataSnapshot(this.database, expSnapshot);
            if (callback) callback.call(ret.context, result, previousChildName);
            deferred.resolve(result);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = (error)=>{
            if (ret.cancel) ret.cancel.call(ret.context, error);
            deferred.reject(error);
        };
        switch(eventType){
            case 'value':
                (0, $9ff5424ed9b4a5e9$export$ad30f661f41f4d90)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_added':
                (0, $9ff5424ed9b4a5e9$export$fdc3e67b2775c753)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_removed':
                (0, $9ff5424ed9b4a5e9$export$8362b530316d1aba)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_changed':
                (0, $9ff5424ed9b4a5e9$export$a3fdf31223dcb03)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_moved':
                (0, $9ff5424ed9b4a5e9$export$1b001b15904d2a7f)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            default:
                throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)('Query.once', 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
        return deferred.promise;
    }
    /**
     * Set a limit and anchor it to the start of the window.
     */ limitToFirst(limit) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.limitToFirst', 1, 1, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$9d02e839f813b99d)(limit)));
    }
    /**
     * Set a limit and anchor it to the end of the window.
     */ limitToLast(limit) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.limitToLast', 1, 1, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$f823b3589f69d3b8)(limit)));
    }
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     */ orderByChild(path) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.orderByChild', 1, 1, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$5162bd9025f8e144)(path)));
    }
    /**
     * Return a new query ordered by the KeyIndex
     */ orderByKey() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.orderByKey', 0, 0, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$d5ab8b3bbd8afbf8)()));
    }
    /**
     * Return a new query ordered by the PriorityIndex
     */ orderByPriority() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.orderByPriority', 0, 0, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$19e8ae5500cf2e55)()));
    }
    /**
     * Return a new query ordered by the ValueIndex
     */ orderByValue() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.orderByValue', 0, 0, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$7f2f62793c39d0c0)()));
    }
    startAt(value = null, name) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.startAt', 0, 2, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$859941c5fc8eba6b)(value, name)));
    }
    startAfter(value = null, name) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.startAfter', 0, 2, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$dd8dee5f7b804673)(value, name)));
    }
    endAt(value = null, name) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.endAt', 0, 2, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$28ec54a8428bdb3f)(value, name)));
    }
    endBefore(value = null, name) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.endBefore', 0, 2, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$57203950645b8b11)(value, name)));
    }
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     */ equalTo(value, name) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.equalTo', 1, 2, arguments.length);
        return new $cba605d8a10a72d4$var$Query(this.database, (0, $9ff5424ed9b4a5e9$export$2fa187e846a241c4)(this._delegate, (0, $9ff5424ed9b4a5e9$export$bdcdec1f91f16dff)(value, name)));
    }
    /**
     * @returns URL for this location.
     */ toString() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.toString', 0, 0, arguments.length);
        return this._delegate.toString();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    toJSON() {
        // An optional spacer argument is unnecessary for a string.
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.toJSON', 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     */ isEqual(other) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof $cba605d8a10a72d4$var$Query)) {
            const error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        return this._delegate.isEqual(other._delegate);
    }
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param fnName - The function name (on or once)
     *
     */ static getCancelAndContextArgs_(fnName, cancelOrContext, context) {
        const ret = {
            cancel: undefined,
            context: undefined
        };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)(fnName, 'cancel', ret.cancel, true);
            ret.context = context;
            (0, $4e6a98b76c0d0a37$export$df77539402cfb523)(fnName, 'context', ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) // it's a context!
            ret.context = cancelOrContext;
            else if (typeof cancelOrContext === 'function') ret.cancel = cancelOrContext;
            else throw new Error((0, $4e6a98b76c0d0a37$export$adea4917e02d93dc)(fnName, 'cancelOrContext') + ' must either be a cancel callback or a context object.');
        }
        return ret;
    }
    get ref() {
        return new $cba605d8a10a72d4$var$Reference(this.database, new (0, $9ff5424ed9b4a5e9$export$35c3a5e7c9d1033c)(this._delegate._repo, this._delegate._path));
    }
}
class $cba605d8a10a72d4$var$Reference extends $cba605d8a10a72d4$var$Query {
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     */ constructor(database, _delegate){
        super(database, new (0, $9ff5424ed9b4a5e9$export$e79c8d837d2220a8)(_delegate._repo, _delegate._path, new (0, $9ff5424ed9b4a5e9$export$7ba287e361c94330)(), false));
        this.database = database;
        this._delegate = _delegate;
    }
    /** @returns {?string} */ getKey() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.key', 0, 0, arguments.length);
        return this._delegate.key;
    }
    child(pathString) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') pathString = String(pathString);
        return new $cba605d8a10a72d4$var$Reference(this.database, (0, $9ff5424ed9b4a5e9$export$f9574b70e1d95d9d)(this._delegate, pathString));
    }
    /** @returns {?Reference} */ getParent() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.parent', 0, 0, arguments.length);
        const parent = this._delegate.parent;
        return parent ? new $cba605d8a10a72d4$var$Reference(this.database, parent) : null;
    }
    /** @returns {!Reference} */ getRoot() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.root', 0, 0, arguments.length);
        return new $cba605d8a10a72d4$var$Reference(this.database, this._delegate.root);
    }
    set(newVal, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.set', 1, 2, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.set', 'onComplete', onComplete, true);
        const result = (0, $9ff5424ed9b4a5e9$export$adaa4cf7ef1b65be)(this._delegate, newVal);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(values, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.update', 1, 2, arguments.length);
        if (Array.isArray(values)) {
            const newObjectToMerge = {};
            for(let i = 0; i < values.length; ++i)newObjectToMerge['' + i] = values[i];
            values = newObjectToMerge;
            $cba605d8a10a72d4$var$warn("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $9ff5424ed9b4a5e9$export$8d83036122ae444e)('Reference.update', this._delegate._path);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.update', 'onComplete', onComplete, true);
        const result = (0, $9ff5424ed9b4a5e9$export$722fbec263ad908a)(this._delegate, values);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(newVal, newPriority, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.setWithPriority', 2, 3, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.setWithPriority', 'onComplete', onComplete, true);
        const result = (0, $9ff5424ed9b4a5e9$export$1fa5d5bf488088f3)(this._delegate, newVal, newPriority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.remove', 0, 1, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.remove', 'onComplete', onComplete, true);
        const result = (0, $9ff5424ed9b4a5e9$export$cd7f480d6b8286c3)(this._delegate);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    transaction(transactionUpdate, onComplete, applyLocally) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.transaction', 1, 3, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.transaction', 'transactionUpdate', transactionUpdate, false);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.transaction', 'onComplete', onComplete, true);
        $cba605d8a10a72d4$var$validateBoolean('Reference.transaction', 'applyLocally', applyLocally, true);
        const result = (0, $9ff5424ed9b4a5e9$export$3c54e006bf9c93b7)(this._delegate, transactionUpdate, {
            applyLocally: applyLocally
        }).then((transactionResult)=>new $cba605d8a10a72d4$var$TransactionResult(transactionResult.committed, new $cba605d8a10a72d4$var$DataSnapshot(this.database, transactionResult.snapshot)));
        if (onComplete) result.then((transactionResult)=>onComplete(null, transactionResult.committed, transactionResult.snapshot), (error)=>onComplete(error, false, null));
        return result;
    }
    setPriority(priority, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.setPriority', 1, 2, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.setPriority', 'onComplete', onComplete, true);
        const result = (0, $9ff5424ed9b4a5e9$export$313bf5dbe7a1196e)(this._delegate, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    push(value, onComplete) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('Reference.push', 0, 2, arguments.length);
        (0, $4e6a98b76c0d0a37$export$5bcd2a2eb6640dfa)('Reference.push', 'onComplete', onComplete, true);
        const expPromise = (0, $9ff5424ed9b4a5e9$export$4cbf152802aa238)(this._delegate, value);
        const promise = expPromise.then((expRef)=>new $cba605d8a10a72d4$var$Reference(this.database, expRef));
        if (onComplete) promise.then(()=>onComplete(null), (error)=>onComplete(error));
        const result = new $cba605d8a10a72d4$var$Reference(this.database, expPromise);
        result.then = promise.then.bind(promise);
        result.catch = promise.catch.bind(promise, undefined);
        return result;
    }
    onDisconnect() {
        (0, $9ff5424ed9b4a5e9$export$8d83036122ae444e)('Reference.onDisconnect', this._delegate._path);
        return new $cba605d8a10a72d4$var$OnDisconnect(new (0, $9ff5424ed9b4a5e9$export$95b7818b4ee6c2af)(this._delegate._repo, this._delegate._path));
    }
    get key() {
        return this.getKey();
    }
    get parent() {
        return this.getParent();
    }
    get root() {
        return this.getRoot();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase database.
 */ class $cba605d8a10a72d4$var$Database {
    /**
     * The constructor should not be called by users of our public API.
     */ constructor(_delegate, app){
        this._delegate = _delegate;
        this.app = app;
        this.INTERNAL = {
            delete: ()=>this._delegate._delete(),
            forceWebSockets: $9ff5424ed9b4a5e9$export$752b38c15a5377b6,
            forceLongPolling: $9ff5424ed9b4a5e9$export$387cff57f2608869
        };
    }
    /**
     * Modify this instance to communicate with the Realtime Database emulator.
     *
     * <p>Note: This method must be called before performing any other operation.
     *
     * @param host - the emulator host (ex: localhost)
     * @param port - the emulator port (ex: 8080)
     * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
     */ useEmulator(host, port, options = {}) {
        (0, $9ff5424ed9b4a5e9$export$87f3cfc4a2e3958d)(this._delegate, host, port, options);
    }
    ref(path) {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('database.ref', 0, 1, arguments.length);
        if (path instanceof $cba605d8a10a72d4$var$Reference) {
            const childRef = (0, $9ff5424ed9b4a5e9$export$291fc3c05735451)(this._delegate, path.toString());
            return new $cba605d8a10a72d4$var$Reference(this, childRef);
        } else {
            const childRef = (0, $9ff5424ed9b4a5e9$export$eff4d24c3ff7876e)(this._delegate, path);
            return new $cba605d8a10a72d4$var$Reference(this, childRef);
        }
    }
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @returns Firebase reference.
     */ refFromURL(url) {
        const apiName = 'database.refFromURL';
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)(apiName, 1, 1, arguments.length);
        const childRef = (0, $9ff5424ed9b4a5e9$export$291fc3c05735451)(this._delegate, url);
        return new $cba605d8a10a72d4$var$Reference(this, childRef);
    }
    // Make individual repo go offline.
    goOffline() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('database.goOffline', 0, 0, arguments.length);
        return (0, $9ff5424ed9b4a5e9$export$bee838355d017f0a)(this._delegate);
    }
    goOnline() {
        (0, $4e6a98b76c0d0a37$export$20164226a0ed35c3)('database.goOnline', 0, 0, arguments.length);
        return (0, $9ff5424ed9b4a5e9$export$e0eecaabee32dd)(this._delegate);
    }
}
$cba605d8a10a72d4$var$Database.ServerValue = {
    TIMESTAMP: (0, $9ff5424ed9b4a5e9$export$3ff8e7e00c3264b7)(),
    increment: (delta)=>(0, $9ff5424ed9b4a5e9$export$a2647aa13413c947)(delta)
};
/**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 *
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAuthImpl - custom auth implementation
 */ function $cba605d8a10a72d4$var$initStandalone({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, namespace: namespace, nodeAdmin: nodeAdmin = false }) {
    (0, $9ff5424ed9b4a5e9$export$c9fb972242fcb3c4)(version);
    const container = new (0, $3ba5282a700177ce$export$436a80eea5d5c0c5)('database-standalone');
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const authProvider = new (0, $3ba5282a700177ce$export$2881499e37b75b9a)('auth-internal', container);
    authProvider.setComponent(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    let appCheckProvider = undefined;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $3ba5282a700177ce$export$2881499e37b75b9a)('app-check-internal', container);
        appCheckProvider.setComponent(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    return {
        instance: new $cba605d8a10a72d4$var$Database((0, $9ff5424ed9b4a5e9$export$a248c1d2ea757674)(app, authProvider, appCheckProvider, url, nodeAdmin), app),
        namespace: namespace
    };
}
var $cba605d8a10a72d4$var$INTERNAL = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    initStandalone: $cba605d8a10a72d4$var$initStandalone
});
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $cba605d8a10a72d4$var$ServerValue = $cba605d8a10a72d4$var$Database.ServerValue;
function $cba605d8a10a72d4$export$44894f2caba7dc4c(instance) {
    // Register the Database Service with the 'firebase' namespace.
    instance.INTERNAL.registerComponent(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)('database-compat', (container, { instanceIdentifier: url })=>{
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app-compat').getImmediate();
        const databaseExp = container.getProvider('database').getImmediate({
            identifier: url
        });
        return new $cba605d8a10a72d4$var$Database(databaseExp, app);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setServiceProps(// firebase.database namespace properties
    {
        Reference: $cba605d8a10a72d4$var$Reference,
        Query: $cba605d8a10a72d4$var$Query,
        Database: $cba605d8a10a72d4$var$Database,
        DataSnapshot: $cba605d8a10a72d4$var$DataSnapshot,
        enableLogging: $9ff5424ed9b4a5e9$export$4e1d237eb9e560af,
        INTERNAL: $cba605d8a10a72d4$var$INTERNAL,
        ServerValue: $cba605d8a10a72d4$var$ServerValue
    }).setMultipleInstances(true));
    instance.registerVersion($cba605d8a10a72d4$var$name, $cba605d8a10a72d4$var$version);
}
$cba605d8a10a72d4$export$44894f2caba7dc4c((0, $fa83d0b019b2237e$export$2e2bcd8739ae039));








/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $8c61e6dd391f935a$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $8c61e6dd391f935a$export$9e5f44173e64f162 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $8c61e6dd391f935a$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $8c61e6dd391f935a$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $8c61e6dd391f935a$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $8c61e6dd391f935a$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8c61e6dd391f935a$export$7f8ddf7c7c20b3cd = $8c61e6dd391f935a$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8c61e6dd391f935a$export$9bb611d729802a56 = $8c61e6dd391f935a$var$_prodErrorMap;
const $8c61e6dd391f935a$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $8c61e6dd391f935a$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $8c61e6dd391f935a$export$b4171a6734a65d42 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$logClient = new (0, $ff3e0e0e6ac6e856$export$efa9a398d6368992)('@firebase/auth');
function $8c61e6dd391f935a$var$_logWarn(msg, ...args) {
    if ($8c61e6dd391f935a$var$logClient.logLevel <= (0, $ff3e0e0e6ac6e856$export$243e62d78d3b544d).WARN) $8c61e6dd391f935a$var$logClient.warn(`Auth (${(0, $7c898bf562ba0419$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $8c61e6dd391f935a$var$_logError(msg, ...args) {
    if ($8c61e6dd391f935a$var$logClient.logLevel <= (0, $ff3e0e0e6ac6e856$export$243e62d78d3b544d).ERROR) $8c61e6dd391f935a$var$logClient.error(`Auth (${(0, $7c898bf562ba0419$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$export$28f7fcd39efa255(authOrCode, ...rest) {
    throw $8c61e6dd391f935a$var$createErrorInternal(authOrCode, ...rest);
}
function $8c61e6dd391f935a$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $8c61e6dd391f935a$var$createErrorInternal(authOrCode, ...rest);
}
function $8c61e6dd391f935a$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $8c61e6dd391f935a$export$9bb611d729802a56()), {
        [code]: message
    });
    const factory = new (0, $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $8c61e6dd391f935a$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $8c61e6dd391f935a$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $8c61e6dd391f935a$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $8c61e6dd391f935a$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $8c61e6dd391f935a$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $8c61e6dd391f935a$export$24baa2b76016ce0e(assertion, authOrCode, ...rest) {
    if (!assertion) throw $8c61e6dd391f935a$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $8c61e6dd391f935a$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $8c61e6dd391f935a$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $8c61e6dd391f935a$export$d66dc83d8cfc8dd(assertion, message) {
    if (!assertion) $8c61e6dd391f935a$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$_getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function $8c61e6dd391f935a$var$_isHttpOrHttps() {
    return $8c61e6dd391f935a$var$_getCurrentScheme() === 'http:' || $8c61e6dd391f935a$var$_getCurrentScheme() === 'https:';
}
function $8c61e6dd391f935a$var$_getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $8c61e6dd391f935a$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($8c61e6dd391f935a$var$_isHttpOrHttps() || (0, $4e6a98b76c0d0a37$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $8c61e6dd391f935a$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $8c61e6dd391f935a$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $8c61e6dd391f935a$export$d66dc83d8cfc8dd(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $4e6a98b76c0d0a37$export$872f8323f01d7ae0)() || (0, $4e6a98b76c0d0a37$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$8c61e6dd391f935a$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$_emulatorUrl(config, path) {
    $8c61e6dd391f935a$export$d66dc83d8cfc8dd(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$export$f96d196f7728bb5 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $8c61e6dd391f935a$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $8c61e6dd391f935a$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $8c61e6dd391f935a$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $8c61e6dd391f935a$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $8c61e6dd391f935a$var$DEFAULT_API_TIMEOUT_MS = new $8c61e6dd391f935a$var$Delay(30000, 60000);
function $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $8c61e6dd391f935a$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $8c61e6dd391f935a$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $4e6a98b76c0d0a37$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method: method,
            headers: headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $4e6a98b76c0d0a37$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'no-referrer';
        if (auth.emulatorConfig && (0, $4e6a98b76c0d0a37$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return $8c61e6dd391f935a$export$f96d196f7728bb5.fetch()(await $8c61e6dd391f935a$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $8c61e6dd391f935a$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $8c61e6dd391f935a$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $8c61e6dd391f935a$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $8c61e6dd391f935a$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $8c61e6dd391f935a$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $8c61e6dd391f935a$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $8c61e6dd391f935a$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $8c61e6dd391f935a$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $8c61e6dd391f935a$export$28f7fcd39efa255(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $8c61e6dd391f935a$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $8c61e6dd391f935a$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $8c61e6dd391f935a$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $8c61e6dd391f935a$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($8c61e6dd391f935a$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $8c61e6dd391f935a$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $8c61e6dd391f935a$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($8c61e6dd391f935a$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $8c61e6dd391f935a$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $8c61e6dd391f935a$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $8c61e6dd391f935a$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $8c61e6dd391f935a$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $8c61e6dd391f935a$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $8c61e6dd391f935a$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$getRecaptchaParams(auth) {
    return (await $8c61e6dd391f935a$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $8c61e6dd391f935a$var$getRecaptchaConfig(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$deleteAccount(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $8c61e6dd391f935a$var$deleteLinkedAccounts(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $8c61e6dd391f935a$var$getAccountInfo(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $8c61e6dd391f935a$export$7a38258bbe170828(user, forceRefresh = false) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$2f6ca3d3b1f80bf5(user, forceRefresh = false) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $8c61e6dd391f935a$var$_parseToken(token);
    $8c61e6dd391f935a$export$24baa2b76016ce0e(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $8c61e6dd391f935a$var$utcTimestampToDateString($8c61e6dd391f935a$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $8c61e6dd391f935a$var$utcTimestampToDateString($8c61e6dd391f935a$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $8c61e6dd391f935a$var$utcTimestampToDateString($8c61e6dd391f935a$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function $8c61e6dd391f935a$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $8c61e6dd391f935a$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $8c61e6dd391f935a$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $4e6a98b76c0d0a37$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $8c61e6dd391f935a$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $8c61e6dd391f935a$var$_logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $8c61e6dd391f935a$var$_tokenExpiresIn(token) {
    const parsedToken = $8c61e6dd391f935a$var$_parseToken(token);
    $8c61e6dd391f935a$export$24baa2b76016ce0e(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56) && $8c61e6dd391f935a$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $8c61e6dd391f935a$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $8c61e6dd391f935a$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $8c61e6dd391f935a$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $8c61e6dd391f935a$var$_logoutIfInvalidated(user, $8c61e6dd391f935a$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $8c61e6dd391f935a$export$24baa2b76016ce0e(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $8c61e6dd391f935a$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $8c61e6dd391f935a$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $8c61e6dd391f935a$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$6554612db691658e(user) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    await $8c61e6dd391f935a$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $8c61e6dd391f935a$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $8c61e6dd391f935a$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $8e874a2fb001c377$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$requestStsToken(auth, refreshToken) {
    const response = await $8c61e6dd391f935a$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $4e6a98b76c0d0a37$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $8c61e6dd391f935a$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $4e6a98b76c0d0a37$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) options.credentials = 'include';
        return $8c61e6dd391f935a$export$f96d196f7728bb5.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $8c61e6dd391f935a$var$revokeToken(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $8c61e6dd391f935a$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $8c61e6dd391f935a$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $8c61e6dd391f935a$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $8c61e6dd391f935a$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $8c61e6dd391f935a$var$StsTokenManager();
        if (refreshToken) {
            $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $8c61e6dd391f935a$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $8c61e6dd391f935a$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$assertStringOrUndefined(assertion, appName) {
    $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $8c61e6dd391f935a$export$91477dc880baac21 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $8e874a2fb001c377$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $8c61e6dd391f935a$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $8c61e6dd391f935a$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $8c61e6dd391f935a$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $8c61e6dd391f935a$export$24baa2b76016ce0e(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $8c61e6dd391f935a$export$2f6ca3d3b1f80bf5(this, forceRefresh);
    }
    reload() {
        return $8c61e6dd391f935a$export$6554612db691658e(this);
    }
    _assign(user) {
        if (this === user) return;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $8c61e6dd391f935a$export$91477dc880baac21(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $8c61e6dd391f935a$export$24baa2b76016ce0e(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $8c61e6dd391f935a$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $8c61e6dd391f935a$var$_logoutIfInvalidated(this, $8c61e6dd391f935a$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $8c61e6dd391f935a$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8c61e6dd391f935a$var$assertStringOrUndefined(displayName, auth.name);
        $8c61e6dd391f935a$var$assertStringOrUndefined(email, auth.name);
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $8c61e6dd391f935a$var$assertStringOrUndefined(phoneNumber, auth.name);
        $8c61e6dd391f935a$var$assertStringOrUndefined(photoURL, auth.name);
        $8c61e6dd391f935a$var$assertStringOrUndefined(tenantId, auth.name);
        $8c61e6dd391f935a$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $8c61e6dd391f935a$var$assertStringOrUndefined(createdAt, auth.name);
        $8c61e6dd391f935a$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $8c61e6dd391f935a$export$91477dc880baac21({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $8c61e6dd391f935a$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $8c61e6dd391f935a$export$91477dc880baac21({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $8c61e6dd391f935a$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $8c61e6dd391f935a$export$24baa2b76016ce0e(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $8c61e6dd391f935a$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $8c61e6dd391f935a$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $8c61e6dd391f935a$export$91477dc880baac21({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $8c61e6dd391f935a$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$instanceCache = new Map();
function $8c61e6dd391f935a$export$cf2f7c5792f80b46(cls) {
    $8c61e6dd391f935a$export$d66dc83d8cfc8dd(cls instanceof Function, 'Expected a class definition');
    let instance = $8c61e6dd391f935a$var$instanceCache.get(cls);
    if (instance) {
        $8c61e6dd391f935a$export$d66dc83d8cfc8dd(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $8c61e6dd391f935a$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$8c61e6dd391f935a$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $8c61e6dd391f935a$export$e7c866399fa523f5 = $8c61e6dd391f935a$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $8c61e6dd391f935a$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $8c61e6dd391f935a$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $8c61e6dd391f935a$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await $8c61e6dd391f935a$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $8c61e6dd391f935a$export$91477dc880baac21._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $8c61e6dd391f935a$export$91477dc880baac21._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $8c61e6dd391f935a$var$PersistenceUserManager($8c61e6dd391f935a$export$cf2f7c5792f80b46($8c61e6dd391f935a$export$e7c866399fa523f5), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $8c61e6dd391f935a$export$cf2f7c5792f80b46($8c61e6dd391f935a$export$e7c866399fa523f5);
        const key = $8c61e6dd391f935a$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await $8c61e6dd391f935a$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $8c61e6dd391f935a$export$91477dc880baac21._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $8c61e6dd391f935a$export$91477dc880baac21._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $8c61e6dd391f935a$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $8c61e6dd391f935a$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $8c61e6dd391f935a$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($8c61e6dd391f935a$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($8c61e6dd391f935a$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($8c61e6dd391f935a$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($8c61e6dd391f935a$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($8c61e6dd391f935a$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $8c61e6dd391f935a$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($8c61e6dd391f935a$export$9fa96a7d116ea3ce(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $8c61e6dd391f935a$var$_isFirefox(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $8c61e6dd391f935a$var$_isSafari(userAgent = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $8c61e6dd391f935a$var$_isChromeIOS(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $8c61e6dd391f935a$var$_isIEMobile(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $8c61e6dd391f935a$export$9fa96a7d116ea3ce(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $8c61e6dd391f935a$var$_isBlackBerry(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $8c61e6dd391f935a$var$_isWebOS(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $8c61e6dd391f935a$export$92108d983e8ee699(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $8c61e6dd391f935a$export$9d398bebfec1c039(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $8c61e6dd391f935a$var$_isIOSStandalone(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    var _a;
    return $8c61e6dd391f935a$export$92108d983e8ee699(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $8c61e6dd391f935a$var$_isIE10() {
    return (0, $4e6a98b76c0d0a37$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $8c61e6dd391f935a$var$_isMobileBrowser(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $8c61e6dd391f935a$export$92108d983e8ee699(ua) || $8c61e6dd391f935a$export$9fa96a7d116ea3ce(ua) || $8c61e6dd391f935a$var$_isWebOS(ua) || $8c61e6dd391f935a$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $8c61e6dd391f935a$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $8c61e6dd391f935a$export$faec65b429be379(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $8c61e6dd391f935a$var$_getBrowserName((0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$8c61e6dd391f935a$var$_getBrowserName((0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $7c898bf562ba0419$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $8c61e6dd391f935a$var$_getPasswordPolicy(auth, request = {}) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $8c61e6dd391f935a$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $8c61e6dd391f935a$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $8c61e6dd391f935a$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$export$9f4f30ee63539e24 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $8c61e6dd391f935a$var$Subscription(this);
        this.idTokenSubscription = new $8c61e6dd391f935a$var$Subscription(this);
        this.beforeStateQueue = new $8c61e6dd391f935a$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $8c61e6dd391f935a$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $8c61e6dd391f935a$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b, _c;
            if (this._deleted) return;
            this.persistenceManager = await $8c61e6dd391f935a$var$PersistenceUserManager.create(this, persistenceHierarchy);
            (_a = this._resolvePersistenceManagerAvailable) === null || _a === void 0 || _a.call(this);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_b = this._popupRedirectResolver) === null || _b === void 0 ? void 0 : _b._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_c = this.currentUser) === null || _c === void 0 ? void 0 : _c.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $8c61e6dd391f935a$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $8c61e6dd391f935a$export$91477dc880baac21._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $8c61e6dd391f935a$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $8c61e6dd391f935a$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(this.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $8c61e6dd391f935a$export$24baa2b76016ce0e(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $8c61e6dd391f935a$export$24baa2b76016ce0e(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(this.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(this.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($8c61e6dd391f935a$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $8c61e6dd391f935a$var$_getPasswordPolicy(this);
        const passwordPolicy = new $8c61e6dd391f935a$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $4e6a98b76c0d0a37$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $8c61e6dd391f935a$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $8c61e6dd391f935a$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $8c61e6dd391f935a$export$24baa2b76016ce0e(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $8c61e6dd391f935a$var$PersistenceUserManager.create(this, [
                $8c61e6dd391f935a$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $8c61e6dd391f935a$export$faec65b429be379(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $8c61e6dd391f935a$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $8c61e6dd391f935a$export$23ebac1979863676(auth) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $8c61e6dd391f935a$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $4e6a98b76c0d0a37$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $8c61e6dd391f935a$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $8c61e6dd391f935a$var$_setExternalJSProvider(p) {
    $8c61e6dd391f935a$var$externalJSProvider = p;
}
function $8c61e6dd391f935a$var$_loadJS(url) {
    return $8c61e6dd391f935a$var$externalJSProvider.loadJS(url);
}
function $8c61e6dd391f935a$var$_recaptchaV2ScriptUrl() {
    return $8c61e6dd391f935a$var$externalJSProvider.recaptchaV2Script;
}
function $8c61e6dd391f935a$var$_recaptchaEnterpriseScriptUrl() {
    return $8c61e6dd391f935a$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $8c61e6dd391f935a$var$_gapiScriptUrl() {
    return $8c61e6dd391f935a$var$externalJSProvider.gapiScript;
}
function $8c61e6dd391f935a$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$_SOLVE_TIME_MS = 500;
const $8c61e6dd391f935a$var$_EXPIRATION_TIME_MS = 60000;
const $8c61e6dd391f935a$var$_WIDGET_ID_START = 1000000000000;
class $8c61e6dd391f935a$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $8c61e6dd391f935a$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $8c61e6dd391f935a$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $8c61e6dd391f935a$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $8c61e6dd391f935a$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $8c61e6dd391f935a$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class $8c61e6dd391f935a$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $8c61e6dd391f935a$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $8c61e6dd391f935a$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $8c61e6dd391f935a$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $8c61e6dd391f935a$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $8c61e6dd391f935a$var$_EXPIRATION_TIME_MS);
        }, $8c61e6dd391f935a$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $8c61e6dd391f935a$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $8c61e6dd391f935a$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $8c61e6dd391f935a$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $8c61e6dd391f935a$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $8c61e6dd391f935a$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $8c61e6dd391f935a$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $8c61e6dd391f935a$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $8c61e6dd391f935a$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($8c61e6dd391f935a$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($8c61e6dd391f935a$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $8c61e6dd391f935a$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $8c61e6dd391f935a$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $8c61e6dd391f935a$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $8c61e6dd391f935a$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $8c61e6dd391f935a$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $8c61e6dd391f935a$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $8c61e6dd391f935a$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $8c61e6dd391f935a$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    var _a, _b;
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $8c61e6dd391f935a$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $8c61e6dd391f935a$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if ((_b = authInstance._getRecaptchaConfig()) === null || _b === void 0 ? void 0 : _b.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $8c61e6dd391f935a$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                var _a;
                if (((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $8c61e6dd391f935a$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $8c61e6dd391f935a$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $8c61e6dd391f935a$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    const response = await $8c61e6dd391f935a$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $8c61e6dd391f935a$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $8c61e6dd391f935a$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $8c61e6dd391f935a$export$3466f893ebf79586(app, deps) {
    const provider = (0, $7c898bf562ba0419$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $4e6a98b76c0d0a37$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $8c61e6dd391f935a$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($8c61e6dd391f935a$export$cf2f7c5792f80b46);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $8c61e6dd391f935a$export$61196ced6d74a310(auth, url, options) {
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    $8c61e6dd391f935a$export$24baa2b76016ce0e(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $8c61e6dd391f935a$var$extractProtocol(url);
    const { host: host, port: port } = $8c61e6dd391f935a$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $8c61e6dd391f935a$export$24baa2b76016ce0e(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $8c61e6dd391f935a$export$24baa2b76016ce0e((0, $4e6a98b76c0d0a37$export$9cb4719e2e525b7a)(emulator, authInternal.config.emulator) && (0, $4e6a98b76c0d0a37$export$9cb4719e2e525b7a)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $4e6a98b76c0d0a37$export$5b4d24b45140ad90)(host)) {
        (0, $4e6a98b76c0d0a37$export$c0f0d0ce4283a937)(`${protocol}//${host}${portStr}`);
        (0, $4e6a98b76c0d0a37$export$fd3d2954543183b1)('Auth', true);
    } else if (!disableWarnings) $8c61e6dd391f935a$var$emitEmulatorWarning();
}
function $8c61e6dd391f935a$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $8c61e6dd391f935a$var$extractHostAndPort(url) {
    const protocol = $8c61e6dd391f935a$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $8c61e6dd391f935a$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $8c61e6dd391f935a$var$parsePort(port)
        };
    }
}
function $8c61e6dd391f935a$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $8c61e6dd391f935a$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8c61e6dd391f935a$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $8c61e6dd391f935a$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $8c61e6dd391f935a$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $8c61e6dd391f935a$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $8c61e6dd391f935a$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$resetPassword(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
async function $8c61e6dd391f935a$var$updateEmailPassword(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $8c61e6dd391f935a$var$linkEmailPassword(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $8c61e6dd391f935a$var$applyActionCode$1(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$signInWithPassword(auth, request) {
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
async function $8c61e6dd391f935a$var$sendOobCode(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
async function $8c61e6dd391f935a$var$sendEmailVerification$1(auth, request) {
    return $8c61e6dd391f935a$var$sendOobCode(auth, request);
}
async function $8c61e6dd391f935a$var$sendPasswordResetEmail$1(auth, request) {
    return $8c61e6dd391f935a$var$sendOobCode(auth, request);
}
async function $8c61e6dd391f935a$var$sendSignInLinkToEmail$1(auth, request) {
    return $8c61e6dd391f935a$var$sendOobCode(auth, request);
}
async function $8c61e6dd391f935a$var$verifyAndChangeEmail(auth, request) {
    return $8c61e6dd391f935a$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$signInWithEmailLink$1(auth, request) {
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
async function $8c61e6dd391f935a$var$signInWithEmailLinkForLinking(auth, request) {
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $8c61e6dd391f935a$export$a07804094c3ecf2d extends $8c61e6dd391f935a$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $8c61e6dd391f935a$export$a07804094c3ecf2d(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $8c61e6dd391f935a$export$a07804094c3ecf2d(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $8c61e6dd391f935a$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $8c61e6dd391f935a$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $8c61e6dd391f935a$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $8c61e6dd391f935a$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $8c61e6dd391f935a$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $8c61e6dd391f935a$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$signInWithIdp(auth, request) {
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8c61e6dd391f935a$export$3722cfe417b6ed86 extends $8c61e6dd391f935a$export$3a1a48c8f6ef640e {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $8c61e6dd391f935a$export$3722cfe417b6ed86(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $8c61e6dd391f935a$export$28f7fcd39efa255("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $8e874a2fb001c377$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $8c61e6dd391f935a$export$3722cfe417b6ed86(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8c61e6dd391f935a$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8c61e6dd391f935a$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8c61e6dd391f935a$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $8c61e6dd391f935a$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $4e6a98b76c0d0a37$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$sendPhoneVerificationCode(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
async function $8c61e6dd391f935a$var$signInWithPhoneNumber$1(auth, request) {
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
async function $8c61e6dd391f935a$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $8c61e6dd391f935a$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $8c61e6dd391f935a$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $8c61e6dd391f935a$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, apiRequest), $8c61e6dd391f935a$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $8c61e6dd391f935a$export$3a6d5c9ae78a2c08 extends $8c61e6dd391f935a$export$3a1a48c8f6ef640e {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $8c61e6dd391f935a$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $8c61e6dd391f935a$export$3a6d5c9ae78a2c08({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $8c61e6dd391f935a$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $8c61e6dd391f935a$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $8c61e6dd391f935a$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $8c61e6dd391f935a$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $8c61e6dd391f935a$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $8c61e6dd391f935a$var$parseDeepLink(url) {
    const link = (0, $4e6a98b76c0d0a37$export$c1271ca4c8a70741)((0, $4e6a98b76c0d0a37$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $4e6a98b76c0d0a37$export$c1271ca4c8a70741)((0, $4e6a98b76c0d0a37$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $4e6a98b76c0d0a37$export$c1271ca4c8a70741)((0, $4e6a98b76c0d0a37$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $4e6a98b76c0d0a37$export$c1271ca4c8a70741)((0, $4e6a98b76c0d0a37$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $8c61e6dd391f935a$export$3b513254972cfc9c {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $4e6a98b76c0d0a37$export$c1271ca4c8a70741)((0, $4e6a98b76c0d0a37$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $8c61e6dd391f935a$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $8c61e6dd391f935a$export$24baa2b76016ce0e(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $8c61e6dd391f935a$var$parseDeepLink(link);
        try {
            return new $8c61e6dd391f935a$export$3b513254972cfc9c(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $8c61e6dd391f935a$export$21579262ef46735b(link) {
    return $8c61e6dd391f935a$export$3b513254972cfc9c.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $8c61e6dd391f935a$export$71cec2538cb2c617 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $8c61e6dd391f935a$export$71cec2538cb2c617.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $8c61e6dd391f935a$export$a07804094c3ecf2d._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $8c61e6dd391f935a$export$3b513254972cfc9c.parseLink(emailLink);
        $8c61e6dd391f935a$export$24baa2b76016ce0e(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $8c61e6dd391f935a$export$a07804094c3ecf2d._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $8c61e6dd391f935a$export$71cec2538cb2c617.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $8c61e6dd391f935a$export$71cec2538cb2c617.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $8c61e6dd391f935a$export$71cec2538cb2c617.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $8c61e6dd391f935a$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $8c61e6dd391f935a$var$BaseOAuthProvider extends $8c61e6dd391f935a$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8c61e6dd391f935a$export$71511d61b312f219 extends $8c61e6dd391f935a$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $8c61e6dd391f935a$export$24baa2b76016ce0e('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $8c61e6dd391f935a$export$3722cfe417b6ed86._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $8c61e6dd391f935a$export$3722cfe417b6ed86._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8c61e6dd391f935a$export$71511d61b312f219.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8c61e6dd391f935a$export$71511d61b312f219.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $8c61e6dd391f935a$export$71511d61b312f219(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8c61e6dd391f935a$export$78acf4525d8a74c4 extends $8c61e6dd391f935a$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $8c61e6dd391f935a$export$3722cfe417b6ed86._fromParams({
            providerId: $8c61e6dd391f935a$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $8c61e6dd391f935a$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8c61e6dd391f935a$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8c61e6dd391f935a$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8c61e6dd391f935a$export$78acf4525d8a74c4.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $8c61e6dd391f935a$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $8c61e6dd391f935a$export$78acf4525d8a74c4.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8c61e6dd391f935a$export$8743009a87fcb00f extends $8c61e6dd391f935a$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $8c61e6dd391f935a$export$3722cfe417b6ed86._fromParams({
            providerId: $8c61e6dd391f935a$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $8c61e6dd391f935a$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8c61e6dd391f935a$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8c61e6dd391f935a$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $8c61e6dd391f935a$export$8743009a87fcb00f.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $8c61e6dd391f935a$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $8c61e6dd391f935a$export$8743009a87fcb00f.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8c61e6dd391f935a$export$dc98b0b04f4c7758 extends $8c61e6dd391f935a$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $8c61e6dd391f935a$export$3722cfe417b6ed86._fromParams({
            providerId: $8c61e6dd391f935a$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $8c61e6dd391f935a$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8c61e6dd391f935a$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8c61e6dd391f935a$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8c61e6dd391f935a$export$dc98b0b04f4c7758.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $8c61e6dd391f935a$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $8c61e6dd391f935a$export$dc98b0b04f4c7758.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $8c61e6dd391f935a$export$738ab4df8bf92ae9 extends $8c61e6dd391f935a$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8c61e6dd391f935a$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8c61e6dd391f935a$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8c61e6dd391f935a$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $8c61e6dd391f935a$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $8c61e6dd391f935a$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $8c61e6dd391f935a$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $8c61e6dd391f935a$export$3d8c2f653ac9d0b9 extends $8c61e6dd391f935a$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $8c61e6dd391f935a$export$24baa2b76016ce0e(providerId.startsWith($8c61e6dd391f935a$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8c61e6dd391f935a$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8c61e6dd391f935a$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $8c61e6dd391f935a$export$738ab4df8bf92ae9.fromJSON(json);
        $8c61e6dd391f935a$export$24baa2b76016ce0e(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $8c61e6dd391f935a$export$738ab4df8bf92ae9._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $8c61e6dd391f935a$export$34aec0b863436764 extends $8c61e6dd391f935a$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $8c61e6dd391f935a$export$3722cfe417b6ed86._fromParams({
            providerId: $8c61e6dd391f935a$export$34aec0b863436764.PROVIDER_ID,
            signInMethod: $8c61e6dd391f935a$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8c61e6dd391f935a$export$34aec0b863436764.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8c61e6dd391f935a$export$34aec0b863436764.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $8c61e6dd391f935a$export$34aec0b863436764.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $8c61e6dd391f935a$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $8c61e6dd391f935a$export$34aec0b863436764.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$signUp(auth, request) {
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $8c61e6dd391f935a$export$91477dc880baac21._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $8c61e6dd391f935a$var$providerIdForResponse(idTokenResponse);
        const userCred = new $8c61e6dd391f935a$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $8c61e6dd391f935a$var$providerIdForResponse(response);
        return new $8c61e6dd391f935a$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $8c61e6dd391f935a$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$3c2fa207a37baaea(auth) {
    var _a;
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $8c61e6dd391f935a$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $8c61e6dd391f935a$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $8c61e6dd391f935a$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$MultiFactorError extends (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $8c61e6dd391f935a$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $8c61e6dd391f935a$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $8c61e6dd391f935a$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $8c61e6dd391f935a$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $8c61e6dd391f935a$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$8a5498727ef6be21(user, providerId) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    await $8c61e6dd391f935a$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $8c61e6dd391f935a$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $8c61e6dd391f935a$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $8c61e6dd391f935a$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $8c61e6dd391f935a$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $8c61e6dd391f935a$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $8c61e6dd391f935a$var$_assertLinkedStatus(expected, user, provider) {
    await $8c61e6dd391f935a$var$_reloadWithoutSaving(user);
    const providerIds = $8c61e6dd391f935a$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $8c61e6dd391f935a$var$_logoutIfInvalidated(user, $8c61e6dd391f935a$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $8c61e6dd391f935a$export$24baa2b76016ce0e(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $8c61e6dd391f935a$var$_parseToken(response.idToken);
        $8c61e6dd391f935a$export$24baa2b76016ce0e(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $8c61e6dd391f935a$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $8c61e6dd391f935a$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $8c61e6dd391f935a$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$ce26c07117d59d6a(auth, credential) {
    return $8c61e6dd391f935a$var$_signInWithCredential($8c61e6dd391f935a$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$6559d589eb85fbb6(user, credential) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    await $8c61e6dd391f935a$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $8c61e6dd391f935a$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$efca4cbe5dd06740(user, credential) {
    return $8c61e6dd391f935a$var$_reauthenticate((0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$signInWithCustomToken$1(auth, request) {
    return $8c61e6dd391f935a$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$a8550f7dbe79f93a(auth, customToken) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    const response = await $8c61e6dd391f935a$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $8c61e6dd391f935a$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $8c61e6dd391f935a$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $8c61e6dd391f935a$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $8c61e6dd391f935a$var$PhoneMultiFactorInfoImpl extends $8c61e6dd391f935a$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $8c61e6dd391f935a$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $8c61e6dd391f935a$var$TotpMultiFactorInfoImpl extends $8c61e6dd391f935a$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $8c61e6dd391f935a$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $8c61e6dd391f935a$var$recachePasswordPolicy(auth) {
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$2e2af4578d910ddf(auth, email, actionCodeSettings) {
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $8c61e6dd391f935a$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $8c61e6dd391f935a$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $8c61e6dd391f935a$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$a93c5207d687da10(auth, oobCode, newPassword) {
    await $8c61e6dd391f935a$var$resetPassword((0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $8c61e6dd391f935a$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$c3950d9923825c02(auth, oobCode) {
    await $8c61e6dd391f935a$var$applyActionCode$1((0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$a9c996f45e5784d0(auth, oobCode) {
    const authModular = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth);
    const response = await $8c61e6dd391f935a$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $8c61e6dd391f935a$export$24baa2b76016ce0e(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $8c61e6dd391f935a$export$24baa2b76016ce0e(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $8c61e6dd391f935a$export$24baa2b76016ce0e(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $8c61e6dd391f935a$var$MultiFactorInfoImpl._fromServerResponse($8c61e6dd391f935a$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$7910e0436ed8d1de(auth, code) {
    const { data: data } = await $8c61e6dd391f935a$export$a9c996f45e5784d0((0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$555508cbc6add439(auth, email, password) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $8c61e6dd391f935a$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $8c61e6dd391f935a$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $8c61e6dd391f935a$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $8c61e6dd391f935a$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $8c61e6dd391f935a$export$2219238a014317b0(auth, email, password) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $8c61e6dd391f935a$export$ce26c07117d59d6a((0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth), $8c61e6dd391f935a$export$71cec2538cb2c617.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $8c61e6dd391f935a$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$4c3d22f3d993c33f(auth, email, actionCodeSettings) {
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $8c61e6dd391f935a$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $8c61e6dd391f935a$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $8c61e6dd391f935a$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $8c61e6dd391f935a$export$f787f51d84a910ad(auth, emailLink) {
    const actionCodeUrl = $8c61e6dd391f935a$export$3b513254972cfc9c.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$c9170ad7d4cd7e57(auth, email, emailLink) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth);
    const credential = $8c61e6dd391f935a$export$71cec2538cb2c617.credentialWithLink(email, emailLink || $8c61e6dd391f935a$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $8c61e6dd391f935a$export$24baa2b76016ce0e(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $8c61e6dd391f935a$export$ce26c07117d59d6a(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$createAuthUri(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $8c61e6dd391f935a$export$ee7c8ad385a60b7b(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $8c61e6dd391f935a$var$_isHttpOrHttps() ? $8c61e6dd391f935a$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $8c61e6dd391f935a$var$createAuthUri((0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$995eb9fca571757(user, actionCodeSettings) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $8c61e6dd391f935a$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $8c61e6dd391f935a$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$f38c853ae54ed474(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $8c61e6dd391f935a$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $8c61e6dd391f935a$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$var$updateProfile$1(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$ab83b03e4111b1d0(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $8c61e6dd391f935a$var$_logoutIfInvalidated(userInternal, $8c61e6dd391f935a$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $8c61e6dd391f935a$export$1a82df3d29112e01(user, newEmail) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $8c61e6dd391f935a$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $8c61e6dd391f935a$export$306ddfe3a8403e2(user, newPassword) {
    return $8c61e6dd391f935a$var$updateEmailOrPassword((0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $8c61e6dd391f935a$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $8c61e6dd391f935a$var$_logoutIfInvalidated(user, $8c61e6dd391f935a$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $8c61e6dd391f935a$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $8c61e6dd391f935a$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $8c61e6dd391f935a$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $8c61e6dd391f935a$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $8c61e6dd391f935a$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $8c61e6dd391f935a$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $8c61e6dd391f935a$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $8c61e6dd391f935a$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $8c61e6dd391f935a$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $8c61e6dd391f935a$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $8c61e6dd391f935a$var$FederatedAdditionalUserInfoWithUsername extends $8c61e6dd391f935a$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $8c61e6dd391f935a$var$FacebookAdditionalUserInfo extends $8c61e6dd391f935a$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $8c61e6dd391f935a$var$GithubAdditionalUserInfo extends $8c61e6dd391f935a$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $8c61e6dd391f935a$var$GoogleAdditionalUserInfo extends $8c61e6dd391f935a$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $8c61e6dd391f935a$var$TwitterAdditionalUserInfo extends $8c61e6dd391f935a$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $8c61e6dd391f935a$export$d24c54395ce0c509(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $8c61e6dd391f935a$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $8c61e6dd391f935a$export$625550452a3fa3ec(auth, persistence) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8c61e6dd391f935a$export$90a7f3efeed30595(auth) {
    return $8c61e6dd391f935a$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$efccba1c4a2ef57b(auth, password) {
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8c61e6dd391f935a$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $8c61e6dd391f935a$export$4a5767248b18ef41(auth, callback, onAbort) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8c61e6dd391f935a$export$df995fae86a55f06(auth, nextOrObserver, error, completed) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8c61e6dd391f935a$export$ef35774e6d314e91(auth) {
    (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $8c61e6dd391f935a$export$e7094788287c5e9b(auth, user) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8c61e6dd391f935a$export$96f57966bedc81b4(auth) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $8c61e6dd391f935a$export$a9c23c6ac3fc3eca(auth, token) {
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$2329c99376c9d0a4(user) {
    return (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $8c61e6dd391f935a$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $8c61e6dd391f935a$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $8c61e6dd391f935a$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $8c61e6dd391f935a$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $8c61e6dd391f935a$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$8c61e6dd391f935a$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $8c61e6dd391f935a$export$24baa2b76016ce0e(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $8c61e6dd391f935a$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $8c61e6dd391f935a$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $8c61e6dd391f935a$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $8c61e6dd391f935a$export$24baa2b76016ce0e(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $8c61e6dd391f935a$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $8c61e6dd391f935a$export$493d36ec626b6698(auth, error) {
    var _a;
    const authModular = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $8c61e6dd391f935a$export$24baa2b76016ce0e((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $8c61e6dd391f935a$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$startEnrollPhoneMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
function $8c61e6dd391f935a$var$finalizeEnrollPhoneMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
function $8c61e6dd391f935a$var$startEnrollTotpMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
function $8c61e6dd391f935a$var$finalizeEnrollTotpMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
function $8c61e6dd391f935a$var$withdrawMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
class $8c61e6dd391f935a$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$8c61e6dd391f935a$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $8c61e6dd391f935a$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $8c61e6dd391f935a$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $8c61e6dd391f935a$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $8c61e6dd391f935a$var$_logoutIfInvalidated(this.user, $8c61e6dd391f935a$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $8c61e6dd391f935a$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $8c61e6dd391f935a$export$1fbe638ecf81657e(user) {
    const userModular = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    if (!$8c61e6dd391f935a$var$multiFactorUserCache.has(userModular)) $8c61e6dd391f935a$var$multiFactorUserCache.set(userModular, $8c61e6dd391f935a$var$MultiFactorUserImpl._fromUser(userModular));
    return $8c61e6dd391f935a$var$multiFactorUserCache.get(userModular);
}
const $8c61e6dd391f935a$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $8c61e6dd391f935a$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($8c61e6dd391f935a$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($8c61e6dd391f935a$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $8c61e6dd391f935a$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $8c61e6dd391f935a$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $8c61e6dd391f935a$var$BrowserLocalPersistence extends $8c61e6dd391f935a$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $8c61e6dd391f935a$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($8c61e6dd391f935a$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $8c61e6dd391f935a$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $8c61e6dd391f935a$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$8c61e6dd391f935a$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8c61e6dd391f935a$export$8b22cf2602fb60ce = $8c61e6dd391f935a$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $8c61e6dd391f935a$var$getDocumentCookie(name) {
    var _a, _b;
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return (_b = (_a = document.cookie.match(matcher)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null;
}
// Produce a sanitized cookie name from the persistence key
function $8c61e6dd391f935a$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class $8c61e6dd391f935a$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        var _a;
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return (_a = navigator.cookieEnabled) !== null && _a !== void 0 ? _a : true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $8c61e6dd391f935a$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie === null || cookie === void 0 ? void 0 : cookie.value;
        }
        return $8c61e6dd391f935a$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $8c61e6dd391f935a$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $8c61e6dd391f935a$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = $8c61e6dd391f935a$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $8c61e6dd391f935a$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $8c61e6dd391f935a$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$8c61e6dd391f935a$var$CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $8c61e6dd391f935a$export$407448d2b89b1813 = $8c61e6dd391f935a$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$BrowserSessionPersistence extends $8c61e6dd391f935a$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$8c61e6dd391f935a$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8c61e6dd391f935a$export$db3b6bfb95261072 = $8c61e6dd391f935a$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $8c61e6dd391f935a$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $8c61e6dd391f935a$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $8c61e6dd391f935a$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $8c61e6dd391f935a$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$8c61e6dd391f935a$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$export$c03999cb2f36933f(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $8c61e6dd391f935a$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $8c61e6dd391f935a$export$c03999cb2f36933f('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $8c61e6dd391f935a$var$_window() {
    return window;
}
function $8c61e6dd391f935a$var$_setWindowLocation(url) {
    $8c61e6dd391f935a$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$_isWorker() {
    return typeof $8c61e6dd391f935a$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $8c61e6dd391f935a$var$_window()['importScripts'] === 'function';
}
async function $8c61e6dd391f935a$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $8c61e6dd391f935a$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $8c61e6dd391f935a$var$_getWorkerGlobalScope() {
    return $8c61e6dd391f935a$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$DB_NAME = 'firebaseLocalStorageDb';
const $8c61e6dd391f935a$var$DB_VERSION = 1;
const $8c61e6dd391f935a$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $8c61e6dd391f935a$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $8c61e6dd391f935a$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $8c61e6dd391f935a$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $8c61e6dd391f935a$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($8c61e6dd391f935a$var$DB_OBJECTSTORE_NAME);
}
function $8c61e6dd391f935a$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($8c61e6dd391f935a$var$DB_NAME);
    return new $8c61e6dd391f935a$var$DBPromise(request).toPromise();
}
function $8c61e6dd391f935a$var$_openDatabase() {
    const request = indexedDB.open($8c61e6dd391f935a$var$DB_NAME, $8c61e6dd391f935a$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($8c61e6dd391f935a$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $8c61e6dd391f935a$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($8c61e6dd391f935a$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $8c61e6dd391f935a$var$_deleteDatabase();
                resolve(await $8c61e6dd391f935a$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $8c61e6dd391f935a$var$_putObject(db, key, value) {
    const request = $8c61e6dd391f935a$var$getObjectStore(db, true).put({
        [$8c61e6dd391f935a$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $8c61e6dd391f935a$var$DBPromise(request).toPromise();
}
async function $8c61e6dd391f935a$var$getObject(db, key) {
    const request = $8c61e6dd391f935a$var$getObjectStore(db, false).get(key);
    const data = await new $8c61e6dd391f935a$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $8c61e6dd391f935a$var$_deleteObject(db, key) {
    const request = $8c61e6dd391f935a$var$getObjectStore(db, true).delete(key);
    return new $8c61e6dd391f935a$var$DBPromise(request).toPromise();
}
const $8c61e6dd391f935a$var$_POLLING_INTERVAL_MS = 800;
const $8c61e6dd391f935a$var$_TRANSACTION_RETRY_COUNT = 3;
class $8c61e6dd391f935a$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $8c61e6dd391f935a$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $8c61e6dd391f935a$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $8c61e6dd391f935a$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $8c61e6dd391f935a$var$Receiver._getInstance($8c61e6dd391f935a$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $8c61e6dd391f935a$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $8c61e6dd391f935a$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $8c61e6dd391f935a$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $8c61e6dd391f935a$var$_openDatabase();
            await $8c61e6dd391f935a$var$_putObject(db, $8c61e6dd391f935a$var$STORAGE_AVAILABLE_KEY, '1');
            await $8c61e6dd391f935a$var$_deleteObject(db, $8c61e6dd391f935a$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8c61e6dd391f935a$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$8c61e6dd391f935a$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8c61e6dd391f935a$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $8c61e6dd391f935a$var$getObjectStore(db, false).getAll();
            return new $8c61e6dd391f935a$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $8c61e6dd391f935a$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$8c61e6dd391f935a$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $8c61e6dd391f935a$export$23f2a1d2818174ef = $8c61e6dd391f935a$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$startSignInPhoneMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
function $8c61e6dd391f935a$var$finalizeSignInPhoneMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
function $8c61e6dd391f935a$var$finalizeSignInTotpMfa(auth, request) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $8c61e6dd391f935a$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $8c61e6dd391f935a$var$_JSLOAD_CALLBACK = $8c61e6dd391f935a$var$_generateCallbackName('rcb');
const $8c61e6dd391f935a$var$NETWORK_TIMEOUT_DELAY = new $8c61e6dd391f935a$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $8c61e6dd391f935a$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $8c61e6dd391f935a$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        $8c61e6dd391f935a$export$24baa2b76016ce0e($8c61e6dd391f935a$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $8c61e6dd391f935a$var$isV2($8c61e6dd391f935a$var$_window().grecaptcha)) return Promise.resolve($8c61e6dd391f935a$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $8c61e6dd391f935a$var$_window().setTimeout(()=>{
                reject($8c61e6dd391f935a$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $8c61e6dd391f935a$var$NETWORK_TIMEOUT_DELAY.get());
            $8c61e6dd391f935a$var$_window()[$8c61e6dd391f935a$var$_JSLOAD_CALLBACK] = ()=>{
                $8c61e6dd391f935a$var$_window().clearTimeout(networkTimeout);
                delete $8c61e6dd391f935a$var$_window()[$8c61e6dd391f935a$var$_JSLOAD_CALLBACK];
                const recaptcha = $8c61e6dd391f935a$var$_window().grecaptcha;
                if (!recaptcha || !$8c61e6dd391f935a$var$isV2(recaptcha)) {
                    reject($8c61e6dd391f935a$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$8c61e6dd391f935a$var$_recaptchaV2ScriptUrl()}?${(0, $4e6a98b76c0d0a37$export$ac4103b836844853)({
                onload: $8c61e6dd391f935a$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $8c61e6dd391f935a$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($8c61e6dd391f935a$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $8c61e6dd391f935a$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $8c61e6dd391f935a$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $8c61e6dd391f935a$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $8c61e6dd391f935a$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $8c61e6dd391f935a$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $8c61e6dd391f935a$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $8c61e6dd391f935a$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $8c61e6dd391f935a$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $8c61e6dd391f935a$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $8c61e6dd391f935a$var$MockReCaptchaLoaderImpl() : new $8c61e6dd391f935a$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $8c61e6dd391f935a$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $8c61e6dd391f935a$export$24baa2b76016ce0e($8c61e6dd391f935a$var$_isHttpOrHttps() && !$8c61e6dd391f935a$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $8c61e6dd391f935a$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $8c61e6dd391f935a$var$getRecaptchaParams(this.auth);
        $8c61e6dd391f935a$export$24baa2b76016ce0e(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $8c61e6dd391f935a$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $8c61e6dd391f935a$export$3a6d5c9ae78a2c08._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    const verificationId = await $8c61e6dd391f935a$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(appVerifier));
    return new $8c61e6dd391f935a$var$ConfirmationResultImpl(verificationId, (cred)=>$8c61e6dd391f935a$export$ce26c07117d59d6a(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    await $8c61e6dd391f935a$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $8c61e6dd391f935a$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(appVerifier));
    return new $8c61e6dd391f935a$var$ConfirmationResultImpl(verificationId, (cred)=>$8c61e6dd391f935a$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $8c61e6dd391f935a$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(appVerifier));
    return new $8c61e6dd391f935a$var$ConfirmationResultImpl(verificationId, (cred)=>$8c61e6dd391f935a$export$efca4cbe5dd06740(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $8c61e6dd391f935a$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    if (!auth._getRecaptchaConfig()) try {
        await $8c61e6dd391f935a$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $8c61e6dd391f935a$export$24baa2b76016ce0e(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $8c61e6dd391f935a$var$FAKE_TOKEN) {
                        $8c61e6dd391f935a$export$24baa2b76016ce0e((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $8c61e6dd391f935a$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $8c61e6dd391f935a$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $8c61e6dd391f935a$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $8c61e6dd391f935a$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $8c61e6dd391f935a$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $8c61e6dd391f935a$export$24baa2b76016ce0e(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $8c61e6dd391f935a$export$24baa2b76016ce0e(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $8c61e6dd391f935a$var$FAKE_TOKEN) {
                        $8c61e6dd391f935a$export$24baa2b76016ce0e((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $8c61e6dd391f935a$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $8c61e6dd391f935a$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $8c61e6dd391f935a$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $8c61e6dd391f935a$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $8c61e6dd391f935a$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $8c61e6dd391f935a$var$FAKE_TOKEN) {
                    $8c61e6dd391f935a$export$24baa2b76016ce0e((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $8c61e6dd391f935a$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $8c61e6dd391f935a$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $8c61e6dd391f935a$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $8c61e6dd391f935a$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $8c61e6dd391f935a$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier === null || verifier === void 0 || verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $8c61e6dd391f935a$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $8c61e6dd391f935a$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $8c61e6dd391f935a$export$24baa2b76016ce0e(recaptchaV2Verifier.type === $8c61e6dd391f935a$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = Object.assign({}, request);
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $8c61e6dd391f935a$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $8c61e6dd391f935a$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $8c61e6dd391f935a$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $8c61e6dd391f935a$export$3a6d5c9ae78a2c08._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $8c61e6dd391f935a$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $8c61e6dd391f935a$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $8c61e6dd391f935a$export$3a6d5c9ae78a2c08._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $8c61e6dd391f935a$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $8c61e6dd391f935a$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $8c61e6dd391f935a$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $8c61e6dd391f935a$export$cf2f7c5792f80b46(resolverOverride);
    $8c61e6dd391f935a$export$24baa2b76016ce0e(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$IdpCredential extends $8c61e6dd391f935a$export$3a1a48c8f6ef640e {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $8c61e6dd391f935a$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $8c61e6dd391f935a$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $8c61e6dd391f935a$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $8c61e6dd391f935a$var$_signIn(params) {
    return $8c61e6dd391f935a$var$_signInWithCredential(params.auth, new $8c61e6dd391f935a$var$IdpCredential(params), params.bypassAuthState);
}
function $8c61e6dd391f935a$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $8c61e6dd391f935a$var$_reauthenticate(user, new $8c61e6dd391f935a$var$IdpCredential(params), params.bypassAuthState);
}
async function $8c61e6dd391f935a$var$_link(params) {
    const { auth: auth, user: user } = params;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $8c61e6dd391f935a$var$_link$1(user, new $8c61e6dd391f935a$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $8c61e6dd391f935a$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $8c61e6dd391f935a$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $8c61e6dd391f935a$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $8c61e6dd391f935a$var$_reauth;
            default:
                $8c61e6dd391f935a$export$28f7fcd39efa255(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $8c61e6dd391f935a$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $8c61e6dd391f935a$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $8c61e6dd391f935a$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$4368d992c4eafac0(auth, provider, resolver) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    $8c61e6dd391f935a$var$_assertInstanceOf(auth, provider, $8c61e6dd391f935a$var$FederatedAuthProvider);
    const resolverInternal = $8c61e6dd391f935a$var$_withDefaultResolver(authInternal, resolver);
    const action = new $8c61e6dd391f935a$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$2d1720544b23b823(user, provider, resolver) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($8c61e6dd391f935a$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $8c61e6dd391f935a$var$_assertInstanceOf(userInternal.auth, provider, $8c61e6dd391f935a$var$FederatedAuthProvider);
    const resolverInternal = $8c61e6dd391f935a$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8c61e6dd391f935a$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    $8c61e6dd391f935a$var$_assertInstanceOf(userInternal.auth, provider, $8c61e6dd391f935a$var$FederatedAuthProvider);
    const resolverInternal = $8c61e6dd391f935a$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8c61e6dd391f935a$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $8c61e6dd391f935a$var$PopupOperation extends $8c61e6dd391f935a$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($8c61e6dd391f935a$var$PopupOperation.currentPopupAction) $8c61e6dd391f935a$var$PopupOperation.currentPopupAction.cancel();
        $8c61e6dd391f935a$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $8c61e6dd391f935a$export$24baa2b76016ce0e(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $8c61e6dd391f935a$export$d66dc83d8cfc8dd(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $8c61e6dd391f935a$export$c03999cb2f36933f();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($8c61e6dd391f935a$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($8c61e6dd391f935a$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $8c61e6dd391f935a$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($8c61e6dd391f935a$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $8c61e6dd391f935a$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$8c61e6dd391f935a$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $8c61e6dd391f935a$var$redirectOutcomeMap = new Map();
class $8c61e6dd391f935a$var$RedirectAction extends $8c61e6dd391f935a$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $8c61e6dd391f935a$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $8c61e6dd391f935a$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $8c61e6dd391f935a$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $8c61e6dd391f935a$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $8c61e6dd391f935a$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $8c61e6dd391f935a$var$pendingRedirectKey(auth);
    const persistence = $8c61e6dd391f935a$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $8c61e6dd391f935a$var$_setPendingRedirectStatus(resolver, auth) {
    return $8c61e6dd391f935a$var$resolverPersistence(resolver)._set($8c61e6dd391f935a$var$pendingRedirectKey(auth), 'true');
}
function $8c61e6dd391f935a$export$a05254e7c3aeba6e() {
    $8c61e6dd391f935a$var$redirectOutcomeMap.clear();
}
function $8c61e6dd391f935a$export$b9a6b53f9be3734(auth, result) {
    $8c61e6dd391f935a$var$redirectOutcomeMap.set(auth._key(), result);
}
function $8c61e6dd391f935a$var$resolverPersistence(resolver) {
    return $8c61e6dd391f935a$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $8c61e6dd391f935a$var$pendingRedirectKey(auth) {
    return $8c61e6dd391f935a$export$53a70dd1ebbae346($8c61e6dd391f935a$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8c61e6dd391f935a$export$39b482c5e57630a8(auth, provider, resolver) {
    return $8c61e6dd391f935a$var$_signInWithRedirect(auth, provider, resolver);
}
async function $8c61e6dd391f935a$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    $8c61e6dd391f935a$var$_assertInstanceOf(auth, provider, $8c61e6dd391f935a$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $8c61e6dd391f935a$var$_withDefaultResolver(authInternal, resolver);
    await $8c61e6dd391f935a$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8c61e6dd391f935a$export$35e795649ee09318(user, provider, resolver) {
    return $8c61e6dd391f935a$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $8c61e6dd391f935a$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    $8c61e6dd391f935a$var$_assertInstanceOf(userInternal.auth, provider, $8c61e6dd391f935a$var$FederatedAuthProvider);
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8c61e6dd391f935a$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8c61e6dd391f935a$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8c61e6dd391f935a$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8c61e6dd391f935a$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $8c61e6dd391f935a$var$_linkWithRedirect(user, provider, resolver);
}
async function $8c61e6dd391f935a$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $4e6a98b76c0d0a37$export$4befe9b5fa509a1b)(user);
    $8c61e6dd391f935a$var$_assertInstanceOf(userInternal.auth, provider, $8c61e6dd391f935a$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8c61e6dd391f935a$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8c61e6dd391f935a$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $8c61e6dd391f935a$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8c61e6dd391f935a$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8c61e6dd391f935a$export$342063e11d6c3cad(auth, resolver) {
    await $8c61e6dd391f935a$export$23ebac1979863676(auth)._initializationPromise;
    return $8c61e6dd391f935a$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $8c61e6dd391f935a$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $7c898bf562ba0419$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($8c61e6dd391f935a$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $8c61e6dd391f935a$export$23ebac1979863676(auth);
    const resolver = $8c61e6dd391f935a$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $8c61e6dd391f935a$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $8c61e6dd391f935a$var$prepareUserForRedirect(user) {
    const eventId = $8c61e6dd391f935a$export$c03999cb2f36933f(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $8c61e6dd391f935a$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $8c61e6dd391f935a$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$8c61e6dd391f935a$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$8c61e6dd391f935a$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($8c61e6dd391f935a$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $8c61e6dd391f935a$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($8c61e6dd391f935a$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($8c61e6dd391f935a$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $8c61e6dd391f935a$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $8c61e6dd391f935a$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $8c61e6dd391f935a$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $8c61e6dd391f935a$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8c61e6dd391f935a$export$91c6e00c14e7e6fd(auth, request = {}) {
    return $8c61e6dd391f935a$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $8c61e6dd391f935a$var$HTTP_REGEX = /^https?/;
async function $8c61e6dd391f935a$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $8c61e6dd391f935a$export$91c6e00c14e7e6fd(auth);
    for (const domain of authorizedDomains)try {
        if ($8c61e6dd391f935a$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $8c61e6dd391f935a$var$matchDomain(expected) {
    const currentUrl = $8c61e6dd391f935a$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$8c61e6dd391f935a$var$HTTP_REGEX.test(protocol)) return false;
    if ($8c61e6dd391f935a$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$NETWORK_TIMEOUT = new $8c61e6dd391f935a$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $8c61e6dd391f935a$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $8c61e6dd391f935a$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $8c61e6dd391f935a$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $8c61e6dd391f935a$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $8c61e6dd391f935a$var$resetUnloadedGapiModules();
                    reject($8c61e6dd391f935a$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $8c61e6dd391f935a$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $8c61e6dd391f935a$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $8c61e6dd391f935a$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $8c61e6dd391f935a$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $8c61e6dd391f935a$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($8c61e6dd391f935a$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $8c61e6dd391f935a$var$_loadJS(`${$8c61e6dd391f935a$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $8c61e6dd391f935a$var$cachedGApiLoader = null;
        throw error;
    });
}
let $8c61e6dd391f935a$var$cachedGApiLoader = null;
function $8c61e6dd391f935a$var$_loadGapi(auth) {
    $8c61e6dd391f935a$var$cachedGApiLoader = $8c61e6dd391f935a$var$cachedGApiLoader || $8c61e6dd391f935a$var$loadGapi(auth);
    return $8c61e6dd391f935a$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$PING_TIMEOUT = new $8c61e6dd391f935a$var$Delay(5000, 15000);
const $8c61e6dd391f935a$var$IFRAME_PATH = '__/auth/iframe';
const $8c61e6dd391f935a$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $8c61e6dd391f935a$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $8c61e6dd391f935a$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $8c61e6dd391f935a$var$getIframeUrl(auth) {
    const config = auth.config;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $8c61e6dd391f935a$var$_emulatorUrl(config, $8c61e6dd391f935a$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$8c61e6dd391f935a$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $7c898bf562ba0419$export$31499a9cd224b78c)
    };
    const eid = $8c61e6dd391f935a$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $4e6a98b76c0d0a37$export$ac4103b836844853)(params).slice(1)}`;
}
async function $8c61e6dd391f935a$var$_openIframe(auth) {
    const context = await $8c61e6dd391f935a$var$_loadGapi(auth);
    const gapi1 = $8c61e6dd391f935a$var$_window().gapi;
    $8c61e6dd391f935a$export$24baa2b76016ce0e(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $8c61e6dd391f935a$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $8c61e6dd391f935a$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $8c61e6dd391f935a$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $8c61e6dd391f935a$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $8c61e6dd391f935a$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $8c61e6dd391f935a$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $8c61e6dd391f935a$var$DEFAULT_WIDTH = 500;
const $8c61e6dd391f935a$var$DEFAULT_HEIGHT = 600;
const $8c61e6dd391f935a$var$TARGET_BLANK = '_blank';
const $8c61e6dd391f935a$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $8c61e6dd391f935a$export$2ed0fc6709e59212 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $8c61e6dd391f935a$var$_open(auth, url, name, width = $8c61e6dd391f935a$var$DEFAULT_WIDTH, height = $8c61e6dd391f935a$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, $8c61e6dd391f935a$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $8c61e6dd391f935a$var$_isChromeIOS(ua) ? $8c61e6dd391f935a$var$TARGET_BLANK : name;
    if ($8c61e6dd391f935a$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $8c61e6dd391f935a$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($8c61e6dd391f935a$var$_isIOSStandalone(ua) && target !== '_self') {
        $8c61e6dd391f935a$var$openAsNewWindowIOS(url || '', target);
        return new $8c61e6dd391f935a$export$2ed0fc6709e59212(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $8c61e6dd391f935a$export$24baa2b76016ce0e(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $8c61e6dd391f935a$export$2ed0fc6709e59212(newWin);
}
function $8c61e6dd391f935a$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $8c61e6dd391f935a$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $8c61e6dd391f935a$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $8c61e6dd391f935a$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $8c61e6dd391f935a$export$3d12bd131bb975d1(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $8c61e6dd391f935a$export$24baa2b76016ce0e(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $8c61e6dd391f935a$export$24baa2b76016ce0e(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $7c898bf562ba0419$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $8c61e6dd391f935a$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $4e6a98b76c0d0a37$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $8c61e6dd391f935a$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$8c61e6dd391f935a$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$8c61e6dd391f935a$var$getHandlerBase(auth)}?${(0, $4e6a98b76c0d0a37$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $8c61e6dd391f935a$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$8c61e6dd391f935a$var$WIDGET_PATH}`;
    return $8c61e6dd391f935a$var$_emulatorUrl(config, $8c61e6dd391f935a$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $8c61e6dd391f935a$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $8c61e6dd391f935a$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $8c61e6dd391f935a$export$db3b6bfb95261072;
        this._completeRedirectFn = $8c61e6dd391f935a$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $8c61e6dd391f935a$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $8c61e6dd391f935a$export$d66dc83d8cfc8dd((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await $8c61e6dd391f935a$export$3d12bd131bb975d1(auth, provider, authType, $8c61e6dd391f935a$var$_getCurrentUrl(), eventId);
        return $8c61e6dd391f935a$var$_open(auth, url, $8c61e6dd391f935a$export$c03999cb2f36933f());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $8c61e6dd391f935a$export$3d12bd131bb975d1(auth, provider, authType, $8c61e6dd391f935a$var$_getCurrentUrl(), eventId);
        $8c61e6dd391f935a$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $8c61e6dd391f935a$export$d66dc83d8cfc8dd(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $8c61e6dd391f935a$var$_openIframe(auth);
        const manager = new $8c61e6dd391f935a$export$158acd800e1ef08b(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $8c61e6dd391f935a$export$24baa2b76016ce0e(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($8c61e6dd391f935a$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $8c61e6dd391f935a$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$8c61e6dd391f935a$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $8c61e6dd391f935a$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $8c61e6dd391f935a$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $8c61e6dd391f935a$var$_isMobileBrowser() || $8c61e6dd391f935a$var$_isSafari() || $8c61e6dd391f935a$export$92108d983e8ee699();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $8c61e6dd391f935a$export$953cecd6e717a553 = $8c61e6dd391f935a$var$BrowserPopupRedirectResolver;
class $8c61e6dd391f935a$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $8c61e6dd391f935a$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $8c61e6dd391f935a$var$PhoneMultiFactorAssertionImpl extends $8c61e6dd391f935a$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $8c61e6dd391f935a$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $8c61e6dd391f935a$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $8c61e6dd391f935a$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $8c61e6dd391f935a$export$7ccc53e8f1e7dfc5 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $8c61e6dd391f935a$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $8c61e6dd391f935a$export$7ccc53e8f1e7dfc5.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $8c61e6dd391f935a$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $8c61e6dd391f935a$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $8c61e6dd391f935a$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $8c61e6dd391f935a$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $8c61e6dd391f935a$export$ae1af26003f05816._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $8c61e6dd391f935a$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $8c61e6dd391f935a$var$TotpMultiFactorAssertionImpl extends $8c61e6dd391f935a$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $8c61e6dd391f935a$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $8c61e6dd391f935a$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $8c61e6dd391f935a$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $8c61e6dd391f935a$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $8c61e6dd391f935a$export$ae1af26003f05816 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $8c61e6dd391f935a$export$ae1af26003f05816(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($8c61e6dd391f935a$var$_isEmptyString(accountName) || $8c61e6dd391f935a$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($8c61e6dd391f935a$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if ($8c61e6dd391f935a$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $8c61e6dd391f935a$var$_isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $8c61e6dd391f935a$var$name = "@firebase/auth";
var $8c61e6dd391f935a$var$version = "1.10.8";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8c61e6dd391f935a$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $8c61e6dd391f935a$export$24baa2b76016ce0e(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c61e6dd391f935a$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $8c61e6dd391f935a$var$registerAuth(clientPlatform) {
    (0, $7c898bf562ba0419$export$c930050e7bb63965)(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $8c61e6dd391f935a$export$24baa2b76016ce0e(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $8c61e6dd391f935a$export$faec65b429be379(clientPlatform)
        };
        const authInstance = new $8c61e6dd391f935a$export$9f4f30ee63539e24(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $8c61e6dd391f935a$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $7c898bf562ba0419$export$c930050e7bb63965)(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $8c61e6dd391f935a$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $8c61e6dd391f935a$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $7c898bf562ba0419$export$d29d5299a7137abc)($8c61e6dd391f935a$var$name, $8c61e6dd391f935a$var$version, $8c61e6dd391f935a$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $7c898bf562ba0419$export$d29d5299a7137abc)($8c61e6dd391f935a$var$name, $8c61e6dd391f935a$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c61e6dd391f935a$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $8c61e6dd391f935a$var$authIdTokenMaxAge = (0, $4e6a98b76c0d0a37$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $8c61e6dd391f935a$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $8c61e6dd391f935a$var$lastPostedIdToken = null;
const $8c61e6dd391f935a$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $8c61e6dd391f935a$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($8c61e6dd391f935a$var$lastPostedIdToken === idToken) return;
        $8c61e6dd391f935a$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $8c61e6dd391f935a$export$ffb5f4729a158638(app = (0, $7c898bf562ba0419$export$f9962582c9e66d99)()) {
    const provider = (0, $7c898bf562ba0419$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $8c61e6dd391f935a$export$3466f893ebf79586(app, {
        popupRedirectResolver: $8c61e6dd391f935a$export$953cecd6e717a553,
        persistence: [
            $8c61e6dd391f935a$export$23f2a1d2818174ef,
            $8c61e6dd391f935a$export$8b22cf2602fb60ce,
            $8c61e6dd391f935a$export$db3b6bfb95261072
        ]
    });
    const authTokenSyncPath = (0, $4e6a98b76c0d0a37$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $8c61e6dd391f935a$var$mintCookieFactory(authTokenSyncUrl.toString());
            $8c61e6dd391f935a$export$4a5767248b18ef41(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $8c61e6dd391f935a$export$d141bba7fdc215a3(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $4e6a98b76c0d0a37$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $8c61e6dd391f935a$export$61196ced6d74a310(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $8c61e6dd391f935a$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$8c61e6dd391f935a$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $8c61e6dd391f935a$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $8c61e6dd391f935a$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$8c61e6dd391f935a$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );







/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $bc401b4e68da01a3$var$_cordovaWindow() {
    return window;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How long to wait after the app comes back into focus before concluding that
 * the user closed the sign in tab.
 */ const $bc401b4e68da01a3$var$REDIRECT_TIMEOUT_MS = 2000;
/**
 * Generates the URL for the OAuth handler.
 */ async function $bc401b4e68da01a3$var$_generateHandlerUrl(auth, event, provider) {
    var _a;
    // Get the cordova plugins
    const { BuildInfo: BuildInfo } = $bc401b4e68da01a3$var$_cordovaWindow();
    (0, $8c61e6dd391f935a$export$d66dc83d8cfc8dd)(event.sessionId, 'AuthEvent did not contain a session ID');
    const sessionDigest = await $bc401b4e68da01a3$var$computeSha256(event.sessionId);
    const additionalParams = {};
    if ((0, $8c61e6dd391f935a$export$92108d983e8ee699)()) // iOS app identifier
    additionalParams['ibi'] = BuildInfo.packageName;
    else if ((0, $8c61e6dd391f935a$export$9fa96a7d116ea3ce)()) // Android app identifier
    additionalParams['apn'] = BuildInfo.packageName;
    else (0, $8c61e6dd391f935a$export$28f7fcd39efa255)(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    // Add the display name if available
    if (BuildInfo.displayName) additionalParams['appDisplayName'] = BuildInfo.displayName;
    // Attached the hashed session ID
    additionalParams['sessionId'] = sessionDigest;
    return (0, $8c61e6dd391f935a$export$3d12bd131bb975d1)(auth, provider, event.type, undefined, (_a = event.eventId) !== null && _a !== void 0 ? _a : undefined, additionalParams);
}
/**
 * Validates that this app is valid for this project configuration
 */ async function $bc401b4e68da01a3$var$_validateOrigin(auth) {
    const { BuildInfo: BuildInfo } = $bc401b4e68da01a3$var$_cordovaWindow();
    const request = {};
    if ((0, $8c61e6dd391f935a$export$92108d983e8ee699)()) request.iosBundleId = BuildInfo.packageName;
    else if ((0, $8c61e6dd391f935a$export$9fa96a7d116ea3ce)()) request.androidPackageName = BuildInfo.packageName;
    else (0, $8c61e6dd391f935a$export$28f7fcd39efa255)(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    // Will fail automatically if package name is not authorized
    await (0, $8c61e6dd391f935a$export$91c6e00c14e7e6fd)(auth, request);
}
function $bc401b4e68da01a3$var$_performRedirect(handlerUrl) {
    // Get the cordova plugins
    const { cordova: cordova } = $bc401b4e68da01a3$var$_cordovaWindow();
    return new Promise((resolve)=>{
        cordova.plugins.browsertab.isAvailable((browserTabIsAvailable)=>{
            let iabRef = null;
            if (browserTabIsAvailable) cordova.plugins.browsertab.openUrl(handlerUrl);
            else // TODO: Return the inappbrowser ref that's returned from the open call
            iabRef = cordova.InAppBrowser.open(handlerUrl, (0, $8c61e6dd391f935a$export$9d398bebfec1c039)() ? '_blank' : '_system', 'location=yes');
            resolve(iabRef);
        });
    });
}
/**
 * This function waits for app activity to be seen before resolving. It does
 * this by attaching listeners to various dom events. Once the app is determined
 * to be visible, this promise resolves. AFTER that resolution, the listeners
 * are detached and any browser tabs left open will be closed.
 */ async function $bc401b4e68da01a3$var$_waitForAppResume(auth, eventListener, iabRef) {
    // Get the cordova plugins
    const { cordova: cordova } = $bc401b4e68da01a3$var$_cordovaWindow();
    let cleanup = ()=>{};
    try {
        await new Promise((resolve, reject)=>{
            let onCloseTimer = null;
            // DEFINE ALL THE CALLBACKS =====
            function authEventSeen() {
                var _a;
                // Auth event was detected. Resolve this promise and close the extra
                // window if it's still open.
                resolve();
                const closeBrowserTab = (_a = cordova.plugins.browsertab) === null || _a === void 0 ? void 0 : _a.close;
                if (typeof closeBrowserTab === 'function') closeBrowserTab();
                // Close inappbrowser embedded webview in iOS7 and 8 case if still
                // open.
                if (typeof (iabRef === null || iabRef === void 0 ? void 0 : iabRef.close) === 'function') iabRef.close();
            }
            function resumed() {
                if (onCloseTimer) // This code already ran; do not rerun.
                return;
                onCloseTimer = window.setTimeout(()=>{
                    // Wait two seconds after resume then reject.
                    reject((0, $8c61e6dd391f935a$export$890c4ad488842ce7)(auth, "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ));
                }, $bc401b4e68da01a3$var$REDIRECT_TIMEOUT_MS);
            }
            function visibilityChanged() {
                if ((document === null || document === void 0 ? void 0 : document.visibilityState) === 'visible') resumed();
            }
            // ATTACH ALL THE LISTENERS =====
            // Listen for the auth event
            eventListener.addPassiveListener(authEventSeen);
            // Listen for resume and visibility events
            document.addEventListener('resume', resumed, false);
            if ((0, $8c61e6dd391f935a$export$9fa96a7d116ea3ce)()) document.addEventListener('visibilitychange', visibilityChanged, false);
            // SETUP THE CLEANUP FUNCTION =====
            cleanup = ()=>{
                eventListener.removePassiveListener(authEventSeen);
                document.removeEventListener('resume', resumed, false);
                document.removeEventListener('visibilitychange', visibilityChanged, false);
                if (onCloseTimer) window.clearTimeout(onCloseTimer);
            };
        });
    } finally{
        cleanup();
    }
}
/**
 * Checks the configuration of the Cordova environment. This has no side effect
 * if the configuration is correct; otherwise it throws an error with the
 * missing plugin.
 */ function $bc401b4e68da01a3$var$_checkCordovaConfiguration(auth) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const win = $bc401b4e68da01a3$var$_cordovaWindow();
    // Check all dependencies installed.
    // https://github.com/nordnet/cordova-universal-links-plugin
    // Note that cordova-universal-links-plugin has been abandoned.
    // A fork with latest fixes is available at:
    // https://www.npmjs.com/package/cordova-universal-links-plugin-fix
    (0, $8c61e6dd391f935a$export$24baa2b76016ce0e)(typeof ((_a = win === null || win === void 0 ? void 0 : win.universalLinks) === null || _a === void 0 ? void 0 : _a.subscribe) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-universal-links-plugin-fix'
    });
    // https://www.npmjs.com/package/cordova-plugin-buildinfo
    (0, $8c61e6dd391f935a$export$24baa2b76016ce0e)(typeof ((_b = win === null || win === void 0 ? void 0 : win.BuildInfo) === null || _b === void 0 ? void 0 : _b.packageName) !== 'undefined', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-buildInfo'
    });
    // https://github.com/google/cordova-plugin-browsertab
    (0, $8c61e6dd391f935a$export$24baa2b76016ce0e)(typeof ((_e = (_d = (_c = win === null || win === void 0 ? void 0 : win.cordova) === null || _c === void 0 ? void 0 : _c.plugins) === null || _d === void 0 ? void 0 : _d.browsertab) === null || _e === void 0 ? void 0 : _e.openUrl) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-browsertab'
    });
    (0, $8c61e6dd391f935a$export$24baa2b76016ce0e)(typeof ((_h = (_g = (_f = win === null || win === void 0 ? void 0 : win.cordova) === null || _f === void 0 ? void 0 : _f.plugins) === null || _g === void 0 ? void 0 : _g.browsertab) === null || _h === void 0 ? void 0 : _h.isAvailable) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-browsertab'
    });
    // https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-inappbrowser/
    (0, $8c61e6dd391f935a$export$24baa2b76016ce0e)(typeof ((_k = (_j = win === null || win === void 0 ? void 0 : win.cordova) === null || _j === void 0 ? void 0 : _j.InAppBrowser) === null || _k === void 0 ? void 0 : _k.open) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , {
        missingPlugin: 'cordova-plugin-inappbrowser'
    });
}
/**
 * Computes the SHA-256 of a session ID. The SubtleCrypto interface is only
 * available in "secure" contexts, which covers Cordova (which is served on a file
 * protocol).
 */ async function $bc401b4e68da01a3$var$computeSha256(sessionId) {
    const bytes = $bc401b4e68da01a3$var$stringToArrayBuffer(sessionId);
    // TODO: For IE11 crypto has a different name and this operation comes back
    //       as an object, not a promise. This is the old proposed standard that
    //       is used by IE11:
    // https://www.w3.org/TR/2013/WD-WebCryptoAPI-20130108/#cryptooperation-interface
    const buf = await crypto.subtle.digest('SHA-256', bytes);
    const arr = Array.from(new Uint8Array(buf));
    return arr.map((num)=>num.toString(16).padStart(2, '0')).join('');
}
function $bc401b4e68da01a3$var$stringToArrayBuffer(str) {
    // This function is only meant to deal with an ASCII charset and makes
    // certain simplifying assumptions.
    (0, $8c61e6dd391f935a$export$d66dc83d8cfc8dd)(/[0-9a-zA-Z]+/.test(str), 'Can only convert alpha-numeric strings');
    if (typeof TextEncoder !== 'undefined') return new TextEncoder().encode(str);
    const buff = new ArrayBuffer(str.length);
    const view = new Uint8Array(buff);
    for(let i = 0; i < str.length; i++)view[i] = str.charCodeAt(i);
    return view;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $bc401b4e68da01a3$var$SESSION_ID_LENGTH = 20;
/** Custom AuthEventManager that adds passive listeners to events */ class $bc401b4e68da01a3$var$CordovaAuthEventManager extends (0, $8c61e6dd391f935a$export$158acd800e1ef08b) {
    constructor(){
        super(...arguments);
        this.passiveListeners = new Set();
        this.initPromise = new Promise((resolve)=>{
            this.resolveInitialized = resolve;
        });
    }
    addPassiveListener(cb) {
        this.passiveListeners.add(cb);
    }
    removePassiveListener(cb) {
        this.passiveListeners.delete(cb);
    }
    // In a Cordova environment, this manager can live through multiple redirect
    // operations
    resetRedirect() {
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
    }
    /** Override the onEvent method */ onEvent(event) {
        this.resolveInitialized();
        this.passiveListeners.forEach((cb)=>cb(event));
        return super.onEvent(event);
    }
    async initialized() {
        await this.initPromise;
    }
}
/**
 * Generates a (partial) {@link AuthEvent}.
 */ function $bc401b4e68da01a3$var$_generateNewEvent(auth, type, eventId = null) {
    return {
        type: type,
        eventId: eventId,
        urlResponse: null,
        sessionId: $bc401b4e68da01a3$var$generateSessionId(),
        postBody: null,
        tenantId: auth.tenantId,
        error: (0, $8c61e6dd391f935a$export$890c4ad488842ce7)(auth, "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ )
    };
}
function $bc401b4e68da01a3$var$_savePartialEvent(auth, event) {
    return $bc401b4e68da01a3$var$storage()._set($bc401b4e68da01a3$var$persistenceKey(auth), event);
}
async function $bc401b4e68da01a3$var$_getAndRemoveEvent(auth) {
    const event = await $bc401b4e68da01a3$var$storage()._get($bc401b4e68da01a3$var$persistenceKey(auth));
    if (event) await $bc401b4e68da01a3$var$storage()._remove($bc401b4e68da01a3$var$persistenceKey(auth));
    return event;
}
function $bc401b4e68da01a3$var$_eventFromPartialAndUrl(partialEvent, url) {
    var _a, _b;
    // Parse the deep link within the dynamic link URL.
    const callbackUrl = $bc401b4e68da01a3$var$_getDeepLinkFromCallback(url);
    // Confirm it is actually a callback URL.
    // Currently the universal link will be of this format:
    // https://<AUTH_DOMAIN>/__/auth/callback<OAUTH_RESPONSE>
    // This is a fake URL but is not intended to take the user anywhere
    // and just redirect to the app.
    if (callbackUrl.includes('/__/auth/callback')) {
        // Check if there is an error in the URL.
        // This mechanism is also used to pass errors back to the app:
        // https://<AUTH_DOMAIN>/__/auth/callback?firebaseError=<STRINGIFIED_ERROR>
        const params = $bc401b4e68da01a3$var$searchParamsOrEmpty(callbackUrl);
        // Get the error object corresponding to the stringified error if found.
        const errorObject = params['firebaseError'] ? $bc401b4e68da01a3$var$parseJsonOrNull(decodeURIComponent(params['firebaseError'])) : null;
        const code = (_b = (_a = errorObject === null || errorObject === void 0 ? void 0 : errorObject['code']) === null || _a === void 0 ? void 0 : _a.split('auth/')) === null || _b === void 0 ? void 0 : _b[1];
        const error = code ? (0, $8c61e6dd391f935a$export$890c4ad488842ce7)(code) : null;
        if (error) return {
            type: partialEvent.type,
            eventId: partialEvent.eventId,
            tenantId: partialEvent.tenantId,
            error: error,
            urlResponse: null,
            sessionId: null,
            postBody: null
        };
        else return {
            type: partialEvent.type,
            eventId: partialEvent.eventId,
            tenantId: partialEvent.tenantId,
            sessionId: partialEvent.sessionId,
            urlResponse: callbackUrl,
            postBody: null
        };
    }
    return null;
}
function $bc401b4e68da01a3$var$generateSessionId() {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < $bc401b4e68da01a3$var$SESSION_ID_LENGTH; i++){
        const idx = Math.floor(Math.random() * allowedChars.length);
        chars.push(allowedChars.charAt(idx));
    }
    return chars.join('');
}
function $bc401b4e68da01a3$var$storage() {
    return (0, $8c61e6dd391f935a$export$cf2f7c5792f80b46)((0, $8c61e6dd391f935a$export$8b22cf2602fb60ce));
}
function $bc401b4e68da01a3$var$persistenceKey(auth) {
    return (0, $8c61e6dd391f935a$export$53a70dd1ebbae346)("authEvent" /* KeyName.AUTH_EVENT */ , auth.config.apiKey, auth.name);
}
function $bc401b4e68da01a3$var$parseJsonOrNull(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return null;
    }
}
// Exported for testing
function $bc401b4e68da01a3$var$_getDeepLinkFromCallback(url) {
    const params = $bc401b4e68da01a3$var$searchParamsOrEmpty(url);
    const link = params['link'] ? decodeURIComponent(params['link']) : undefined;
    // Double link case (automatic redirect)
    const doubleDeepLink = $bc401b4e68da01a3$var$searchParamsOrEmpty(link)['link'];
    // iOS custom scheme links.
    const iOSDeepLink = params['deep_link_id'] ? decodeURIComponent(params['deep_link_id']) : undefined;
    const iOSDoubleDeepLink = $bc401b4e68da01a3$var$searchParamsOrEmpty(iOSDeepLink)['link'];
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * Optimistically tries to get search params from a string, or else returns an
 * empty search params object.
 */ function $bc401b4e68da01a3$var$searchParamsOrEmpty(url) {
    if (!(url === null || url === void 0 ? void 0 : url.includes('?'))) return {};
    const [_, ...rest] = url.split('?');
    return (0, $4e6a98b76c0d0a37$export$c1271ca4c8a70741)(rest.join('?'));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How long to wait for the initial auth event before concluding no
 * redirect pending
 */ const $bc401b4e68da01a3$var$INITIAL_EVENT_TIMEOUT_MS = 500;
class $bc401b4e68da01a3$var$CordovaPopupRedirectResolver {
    constructor(){
        this._redirectPersistence = (0, $8c61e6dd391f935a$export$db3b6bfb95261072);
        this._shouldInitProactively = true; // This is lightweight for Cordova
        this.eventManagers = new Map();
        this.originValidationPromises = {};
        this._completeRedirectFn = (0, $8c61e6dd391f935a$export$a33b77bbdbb8366c);
        this._overrideRedirectResult = (0, $8c61e6dd391f935a$export$b9a6b53f9be3734);
    }
    async _initialize(auth) {
        const key = auth._key();
        let manager = this.eventManagers.get(key);
        if (!manager) {
            manager = new $bc401b4e68da01a3$var$CordovaAuthEventManager(auth);
            this.eventManagers.set(key, manager);
            this.attachCallbackListeners(auth, manager);
        }
        return manager;
    }
    _openPopup(auth) {
        (0, $8c61e6dd391f935a$export$28f7fcd39efa255)(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    async _openRedirect(auth, provider, authType, eventId) {
        $bc401b4e68da01a3$var$_checkCordovaConfiguration(auth);
        const manager = await this._initialize(auth);
        await manager.initialized();
        // Reset the persisted redirect states. This does not matter on Web where
        // the redirect always blows away application state entirely. On Cordova,
        // the app maintains control flow through the redirect.
        manager.resetRedirect();
        (0, $8c61e6dd391f935a$export$a05254e7c3aeba6e)();
        await this._originValidation(auth);
        const event = $bc401b4e68da01a3$var$_generateNewEvent(auth, authType, eventId);
        await $bc401b4e68da01a3$var$_savePartialEvent(auth, event);
        const url = await $bc401b4e68da01a3$var$_generateHandlerUrl(auth, event, provider);
        const iabRef = await $bc401b4e68da01a3$var$_performRedirect(url);
        return $bc401b4e68da01a3$var$_waitForAppResume(auth, manager, iabRef);
    }
    _isIframeWebStorageSupported(_auth, _cb) {
        throw new Error('Method not implemented.');
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $bc401b4e68da01a3$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    attachCallbackListeners(auth, manager) {
        // Get the global plugins
        const { universalLinks: universalLinks, handleOpenURL: handleOpenURL, BuildInfo: BuildInfo } = $bc401b4e68da01a3$var$_cordovaWindow();
        const noEventTimeout = setTimeout(async ()=>{
            // We didn't see that initial event. Clear any pending object and
            // dispatch no event
            await $bc401b4e68da01a3$var$_getAndRemoveEvent(auth);
            manager.onEvent($bc401b4e68da01a3$var$generateNoEvent());
        }, $bc401b4e68da01a3$var$INITIAL_EVENT_TIMEOUT_MS);
        const universalLinksCb = async (eventData)=>{
            // We have an event so we can clear the no event timeout
            clearTimeout(noEventTimeout);
            const partialEvent = await $bc401b4e68da01a3$var$_getAndRemoveEvent(auth);
            let finalEvent = null;
            if (partialEvent && (eventData === null || eventData === void 0 ? void 0 : eventData['url'])) finalEvent = $bc401b4e68da01a3$var$_eventFromPartialAndUrl(partialEvent, eventData['url']);
            // If finalEvent is never filled, trigger with no event
            manager.onEvent(finalEvent || $bc401b4e68da01a3$var$generateNoEvent());
        };
        // Universal links subscriber doesn't exist for iOS, so we need to check
        if (typeof universalLinks !== 'undefined' && typeof universalLinks.subscribe === 'function') universalLinks.subscribe(null, universalLinksCb);
        // iOS 7 or 8 custom URL schemes.
        // This is also the current default behavior for iOS 9+.
        // For this to work, cordova-plugin-customurlscheme needs to be installed.
        // https://github.com/EddyVerbruggen/Custom-URL-scheme
        // Do not overwrite the existing developer's URL handler.
        const existingHandleOpenURL = handleOpenURL;
        const packagePrefix = `${BuildInfo.packageName.toLowerCase()}://`;
        $bc401b4e68da01a3$var$_cordovaWindow().handleOpenURL = async (url)=>{
            if (url.toLowerCase().startsWith(packagePrefix)) // We want this intentionally to float
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            universalLinksCb({
                url: url
            });
            // Call the developer's handler if it is present.
            if (typeof existingHandleOpenURL === 'function') try {
                existingHandleOpenURL(url);
            } catch (e) {
                // This is a developer error. Don't stop the flow of the SDK.
                console.error(e);
            }
        };
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for Cordova
 * based applications.
 *
 * @public
 */ const $bc401b4e68da01a3$export$2528817c27f24e17 = $bc401b4e68da01a3$var$CordovaPopupRedirectResolver;
function $bc401b4e68da01a3$var$generateNoEvent() {
    return {
        type: "unknown" /* AuthEventType.UNKNOWN */ ,
        eventId: null,
        sessionId: null,
        urlResponse: null,
        postBody: null,
        tenantId: null,
        error: (0, $8c61e6dd391f935a$export$890c4ad488842ce7)("no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ )
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This function should only be called by frameworks (e.g. FirebaseUI-web) to log their usage.
// It is not intended for direct use by developer apps. NO jsdoc here to intentionally leave it out
// of autogenerated documentation pages to reduce accidental misuse.
function $bc401b4e68da01a3$export$f469bed1b0fbb94f(auth, framework) {
    (0, $8c61e6dd391f935a$export$23ebac1979863676)(auth)._logFramework(framework);
}




var $839307959896a1aa$var$name = "@firebase/auth-compat";
var $839307959896a1aa$var$version = "0.5.28";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $839307959896a1aa$var$CORDOVA_ONDEVICEREADY_TIMEOUT_MS = 1000;
function $839307959896a1aa$var$_getCurrentScheme() {
    var _a;
    return ((_a = self === null || self === void 0 ? void 0 : self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @return {boolean} Whether the current environment is http or https.
 */ function $839307959896a1aa$var$_isHttpOrHttps() {
    return $839307959896a1aa$var$_getCurrentScheme() === 'http:' || $839307959896a1aa$var$_getCurrentScheme() === 'https:';
}
/**
 * @param {?string=} ua The user agent.
 * @return {boolean} Whether the app is rendered in a mobile iOS or Android
 *     Cordova environment.
 */ function $839307959896a1aa$var$_isAndroidOrIosCordovaScheme(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return !!(($839307959896a1aa$var$_getCurrentScheme() === 'file:' || $839307959896a1aa$var$_getCurrentScheme() === 'ionic:' || $839307959896a1aa$var$_getCurrentScheme() === 'capacitor:') && ua.toLowerCase().match(/iphone|ipad|ipod|android/));
}
/**
 * @return {boolean} Whether the environment is a native environment, where
 *     CORS checks do not apply.
 */ function $839307959896a1aa$var$_isNativeEnvironment() {
    return (0, $4e6a98b76c0d0a37$export$f7a1e23e542d38e3)() || (0, $4e6a98b76c0d0a37$export$8ee0fc9ee280b4ee)();
}
/**
 * Checks whether the user agent is IE11.
 * @return {boolean} True if it is IE11.
 */ function $839307959896a1aa$var$_isIe11() {
    return (0, $4e6a98b76c0d0a37$export$7e7b1a9668aaed8)() && (document === null || document === void 0 ? void 0 : document.documentMode) === 11;
}
/**
 * Checks whether the user agent is Edge.
 * @param {string} userAgent The browser user agent string.
 * @return {boolean} True if it is Edge.
 */ function $839307959896a1aa$var$_isEdge(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return /Edge\/\d+/.test(ua);
}
/**
 * @param {?string=} opt_userAgent The navigator user agent.
 * @return {boolean} Whether local storage is not synchronized between an iframe
 *     and a popup of the same domain.
 */ function $839307959896a1aa$var$_isLocalStorageNotSynchronized(ua = (0, $4e6a98b76c0d0a37$export$c36915b22ce77c19)()) {
    return $839307959896a1aa$var$_isIe11() || $839307959896a1aa$var$_isEdge(ua);
}
/** @return {boolean} Whether web storage is supported. */ function $839307959896a1aa$var$_isWebStorageSupported() {
    try {
        const storage = self.localStorage;
        const key = $8c61e6dd391f935a$export$c03999cb2f36933f();
        if (storage) {
            // setItem will throw an exception if we cannot access WebStorage (e.g.,
            // Safari in private mode).
            storage['setItem'](key, '1');
            storage['removeItem'](key);
            // For browsers where iframe web storage does not synchronize with a popup
            // of the same domain, indexedDB is used for persistent storage. These
            // browsers include IE11 and Edge.
            // Make sure it is supported (IE11 and Edge private mode does not support
            // that).
            if ($839307959896a1aa$var$_isLocalStorageNotSynchronized()) // In such browsers, if indexedDB is not supported, an iframe cannot be
            // notified of the popup sign in result.
            return (0, $4e6a98b76c0d0a37$export$3865db50535c2055)();
            return true;
        }
    } catch (e) {
        // localStorage is not available from a worker. Test availability of
        // indexedDB.
        return $839307959896a1aa$var$_isWorker() && (0, $4e6a98b76c0d0a37$export$3865db50535c2055)();
    }
    return false;
}
/**
 * @param {?Object=} global The optional global scope.
 * @return {boolean} Whether current environment is a worker.
 */ function $839307959896a1aa$var$_isWorker() {
    // WorkerGlobalScope only defined in worker environment.
    return typeof $parcel$global !== 'undefined' && 'WorkerGlobalScope' in $parcel$global && 'importScripts' in $parcel$global;
}
function $839307959896a1aa$var$_isPopupRedirectSupported() {
    return ($839307959896a1aa$var$_isHttpOrHttps() || (0, $4e6a98b76c0d0a37$export$caa8774a9107a58e)() || $839307959896a1aa$var$_isAndroidOrIosCordovaScheme()) && // React Native with remote debugging reports its location.protocol as
    // http.
    !$839307959896a1aa$var$_isNativeEnvironment() && // Local storage has to be supported for browser popup and redirect
    // operations to work.
    $839307959896a1aa$var$_isWebStorageSupported() && // DOM, popups and redirects are not supported within a worker.
    !$839307959896a1aa$var$_isWorker();
}
/** Quick check that indicates the platform *may* be Cordova */ function $839307959896a1aa$var$_isLikelyCordova() {
    return $839307959896a1aa$var$_isAndroidOrIosCordovaScheme() && typeof document !== 'undefined';
}
async function $839307959896a1aa$var$_isCordova() {
    if (!$839307959896a1aa$var$_isLikelyCordova()) return false;
    return new Promise((resolve)=>{
        const timeoutId = setTimeout(()=>{
            // We've waited long enough; the telltale Cordova event didn't happen
            resolve(false);
        }, $839307959896a1aa$var$CORDOVA_ONDEVICEREADY_TIMEOUT_MS);
        document.addEventListener('deviceready', ()=>{
            clearTimeout(timeoutId);
            resolve(true);
        });
    });
}
function $839307959896a1aa$var$_getSelfWindow() {
    return typeof window !== 'undefined' ? window : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $839307959896a1aa$var$Persistence = {
    LOCAL: 'local',
    NONE: 'none',
    SESSION: 'session'
};
const $839307959896a1aa$var$_assert$3 = $8c61e6dd391f935a$export$24baa2b76016ce0e;
const $839307959896a1aa$var$PERSISTENCE_KEY = 'persistence';
/**
 * Validates that an argument is a valid persistence value. If an invalid type
 * is specified, an error is thrown synchronously.
 */ function $839307959896a1aa$var$_validatePersistenceArgument(auth, persistence) {
    $839307959896a1aa$var$_assert$3(Object.values($839307959896a1aa$var$Persistence).includes(persistence), auth, "invalid-persistence-type" /* exp.AuthErrorCode.INVALID_PERSISTENCE */ );
    // Validate if the specified type is supported in the current environment.
    if ((0, $4e6a98b76c0d0a37$export$f7a1e23e542d38e3)()) {
        // This is only supported in a browser.
        $839307959896a1aa$var$_assert$3(persistence !== $839307959896a1aa$var$Persistence.SESSION, auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
        return;
    }
    if ((0, $4e6a98b76c0d0a37$export$8ee0fc9ee280b4ee)()) {
        // Only none is supported in Node.js.
        $839307959896a1aa$var$_assert$3(persistence === $839307959896a1aa$var$Persistence.NONE, auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
        return;
    }
    if ($839307959896a1aa$var$_isWorker()) {
        // In a worker environment, either LOCAL or NONE are supported.
        // If indexedDB not supported and LOCAL provided, throw an error
        $839307959896a1aa$var$_assert$3(persistence === $839307959896a1aa$var$Persistence.NONE || persistence === $839307959896a1aa$var$Persistence.LOCAL && (0, $4e6a98b76c0d0a37$export$3865db50535c2055)(), auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
        return;
    }
    // This is restricted by what the browser supports.
    $839307959896a1aa$var$_assert$3(persistence === $839307959896a1aa$var$Persistence.NONE || $839307959896a1aa$var$_isWebStorageSupported(), auth, "unsupported-persistence-type" /* exp.AuthErrorCode.UNSUPPORTED_PERSISTENCE */ );
}
async function $839307959896a1aa$var$_savePersistenceForRedirect(auth) {
    await auth._initializationPromise;
    const session = $839307959896a1aa$var$getSessionStorageIfAvailable();
    const key = $8c61e6dd391f935a$export$53a70dd1ebbae346($839307959896a1aa$var$PERSISTENCE_KEY, auth.config.apiKey, auth.name);
    if (session) session.setItem(key, auth._getPersistenceType());
}
function $839307959896a1aa$var$_getPersistencesFromRedirect(apiKey, appName) {
    const session = $839307959896a1aa$var$getSessionStorageIfAvailable();
    if (!session) return [];
    const key = $8c61e6dd391f935a$export$53a70dd1ebbae346($839307959896a1aa$var$PERSISTENCE_KEY, apiKey, appName);
    const persistence = session.getItem(key);
    switch(persistence){
        case $839307959896a1aa$var$Persistence.NONE:
            return [
                $8c61e6dd391f935a$export$e7c866399fa523f5
            ];
        case $839307959896a1aa$var$Persistence.LOCAL:
            return [
                $8c61e6dd391f935a$export$23f2a1d2818174ef,
                $8c61e6dd391f935a$export$db3b6bfb95261072
            ];
        case $839307959896a1aa$var$Persistence.SESSION:
            return [
                $8c61e6dd391f935a$export$db3b6bfb95261072
            ];
        default:
            return [];
    }
}
/** Returns session storage, or null if the property access errors */ function $839307959896a1aa$var$getSessionStorageIfAvailable() {
    var _a;
    try {
        return ((_a = $839307959896a1aa$var$_getSelfWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) || null;
    } catch (e) {
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $839307959896a1aa$var$_assert$2 = $8c61e6dd391f935a$export$24baa2b76016ce0e;
/** Platform-agnostic popup-redirect resolver */ class $839307959896a1aa$var$CompatPopupRedirectResolver {
    constructor(){
        // Create both resolvers for dynamic resolution later
        this.browserResolver = $8c61e6dd391f935a$export$cf2f7c5792f80b46($8c61e6dd391f935a$export$953cecd6e717a553);
        this.cordovaResolver = $8c61e6dd391f935a$export$cf2f7c5792f80b46($bc401b4e68da01a3$export$2528817c27f24e17);
        // The actual resolver in use: either browserResolver or cordovaResolver.
        this.underlyingResolver = null;
        this._redirectPersistence = $8c61e6dd391f935a$export$db3b6bfb95261072;
        this._completeRedirectFn = $8c61e6dd391f935a$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $8c61e6dd391f935a$export$b9a6b53f9be3734;
    }
    async _initialize(auth) {
        await this.selectUnderlyingResolver();
        return this.assertedUnderlyingResolver._initialize(auth);
    }
    async _openPopup(auth, provider, authType, eventId) {
        await this.selectUnderlyingResolver();
        return this.assertedUnderlyingResolver._openPopup(auth, provider, authType, eventId);
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this.selectUnderlyingResolver();
        return this.assertedUnderlyingResolver._openRedirect(auth, provider, authType, eventId);
    }
    _isIframeWebStorageSupported(auth, cb) {
        this.assertedUnderlyingResolver._isIframeWebStorageSupported(auth, cb);
    }
    _originValidation(auth) {
        return this.assertedUnderlyingResolver._originValidation(auth);
    }
    get _shouldInitProactively() {
        return $839307959896a1aa$var$_isLikelyCordova() || this.browserResolver._shouldInitProactively;
    }
    get assertedUnderlyingResolver() {
        $839307959896a1aa$var$_assert$2(this.underlyingResolver, "internal-error" /* exp.AuthErrorCode.INTERNAL_ERROR */ );
        return this.underlyingResolver;
    }
    async selectUnderlyingResolver() {
        if (this.underlyingResolver) return;
        // We haven't yet determined whether or not we're in Cordova; go ahead
        // and determine that state now.
        const isCordova = await $839307959896a1aa$var$_isCordova();
        this.underlyingResolver = isCordova ? this.cordovaResolver : this.browserResolver;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $839307959896a1aa$var$unwrap(object) {
    return object.unwrap();
}
function $839307959896a1aa$var$wrapped(object) {
    return object.wrapped();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $839307959896a1aa$var$credentialFromResponse(userCredential) {
    return $839307959896a1aa$var$credentialFromObject(userCredential);
}
function $839307959896a1aa$var$attachExtraErrorFields(auth, e) {
    var _a;
    // The response contains all fields from the server which may or may not
    // actually match the underlying type
    const response = (_a = e.customData) === null || _a === void 0 ? void 0 : _a._tokenResponse;
    if ((e === null || e === void 0 ? void 0 : e.code) === 'auth/multi-factor-auth-required') {
        const mfaErr = e;
        mfaErr.resolver = new $839307959896a1aa$var$MultiFactorResolver(auth, $8c61e6dd391f935a$export$493d36ec626b6698(auth, e));
    } else if (response) {
        const credential = $839307959896a1aa$var$credentialFromObject(e);
        const credErr = e;
        if (credential) {
            credErr.credential = credential;
            credErr.tenantId = response.tenantId || undefined;
            credErr.email = response.email || undefined;
            credErr.phoneNumber = response.phoneNumber || undefined;
        }
    }
}
function $839307959896a1aa$var$credentialFromObject(object) {
    const { _tokenResponse: _tokenResponse } = object instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56) ? object.customData : object;
    if (!_tokenResponse) return null;
    // Handle phone Auth credential responses, as they have a different format
    // from other backend responses (i.e. no providerId). This is also only the
    // case for user credentials (does not work for errors).
    if (!(object instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56))) {
        if ('temporaryProof' in _tokenResponse && 'phoneNumber' in _tokenResponse) return $8c61e6dd391f935a$export$56c0d5a1e737357d.credentialFromResult(object);
    }
    const providerId = _tokenResponse.providerId;
    // Email and password is not supported as there is no situation where the
    // server would return the password to the client.
    if (!providerId || providerId === $8c61e6dd391f935a$export$9e5f44173e64f162.PASSWORD) return null;
    let provider;
    switch(providerId){
        case $8c61e6dd391f935a$export$9e5f44173e64f162.GOOGLE:
            provider = $8c61e6dd391f935a$export$8743009a87fcb00f;
            break;
        case $8c61e6dd391f935a$export$9e5f44173e64f162.FACEBOOK:
            provider = $8c61e6dd391f935a$export$78acf4525d8a74c4;
            break;
        case $8c61e6dd391f935a$export$9e5f44173e64f162.GITHUB:
            provider = $8c61e6dd391f935a$export$dc98b0b04f4c7758;
            break;
        case $8c61e6dd391f935a$export$9e5f44173e64f162.TWITTER:
            provider = $8c61e6dd391f935a$export$34aec0b863436764;
            break;
        default:
            const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce } = _tokenResponse;
            if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
            // TODO(avolkovi): uncomment this and get it working with SAML & OIDC
            if (pendingToken) {
                if (providerId.startsWith('saml.')) return $8c61e6dd391f935a$export$738ab4df8bf92ae9._create(providerId, pendingToken);
                else // OIDC and non-default providers excluding Twitter.
                return $8c61e6dd391f935a$export$3722cfe417b6ed86._fromParams({
                    providerId: providerId,
                    signInMethod: providerId,
                    pendingToken: pendingToken,
                    idToken: oauthIdToken,
                    accessToken: oauthAccessToken
                });
            }
            return new $8c61e6dd391f935a$export$71511d61b312f219(providerId).credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                rawNonce: nonce
            });
    }
    return object instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56) ? provider.credentialFromError(object) : provider.credentialFromResult(object);
}
function $839307959896a1aa$var$convertCredential(auth, credentialPromise) {
    return credentialPromise.catch((e)=>{
        if (e instanceof (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56)) $839307959896a1aa$var$attachExtraErrorFields(auth, e);
        throw e;
    }).then((credential)=>{
        const operationType = credential.operationType;
        const user = credential.user;
        return {
            operationType: operationType,
            credential: $839307959896a1aa$var$credentialFromResponse(credential),
            additionalUserInfo: $8c61e6dd391f935a$export$d24c54395ce0c509(credential),
            user: $839307959896a1aa$var$User.getOrCreate(user)
        };
    });
}
async function $839307959896a1aa$var$convertConfirmationResult(auth, confirmationResultPromise) {
    const confirmationResultExp = await confirmationResultPromise;
    return {
        verificationId: confirmationResultExp.verificationId,
        confirm: (verificationCode)=>$839307959896a1aa$var$convertCredential(auth, confirmationResultExp.confirm(verificationCode))
    };
}
class $839307959896a1aa$var$MultiFactorResolver {
    constructor(auth, resolver){
        this.resolver = resolver;
        this.auth = $839307959896a1aa$var$wrapped(auth);
    }
    get session() {
        return this.resolver.session;
    }
    get hints() {
        return this.resolver.hints;
    }
    resolveSignIn(assertion) {
        return $839307959896a1aa$var$convertCredential($839307959896a1aa$var$unwrap(this.auth), this.resolver.resolveSignIn(assertion));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $839307959896a1aa$var$User {
    constructor(_delegate){
        this._delegate = _delegate;
        this.multiFactor = $8c61e6dd391f935a$export$1fbe638ecf81657e(_delegate);
    }
    static getOrCreate(user) {
        if (!$839307959896a1aa$var$User.USER_MAP.has(user)) $839307959896a1aa$var$User.USER_MAP.set(user, new $839307959896a1aa$var$User(user));
        return $839307959896a1aa$var$User.USER_MAP.get(user);
    }
    delete() {
        return this._delegate.delete();
    }
    reload() {
        return this._delegate.reload();
    }
    toJSON() {
        return this._delegate.toJSON();
    }
    getIdTokenResult(forceRefresh) {
        return this._delegate.getIdTokenResult(forceRefresh);
    }
    getIdToken(forceRefresh) {
        return this._delegate.getIdToken(forceRefresh);
    }
    linkAndRetrieveDataWithCredential(credential) {
        return this.linkWithCredential(credential);
    }
    async linkWithCredential(credential) {
        return $839307959896a1aa$var$convertCredential(this.auth, $8c61e6dd391f935a$export$6559d589eb85fbb6(this._delegate, credential));
    }
    async linkWithPhoneNumber(phoneNumber, applicationVerifier) {
        return $839307959896a1aa$var$convertConfirmationResult(this.auth, $8c61e6dd391f935a$export$882b5998b3b9117c(this._delegate, phoneNumber, applicationVerifier));
    }
    async linkWithPopup(provider) {
        return $839307959896a1aa$var$convertCredential(this.auth, $8c61e6dd391f935a$export$f1e1789686576879(this._delegate, provider, $839307959896a1aa$var$CompatPopupRedirectResolver));
    }
    async linkWithRedirect(provider) {
        await $839307959896a1aa$var$_savePersistenceForRedirect($8c61e6dd391f935a$export$23ebac1979863676(this.auth));
        return $8c61e6dd391f935a$export$dda1d9f60106f0e9(this._delegate, provider, $839307959896a1aa$var$CompatPopupRedirectResolver);
    }
    reauthenticateAndRetrieveDataWithCredential(credential) {
        return this.reauthenticateWithCredential(credential);
    }
    async reauthenticateWithCredential(credential) {
        return $839307959896a1aa$var$convertCredential(this.auth, $8c61e6dd391f935a$export$efca4cbe5dd06740(this._delegate, credential));
    }
    reauthenticateWithPhoneNumber(phoneNumber, applicationVerifier) {
        return $839307959896a1aa$var$convertConfirmationResult(this.auth, $8c61e6dd391f935a$export$43caf9889c228507(this._delegate, phoneNumber, applicationVerifier));
    }
    reauthenticateWithPopup(provider) {
        return $839307959896a1aa$var$convertCredential(this.auth, $8c61e6dd391f935a$export$2d1720544b23b823(this._delegate, provider, $839307959896a1aa$var$CompatPopupRedirectResolver));
    }
    async reauthenticateWithRedirect(provider) {
        await $839307959896a1aa$var$_savePersistenceForRedirect($8c61e6dd391f935a$export$23ebac1979863676(this.auth));
        return $8c61e6dd391f935a$export$35e795649ee09318(this._delegate, provider, $839307959896a1aa$var$CompatPopupRedirectResolver);
    }
    sendEmailVerification(actionCodeSettings) {
        return $8c61e6dd391f935a$export$995eb9fca571757(this._delegate, actionCodeSettings);
    }
    async unlink(providerId) {
        await $8c61e6dd391f935a$export$8a5498727ef6be21(this._delegate, providerId);
        return this;
    }
    updateEmail(newEmail) {
        return $8c61e6dd391f935a$export$1a82df3d29112e01(this._delegate, newEmail);
    }
    updatePassword(newPassword) {
        return $8c61e6dd391f935a$export$306ddfe3a8403e2(this._delegate, newPassword);
    }
    updatePhoneNumber(phoneCredential) {
        return $8c61e6dd391f935a$export$3b14a55fb2447963(this._delegate, phoneCredential);
    }
    updateProfile(profile) {
        return $8c61e6dd391f935a$export$ab83b03e4111b1d0(this._delegate, profile);
    }
    verifyBeforeUpdateEmail(newEmail, actionCodeSettings) {
        return $8c61e6dd391f935a$export$f38c853ae54ed474(this._delegate, newEmail, actionCodeSettings);
    }
    get emailVerified() {
        return this._delegate.emailVerified;
    }
    get isAnonymous() {
        return this._delegate.isAnonymous;
    }
    get metadata() {
        return this._delegate.metadata;
    }
    get phoneNumber() {
        return this._delegate.phoneNumber;
    }
    get providerData() {
        return this._delegate.providerData;
    }
    get refreshToken() {
        return this._delegate.refreshToken;
    }
    get tenantId() {
        return this._delegate.tenantId;
    }
    get displayName() {
        return this._delegate.displayName;
    }
    get email() {
        return this._delegate.email;
    }
    get photoURL() {
        return this._delegate.photoURL;
    }
    get providerId() {
        return this._delegate.providerId;
    }
    get uid() {
        return this._delegate.uid;
    }
    get auth() {
        return this._delegate.auth;
    }
}
// Maintain a map so that there's always a 1:1 mapping between new User and
// legacy compat users
$839307959896a1aa$var$User.USER_MAP = new WeakMap();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $839307959896a1aa$var$_assert$1 = $8c61e6dd391f935a$export$24baa2b76016ce0e;
class $839307959896a1aa$var$Auth {
    constructor(app, provider){
        this.app = app;
        if (provider.isInitialized()) {
            this._delegate = provider.getImmediate();
            this.linkUnderlyingAuth();
            return;
        }
        const { apiKey: apiKey } = app.options;
        // TODO: platform needs to be determined using heuristics
        $839307959896a1aa$var$_assert$1(apiKey, "invalid-api-key" /* exp.AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        // TODO: platform needs to be determined using heuristics
        $839307959896a1aa$var$_assert$1(apiKey, "invalid-api-key" /* exp.AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        // Only use a popup/redirect resolver in browser environments
        const resolver = typeof window !== 'undefined' ? $839307959896a1aa$var$CompatPopupRedirectResolver : undefined;
        this._delegate = provider.initialize({
            options: {
                persistence: $839307959896a1aa$var$buildPersistenceHierarchy(apiKey, app.name),
                popupRedirectResolver: resolver
            }
        });
        this._delegate._updateErrorMap($8c61e6dd391f935a$export$7f8ddf7c7c20b3cd);
        this.linkUnderlyingAuth();
    }
    get emulatorConfig() {
        return this._delegate.emulatorConfig;
    }
    get currentUser() {
        if (!this._delegate.currentUser) return null;
        return $839307959896a1aa$var$User.getOrCreate(this._delegate.currentUser);
    }
    get languageCode() {
        return this._delegate.languageCode;
    }
    set languageCode(languageCode) {
        this._delegate.languageCode = languageCode;
    }
    get settings() {
        return this._delegate.settings;
    }
    get tenantId() {
        return this._delegate.tenantId;
    }
    set tenantId(tid) {
        this._delegate.tenantId = tid;
    }
    useDeviceLanguage() {
        this._delegate.useDeviceLanguage();
    }
    signOut() {
        return this._delegate.signOut();
    }
    useEmulator(url, options) {
        $8c61e6dd391f935a$export$61196ced6d74a310(this._delegate, url, options);
    }
    applyActionCode(code) {
        return $8c61e6dd391f935a$export$c3950d9923825c02(this._delegate, code);
    }
    checkActionCode(code) {
        return $8c61e6dd391f935a$export$a9c996f45e5784d0(this._delegate, code);
    }
    confirmPasswordReset(code, newPassword) {
        return $8c61e6dd391f935a$export$a93c5207d687da10(this._delegate, code, newPassword);
    }
    async createUserWithEmailAndPassword(email, password) {
        return $839307959896a1aa$var$convertCredential(this._delegate, $8c61e6dd391f935a$export$555508cbc6add439(this._delegate, email, password));
    }
    fetchProvidersForEmail(email) {
        return this.fetchSignInMethodsForEmail(email);
    }
    fetchSignInMethodsForEmail(email) {
        return $8c61e6dd391f935a$export$ee7c8ad385a60b7b(this._delegate, email);
    }
    isSignInWithEmailLink(emailLink) {
        return $8c61e6dd391f935a$export$f787f51d84a910ad(this._delegate, emailLink);
    }
    async getRedirectResult() {
        $839307959896a1aa$var$_assert$1($839307959896a1aa$var$_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment" /* exp.AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const credential = await $8c61e6dd391f935a$export$342063e11d6c3cad(this._delegate, $839307959896a1aa$var$CompatPopupRedirectResolver);
        if (!credential) return {
            credential: null,
            user: null
        };
        return $839307959896a1aa$var$convertCredential(this._delegate, Promise.resolve(credential));
    }
    // This function should only be called by frameworks (e.g. FirebaseUI-web) to log their usage.
    // It is not intended for direct use by developer apps. NO jsdoc here to intentionally leave it
    // out of autogenerated documentation pages to reduce accidental misuse.
    addFrameworkForLogging(framework) {
        $bc401b4e68da01a3$export$f469bed1b0fbb94f(this._delegate, framework);
    }
    onAuthStateChanged(nextOrObserver, errorFn, completed) {
        const { next: next, error: error, complete: complete } = $839307959896a1aa$var$wrapObservers(nextOrObserver, errorFn, completed);
        return this._delegate.onAuthStateChanged(next, error, complete);
    }
    onIdTokenChanged(nextOrObserver, errorFn, completed) {
        const { next: next, error: error, complete: complete } = $839307959896a1aa$var$wrapObservers(nextOrObserver, errorFn, completed);
        return this._delegate.onIdTokenChanged(next, error, complete);
    }
    sendSignInLinkToEmail(email, actionCodeSettings) {
        return $8c61e6dd391f935a$export$4c3d22f3d993c33f(this._delegate, email, actionCodeSettings);
    }
    sendPasswordResetEmail(email, actionCodeSettings) {
        return $8c61e6dd391f935a$export$2e2af4578d910ddf(this._delegate, email, actionCodeSettings || undefined);
    }
    async setPersistence(persistence) {
        $839307959896a1aa$var$_validatePersistenceArgument(this._delegate, persistence);
        let converted;
        switch(persistence){
            case $839307959896a1aa$var$Persistence.SESSION:
                converted = $8c61e6dd391f935a$export$db3b6bfb95261072;
                break;
            case $839307959896a1aa$var$Persistence.LOCAL:
                // Not using isIndexedDBAvailable() since it only checks if indexedDB is defined.
                const isIndexedDBFullySupported = await $8c61e6dd391f935a$export$cf2f7c5792f80b46($8c61e6dd391f935a$export$23f2a1d2818174ef)._isAvailable();
                converted = isIndexedDBFullySupported ? $8c61e6dd391f935a$export$23f2a1d2818174ef : $8c61e6dd391f935a$export$8b22cf2602fb60ce;
                break;
            case $839307959896a1aa$var$Persistence.NONE:
                converted = $8c61e6dd391f935a$export$e7c866399fa523f5;
                break;
            default:
                return $8c61e6dd391f935a$export$28f7fcd39efa255("argument-error" /* exp.AuthErrorCode.ARGUMENT_ERROR */ , {
                    appName: this._delegate.name
                });
        }
        return this._delegate.setPersistence(converted);
    }
    signInAndRetrieveDataWithCredential(credential) {
        return this.signInWithCredential(credential);
    }
    signInAnonymously() {
        return $839307959896a1aa$var$convertCredential(this._delegate, $8c61e6dd391f935a$export$3c2fa207a37baaea(this._delegate));
    }
    signInWithCredential(credential) {
        return $839307959896a1aa$var$convertCredential(this._delegate, $8c61e6dd391f935a$export$ce26c07117d59d6a(this._delegate, credential));
    }
    signInWithCustomToken(token) {
        return $839307959896a1aa$var$convertCredential(this._delegate, $8c61e6dd391f935a$export$a8550f7dbe79f93a(this._delegate, token));
    }
    signInWithEmailAndPassword(email, password) {
        return $839307959896a1aa$var$convertCredential(this._delegate, $8c61e6dd391f935a$export$2219238a014317b0(this._delegate, email, password));
    }
    signInWithEmailLink(email, emailLink) {
        return $839307959896a1aa$var$convertCredential(this._delegate, $8c61e6dd391f935a$export$c9170ad7d4cd7e57(this._delegate, email, emailLink));
    }
    signInWithPhoneNumber(phoneNumber, applicationVerifier) {
        return $839307959896a1aa$var$convertConfirmationResult(this._delegate, $8c61e6dd391f935a$export$2408f22a0fab9ae5(this._delegate, phoneNumber, applicationVerifier));
    }
    async signInWithPopup(provider) {
        $839307959896a1aa$var$_assert$1($839307959896a1aa$var$_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment" /* exp.AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        return $839307959896a1aa$var$convertCredential(this._delegate, $8c61e6dd391f935a$export$4368d992c4eafac0(this._delegate, provider, $839307959896a1aa$var$CompatPopupRedirectResolver));
    }
    async signInWithRedirect(provider) {
        $839307959896a1aa$var$_assert$1($839307959896a1aa$var$_isPopupRedirectSupported(), this._delegate, "operation-not-supported-in-this-environment" /* exp.AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        await $839307959896a1aa$var$_savePersistenceForRedirect(this._delegate);
        return $8c61e6dd391f935a$export$39b482c5e57630a8(this._delegate, provider, $839307959896a1aa$var$CompatPopupRedirectResolver);
    }
    updateCurrentUser(user) {
        // remove ts-ignore once overloads are defined for exp functions to accept compat objects
        // @ts-ignore
        return this._delegate.updateCurrentUser(user);
    }
    verifyPasswordResetCode(code) {
        return $8c61e6dd391f935a$export$7910e0436ed8d1de(this._delegate, code);
    }
    unwrap() {
        return this._delegate;
    }
    _delete() {
        return this._delegate._delete();
    }
    linkUnderlyingAuth() {
        this._delegate.wrapped = ()=>this;
    }
}
$839307959896a1aa$var$Auth.Persistence = $839307959896a1aa$var$Persistence;
function $839307959896a1aa$var$wrapObservers(nextOrObserver, error, complete) {
    let next = nextOrObserver;
    if (typeof nextOrObserver !== 'function') ({ next: next, error: error, complete: complete } = nextOrObserver);
    // We know 'next' is now a function
    const oldNext = next;
    const newNext = (user)=>oldNext(user && $839307959896a1aa$var$User.getOrCreate(user));
    return {
        next: newNext,
        error: error,
        complete: complete
    };
}
function $839307959896a1aa$var$buildPersistenceHierarchy(apiKey, appName) {
    // Note this is slightly different behavior: in this case, the stored
    // persistence is checked *first* rather than last. This is because we want
    // to prefer stored persistence type in the hierarchy. This is an empty
    // array if window is not available or there is no pending redirect
    const persistences = $839307959896a1aa$var$_getPersistencesFromRedirect(apiKey, appName);
    // If "self" is available, add indexedDB
    if (typeof self !== 'undefined' && !persistences.includes($8c61e6dd391f935a$export$23f2a1d2818174ef)) persistences.push($8c61e6dd391f935a$export$23f2a1d2818174ef);
    // If "window" is available, add HTML Storage persistences
    if (typeof window !== 'undefined') {
        for (const persistence of [
            $8c61e6dd391f935a$export$8b22cf2602fb60ce,
            $8c61e6dd391f935a$export$db3b6bfb95261072
        ])if (!persistences.includes(persistence)) persistences.push(persistence);
    }
    // Add in-memory as a final fallback
    if (!persistences.includes($8c61e6dd391f935a$export$e7c866399fa523f5)) persistences.push($8c61e6dd391f935a$export$e7c866399fa523f5);
    return persistences;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $839307959896a1aa$var$PhoneAuthProvider {
    static credential(verificationId, verificationCode) {
        return $8c61e6dd391f935a$export$56c0d5a1e737357d.credential(verificationId, verificationCode);
    }
    constructor(){
        this.providerId = 'phone';
        // TODO: remove ts-ignore when moving types from auth-types to auth-compat
        // @ts-ignore
        this._delegate = new $8c61e6dd391f935a$export$56c0d5a1e737357d($839307959896a1aa$var$unwrap((0, $fa83d0b019b2237e$export$2e2bcd8739ae039).auth()));
    }
    verifyPhoneNumber(phoneInfoOptions, applicationVerifier) {
        return this._delegate.verifyPhoneNumber(// The implementation matches but the types are subtly incompatible
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        phoneInfoOptions, applicationVerifier);
    }
    unwrap() {
        return this._delegate;
    }
}
$839307959896a1aa$var$PhoneAuthProvider.PHONE_SIGN_IN_METHOD = $8c61e6dd391f935a$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD;
$839307959896a1aa$var$PhoneAuthProvider.PROVIDER_ID = $8c61e6dd391f935a$export$56c0d5a1e737357d.PROVIDER_ID;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $839307959896a1aa$var$_assert = $8c61e6dd391f935a$export$24baa2b76016ce0e;
class $839307959896a1aa$var$RecaptchaVerifier {
    constructor(container, parameters, app = (0, $fa83d0b019b2237e$export$2e2bcd8739ae039).app()){
        var _a;
        // API key is required for web client RPC calls.
        $839307959896a1aa$var$_assert((_a = app.options) === null || _a === void 0 ? void 0 : _a.apiKey, "invalid-api-key" /* exp.AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        this._delegate = new $8c61e6dd391f935a$export$db202ddc8be9136(// TODO: remove ts-ignore when moving types from auth-types to auth-compat
        // @ts-ignore
        app.auth(), container, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        parameters);
        this.type = this._delegate.type;
    }
    clear() {
        this._delegate.clear();
    }
    render() {
        return this._delegate.render();
    }
    verify() {
        return this._delegate.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $839307959896a1aa$var$AUTH_TYPE = 'auth-compat';
// Create auth components to register with firebase.
// Provides Auth public APIs.
function $839307959896a1aa$var$registerAuthCompat(instance) {
    instance.INTERNAL.registerComponent(new (0, $3ba5282a700177ce$export$16fa2f45be04daa8)($839307959896a1aa$var$AUTH_TYPE, (container)=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app-compat').getImmediate();
        const authProvider = container.getProvider('auth');
        return new $839307959896a1aa$var$Auth(app, authProvider);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setServiceProps({
        ActionCodeInfo: {
            Operation: {
                EMAIL_SIGNIN: $8c61e6dd391f935a$export$ebd11618f299a286.EMAIL_SIGNIN,
                PASSWORD_RESET: $8c61e6dd391f935a$export$ebd11618f299a286.PASSWORD_RESET,
                RECOVER_EMAIL: $8c61e6dd391f935a$export$ebd11618f299a286.RECOVER_EMAIL,
                REVERT_SECOND_FACTOR_ADDITION: $8c61e6dd391f935a$export$ebd11618f299a286.REVERT_SECOND_FACTOR_ADDITION,
                VERIFY_AND_CHANGE_EMAIL: $8c61e6dd391f935a$export$ebd11618f299a286.VERIFY_AND_CHANGE_EMAIL,
                VERIFY_EMAIL: $8c61e6dd391f935a$export$ebd11618f299a286.VERIFY_EMAIL
            }
        },
        EmailAuthProvider: $8c61e6dd391f935a$export$71cec2538cb2c617,
        FacebookAuthProvider: $8c61e6dd391f935a$export$78acf4525d8a74c4,
        GithubAuthProvider: $8c61e6dd391f935a$export$dc98b0b04f4c7758,
        GoogleAuthProvider: $8c61e6dd391f935a$export$8743009a87fcb00f,
        OAuthProvider: $8c61e6dd391f935a$export$71511d61b312f219,
        SAMLAuthProvider: $8c61e6dd391f935a$export$3d8c2f653ac9d0b9,
        PhoneAuthProvider: $839307959896a1aa$var$PhoneAuthProvider,
        PhoneMultiFactorGenerator: $8c61e6dd391f935a$export$7ccc53e8f1e7dfc5,
        RecaptchaVerifier: $839307959896a1aa$var$RecaptchaVerifier,
        TwitterAuthProvider: $8c61e6dd391f935a$export$34aec0b863436764,
        Auth: $839307959896a1aa$var$Auth,
        AuthCredential: $8c61e6dd391f935a$export$3a1a48c8f6ef640e,
        Error: (0, $4e6a98b76c0d0a37$export$dd24e9cd51226c56)
    }).setInstantiationMode("LAZY" /* InstantiationMode.LAZY */ ).setMultipleInstances(false));
    instance.registerVersion($839307959896a1aa$var$name, $839307959896a1aa$var$version);
}
$839307959896a1aa$var$registerAuthCompat((0, $fa83d0b019b2237e$export$2e2bcd8739ae039));




const $5f7ab37ddb79268c$var$firebaseConfig = {
    apiKey: "AIzaSyAnQkuuL0wu69L3FNsRcRnPA-g394z1W1M",
    authDomain: "bw-planning-poker.firebaseapp.com",
    databaseURL: "https://bw-planning-poker-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "bw-planning-poker",
    storageBucket: "bw-planning-poker.firebasestorage.app",
    messagingSenderId: "647445875111",
    appId: "1:647445875111:web:95f841ca4d0a6cd68c4e82"
};
// Initialize Firebase
if (!(0, $fa83d0b019b2237e$export$2e2bcd8739ae039).apps.length) (0, $fa83d0b019b2237e$export$2e2bcd8739ae039).initializeApp($5f7ab37ddb79268c$var$firebaseConfig);
const $5f7ab37ddb79268c$export$f932f06c7eb6abeb = (0, $fa83d0b019b2237e$export$2e2bcd8739ae039).database();
const $5f7ab37ddb79268c$export$73693bad9f5880b0 = (0, $fa83d0b019b2237e$export$2e2bcd8739ae039).auth();
var $5f7ab37ddb79268c$export$2e2bcd8739ae039 = (0, $fa83d0b019b2237e$export$2e2bcd8739ae039);


const $80df39b5d570f70c$export$ebd0aaf6e6c967e5 = async ()=>{
    try {
        // First check if user is already signed in
        let currentUser = (0, $5f7ab37ddb79268c$export$73693bad9f5880b0).currentUser;
        if (!currentUser) {
            // Sign in anonymously if not already signed in
            const userCredential = await (0, $5f7ab37ddb79268c$export$73693bad9f5880b0).signInAnonymously();
            currentUser = userCredential.user;
        }
        if (!currentUser) throw new Error('Failed to sign in anonymously');
        return currentUser.uid;
    } catch (error) {
        console.error('Error signing in anonymously:', error);
        throw error;
    }
};
const $80df39b5d570f70c$export$9f4a692b5a33c91f = async (roomCode, userId)=>{
    try {
        const roomRef = (0, $fa83d0b019b2237e$export$2e2bcd8739ae039).database().ref(`rooms/${roomCode}`);
        const roomSnapshot = await roomRef.once('value');
        if (!roomSnapshot.exists()) return false;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const roomData = roomSnapshot.val();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
        return roomData.participants[userId]?.isAdmin || false;
    } catch (error) {
        console.error('Error checking admin status:', error);
        return false;
    }
};
const $80df39b5d570f70c$export$e9dbbdd5c9d6144f = async ()=>{
    // Firebase will persist the auth state automatically with localStorage
    // This function is mainly to trigger initialization early
    try {
        await (0, $5f7ab37ddb79268c$export$73693bad9f5880b0).signInAnonymously();
        // Set up auth state listener for debugging
        (0, $5f7ab37ddb79268c$export$73693bad9f5880b0).onAuthStateChanged((user)=>{
            if (user) console.log('User is signed in anonymously with ID:', user.uid);
            else console.log('User is signed out');
        });
    } catch (error) {
        console.error('Error initializing auth:', error);
    }
};




const $4cc3d49d3269c10d$export$564a3bb759e84e42 = ()=>{
    return Math.random().toString(36).substring(2, 8).toUpperCase();
};
const $4cc3d49d3269c10d$export$5805271a0f1d493 = {
    fibonacci: [
        '0',
        '1',
        '2',
        '3',
        '5',
        '8',
        '13',
        '21',
        '34',
        '?'
    ],
    bau: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10'
    ],
    tshirt: [
        'XXS',
        'XS',
        'S',
        'M',
        'L',
        'XL',
        '?'
    ],
    powers: [
        '0',
        '1',
        '2',
        '4',
        '8',
        '16',
        '32',
        '64',
        '?'
    ],
    custom: []
};
const $4cc3d49d3269c10d$export$4a6fbf23fa252689 = async (roomName, creatorName, deckType = 'fibonacci', customValues = [])=>{
    const userId = await (0, $80df39b5d570f70c$export$ebd0aaf6e6c967e5)();
    const roomCode = $4cc3d49d3269c10d$export$564a3bb759e84e42();
    let cardValues = [
        ...$4cc3d49d3269c10d$export$5805271a0f1d493[deckType]
    ];
    if (deckType === 'custom' && customValues.length > 0) cardValues = Array.from(new Set(customValues));
    else if (deckType === 'custom') {
        deckType = 'fibonacci';
        cardValues = [
            ...$4cc3d49d3269c10d$export$5805271a0f1d493[deckType]
        ];
    }
    const roomData = {
        id: roomCode,
        name: roomName,
        createdAt: Date.now(),
        creatorId: userId,
        currentRound: null,
        rounds: {},
        participants: {
            [userId]: {
                id: userId,
                name: creatorName,
                isActive: true,
                lastSeen: Date.now(),
                isAdmin: true
            }
        },
        cardDeck: {
            type: deckType,
            values: cardValues
        }
    };
    await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}`).set(roomData);
    localStorage.setItem(`pp_lastRoom`, roomCode);
    localStorage.setItem(`pp_${roomCode}_userName`, creatorName);
    return {
        roomCode: roomCode,
        userId: userId
    };
};
const $4cc3d49d3269c10d$export$767472c72ffc2784 = async (roomCode, userName)=>{
    const userId = await (0, $80df39b5d570f70c$export$ebd0aaf6e6c967e5)();
    const roomRef = (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}`);
    const roomSnapshot = await roomRef.once('value');
    if (!roomSnapshot.exists()) throw new Error('Room not found');
    const participantRef = roomRef.child(`participants/${userId}`);
    const participantSnapshot = await participantRef.once('value');
    if (participantSnapshot.exists()) await participantRef.update({
        name: userName,
        isActive: true,
        lastSeen: Date.now()
    });
    else {
        const participant = {
            id: userId,
            name: userName,
            isActive: true,
            lastSeen: Date.now(),
            isAdmin: false
        };
        await roomRef.child(`participants/${userId}`).set(participant);
    }
    // Set up presence handlers for disconnect
    await participantRef.onDisconnect().update({
        isActive: false,
        lastSeen: Date.now()
    });
    // Store the room code in localStorage for convenience
    localStorage.setItem(`pp_lastRoom`, roomCode);
    localStorage.setItem(`pp_${roomCode}_userName`, userName);
    return userId;
};
const $4cc3d49d3269c10d$export$acfa0decbf1145d3 = async (roomCode, deckType, customValues = [])=>{
    let cardValues = [
        ...$4cc3d49d3269c10d$export$5805271a0f1d493[deckType]
    ];
    if (deckType === 'custom' && customValues.length > 0) cardValues = Array.from(new Set(customValues));
    else if (deckType === 'custom') {
        deckType = 'fibonacci';
        cardValues = [
            ...$4cc3d49d3269c10d$export$5805271a0f1d493[deckType]
        ];
    }
    await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/cardDeck`).set({
        type: deckType,
        values: cardValues
    });
};
const $4cc3d49d3269c10d$export$50ff9bae65ce21fe = async (roomCode, description)=>{
    const roundId = `round_${Date.now()}`;
    const roundData = {
        id: roundId,
        description: description,
        revealed: false,
        startedAt: Date.now(),
        votes: {}
    };
    await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/rounds/${roundId}`).set(roundData);
    await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/currentRound`).set(roundId);
    return roundId;
};
const $4cc3d49d3269c10d$export$b6daf3119ce2fd97 = async (roomCode, roundId, userId, value)=>{
    const vote = {
        userId: userId,
        value: value,
        timestamp: Date.now()
    };
    await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/rounds/${roundId}/votes/${userId}`).set(vote);
};
const $4cc3d49d3269c10d$export$a73b8ae7b8aea93a = async (roomCode, roundId)=>{
    await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/rounds/${roundId}/revealed`).set(true);
};
const $4cc3d49d3269c10d$export$953889bdf646ec23 = async (roomCode, userId)=>{
    try {
        const timestamp = Date.now();
        const updates = {
            [`/rooms/${roomCode}/participants/${userId}/lastSeen`]: timestamp,
            [`/rooms/${roomCode}/participants/${userId}/isActive`]: true
        };
        await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref().update(updates);
        // Set up presence handlers
        const userStatusRef = (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`/rooms/${roomCode}/participants/${userId}`);
        // When user disconnects, update their status
        await userStatusRef.onDisconnect().update({
            isActive: false,
            lastSeen: timestamp
        });
    } catch (error) {
        console.error('Error updating user activity:', error);
        throw error;
    }
};



const $9aecac4636d85589$var$HomePage = ()=>{
    const [activeTab, setActiveTab] = (0, $2WGWz.useState)('create');
    const [roomName, setRoomName] = (0, $2WGWz.useState)('');
    const [userName, setUserName] = (0, $2WGWz.useState)('');
    const [roomCode, setRoomCode] = (0, $2WGWz.useState)('');
    const [joinUserName, setJoinUserName] = (0, $2WGWz.useState)('');
    const [error, setError] = (0, $2WGWz.useState)('');
    const [loading, setLoading] = (0, $2WGWz.useState)(false);
    const [deckType, setDeckType] = (0, $2WGWz.useState)('fibonacci');
    const [customValues, setCustomValues] = (0, $2WGWz.useState)('');
    const [showCustomDeck, setShowCustomDeck] = (0, $2WGWz.useState)(false);
    const history = (0, $80c9b230a4f51b6a$export$3420e1dc2c4a518c)();
    // Initialize anonymous auth when the component loads
    (0, $2WGWz.useEffect)(()=>{
        const initAuth = async ()=>{
            try {
                await (0, $80df39b5d570f70c$export$ebd0aaf6e6c967e5)();
                // Check for room code in URL params
                const urlParams = new URLSearchParams(window.location.search);
                const joinRoomCode = urlParams.get('join');
                if (joinRoomCode) {
                    setActiveTab('join');
                    setRoomCode(joinRoomCode);
                }
                // Check if there's a recent room in localStorage
                const lastRoom = localStorage.getItem('pp_lastRoom');
                const lastUserName = lastRoom ? localStorage.getItem(`pp_${lastRoom}_userName`) : null;
                if (lastUserName) {
                    setUserName(lastUserName);
                    setJoinUserName(lastUserName);
                }
            } catch (error) {
                console.error('Error initializing auth:', error);
            }
        };
        initAuth();
    }, []);
    const handleCreateRoom = async ()=>{
        setError('');
        if (!roomName.trim()) {
            setError('Please enter a room name');
            return;
        }
        if (!userName.trim()) {
            setError('Please enter your name');
            return;
        }
        try {
            setLoading(true);
            console.log('Creating room with name:', roomName.trim(), 'and username:', userName.trim());
            let customValueArray = [];
            if (deckType === 'custom' && customValues.trim()) {
                customValueArray = customValues.split(',').map((v)=>v.trim()).filter((v)=>v.length > 0);
                if (customValueArray.length === 0) {
                    setError('Please enter valid custom card values or select a different deck type');
                    setLoading(false);
                    return;
                }
            }
            const { roomCode: newRoomCode } = await (0, $4cc3d49d3269c10d$export$4a6fbf23fa252689)(roomName.trim(), userName.trim(), deckType, deckType === 'custom' ? customValueArray : undefined);
            history.push(`/room/${newRoomCode}`);
        } catch (err) {
            setError('Failed to create room. Please try again.');
            console.error('Room creation error:', err);
        } finally{
            setLoading(false);
        }
    };
    const handleJoinRoom = async ()=>{
        setError('');
        if (!roomCode.trim()) {
            setError('Please enter a room code');
            return;
        }
        if (!joinUserName.trim()) {
            setError('Please enter your name');
            return;
        }
        try {
            setLoading(true);
            const formattedRoomCode = roomCode.trim().toUpperCase();
            await (0, $4cc3d49d3269c10d$export$767472c72ffc2784)(formattedRoomCode, joinUserName.trim());
            history.push(`/room/${formattedRoomCode}`);
        } catch (err) {
            setError('Failed to join room. Please check your room code and try again.');
            console.error('Room join error:', err);
        } finally{
            setLoading(false);
        }
    };
    const handleDeckTypeChange = (e)=>{
        const newType = e.target.value;
        setDeckType(newType);
        setShowCustomDeck(newType === 'custom');
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e1131a681a58b314$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "max-w-md mx-auto p-6",
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                    className: "bg-white dark:bg-dark-card rounded-lg shadow-lg overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                            className: "flex border-b border-gray-200 dark:border-dark-border",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                    onClick: ()=>setActiveTab('create'),
                                    className: `flex-1 py-3 font-medium transition-colors duration-200 ${activeTab === 'create' ? 'bg-primary text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`,
                                    children: "Create Room"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                    onClick: ()=>setActiveTab('join'),
                                    className: `flex-1 py-3 font-medium transition-colors duration-200 ${activeTab === 'join' ? 'bg-primary text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`,
                                    children: "Join Room"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                            className: "p-6",
                            children: [
                                error && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                    className: "mb-4 p-3 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 rounded-md border border-red-200 dark:border-red-800",
                                    children: error
                                }),
                                activeTab === 'create' ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-center mb-6 dark:text-dark-text",
                                            children: "Create a New Room"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                                                    htmlFor: "roomName",
                                                    className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                                                    children: "Room Name"
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
                                                    id: "roomName",
                                                    type: "text",
                                                    value: roomName,
                                                    onChange: (e)=>setRoomName(e.target.value),
                                                    placeholder: "Planning Poker Room",
                                                    className: "input dark:bg-dark-card dark:border-dark-border dark:text-dark-text"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                                                    htmlFor: "userName",
                                                    className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                                                    children: "Your Name"
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
                                                    id: "userName",
                                                    type: "text",
                                                    value: userName,
                                                    onChange: (e)=>setUserName(e.target.value),
                                                    placeholder: "John Doe",
                                                    className: "input dark:bg-dark-card dark:border-dark-border dark:text-dark-text"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                                                    htmlFor: "deckType",
                                                    className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                                                    children: "Card Deck Type"
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("select", {
                                                    id: "deckType",
                                                    value: deckType,
                                                    onChange: handleDeckTypeChange,
                                                    className: "select dark:bg-dark-card dark:border-dark-border dark:text-dark-text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                            value: "fibonacci",
                                                            children: "Fibonacci (0, 1, 2, 3, 5, 8, 13, 21, 34, ?)"
                                                        }),
                                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                            value: "bau",
                                                            children: "BAU (1, 2, 3, 4, 5, 6, 7, 8, 9, 10)"
                                                        }),
                                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                            value: "tshirt",
                                                            children: "T-Shirt Sizes (XXS, XS, S, M, L, XL, ?)"
                                                        }),
                                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                            value: "powers",
                                                            children: "Powers of 2 (0, 1, 2, 4, 8, 16, 32, 64, ?)"
                                                        }),
                                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                                            value: "custom",
                                                            children: "Custom Values"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        showCustomDeck && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                                                    htmlFor: "customValues",
                                                    className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                                                    children: "Custom Card Values (comma-separated)"
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
                                                    id: "customValues",
                                                    type: "text",
                                                    value: customValues,
                                                    onChange: (e)=>setCustomValues(e.target.value),
                                                    placeholder: "1, 2, 3, 5, 8, 13, ?",
                                                    className: "input dark:bg-dark-card dark:border-dark-border dark:text-dark-text"
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                                                    className: "mt-1 text-sm text-gray-500 dark:text-gray-400",
                                                    children: 'Enter values separated by commas. Include "?" for unknown estimates.'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                            onClick: handleCreateRoom,
                                            disabled: loading,
                                            className: `w-full btn ${loading ? 'bg-opacity-70 cursor-not-allowed' : ''} bg-secondary text-white py-3 rounded-md font-medium transition-all duration-200 hover:bg-secondary-dark focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-opacity-50`,
                                            children: loading ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                                className: "flex items-center justify-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("svg", {
                                                        className: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("circle", {
                                                                className: "opacity-25",
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10",
                                                                stroke: "currentColor",
                                                                strokeWidth: "4"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                className: "opacity-75",
                                                                fill: "currentColor",
                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            })
                                                        ]
                                                    }),
                                                    "Creating..."
                                                ]
                                            }) : 'Create Room'
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                                            className: "text-xl font-bold text-center mb-6 dark:text-dark-text",
                                            children: "Join an Existing Room"
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                                                    htmlFor: "roomCode",
                                                    className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                                                    children: "Room Code"
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
                                                    id: "roomCode",
                                                    type: "text",
                                                    value: roomCode,
                                                    onChange: (e)=>setRoomCode(e.target.value),
                                                    placeholder: "ABCDEF",
                                                    className: "input uppercase dark:bg-dark-card dark:border-dark-border dark:text-dark-text"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                                                    htmlFor: "joinUserName",
                                                    className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                                                    children: "Your Name"
                                                }),
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
                                                    id: "joinUserName",
                                                    type: "text",
                                                    value: joinUserName,
                                                    onChange: (e)=>setJoinUserName(e.target.value),
                                                    placeholder: "John Doe",
                                                    className: "input dark:bg-dark-card dark:border-dark-border dark:text-dark-text"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                            onClick: handleJoinRoom,
                                            disabled: loading,
                                            className: `w-full btn ${loading ? 'bg-opacity-70 cursor-not-allowed' : ''} bg-primary text-white py-3 rounded-md font-medium transition-all duration-200 hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50`,
                                            children: loading ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                                className: "flex items-center justify-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("svg", {
                                                        className: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("circle", {
                                                                className: "opacity-25",
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10",
                                                                stroke: "currentColor",
                                                                strokeWidth: "4"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                className: "opacity-75",
                                                                fill: "currentColor",
                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            })
                                                        ]
                                                    }),
                                                    "Joining..."
                                                ]
                                            }) : 'Join Room'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $9aecac4636d85589$export$2e2bcd8739ae039 = $9aecac4636d85589$var$HomePage;


/* eslint-disable @typescript-eslint/no-unused-vars */ 

var $2WGWz = parcelRequire("2WGWz");



var $2WGWz = parcelRequire("2WGWz");

const $a9fa1e44dd23b9f4$var$EMOJIS = [
    "\uD83C\uDF89",
    "\uD83D\uDC4F",
    "\u2764\uFE0F",
    "\uD83D\uDE02",
    "\uD83D\uDE80",
    "\uD83D\uDD25",
    "\uD83D\uDE4C",
    "\uD83E\uDD14",
    "\uD83D\uDE31",
    "\uD83E\uDEB1"
];
const $a9fa1e44dd23b9f4$var$EmojiReactions = ({ roomCode: roomCode, userId: userId })=>{
    const [reactions, setReactions] = (0, $2WGWz.useState)([]);
    const [showPicker, setShowPicker] = (0, $2WGWz.useState)(false);
    const [buttonDisabled, setButtonDisabled] = (0, $2WGWz.useState)(false);
    (0, $2WGWz.useEffect)(()=>{
        const reactionsRef = (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/reactions`);
        const handleNewReaction = (snapshot)=>{
            const reaction = snapshot.val();
            if (reaction) {
                const newReaction = {
                    ...reaction,
                    id: snapshot.key
                };
                setReactions((prev)=>[
                        ...prev,
                        newReaction
                    ]);
                setTimeout(()=>{
                    setReactions((prev)=>prev.filter((r)=>r.id !== snapshot.key));
                }, 4000);
                setTimeout(()=>{
                    reactionsRef.child(snapshot.key).remove();
                }, 4500);
            }
        };
        reactionsRef.on('child_added', handleNewReaction);
        return ()=>{
            reactionsRef.off('child_added', handleNewReaction);
        };
    }, [
        roomCode
    ]);
    const sendReaction = (emoji)=>{
        const x = 10 + Math.random() * 80;
        const y = 10 + Math.random() * 80;
        const reaction = {
            emoji: emoji,
            userId: userId,
            timestamp: Date.now(),
            x: x,
            y: y
        };
        (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/reactions`).push(reaction);
        setShowPicker(false);
        setButtonDisabled(true);
        setTimeout(()=>{
            setButtonDisabled(false);
        }, 10000);
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "emoji-reactions-container",
                style: {
                    position: 'fixed',
                    bottom: '1rem',
                    right: '1rem',
                    zIndex: 9999
                },
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                    style: {
                        position: 'relative'
                    },
                    children: [
                        showPicker && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-picker-panel",
                            style: {
                                position: 'absolute',
                                bottom: '4rem',
                                right: '0',
                                backgroundColor: 'white',
                                borderRadius: '0.5rem',
                                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                                padding: '1rem',
                                display: 'grid',
                                gridTemplateColumns: 'repeat(5, 1fr)',
                                gap: '0.75rem',
                                border: '1px solid #e5e7eb',
                                minWidth: '280px'
                            },
                            children: $a9fa1e44dd23b9f4$var$EMOJIS.map((emoji)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                    onClick: ()=>sendReaction(emoji),
                                    style: {
                                        fontSize: '1.875rem',
                                        padding: '0.5rem',
                                        borderRadius: '0.5rem',
                                        border: 'none',
                                        backgroundColor: 'transparent',
                                        cursor: 'pointer',
                                        width: '48px',
                                        height: '48px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'transform 0.2s, background-color 0.2s'
                                    },
                                    onMouseEnter: (e)=>{
                                        e.currentTarget.style.transform = 'scale(1.25)';
                                        e.currentTarget.style.backgroundColor = '#f3f4f6';
                                    },
                                    onMouseLeave: (e)=>{
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    },
                                    children: emoji
                                }, emoji))
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                            disabled: buttonDisabled,
                            onClick: ()=>setShowPicker(!showPicker),
                            style: {
                                backgroundColor: buttonDisabled ? '#9CA3AF' : '#3182ce',
                                color: 'white',
                                borderRadius: '9999px',
                                padding: '1rem',
                                border: 'none',
                                cursor: buttonDisabled ? 'not-allowed' : 'pointer',
                                boxShadow: buttonDisabled ? 'none' : '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                transition: 'all 0.2s',
                                transform: buttonDisabled ? 'scale(1)' : 'scale(1)',
                                opacity: buttonDisabled ? 0.5 : 1
                            },
                            onMouseEnter: (e)=>{
                                if (!buttonDisabled) {
                                    e.currentTarget.style.backgroundColor = '#2c5282';
                                    e.currentTarget.style.transform = 'scale(1.1)';
                                }
                            },
                            onMouseLeave: (e)=>{
                                if (!buttonDisabled) {
                                    e.currentTarget.style.backgroundColor = '#3182ce';
                                    e.currentTarget.style.transform = 'scale(1)';
                                }
                            },
                            children: !buttonDisabled ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                style: {
                                    height: '1.5rem',
                                    width: '1.5rem'
                                },
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 1.5,
                                stroke: "currentColor",
                                style: {
                                    height: '1.5rem',
                                    width: '1.5rem'
                                },
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
                                })
                            })
                        })
                    ]
                })
            }),
            reactions.map((reaction)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                    className: "emoji-fountain",
                    style: {
                        left: `${reaction.x}%`,
                        top: `${reaction.y}%`
                    },
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-core",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "rainbow-ring ring-1"
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "rainbow-ring ring-2"
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "rainbow-ring ring-3"
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-1",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-2",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-3",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-4",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-5",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-6",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-7",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "emoji-burst burst-8",
                            children: reaction.emoji
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                            className: "sparkle-container",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                    className: "sparkle s1",
                                    children: "\u2728"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                    className: "sparkle s2",
                                    children: "\u2B50"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                    className: "sparkle s3",
                                    children: "\uD83D\uDCAB"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                    className: "sparkle s4",
                                    children: "\u2728"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                    className: "sparkle s5",
                                    children: "\u2B50"
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                    className: "sparkle s6",
                                    children: "\uD83D\uDCAB"
                                })
                            ]
                        })
                    ]
                }, reaction.id))
        ]
    });
};
var $a9fa1e44dd23b9f4$export$2e2bcd8739ae039 = $a9fa1e44dd23b9f4$var$EmojiReactions;




parcelRequire("2WGWz");
const $571d2094c35f4038$var$ParticipantList = ({ participants: participants, currentVotes: currentVotes, revealed: revealed })=>{
    // Sort participants: admins first, then active users, then inactive users
    const sortedParticipants = Object.values(participants).sort((a, b)=>{
        if (a.isAdmin && !b.isAdmin) return -1;
        if (!a.isAdmin && b.isAdmin) return 1;
        if (a.isActive && !b.isActive) return -1;
        if (!a.isActive && b.isActive) return 1;
        return a.name.localeCompare(b.name);
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "my-6",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("h3", {
                className: "text-lg font-semibold mb-4 text-gray-700 dark:text-gray-300 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "h-5 w-5 mr-2",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                        })
                    }),
                    "Participants (",
                    sortedParticipants.length,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("ul", {
                className: "space-y-2",
                children: sortedParticipants.map((participant)=>{
                    const hasVoted = currentVotes && currentVotes[participant.id];
                    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("li", {
                        className: `
                                flex items-center justify-between
                                p-3 rounded-lg transition-all duration-200
                                ${participant.isActive ? 'bg-white dark:bg-dark-card shadow-sm border border-gray-100 dark:border-dark-border' : 'bg-gray-100 dark:bg-gray-800 opacity-60'}
                                ${participant.isAdmin ? 'border-l-4 border-l-primary-dark' : ''}
                            `,
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                className: "flex items-center min-w-0 flex-1 mr-3",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: `
                                    h-2 w-2 rounded-full mr-3 flex-shrink-0
                                    ${participant.isActive ? 'bg-green-500' : 'bg-gray-400 dark:bg-gray-600'}
                                `
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                        className: "min-w-0 flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                                className: "font-medium dark:text-dark-text block truncate",
                                                title: participant.name,
                                                children: participant.name
                                            }),
                                            participant.isAdmin && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                                className: "inline-block mt-1 text-xs bg-primary-light text-white px-2 py-0.5 rounded-full",
                                                children: "Admin"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                className: "flex-shrink-0",
                                children: hasVoted ? revealed ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                    className: `
                                            inline-flex items-center justify-center
                                            h-8 min-w-8 px-2 rounded-full font-bold text-sm
                                            ${currentVotes[participant.id].value === '?' ? 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300' : 'bg-primary-light text-white'}
                                        `,
                                    title: currentVotes[participant.id].value,
                                    children: currentVotes[participant.id].value.length > 8 ? currentVotes[participant.id].value.substring(0, 8) + '...' : currentVotes[participant.id].value
                                }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                    className: "flex items-center justify-center h-6 w-6 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-full",
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-4 w-4",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M5 13l4 4L19 7"
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                                    className: "flex items-center text-gray-400 dark:text-gray-500 text-sm whitespace-nowrap",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            className: "h-4 w-4 mr-1",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                            })
                                        }),
                                        "waiting"
                                    ]
                                })
                            })
                        ]
                    }, participant.id);
                })
            }),
            sortedParticipants.length === 0 && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "text-center p-6 bg-gray-50 dark:bg-gray-800/50 rounded-lg",
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                    className: "text-gray-500 dark:text-gray-400",
                    children: "No participants have joined yet."
                })
            })
        ]
    });
};
var $571d2094c35f4038$export$2e2bcd8739ae039 = $571d2094c35f4038$var$ParticipantList;




var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");

const $6707cf70c0eafa2e$var$CardDeckSelector = ({ currentDeckType: currentDeckType, currentValues: currentValues, onUpdateDeck: onUpdateDeck })=>{
    const [deckType, setDeckType] = (0, $2WGWz.useState)(currentDeckType);
    const [customValues, setCustomValues] = (0, $2WGWz.useState)(currentDeckType === 'custom' ? currentValues.join(', ') : '');
    const [showCustomInput, setShowCustomInput] = (0, $2WGWz.useState)(currentDeckType === 'custom');
    const [isDirty, setIsDirty] = (0, $2WGWz.useState)(false);
    const [isSaving, setIsSaving] = (0, $2WGWz.useState)(false);
    const [saveSuccess, setSaveSuccess] = (0, $2WGWz.useState)(false);
    (0, $2WGWz.useEffect)(()=>{
        if (saveSuccess) {
            const timer = setTimeout(()=>{
                setSaveSuccess(false);
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        saveSuccess
    ]);
    const handleDeckTypeChange = (e)=>{
        const newType = e.target.value;
        setDeckType(newType);
        setShowCustomInput(newType === 'custom');
        setIsDirty(true);
        if (newType !== 'custom') handleDeckSave(newType);
    };
    const handleCustomValuesChange = (e)=>{
        setCustomValues(e.target.value);
        setIsDirty(true);
    };
    const handleDeckSave = (type = deckType)=>{
        if (type === 'custom') {
            const values = Array.from(new Set(customValues.split(',').map((val)=>val.trim()).filter((val)=>val.length > 0)));
            if (values.length === 0) {
                alert('Please enter at least one valid card value');
                return;
            }
            setIsSaving(true);
            try {
                onUpdateDeck('custom', values);
                setSaveSuccess(true);
                setIsDirty(false);
            } catch (error) {
                console.error('Failed to save custom deck:', error);
                alert('Failed to save custom deck. Please try again.');
            } finally{
                setIsSaving(false);
            }
        } else {
            setIsSaving(true);
            try {
                onUpdateDeck(type);
                setSaveSuccess(true);
                setIsDirty(false);
            } catch (error) {
                console.error('Failed to update deck:', error);
                alert('Failed to update deck. Please try again.');
            } finally{
                setIsSaving(false);
            }
        }
    };
    const renderCardPreviews = ()=>{
        const previewValues = deckType === 'custom' ? Array.from(new Set(customValues.split(',').map((val)=>val.trim()).filter((val)=>val.length > 0))) : (0, $4cc3d49d3269c10d$export$5805271a0f1d493)[deckType];
        return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            className: "flex flex-wrap gap-2 mt-3 justify-center",
            children: previewValues.length > 0 ? previewValues.map((value, index)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                    className: "px-3 py-2 bg-white dark:bg-dark-card shadow-sm rounded-md border border-gray-200 dark:border-dark-border text-center font-medium dark:text-dark-text",
                    children: value
                }, index)) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                className: "text-gray-500 dark:text-gray-400 italic",
                children: "No card values defined"
            })
        });
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "bg-white dark:bg-dark-card rounded-lg p-4 border border-gray-200 dark:border-dark-border shadow-sm",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                        htmlFor: "deckType",
                        className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                        children: "Card Deck Type"
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("select", {
                        id: "deckType",
                        value: deckType,
                        onChange: handleDeckTypeChange,
                        className: "w-full p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-dark-border text-gray-900 dark:text-dark-text rounded-md focus:ring-2 focus:ring-primary focus:border-transparent shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                value: "fibonacci",
                                children: "Fibonacci (0, 1, 2, 3, 5, 8, 13, 21, 34, ?)"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                value: "bau",
                                children: "BAU (1, 2, 3, 4, 5, 6, 7, 8, 9, 10)"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                value: "tshirt",
                                children: "T-Shirt Sizes (XXS, XS, S, M, L, XL, ?)"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                value: "powers",
                                children: "Powers of 2 (0, 1, 2, 4, 8, 16, 32, 64, ?)"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("option", {
                                value: "custom",
                                children: "Custom Values"
                            })
                        ]
                    })
                ]
            }),
            showCustomInput && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("label", {
                        htmlFor: "customValues",
                        className: "block mb-2 font-medium text-gray-700 dark:text-gray-300",
                        children: "Custom Card Values (comma-separated)"
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
                                id: "customValues",
                                type: "text",
                                value: customValues,
                                onChange: handleCustomValuesChange,
                                placeholder: "1, 2, 3, 5, 8, 13, ?",
                                className: "flex-1 p-2 border border-gray-300 dark:border-dark-border dark:bg-gray-800 dark:text-dark-text rounded-md focus:ring-2 focus:ring-primary focus:border-transparent shadow-sm"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                onClick: ()=>handleDeckSave(),
                                disabled: isSaving || !isDirty,
                                className: `
                                px-4 py-2 rounded-md font-medium transition-colors duration-200
                                ${isSaving ? 'bg-gray-300 dark:bg-gray-600 cursor-not-allowed' : isDirty ? 'bg-primary text-white hover:bg-primary-dark' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'}
                            `,
                                children: isSaving ? 'Saving...' : 'Save'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                        className: "text-xs text-gray-500 dark:text-gray-400 mt-1",
                        children: 'Enter values separated by commas. Include "?" for unknown estimates.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "mt-4 bg-gray-50 dark:bg-gray-800/50 p-3 rounded-md border border-gray-100 dark:border-gray-700",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h4", {
                        className: "text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2",
                        children: "Card Preview"
                    }),
                    renderCardPreviews()
                ]
            }),
            saveSuccess && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "mt-3 py-2 px-3 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 text-sm flex items-center rounded-md border border-green-100 dark:border-green-800",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "h-5 w-5 mr-2",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M5 13l4 4L19 7"
                        })
                    }),
                    "Card deck updated successfully!"
                ]
            })
        ]
    });
};
var $6707cf70c0eafa2e$export$2e2bcd8739ae039 = $6707cf70c0eafa2e$var$CardDeckSelector;


const $f37774a1db9e0eb7$var$RoundControls = ({ onStartNewRound: onStartNewRound, onRevealVotes: onRevealVotes, onUpdateCardDeck: onUpdateCardDeck, isAdmin: isAdmin, revealed: revealed, currentDeckType: currentDeckType, currentCardValues: currentCardValues })=>{
    const [description, setDescription] = (0, $2WGWz.useState)('');
    const [showDeckSettings, setShowDeckSettings] = (0, $2WGWz.useState)(false);
    const [isConfirmingReveal, setIsConfirmingReveal] = (0, $2WGWz.useState)(false);
    const handleStartNewRound = ()=>{
        onStartNewRound(description.trim());
        setDescription('');
    };
    const handleRevealVotes = ()=>{
        if (isConfirmingReveal) {
            onRevealVotes();
            setIsConfirmingReveal(false);
        } else {
            setIsConfirmingReveal(true);
            // Auto-reset after 3 seconds
            setTimeout(()=>{
                setIsConfirmingReveal(false);
            }, 3000);
        }
    };
    if (!isAdmin) return null;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
        className: "my-6 overflow-hidden",
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
            className: "bg-white dark:bg-dark-card rounded-lg shadow-md border border-gray-100 dark:border-dark-border",
            children: [
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                    className: "bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 px-4 py-3 border-b border-gray-200 dark:border-dark-border",
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("h3", {
                        className: "text-lg font-semibold text-gray-700 dark:text-gray-300 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-5 w-5 mr-2 text-primary",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                    })
                                ]
                            }),
                            "Admin Controls"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                    className: "p-4",
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("button", {
                            onClick: ()=>setShowDeckSettings(!showDeckSettings),
                            className: "flex items-center justify-between w-full p-3 mb-4 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-md transition-colors duration-200 border border-gray-200 dark:border-dark-border",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                                    className: "flex items-center font-medium",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            className: "h-5 w-5 mr-2 text-gray-500 dark:text-gray-400",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                            })
                                        }),
                                        "Card Deck Settings"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: `h-5 w-5 text-gray-500 dark:text-gray-400 transform transition-transform duration-200 ${showDeckSettings ? 'rotate-180' : ''}`,
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M19 9l-7 7-7-7"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: `overflow-hidden transition-all duration-300 ${showDeckSettings ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`,
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $6707cf70c0eafa2e$export$2e2bcd8739ae039), {
                                currentDeckType: currentDeckType,
                                currentValues: currentCardValues,
                                onUpdateDeck: onUpdateCardDeck
                            })
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                    className: "relative mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("input", {
                                            type: "text",
                                            placeholder: "Describe the user story or task...",
                                            value: description,
                                            onChange: (e)=>setDescription(e.target.value),
                                            className: "w-full p-3 pr-10 border border-gray-300 dark:border-dark-border dark:bg-dark-card dark:text-dark-text rounded-md focus:ring-2 focus:ring-primary focus:border-primary"
                                        }),
                                        description && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                            onClick: ()=>setDescription(''),
                                            className: "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-400",
                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                className: "h-5 w-5",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M6 18L18 6M6 6l12 12"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                    className: "flex gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("button", {
                                            onClick: handleStartNewRound,
                                            className: "flex-1 flex items-center justify-center p-3 bg-secondary hover:bg-secondary-dark text-white rounded-md transition-colors duration-200 font-medium",
                                            children: [
                                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    className: "h-5 w-5 mr-2",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        strokeWidth: 2,
                                                        d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                                    })
                                                }),
                                                "Start New Round"
                                            ]
                                        }),
                                        !revealed && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("button", {
                                            onClick: handleRevealVotes,
                                            className: `
                                        flex-1 flex items-center justify-center p-3 rounded-md transition-all duration-200 font-medium
                                        ${isConfirmingReveal ? 'bg-red-500 hover:bg-red-600 text-white' : 'bg-primary hover:bg-primary-dark text-white'}
                                    `,
                                            children: isConfirmingReveal ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5 mr-2",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: 2,
                                                            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                                        })
                                                    }),
                                                    "Confirm Reveal"
                                                ]
                                            }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5 mr-2",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: 2,
                                                                d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: 2,
                                                                d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                            })
                                                        ]
                                                    }),
                                                    "Reveal Votes"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $f37774a1db9e0eb7$export$2e2bcd8739ae039 = $f37774a1db9e0eb7$var$RoundControls;




var $2WGWz = parcelRequire("2WGWz");
const $5b890932354c5e84$var$VotingCards = ({ onVote: onVote, selectedValue: selectedValue, disabled: disabled, cardValues: cardValues })=>{
    const [keyboardVote, setKeyboardVote] = (0, $2WGWz.useState)(null);
    const [recentlySelected, setRecentlySelected] = (0, $2WGWz.useState)(null);
    (0, $2WGWz.useEffect)(()=>{
        if (selectedValue === null) {
            setKeyboardVote(null);
            setRecentlySelected(null);
        }
    }, [
        selectedValue
    ]);
    (0, $2WGWz.useEffect)(()=>{
        if (selectedValue && selectedValue !== recentlySelected && !keyboardVote) {
            setRecentlySelected(selectedValue);
            const timer = setTimeout(()=>{
                setRecentlySelected(null);
            }, 3700);
            return ()=>clearTimeout(timer);
        }
    }, [
        selectedValue,
        keyboardVote
    ]);
    const getKeyboardMapping = ()=>{
        const mapping = {};
        for(let i = 1; i <= 9; i++)mapping[i.toString()] = i - 1;
        mapping['0'] = 9;
        const letters = [
            'q',
            'w',
            'e',
            'r',
            't',
            'y',
            'u',
            'i',
            'o',
            'p',
            'a',
            's',
            'd',
            'f',
            'g',
            'h',
            'j',
            'k',
            'l',
            'z',
            'x',
            'c',
            'v',
            'b',
            'n',
            'm'
        ];
        letters.forEach((letter, index)=>{
            mapping[letter] = index + 10;
        });
        mapping['='] = -1;
        return mapping;
    };
    const keyboardMapping = getKeyboardMapping();
    (0, $2WGWz.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (disabled) return;
            const keyPressed = event.key.toLowerCase();
            if (keyPressed in keyboardMapping) {
                const index = keyboardMapping[keyPressed];
                if (keyPressed === '=' && cardValues.includes('?')) {
                    if (selectedValue === '?') {
                        setKeyboardVote(null);
                        onVote('');
                    } else {
                        setKeyboardVote('?');
                        onVote('?');
                    }
                    return;
                }
                if (index >= 0 && index < cardValues.length) {
                    const value = cardValues[index];
                    if (selectedValue === value) {
                        setKeyboardVote(null);
                        onVote('');
                    } else {
                        setKeyboardVote(value);
                        onVote(value);
                    }
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onVote,
        disabled,
        cardValues,
        keyboardMapping,
        selectedValue
    ]);
    const getShortcutKey = (value, index)=>{
        if (value === '?') return '=';
        for (const [key, idx] of Object.entries(keyboardMapping)){
            if (idx === index) return key.toUpperCase();
        }
        return '';
    };
    const cardSizeClass = cardValues.length > 8 ? 'w-16 h-24 text-xl' : 'w-20 h-28 text-2xl';
    const getTextSizeClass = (value)=>{
        const length = value.length;
        if (length > 10) return 'text-xs';
        if (length > 6) return 'text-sm';
        if (length > 4) return 'text-base';
        return cardValues.length > 8 ? 'text-xl' : 'text-2xl';
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "my-6",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h3", {
                className: "text-lg font-semibold mb-4 text-gray-700 dark:text-gray-300",
                children: "Your Vote"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "flex flex-wrap gap-3 justify-center",
                children: cardValues.map((value, index)=>{
                    const isSelected = selectedValue === value && keyboardVote !== value;
                    const isRecentlySelected = recentlySelected === value;
                    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("button", {
                        onClick: ()=>{
                            setKeyboardVote(null);
                            if (selectedValue === value) onVote('');
                            else onVote(value);
                        },
                        disabled: disabled,
                        className: `
                                ${cardSizeClass}
                                relative 
                                flex flex-col items-center justify-center
                                font-bold rounded-lg
                                transform transition-all duration-200
                                ${isSelected ? 'bg-primary-light text-white shadow-lg ring-2 ring-primary-light' : 'bg-white dark:bg-dark-card text-gray-700 dark:text-gray-200 shadow border border-gray-200 dark:border-dark-border hover:shadow-md hover:-translate-y-1'}
                                ${isRecentlySelected ? 'animate-pulse' : ''}
                                ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
                            `,
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                className: "text-sm absolute top-1 right-1 opacity-50 dark:opacity-70",
                                children: getShortcutKey(value, index)
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                className: `${getTextSizeClass(value)} text-center px-1 break-all overflow-hidden whitespace-normal leading-tight`,
                                children: value.length > 30 ? value.substring(0, 30) + '...' : value
                            })
                        ]
                    }, value);
                })
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "mt-4 text-sm text-gray-600 dark:text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("p", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-4 w-4 mr-1",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M13 10V3L4 14h7v7l9-11h-7z"
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                children: "Keyboard shortcuts:"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                className: "ml-1",
                                children: "Use keys 1-9, 0 for the first 10 cards, then Q,W,E,R,T,Y... for additional cards. Press = for '?'"
                            })
                        ]
                    }),
                    keyboardVote && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("p", {
                        className: "flex items-center mt-2 text-secondary-dark dark:text-secondary-light",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-4 w-4 mr-1",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M5 13l4 4L19 7"
                                })
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("strong", {
                                children: "Vote submitted via keyboard"
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                className: "ml-1 text-xs opacity-70",
                                children: "(not visible to others when sharing screen)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5b890932354c5e84$export$2e2bcd8739ae039 = $5b890932354c5e84$var$VotingCards;




var $2WGWz = parcelRequire("2WGWz");
const $cdd2f690c0347d2c$var$VotingResults = ({ votes: votes, revealed: revealed })=>{
    const [showAnimation, setShowAnimation] = (0, $2WGWz.useState)(false);
    (0, $2WGWz.useEffect)(()=>{
        if (revealed) {
            setShowAnimation(true);
            const timer = setTimeout(()=>{
                setShowAnimation(false);
            }, 1000);
            return ()=>clearTimeout(timer);
        }
    }, [
        revealed
    ]);
    if (!votes || !revealed) return null;
    const voteValues = Object.values(votes).map((vote)=>vote.value);
    // Calculate vote statistics (excluding '?' votes)
    const numericVotes = voteValues.filter((value)=>value !== '?' && !isNaN(Number(value))).map((value)=>Number(value));
    const average = numericVotes.length > 0 ? numericVotes.reduce((sum, val)=>sum + val, 0) / numericVotes.length : 0;
    // Count occurrences of each value
    const voteCounts = {};
    voteValues.forEach((value)=>{
        voteCounts[value] = (voteCounts[value] || 0) + 1;
    });
    // Sort vote values for display
    const sortedVotes = Object.entries(voteCounts).sort((a, b)=>{
        // Sort '?' to the end
        if (a[0] === '?') return 1;
        if (b[0] === '?') return -1;
        // Sort remaining values numerically if possible
        const aNum = parseFloat(a[0]);
        const bNum = parseFloat(b[0]);
        if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
        // Otherwise sort alphabetically
        return a[0].localeCompare(b[0]);
    });
    // Find the most voted value(s)
    const maxVotes = Math.max(...Object.values(voteCounts));
    const consensusValues = Object.entries(voteCounts)// eslint-disable-next-line @typescript-eslint/no-unused-vars
    .filter(([_, count])=>count === maxVotes).map(([value])=>value);
    // Check if there is consensus (more than 50% agree)
    const totalVotes = voteValues.length;
    const hasConsensus = maxVotes > totalVotes / 2;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: `
            my-6 p-6 rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 shadow-md
            ${showAnimation ? 'animate-reveal' : ''}
        `,
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("h3", {
                className: "text-lg font-semibold mb-4 text-gray-700 dark:text-gray-300 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "h-5 w-5 mr-2",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                        })
                    }),
                    "Voting Results"
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                        className: "bg-white dark:bg-dark-card p-4 rounded-lg shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                        className: "flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                                className: "text-sm text-gray-500 dark:text-gray-400",
                                                children: "Average Score"
                                            }),
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                                className: "text-2xl font-bold text-primary-dark dark:text-primary-light",
                                                children: average.toFixed(1)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: "mt-1 h-1 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                            className: "bg-primary h-full rounded-full transition-all duration-1000 ease-out",
                                            style: {
                                                width: numericVotes.length ? `${Math.min(100, average / 15 * 100)}%` : '0%'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                        className: "flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                                className: "text-sm text-gray-500 dark:text-gray-400",
                                                children: "Consensus"
                                            }),
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                                children: hasConsensus ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                                                    className: "inline-flex items-center text-sm font-medium text-green-600 dark:text-green-400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            className: "h-4 w-4 mr-1",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: 2,
                                                                d: "M5 13l4 4L19 7"
                                                            })
                                                        }),
                                                        consensusValues.map((v)=>v.length > 8 ? v.substring(0, 8) + '...' : v).join(', ')
                                                    ]
                                                }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                                                    className: "inline-flex items-center text-sm font-medium text-amber-600 dark:text-amber-400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            className: "h-4 w-4 mr-1",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: 2,
                                                                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                                            })
                                                        }),
                                                        "No Consensus"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: "mt-1 h-1 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                            className: `h-full rounded-full transition-all duration-1000 ease-out ${hasConsensus ? 'bg-green-500' : 'bg-amber-500'}`,
                                            style: {
                                                width: `${maxVotes / totalVotes * 100}%`
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                        className: "flex flex-wrap gap-2 justify-center items-center",
                        children: sortedVotes.map(([value, count])=>{
                            const isConsensus = consensusValues.includes(value);
                            const isQuestionMark = value === '?';
                            return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                className: `
                                    relative flex flex-col items-center p-3 rounded-lg 
                                    ${isConsensus ? 'bg-primary-light text-white' : isQuestionMark ? 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300' : 'bg-white dark:bg-dark-card text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-dark-border'}
                                    ${showAnimation ? 'animate-pop-in' : ''}
                                    shadow-sm transition-all duration-200
                                `,
                                style: {
                                    animationDelay: `${parseInt(value) * 50}ms`,
                                    minWidth: '4rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                        className: `
                                    absolute -top-2 -right-2 
                                    ${count > 1 ? 'flex' : 'hidden'} 
                                    items-center justify-center 
                                    w-5 h-5 text-xs font-bold rounded-full
                                    ${isConsensus ? 'bg-white text-primary-dark' : 'bg-primary-light text-white'}
                                `,
                                        children: count
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: "text-2xl font-bold text-center",
                                        title: value,
                                        children: value.length > 6 ? value.substring(0, 6) + '...' : value
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: "text-xs mt-1 opacity-80",
                                        children: count === 1 ? '1 vote' : `${count} votes`
                                    })
                                ]
                            }, value);
                        })
                    })
                ]
            })
        ]
    });
};
var $cdd2f690c0347d2c$export$2e2bcd8739ae039 = $cdd2f690c0347d2c$var$VotingResults;






const $a9402a11c2ad053c$var$TShirtSizeReference = ()=>{
    const tshirtSizeMapping = {
        XXS: {
            weeks: '0 - 2 weeks',
            sprints: 'Up to 1 Sprint'
        },
        XS: {
            weeks: '2 - 4 weeks',
            sprints: 'Up to 2 Sprints'
        },
        S: {
            weeks: '4 - 6 weeks',
            sprints: 'Up to 3 Sprints'
        },
        M: {
            weeks: '6 - 10 weeks',
            sprints: 'Up to 5 Sprints'
        },
        L: {
            weeks: '10 - 16 weeks',
            sprints: 'Up to 8 Sprints'
        },
        XL: {
            weeks: '16+ weeks',
            sprints: '8 Sprints or more'
        },
        '?': {
            weeks: 'Not sure',
            sprints: 'Not sure'
        }
    };
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "bg-white dark:bg-dark-card rounded-lg shadow-md p-4",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("h4", {
                className: "text-md font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "h-4 w-4 mr-2",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                    }),
                    "T-Shirt Size Reference"
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("table", {
                    className: "w-full text-sm",
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("tr", {
                                className: "border-b border-gray-200 dark:border-gray-600",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("th", {
                                        className: "text-left py-2 pr-4 font-medium text-gray-700 dark:text-gray-300 w-16",
                                        children: "Size"
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("th", {
                                        className: "text-left py-2 px-2 font-medium text-gray-700 dark:text-gray-300 w-24",
                                        children: "Duration"
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("th", {
                                        className: "text-left py-2 pl-2 font-medium text-gray-700 dark:text-gray-300",
                                        children: "Sprints"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("tbody", {
                            children: Object.entries(tshirtSizeMapping).map(([size, info])=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("tr", {
                                    className: "border-b border-gray-100 dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("td", {
                                            className: "py-2 pr-4 font-medium text-gray-900 dark:text-gray-100 w-16",
                                            children: size
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("td", {
                                            className: "py-2 px-2 text-gray-600 dark:text-gray-400 w-24 whitespace-nowrap",
                                            children: info.weeks
                                        }),
                                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("td", {
                                            className: "py-2 pl-2 text-gray-600 dark:text-gray-400",
                                            children: info.sprints
                                        })
                                    ]
                                }, size))
                        })
                    ]
                })
            })
        ]
    });
};
const $a9402a11c2ad053c$var$RoomPage = ()=>{
    const { roomCode: roomCode } = (0, $80c9b230a4f51b6a$export$99eaa27ddbbb95ef)();
    const history = (0, $80c9b230a4f51b6a$export$3420e1dc2c4a518c)();
    const [room, setRoom] = (0, $2WGWz.useState)(null);
    const [loading, setLoading] = (0, $2WGWz.useState)(true);
    const [error, setError] = (0, $2WGWz.useState)('');
    const [userId, setUserId] = (0, $2WGWz.useState)(null);
    const [currentRound, setCurrentRound] = (0, $2WGWz.useState)(null);
    const [selectedValue, setSelectedValue] = (0, $2WGWz.useState)(null);
    const [userName, setUserName] = (0, $2WGWz.useState)('');
    const [roundTransition, setRoundTransition] = (0, $2WGWz.useState)(false);
    const [autoRevealCountdown, setAutoRevealCountdown] = (0, $2WGWz.useState)(null);
    const autoRevealTimerRef = (0, $2WGWz.useRef)(null);
    const countdownIntervalRef = (0, $2WGWz.useRef)(null);
    (0, $2WGWz.useEffect)(()=>{
        const setupRoom = async ()=>{
            try {
                // Ensure user is authenticated anonymously
                const authenticatedUserId = await (0, $80df39b5d570f70c$export$ebd0aaf6e6c967e5)();
                setUserId(authenticatedUserId);
                // Get username from localStorage if available
                const storedUserName = localStorage.getItem(`pp_${roomCode}_userName`);
                if (storedUserName) setUserName(storedUserName);
                const roomRef = (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}`);
                console.log('Setting up room connection for room:', roomCode);
                // Test if we can read the room first
                try {
                    const testSnapshot = await roomRef.once('value');
                    if (!testSnapshot.exists()) {
                        setError('Room not found');
                        setLoading(false);
                        return;
                    }
                } catch (testError) {
                    console.error('Permission test failed:', testError);
                    setError('Unable to access room. Please try refreshing the page.');
                    setLoading(false);
                    return;
                }
                // Check if user is already a participant, if not, redirect to join flow
                const participantSnapshot = await roomRef.child(`participants/${authenticatedUserId}`).once('value');
                if (!participantSnapshot.exists()) {
                    // User is not a participant, redirect to home with room code
                    history.push(`/?join=${roomCode}`);
                    return;
                }
                // Initial user activity update - do this just once
                if (authenticatedUserId) try {
                    await (0, $4cc3d49d3269c10d$export$953889bdf646ec23)(roomCode, authenticatedUserId);
                    console.log('Initial activity status updated');
                } catch (err) {
                    console.error('Failed to update initial user activity:', err);
                // Continue even if this fails
                }
                roomRef.on('value', (snapshot)=>{
                    if (snapshot.exists()) {
                        const roomData = snapshot.val();
                        // Ensure cardDeck exists (for backward compatibility)
                        if (!roomData.cardDeck) {
                            roomData.cardDeck = {
                                type: 'fibonacci',
                                values: [
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '5',
                                    '8',
                                    '13',
                                    '21',
                                    '?'
                                ]
                            };
                            (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/cardDeck`).set(roomData.cardDeck);
                        }
                        setRoom(roomData);
                        // Track round transitions
                        if (currentRound === null || roomData.currentRound && roomData.currentRound !== currentRound?.id) {
                            setRoundTransition(true);
                            setTimeout(()=>setRoundTransition(false), 500);
                        }
                        // Update current round if available
                        if (roomData.currentRound && roomData.rounds[roomData.currentRound]) {
                            const currentRoundData = roomData.rounds[roomData.currentRound];
                            setCurrentRound(currentRoundData);
                            // Check if user has already voted in this round
                            if (currentRoundData.votes && currentRoundData.votes[authenticatedUserId]) setSelectedValue(currentRoundData.votes[authenticatedUserId].value);
                            else setSelectedValue(null);
                            // Check if all active participants have voted
                            // Check if all active participants have voted
                            if (!currentRoundData.revealed && currentRoundData.votes) {
                                const activeParticipants = Object.values(roomData.participants).filter((p)=>p.isActive);
                                const voteCount = Object.keys(currentRoundData.votes).length;
                                if (activeParticipants.length > 0 && voteCount === activeParticipants.length) // All active participants have voted
                                {
                                    if (!autoRevealTimerRef.current) {
                                        // Show countdown for all users
                                        console.log('All participants voted, showing countdown');
                                        // Start countdown
                                        setAutoRevealCountdown(3);
                                        // Set up countdown interval
                                        let countdown = 3;
                                        countdownIntervalRef.current = setInterval(()=>{
                                            countdown -= 1;
                                            setAutoRevealCountdown(countdown);
                                            if (countdown <= 0) {
                                                if (countdownIntervalRef.current) {
                                                    clearInterval(countdownIntervalRef.current);
                                                    countdownIntervalRef.current = null;
                                                }
                                            }
                                        }, 1000);
                                        // Only admin initiates the auto-reveal
                                        if (roomData.participants[authenticatedUserId]?.isAdmin) autoRevealTimerRef.current = setTimeout(()=>{
                                            (0, $4cc3d49d3269c10d$export$a73b8ae7b8aea93a)(roomCode, currentRoundData.id).catch((err)=>{
                                                console.error('Failed to auto-reveal votes:', err);
                                            });
                                            autoRevealTimerRef.current = null;
                                            setAutoRevealCountdown(null);
                                        }, 3000);
                                        else // Non-admin users just clear countdown after 3 seconds
                                        autoRevealTimerRef.current = setTimeout(()=>{
                                            autoRevealTimerRef.current = null;
                                            setAutoRevealCountdown(null);
                                        }, 3000);
                                    }
                                } else {
                                    // Not all have voted - clear timers if they exist
                                    if (autoRevealTimerRef.current) {
                                        clearTimeout(autoRevealTimerRef.current);
                                        autoRevealTimerRef.current = null;
                                    }
                                    if (countdownIntervalRef.current) {
                                        clearInterval(countdownIntervalRef.current);
                                        countdownIntervalRef.current = null;
                                    }
                                    setAutoRevealCountdown(null);
                                }
                            } else {
                                // Round is revealed or no votes yet - clear timers if they exist
                                if (autoRevealTimerRef.current) {
                                    clearTimeout(autoRevealTimerRef.current);
                                    autoRevealTimerRef.current = null;
                                }
                                if (countdownIntervalRef.current) {
                                    clearInterval(countdownIntervalRef.current);
                                    countdownIntervalRef.current = null;
                                }
                                setAutoRevealCountdown(null);
                            }
                        } else {
                            setCurrentRound(null);
                            setSelectedValue(null);
                            // Clear timers if they exist
                            if (autoRevealTimerRef.current) {
                                clearTimeout(autoRevealTimerRef.current);
                                autoRevealTimerRef.current = null;
                            }
                            if (countdownIntervalRef.current) {
                                clearInterval(countdownIntervalRef.current);
                                countdownIntervalRef.current = null;
                            }
                            setAutoRevealCountdown(null);
                        }
                        setLoading(false);
                    } else {
                        setError('Room not found');
                        setLoading(false);
                    }
                }, (err)=>{
                    setError('Failed to load room data');
                    setLoading(false);
                    console.error(err);
                });
                let lastUpdateTime = Date.now();
                const MINIMUM_UPDATE_INTERVAL = 20000;
                const activityInterval = setInterval(()=>{
                    const now = Date.now();
                    if (authenticatedUserId && now - lastUpdateTime >= MINIMUM_UPDATE_INTERVAL) {
                        lastUpdateTime = now;
                        (0, $4cc3d49d3269c10d$export$953889bdf646ec23)(roomCode, authenticatedUserId).catch((err)=>{
                            console.error('Periodic activity update failed:', err);
                        });
                    }
                }, 30000);
                return async ()=>{
                    console.log('Cleaning up room listeners');
                    roomRef.off();
                    clearInterval(activityInterval);
                    if (autoRevealTimerRef.current) clearTimeout(autoRevealTimerRef.current);
                    if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
                    // Cancel the onDisconnect handlers and set user as inactive
                    if (authenticatedUserId) {
                        const userStatusRef = (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`/rooms/${roomCode}/participants/${authenticatedUserId}`);
                        await userStatusRef.onDisconnect().cancel();
                        await userStatusRef.update({
                            isActive: false,
                            lastSeen: Date.now()
                        });
                    }
                };
            } catch (error) {
                console.error('Error setting up room:', error);
                setError('Failed to set up room');
                setLoading(false);
            }
        };
        setupRoom();
    }, [
        roomCode,
        history
    ]);
    const handleVote = async (value)=>{
        if (!userId || !currentRound) return;
        try {
            if (value === '') {
                // Remove the vote
                await (0, $5f7ab37ddb79268c$export$f932f06c7eb6abeb).ref(`rooms/${roomCode}/rounds/${currentRound.id}/votes/${userId}`).remove();
                setSelectedValue(null);
            } else {
                await (0, $4cc3d49d3269c10d$export$b6daf3119ce2fd97)(roomCode, currentRound.id, userId, value);
                setSelectedValue(value);
            }
        } catch (err) {
            console.error('Failed to submit vote:', err);
        }
    };
    const handleStartNewRound = async (description)=>{
        try {
            await (0, $4cc3d49d3269c10d$export$50ff9bae65ce21fe)(roomCode, description);
        } catch (err) {
            console.error('Failed to start new round:', err);
        }
    };
    const handleRevealVotes = async ()=>{
        if (!currentRound) return;
        try {
            await (0, $4cc3d49d3269c10d$export$a73b8ae7b8aea93a)(roomCode, currentRound.id);
        } catch (err) {
            console.error('Failed to reveal votes:', err);
        }
    };
    const handleUpdateCardDeck = async (deckType, customValues)=>{
        try {
            await (0, $4cc3d49d3269c10d$export$acfa0decbf1145d3)(roomCode, deckType, customValues);
        } catch (err) {
            console.error('Failed to update card deck:', err);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e1131a681a58b314$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "flex items-center justify-center h-screen",
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                    className: "text-center p-8 bg-white dark:bg-dark-card rounded-lg shadow-lg max-w-md mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "animate-spin mx-auto mb-4 h-12 w-12 border-4 border-primary border-t-transparent rounded-full"
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                            className: "text-xl font-semibold text-gray-700 dark:text-gray-300",
                            children: "Loading room..."
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                            className: "text-gray-500 dark:text-gray-400 mt-2",
                            children: "Setting up your planning session"
                        })
                    ]
                })
            })
        ]
    });
    if (error || !room) return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e1131a681a58b314$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "flex items-center justify-center h-screen",
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                    className: "text-center p-8 bg-white dark:bg-dark-card rounded-lg shadow-lg max-w-md mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                            className: "mx-auto mb-4 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 dark:bg-red-900/20",
                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-6 w-6 text-red-600 dark:text-red-400",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                            className: "text-xl font-semibold text-red-600 dark:text-red-400",
                            children: error || 'Room not found'
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                            className: "text-gray-500 dark:text-gray-400 mt-2 mb-4",
                            children: "The room you're looking for doesn't exist or is no longer available."
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("button", {
                            onClick: ()=>history.push('/'),
                            className: "inline-flex items-center justify-center px-4 py-2 bg-primary hover:bg-primary-dark text-white rounded-md transition-colors duration-200",
                            children: [
                                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M10 19l-7-7m0 0l7-7m-7 7h18"
                                    })
                                }),
                                "Back to Home"
                            ]
                        })
                    ]
                })
            })
        ]
    });
    const isAdmin = userId ? room.participants[userId]?.isAdmin || false : false;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800 pb-12",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e1131a681a58b314$export$2e2bcd8739ae039), {
                roomName: room.name,
                roomCode: room.id
            }),
            userId && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $a9fa1e44dd23b9f4$export$2e2bcd8739ae039), {
                roomCode: roomCode,
                userId: userId
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto px-4 py-8",
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                        className: `
                    p-6 mb-6 rounded-lg shadow-md relative overflow-hidden
                    transition-all duration-300 transform
                    ${roundTransition ? 'scale-102 translate-y-2' : ''}
                    ${currentRound ? currentRound.revealed ? 'bg-gradient-to-r from-purple-50 to-blue-50 dark:from-purple-900/20 dark:to-blue-900/20 border border-purple-100 dark:border-purple-800' : autoRevealCountdown !== null ? 'bg-gradient-to-r from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20 border border-yellow-100 dark:border-yellow-800' : 'bg-gradient-to-r from-green-50 to-teal-50 dark:from-green-900/20 dark:to-teal-900/20 border border-green-100 dark:border-green-800' : 'bg-gradient-to-r from-amber-50 to-yellow-50 dark:from-amber-900/20 dark:to-yellow-900/20 border border-amber-100 dark:border-amber-800'}
                `,
                        children: [
                            currentRound ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                className: "flex flex-col md:flex-row justify-between items-start md:items-center",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    currentRound.revealed ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-6 w-6 mr-2 text-purple-500",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: 2,
                                                            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                        })
                                                    }) : autoRevealCountdown !== null ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-6 w-6 mr-2 text-yellow-500 animate-spin",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: 2,
                                                            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                        })
                                                    }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-6 w-6 mr-2 text-green-500",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: [
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: 2,
                                                                d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                            }),
                                                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                strokeWidth: 2,
                                                                d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                                                        className: "text-xl font-bold dark:text-dark-text",
                                                        children: currentRound.revealed ? 'Voting Complete' : autoRevealCountdown !== null ? 'All Votes Are In!' : 'Active Round'
                                                    })
                                                ]
                                            }),
                                            currentRound.description && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                                                className: "mt-2 text-gray-700 dark:text-gray-300 font-medium",
                                                children: currentRound.description
                                            }),
                                            autoRevealCountdown !== null && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                                                className: "mt-1 text-gray-600 dark:text-gray-400",
                                                children: "Results will be revealed automatically..."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: "mt-4 md:mt-0",
                                        children: currentRound.revealed ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                            className: "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300",
                                            children: "Results Revealed"
                                        }) : autoRevealCountdown !== null ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                            className: "animate-pulse",
                                            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("span", {
                                                className: "inline-flex items-center px-4 py-2 rounded-full text-sm font-bold bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 border border-yellow-200 dark:border-yellow-800",
                                                children: [
                                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5 mr-2 animate-spin",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: 2,
                                                            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                        })
                                                    }),
                                                    "Revealing in ",
                                                    autoRevealCountdown,
                                                    "..."
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("span", {
                                            className: "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300",
                                            children: "Voting in Progress"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-12 w-12 mx-auto mb-3 text-amber-500",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("h2", {
                                        className: "text-xl font-bold mb-2 dark:text-dark-text",
                                        children: "Waiting for a new round to start"
                                    }),
                                    isAdmin && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("p", {
                                        className: "text-gray-600 dark:text-gray-400",
                                        children: "As the admin, you can start a new round using the controls below."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                className: "absolute top-0 right-0 w-32 h-32 opacity-10 transform rotate-45",
                                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                        className: "grid grid-cols-1 xl:grid-cols-3 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                className: "xl:col-span-1",
                                children: [
                                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $571d2094c35f4038$export$2e2bcd8739ae039), {
                                        participants: room.participants,
                                        currentVotes: currentRound?.votes,
                                        revealed: currentRound?.revealed || false
                                    }),
                                    room.cardDeck.type === 'tshirt' && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: "mt-6",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($a9402a11c2ad053c$var$TShirtSizeReference, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                                className: "xl:col-span-2",
                                children: [
                                    currentRound && !currentRound.revealed && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                                        className: "bg-white dark:bg-dark-card rounded-lg shadow-md p-6 mb-6",
                                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $5b890932354c5e84$export$2e2bcd8739ae039), {
                                            onVote: handleVote,
                                            selectedValue: selectedValue,
                                            disabled: false,
                                            cardValues: room.cardDeck.values
                                        })
                                    }),
                                    currentRound && currentRound.revealed && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $cdd2f690c0347d2c$export$2e2bcd8739ae039), {
                                        votes: currentRound.votes,
                                        revealed: currentRound.revealed
                                    }),
                                    isAdmin && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $f37774a1db9e0eb7$export$2e2bcd8739ae039), {
                                        onStartNewRound: handleStartNewRound,
                                        onRevealVotes: handleRevealVotes,
                                        onUpdateCardDeck: handleUpdateCardDeck,
                                        isAdmin: isAdmin,
                                        revealed: currentRound?.revealed || false,
                                        currentDeckType: room.cardDeck.type,
                                        currentCardValues: room.cardDeck.values
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a9402a11c2ad053c$export$2e2bcd8739ae039 = $a9402a11c2ad053c$var$RoomPage;



const $cd93687958c8007e$var$App = ()=>{
    (0, $2WGWz.useEffect)(()=>{
        // Initialize Firebase Anonymous Auth when the app loads
        (0, $80df39b5d570f70c$export$e9dbbdd5c9d6144f)().catch((error)=>{
            console.error('Failed to initialize authentication:', error);
        });
    }, []);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $e3cf8f15688cff98$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $80c9b230a4f51b6a$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $80c9b230a4f51b6a$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: "/",
                    component: (0, $9aecac4636d85589$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $80c9b230a4f51b6a$export$e7b0ac011bb776c6), {
                    path: "/room/:roomCode",
                    component: (0, $a9402a11c2ad053c$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $80c9b230a4f51b6a$export$2d8d895a0a0f636e), {
                    to: "/"
                })
            ]
        })
    });
};
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;




const $70fc9a727fa662ae$var$rootElement = document.getElementById('root');
if (!$70fc9a727fa662ae$var$rootElement) throw new Error('Failed to find the root element');
const $70fc9a727fa662ae$var$root = (0, $9304165f01abb7b7$exports.createRoot)($70fc9a727fa662ae$var$rootElement);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).StrictMode, {
    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $d8dc7d600134d582$export$d8964aec282183a3), {
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=bw-planning-poker.1e566c20.js.map
